// // // // // // // // // import { useState, useEffect } from "react";
// // // // // // // // // import {
// // // // // // // // //   Grid,
// // // // // // // // //   Card,
// // // // // // // // //   CardContent,
// // // // // // // // //   Container,
// // // // // // // // //   Typography,
// // // // // // // // //   Box,
// // // // // // // // //   Button,
// // // // // // // // //   Paper,
// // // // // // // // //   Avatar,
// // // // // // // // //   Chip,
// // // // // // // // //   Dialog,
// // // // // // // // //   DialogTitle,
// // // // // // // // //   DialogContent,
// // // // // // // // //   DialogActions,
// // // // // // // // //   List,
// // // // // // // // //   ListItem,
// // // // // // // // //   ListItemIcon,
// // // // // // // // //   ListItemText,
// // // // // // // // //   Divider,
// // // // // // // // //   Stack,
// // // // // // // // //   LinearProgress,
// // // // // // // // //   Skeleton,
// // // // // // // // //   alpha,
// // // // // // // // //   IconButton,
// // // // // // // // //   Tabs,
// // // // // // // // //   Tab,
// // // // // // // // //   FormGroup,
// // // // // // // // //   FormControlLabel,
// // // // // // // // //   Checkbox,
// // // // // // // // //   Alert,
// // // // // // // // //   AlertTitle,
// // // // // // // // // } from "@mui/material";
// // // // // // // // // import { styled, useTheme } from "@mui/material/styles";
// // // // // // // // // import {
// // // // // // // // //   Psychology,
// // // // // // // // //   TrendingUp,
// // // // // // // // //   School,
// // // // // // // // //   Work,
// // // // // // // // //   Language,
// // // // // // // // //   Assessment,
// // // // // // // // //   VideoCall,
// // // // // // // // //   Lightbulb,
// // // // // // // // //   Timeline,
// // // // // // // // //   CheckCircle,
// // // // // // // // //   ErrorOutline,
// // // // // // // // //   ArrowForward,
// // // // // // // // //   MilitaryTech,
// // // // // // // // //   Stars,
// // // // // // // // //   RocketLaunch,
// // // // // // // // //   TrendingDown,
// // // // // // // // //   TrendingFlat,
// // // // // // // // //   LocationOn,
// // // // // // // // //   MonetizationOn,
// // // // // // // // //   AutoAwesome,
// // // // // // // // //   Close as CloseIcon, // For the dismissible alert
// // // // // // // // //   Insights, // For the chart empty state
// // // // // // // // // } from "@mui/icons-material";
// // // // // // // // // import {
// // // // // // // // //   BarChart,
// // // // // // // // //   Bar,
// // // // // // // // //   XAxis,
// // // // // // // // //   YAxis,
// // // // // // // // //   CartesianGrid,
// // // // // // // // //   Tooltip,
// // // // // // // // //   ResponsiveContainer,
// // // // // // // // //   Cell,
// // // // // // // // //   LabelList,
// // // // // // // // // } from "recharts";
// // // // // // // // // import Layout from "../common/Layout";
// // // // // // // // // import { useNotification } from "../../context/NotificationContext";
// // // // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // // // import apiClient from "../../context/apiClient";

// // // // // // // // // // --- Helper Components ---

// // // // // // // // // const ServiceListItem = styled(Paper)(({ theme, color = "primary" }) => ({
// // // // // // // // //   backgroundColor: theme.palette.mint.main,
// // // // // // // // //   display: "flex",
// // // // // // // // //   flexDirection: "row",
// // // // // // // // //   alignItems: "center",
// // // // // // // // //   padding: theme.spacing(2),
// // // // // // // // //   borderRadius: "12px",
// // // // // // // // //   cursor: "pointer",
// // // // // // // // //   transition:
// // // // // // // // //     "background-color 0.3s ease, border-color 0.3s ease, transform 0.2s ease-in-out", // Added transform transition
// // // // // // // // //   border: `1px solid ${theme.palette.divider}`,
// // // // // // // // //   "&:hover": {
// // // // // // // // //     backgroundColor: alpha(
// // // // // // // // //       theme.palette[color]?.main || theme.palette.primary.main,
// // // // // // // // //       0.08
// // // // // // // // //     ),
// // // // // // // // //     borderColor: theme.palette[color]?.main || theme.palette.primary.main,
// // // // // // // // //     transform: "scale(1.02)", // Added hover effect
// // // // // // // // //   },
// // // // // // // // //   ".MuiAvatar-root": {
// // // // // // // // //     backgroundColor: alpha(
// // // // // // // // //       theme.palette[color]?.main || theme.palette.primary.main,
// // // // // // // // //       0.15
// // // // // // // // //     ),
// // // // // // // // //     color: theme.palette[color]?.main || theme.palette.primary.main,
// // // // // // // // //     marginRight: theme.spacing(2),
// // // // // // // // //   },
// // // // // // // // // }));

// // // // // // // // // function TabPanel(props) {
// // // // // // // // //   const { children, value, index, ...other } = props;
// // // // // // // // //   return (
// // // // // // // // //     <div
// // // // // // // // //       role="tabpanel"
// // // // // // // // //       hidden={value !== index}
// // // // // // // // //       id={`tabpanel-${index}`}
// // // // // // // // //       aria-labelledby={`tab-${index}`}
// // // // // // // // //       {...other}
// // // // // // // // //     >
// // // // // // // // //       {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
// // // // // // // // //     </div>
// // // // // // // // //   );
// // // // // // // // // }

// // // // // // // // // // --- Main Component ---

// // // // // // // // // const CareerAssistant = () => {
// // // // // // // // //   const theme = useTheme();
// // // // // // // // //   const { showNotification } = useNotification();
// // // // // // // // //   const navigate = useNavigate();

// // // // // // // // //   const availableRoles = [
// // // // // // // // //     "AI/ML Engineer",
// // // // // // // // //     "Data Scientist",
// // // // // // // // //     "Business Analyst",
// // // // // // // // //   ];

// // // // // // // // //   // --- State Declarations ---
// // // // // // // // //   const [showWelcomeCard, setShowWelcomeCard] = useState(true); // State for the new welcome card
// // // // // // // // //   const [mockInterviewDialog, setMockInterviewDialog] = useState(false);
// // // // // // // // //   const [resumeReviewDialog, setResumeReviewDialog] = useState(false);
// // // // // // // // //   const [skillGapDialog, setSkillGapDialog] = useState(false);
// // // // // // // // //   const [careerRoadmapDialog, setCareerRoadmapDialog] = useState(false);
// // // // // // // // //   const [culturalPrepDialog, setCulturalPrepDialog] = useState(false);
// // // // // // // // //   const [salaryInsightsDialog, setSalaryInsightsDialog] = useState(false);
// // // // // // // // //   const [trendingSkillsData, setTrendingSkillsData] = useState({});
// // // // // // // // //   const [skillsLoading, setSkillsLoading] = useState(true);
// // // // // // // // //   const [selectedTrendingRoles, setSelectedTrendingRoles] = useState([
// // // // // // // // //     "AI/ML Engineer",
// // // // // // // // //   ]);
// // // // // // // // //   const [activeTrendingTab, setActiveTrendingTab] = useState(0);
// // // // // // // // //   const [resumeReviewData, setResumeReviewData] = useState(null);
// // // // // // // // //   const [resumeReviewLoading, setResumeReviewLoading] = useState(false);
// // // // // // // // //   const [selectedResumeRoles, setSelectedResumeRoles] = useState([]);
// // // // // // // // //   const [activeResumeTab, setActiveResumeTab] = useState(0);
// // // // // // // // //   const [skillGapData, setSkillGapData] = useState(null);
// // // // // // // // //   const [skillGapLoading, setSkillGapLoading] = useState(false);
// // // // // // // // //   const [selectedSkillGapRoles, setSelectedSkillGapRoles] = useState([]);
// // // // // // // // //   const [activeSkillGapTab, setActiveSkillGapTab] = useState(0);
// // // // // // // // //   const [careerRoadmapData, setCareerRoadmapData] = useState(null);
// // // // // // // // //   const [careerRoadmapLoading, setCareerRoadmapLoading] = useState(false);
// // // // // // // // //   const [selectedRoadmapRoles, setSelectedRoadmapRoles] = useState([]);
// // // // // // // // //   const [activeRoadmapTab, setActiveRoadmapTab] = useState(0);
// // // // // // // // //   const [culturalPrepData, setCulturalPrepData] = useState(null);
// // // // // // // // //   const [culturalPrepLoading, setCulturalPrepLoading] = useState(false);
// // // // // // // // //   const [culturalPrepTab, setCulturalPrepTab] = useState(0);
// // // // // // // // //   const [salaryInsightsData, setSalaryInsightsData] = useState(null);
// // // // // // // // //   const [salaryInsightsLoading, setSalaryInsightsLoading] = useState(false);

// // // // // // // // //   // --- Data Fetching Functions ---

// // // // // // // // //   const fetchTrendingSkills = async (roles) => {
// // // // // // // // //     if (!roles || roles.length === 0) {
// // // // // // // // //       setTrendingSkillsData({});
// // // // // // // // //       setSkillsLoading(false); // Ensure loading is off
// // // // // // // // //       return;
// // // // // // // // //     }
// // // // // // // // //     setSkillsLoading(true);
// // // // // // // // //     try {
// // // // // // // // //       const response = await apiClient.post("/trending-skills/", {
// // // // // // // // //         selected_roles: roles,
// // // // // // // // //       });
// // // // // // // // //       const transformedData = {};
// // // // // // // // //       for (const [role, skills] of Object.entries(response.data)) {
// // // // // // // // //         transformedData[role] = skills.map((skill) => ({
// // // // // // // // //           skill: skill.skill,
// // // // // // // // //           demand: parseInt(skill.demand) || 0,
// // // // // // // // //           growth: skill.increase || "N/A",
// // // // // // // // //           priority: skill.priority,
// // // // // // // // //         }));
// // // // // // // // //       }
// // // // // // // // //       setTrendingSkillsData(transformedData);
// // // // // // // // //       setActiveTrendingTab(0);
// // // // // // // // //     } catch (error) {
// // // // // // // // //       console.error("Failed to fetch trending skills:", error);
// // // // // // // // //       showNotification("Could not load trending skills data.", "error");
// // // // // // // // //       setTrendingSkillsData({});
// // // // // // // // //     } finally {
// // // // // // // // //       setSkillsLoading(false);
// // // // // // // // //     }
// // // // // // // // //   };

// // // // // // // // //   const fetchResumeReview = async (roles) => {
// // // // // // // // //     if (!roles || roles.length === 0) {
// // // // // // // // //       setResumeReviewData({});
// // // // // // // // //       return;
// // // // // // // // //     }
// // // // // // // // //     setResumeReviewLoading(true);
// // // // // // // // //     try {
// // // // // // // // //       const response = await apiClient.post("/resume/review-talent/", {
// // // // // // // // //         target_roles: roles,
// // // // // // // // //       });
// // // // // // // // //       setResumeReviewData(response.data);
// // // // // // // // //       setActiveResumeTab(0);
// // // // // // // // //     } catch (error) {
// // // // // // // // //       showNotification("Failed to load resume review data.", "error");
// // // // // // // // //     } finally {
// // // // // // // // //       setResumeReviewLoading(false);
// // // // // // // // //     }
// // // // // // // // //   };
// // // // // // // // //   const fetchSkillGap = async (roles) => {
// // // // // // // // //     if (!roles || roles.length === 0) {
// // // // // // // // //       setSkillGapData({});
// // // // // // // // //       return;
// // // // // // // // //     }
// // // // // // // // //     setSkillGapLoading(true);
// // // // // // // // //     try {
// // // // // // // // //       const response = await apiClient.post("/resume/skill-gap/", {
// // // // // // // // //         selected_roles: roles,
// // // // // // // // //       });
// // // // // // // // //       setSkillGapData(response.data);
// // // // // // // // //       setActiveSkillGapTab(0);
// // // // // // // // //     } catch (error) {
// // // // // // // // //       showNotification("Failed to load skill gap analysis.", "error");
// // // // // // // // //     } finally {
// // // // // // // // //       setSkillGapLoading(false);
// // // // // // // // //     }
// // // // // // // // //   };
// // // // // // // // //   const fetchCareerRoadmap = async (roles) => {
// // // // // // // // //     if (!roles || roles.length === 0) {
// // // // // // // // //       setCareerRoadmapData({});
// // // // // // // // //       return;
// // // // // // // // //     }
// // // // // // // // //     setCareerRoadmapLoading(true);
// // // // // // // // //     try {
// // // // // // // // //       const response = await apiClient.post("/resume/career-roadmap/", {
// // // // // // // // //         target_roles: roles,
// // // // // // // // //       });
// // // // // // // // //       setCareerRoadmapData(response.data);
// // // // // // // // //       setActiveRoadmapTab(0);
// // // // // // // // //     } catch (error) {
// // // // // // // // //       showNotification("Failed to load career roadmap.", "error");
// // // // // // // // //       setCareerRoadmapData({});
// // // // // // // // //     } finally {
// // // // // // // // //       setCareerRoadmapLoading(false);
// // // // // // // // //     }
// // // // // // // // //   };

// // // // // // // // //   // --- Handlers ---
// // // // // // // // //   const handleTrendingRoleChange = (event) => {
// // // // // // // // //     const { name, checked } = event.target;
// // // // // // // // //     setSelectedTrendingRoles((prev) =>
// // // // // // // // //       checked ? [...prev, name] : prev.filter((role) => role !== name)
// // // // // // // // //     );
// // // // // // // // //   };

// // // // // // // // //   // --- Child Components ---
// // // // // // // // //   const RoleSelector = ({ selectedRoles, handleRoleChange }) => (
// // // // // // // // //     <FormGroup row sx={{ mb: 2, justifyContent: "center" }}>
// // // // // // // // //       {availableRoles.map((role) => (
// // // // // // // // //         <FormControlLabel
// // // // // // // // //           key={role}
// // // // // // // // //           control={
// // // // // // // // //             <Checkbox
// // // // // // // // //               checked={selectedRoles.includes(role)}
// // // // // // // // //               onChange={handleRoleChange}
// // // // // // // // //               name={role}
// // // // // // // // //             />
// // // // // // // // //           }
// // // // // // // // //           label={role}
// // // // // // // // //         />
// // // // // // // // //       ))}
// // // // // // // // //     </FormGroup>
// // // // // // // // //   );

// // // // // // // // //   const CustomTooltip = ({ active, payload, label }) => {
// // // // // // // // //     if (active && payload && payload.length) {
// // // // // // // // //       const data = payload[0].payload;
// // // // // // // // //       const priorityMuiColor = {
// // // // // // // // //         High: "primary",
// // // // // // // // //         Medium: "info",
// // // // // // // // //       };
// // // // // // // // //       return (
// // // // // // // // //         <Paper
// // // // // // // // //           elevation={3}
// // // // // // // // //           sx={{
// // // // // // // // //             p: 1.5,
// // // // // // // // //             minWidth: 220,
// // // // // // // // //             bgcolor: "background.paper",
// // // // // // // // //             border: `1px solid ${theme.palette.divider}`,
// // // // // // // // //             borderRadius: 2,
// // // // // // // // //           }}
// // // // // // // // //         >
// // // // // // // // //           <Typography variant="body1" fontWeight="bold" gutterBottom>
// // // // // // // // //             {label}
// // // // // // // // //           </Typography>
// // // // // // // // //           <Stack spacing={1}>
// // // // // // // // //             <Stack
// // // // // // // // //               direction="row"
// // // // // // // // //               justifyContent="space-between"
// // // // // // // // //               alignItems="center"
// // // // // // // // //             >
// // // // // // // // //               <Typography variant="body2" color="text.secondary">
// // // // // // // // //                 Demand:
// // // // // // // // //               </Typography>
// // // // // // // // //               <Typography
// // // // // // // // //                 variant="body2"
// // // // // // // // //                 fontWeight="bold"
// // // // // // // // //               >{`${data.demand}%`}</Typography>
// // // // // // // // //             </Stack>
// // // // // // // // //             <Stack
// // // // // // // // //               direction="row"
// // // // // // // // //               justifyContent="space-between"
// // // // // // // // //               alignItems="center"
// // // // // // // // //             >
// // // // // // // // //               <Typography variant="body2" color="text.secondary">
// // // // // // // // //                 Priority:
// // // // // // // // //               </Typography>
// // // // // // // // //               <Chip
// // // // // // // // //                 label={data.priority}
// // // // // // // // //                 size="small"
// // // // // // // // //                 color={priorityMuiColor[data.priority] || "default"}
// // // // // // // // //                 sx={{ fontWeight: 600 }}
// // // // // // // // //               />
// // // // // // // // //             </Stack>
// // // // // // // // //             <Stack
// // // // // // // // //               direction="row"
// // // // // // // // //               justifyContent="space-between"
// // // // // // // // //               alignItems="center"
// // // // // // // // //             >
// // // // // // // // //               <Typography variant="body2" color="text.secondary">
// // // // // // // // //                 Growth:
// // // // // // // // //               </Typography>
// // // // // // // // //               <Typography
// // // // // // // // //                 variant="body2"
// // // // // // // // //                 fontWeight="bold"
// // // // // // // // //                 color={
// // // // // // // // //                   (data.growth || "").startsWith("+")
// // // // // // // // //                     ? "success.main"
// // // // // // // // //                     : "error.main"
// // // // // // // // //                 }
// // // // // // // // //               >
// // // // // // // // //                 {data.growth}
// // // // // // // // //               </Typography>
// // // // // // // // //             </Stack>
// // // // // // // // //           </Stack>
// // // // // // // // //         </Paper>
// // // // // // // // //       );
// // // // // // // // //     }
// // // // // // // // //     return null;
// // // // // // // // //   };

// // // // // // // // //   const RoundedVerticalBar = (props) => {
// // // // // // // // //     const { fill, x, y, width, height } = props;
// // // // // // // // //     const radius = 8;
// // // // // // // // //     if (height <= 0) return null;
// // // // // // // // //     return (
// // // // // // // // //       <g>
// // // // // // // // //         <path
// // // // // // // // //           d={`M${x},${y + radius} A${radius},${radius} 0 0 1 ${
// // // // // // // // //             x + radius
// // // // // // // // //           },${y} L${x + width - radius},${y} A${radius},${radius} 0 0 1 ${
// // // // // // // // //             x + width
// // // // // // // // //           },${y + radius} L${x + width},${y + height} L${x},${y + height} Z`}
// // // // // // // // //           fill={fill}
// // // // // // // // //         />
// // // // // // // // //       </g>
// // // // // // // // //     );
// // // // // // // // //   };

// // // // // // // // //   const assistantServices = [
// // // // // // // // //     {
// // // // // // // // //       id: "resume-review",
// // // // // // // // //       title: "AI Resume Review",
// // // // // // // // //       description:
// // // // // // // // //         "Get detailed feedback & ATS optimization suggestions for target roles.",
// // // // // // // // //       icon: <Assessment />,
// // // // // // // // //       color: "primary",
// // // // // // // // //     },
// // // // // // // // //     {
// // // // // // // // //       id: "mock-interview",
// // // // // // // // //       title: "Mock Interview Practice",
// // // // // // // // //       description:
// // // // // // // // //         "Practice with AI simulations tailored for top global companies.",
// // // // // // // // //       icon: <VideoCall />,
// // // // // // // // //       color: "secondary",
// // // // // // // // //     },
// // // // // // // // //     {
// // // // // // // // //       id: "skill-assessment",
// // // // // // // // //       title: "Skill Gap Analysis",
// // // // // // // // //       description:
// // // // // // // // //         "Identify critical skill gaps based on your resume and target roles.",
// // // // // // // // //       icon: <TrendingUp />,
// // // // // // // // //       color: "success",
// // // // // // // // //     },
// // // // // // // // //     {
// // // // // // // // //       id: "career-roadmap",
// // // // // // // // //       title: "Career Roadmap",
// // // // // // // // //       description:
// // // // // // // // //         "AI-generated personalized path based on your profile and goals.",
// // // // // // // // //       icon: <Timeline />,
// // // // // // // // //       color: "warning",
// // // // // // // // //     },
// // // // // // // // //     {
// // // // // // // // //       id: "salary-insights",
// // // // // // // // //       title: "Salary Insights",
// // // // // // // // //       description:
// // // // // // // // //         "Real-time salary benchmarks for your target roles and locations.",
// // // // // // // // //       icon: <Language />,
// // // // // // // // //       color: "info",
// // // // // // // // //     },
// // // // // // // // //     {
// // // // // // // // //       id: "cultural-prep",
// // // // // // // // //       title: "Cultural Preparation",
// // // // // // // // //       description:
// // // // // // // // //         "Master workplace culture for different countries and companies.",
// // // // // // // // //       icon: <Psychology />,
// // // // // // // // //       color: "error",
// // // // // // // // //     },
// // // // // // // // //   ];

// // // // // // // // //   const handleServiceClick = async (service) => {
// // // // // // // // //     const defaultRolePayload = ["AI/ML Engineer"];
// // // // // // // // //     switch (service.id) {
// // // // // // // // //       case "resume-review":
// // // // // // // // //         setResumeReviewDialog(true);
// // // // // // // // //         setSelectedResumeRoles(defaultRolePayload);
// // // // // // // // //         await fetchResumeReview(defaultRolePayload);
// // // // // // // // //         break;
// // // // // // // // //       case "mock-interview":
// // // // // // // // //         setMockInterviewDialog(true);
// // // // // // // // //         break;
// // // // // // // // //       case "skill-assessment":
// // // // // // // // //         setSkillGapDialog(true);
// // // // // // // // //         setSelectedSkillGapRoles(defaultRolePayload);
// // // // // // // // //         await fetchSkillGap(defaultRolePayload);
// // // // // // // // //         break;
// // // // // // // // //       case "career-roadmap":
// // // // // // // // //         setCareerRoadmapDialog(true);
// // // // // // // // //         setSelectedRoadmapRoles(defaultRolePayload);
// // // // // // // // //         await fetchCareerRoadmap(defaultRolePayload);
// // // // // // // // //         break;
// // // // // // // // //       case "cultural-prep":
// // // // // // // // //         setCulturalPrepDialog(true);
// // // // // // // // //         if (!culturalPrepData) {
// // // // // // // // //           setCulturalPrepLoading(true);
// // // // // // // // //           try {
// // // // // // // // //             const res = await apiClient.get("/ai/cultural-preparation/");
// // // // // // // // //             const validData = Object.fromEntries(
// // // // // // // // //               Object.entries(res.data.cultural_preparation).filter(
// // // // // // // // //                 ([, value]) => !value.error_message
// // // // // // // // //               )
// // // // // // // // //             );
// // // // // // // // //             setCulturalPrepData(validData);
// // // // // // // // //           } catch (err) {
// // // // // // // // //             showNotification("Failed to load cultural prep data.", "error");
// // // // // // // // //           } finally {
// // // // // // // // //             setCulturalPrepLoading(false);
// // // // // // // // //           }
// // // // // // // // //         }
// // // // // // // // //         break;
// // // // // // // // //       case "salary-insights":
// // // // // // // // //         setSalaryInsightsDialog(true);
// // // // // // // // //         if (!salaryInsightsData) {
// // // // // // // // //           setSalaryInsightsLoading(true);
// // // // // // // // //           try {
// // // // // // // // //             const res = await apiClient.get("/ai/salary-insights/");
// // // // // // // // //             setSalaryInsightsData(res.data.salary_insights);
// // // // // // // // //           } catch (err) {
// // // // // // // // //             showNotification("Failed to load salary insights data.", "error");
// // // // // // // // //           } finally {
// // // // // // // // //             setSalaryInsightsLoading(false);
// // // // // // // // //           }
// // // // // // // // //         }
// // // // // // // // //         break;
// // // // // // // // //       default:
// // // // // // // // //         showNotification(`${service.title} feature coming soon!`, "info");
// // // // // // // // //     }
// // // // // // // // //   };

// // // // // // // // //   const DialogSkeleton = () => (
// // // // // // // // //     <Stack spacing={3} sx={{ p: 2, minHeight: 400 }}>
// // // // // // // // //       <Skeleton variant="rounded" width="60%" height={40} />
// // // // // // // // //       <Skeleton variant="rounded" width="100%" height={100} />
// // // // // // // // //       <Skeleton variant="rounded" width="40%" height={30} />
// // // // // // // // //       <Skeleton variant="rounded" width="100%" height={150} />
// // // // // // // // //     </Stack>
// // // // // // // // //   );

// // // // // // // // //   // Initial data fetch on component mount
// // // // // // // // //   useEffect(() => {
// // // // // // // // //     fetchTrendingSkills(selectedTrendingRoles);
// // // // // // // // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // // // // // // // //   }, []);

// // // // // // // // //   // NEW: Debounced effect to fetch trending skills when roles change
// // // // // // // // //   useEffect(() => {
// // // // // // // // //     const handler = setTimeout(() => {
// // // // // // // // //       fetchTrendingSkills(selectedTrendingRoles);
// // // // // // // // //     }, 500); // 500ms delay

// // // // // // // // //     return () => {
// // // // // // // // //       clearTimeout(handler);
// // // // // // // // //     };
// // // // // // // // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // // // // // // // //   }, [selectedTrendingRoles]);

// // // // // // // // //   return (
// // // // // // // // //     <Layout title="AI Career Assistant">
// // // // // // // // //       <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// // // // // // // // //         <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
// // // // // // // // //           <Stack spacing={4}>
// // // // // // // // //             {/* Header */}
// // // // // // // // //             <Paper
// // // // // // // // //               sx={{
// // // // // // // // //                 bgcolor: "mint.main",
// // // // // // // // //                 borderRadius: 3,
// // // // // // // // //                 p: { xs: 2, sm: 3 },
// // // // // // // // //               }}
// // // // // // // // //             >
// // // // // // // // //               <Stack direction="row" alignItems="center" spacing={2}>
// // // // // // // // //                 <Avatar
// // // // // // // // //                   sx={{
// // // // // // // // //                     bgcolor: "primary.main",
// // // // // // // // //                     color: "primary.contrastText",
// // // // // // // // //                     width: { xs: 50, sm: 64 },
// // // // // // // // //                     height: { xs: 50, sm: 64 },
// // // // // // // // //                   }}
// // // // // // // // //                 >
// // // // // // // // //                   <Psychology sx={{ fontSize: { xs: 28, sm: 36 } }} />
// // // // // // // // //                 </Avatar>
// // // // // // // // //                 <Box>
// // // // // // // // //                   <Typography variant="h4" component="h1" fontWeight="bold">
// // // // // // // // //                     AI Career Assistant
// // // // // // // // //                     <AutoAwesome
// // // // // // // // //                       sx={{
// // // // // // // // //                         fontSize: 28,
// // // // // // // // //                         ml: 1,
// // // // // // // // //                         verticalAlign: "middle",
// // // // // // // // //                         color: "primary.main",
// // // // // // // // //                       }}
// // // // // // // // //                     />
// // // // // // // // //                   </Typography>
// // // // // // // // //                   <Typography variant="body1" color="text.secondary">
// // // // // // // // //                     Your intelligent, multilingual guide to global careers.
// // // // // // // // //                   </Typography>
// // // // // // // // //                 </Box>
// // // // // // // // //               </Stack>
// // // // // // // // //             </Paper>

// // // // // // // // //             {/* NEW: Guided Entry Point */}
// // // // // // // // //             {showWelcomeCard && (
// // // // // // // // //               <Alert
// // // // // // // // //                 severity="info"
// // // // // // // // //                 variant="filled"
// // // // // // // // //                 onClose={() => setShowWelcomeCard(false)}
// // // // // // // // //                 action={
// // // // // // // // //                   <Button
// // // // // // // // //                     color="inherit"
// // // // // // // // //                     size="small"
// // // // // // // // //                     onClick={() => {
// // // // // // // // //                       handleServiceClick(assistantServices[0]); // Clicks "AI Resume Review"
// // // // // // // // //                       setShowWelcomeCard(false);
// // // // // // // // //                     }}
// // // // // // // // //                   >
// // // // // // // // //                     Start Review
// // // // // // // // //                   </Button>
// // // // // // // // //                 }
// // // // // // // // //                 sx={{
// // // // // // // // //                   bgcolor: "primary.dark",
// // // // // // // // //                   color: "primary.contrastText",
// // // // // // // // //                   borderRadius: 2,
// // // // // // // // //                 }}
// // // // // // // // //               >
// // // // // // // // //                 <AlertTitle sx={{ fontWeight: "bold" }}>Welcome!</AlertTitle>
// // // // // // // // //                 New here? Start with an AI Resume Review to get personalized
// // // // // // // // //                 feedback and unlock other insights.
// // // // // // // // //               </Alert>
// // // // // // // // //             )}

// // // // // // // // //             {/* REORDERED: Services List is now first */}
// // // // // // // // //             <Box>
// // // // // // // // //               <Stack direction="row" alignItems="center" spacing={1} mb={2}>
// // // // // // // // //                 <Typography variant="h5" component="h2" fontWeight={600}>
// // // // // // // // //                   AI-Powered Career Services
// // // // // // // // //                 </Typography>
// // // // // // // // //                 <RocketLaunch color="primary" />
// // // // // // // // //               </Stack>
// // // // // // // // //               <Grid container spacing={2}>
// // // // // // // // //                 {assistantServices.map((service) => (
// // // // // // // // //                   <Grid item xs={12} md={6} key={service.id}>
// // // // // // // // //                     <ServiceListItem
// // // // // // // // //                       color={service.color}
// // // // // // // // //                       onClick={() => handleServiceClick(service)}
// // // // // // // // //                     >
// // // // // // // // //                       <Avatar sx={{ width: 48, height: 48 }}>
// // // // // // // // //                         {service.icon}
// // // // // // // // //                       </Avatar>
// // // // // // // // //                       <Box flexGrow={1}>
// // // // // // // // //                         <Typography
// // // // // // // // //                           variant="h6"
// // // // // // // // //                           component="div"
// // // // // // // // //                           fontWeight="bold"
// // // // // // // // //                         >
// // // // // // // // //                           {service.title}
// // // // // // // // //                         </Typography>
// // // // // // // // //                         <Typography variant="body2" color="text.secondary">
// // // // // // // // //                           {service.description}
// // // // // // // // //                         </Typography>
// // // // // // // // //                       </Box>
// // // // // // // // //                       <IconButton sx={{ ml: 2 }}>
// // // // // // // // //                         <ArrowForward />
// // // // // // // // //                       </IconButton>
// // // // // // // // //                     </ServiceListItem>
// // // // // // // // //                   </Grid>
// // // // // // // // //                 ))}
// // // // // // // // //               </Grid>
// // // // // // // // //             </Box>

// // // // // // // // //             {/* REORDERED: Trending Skills is now second */}
// // // // // // // // //             <Card sx={{ bgcolor: "mint.main" }}>
// // // // // // // // //               <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
// // // // // // // // //                 <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
// // // // // // // // //                   <Lightbulb color="primary" />
// // // // // // // // //                   <Typography variant="h6" fontWeight={600}>
// // // // // // // // //                     Top In-Demand Skills
// // // // // // // // //                   </Typography>
// // // // // // // // //                 </Stack>
// // // // // // // // //                 <RoleSelector
// // // // // // // // //                   selectedRoles={selectedTrendingRoles}
// // // // // // // // //                   handleRoleChange={handleTrendingRoleChange}
// // // // // // // // //                 />
// // // // // // // // //                 {/* REMOVED: "Get Skills" Button */}
// // // // // // // // //                 {skillsLoading ? (
// // // // // // // // //                   <DialogSkeleton />
// // // // // // // // //                 ) : Object.keys(trendingSkillsData).length > 0 ? (
// // // // // // // // //                   <Box>
// // // // // // // // //                     <Tabs
// // // // // // // // //                       value={activeTrendingTab}
// // // // // // // // //                       onChange={(e, val) => setActiveTrendingTab(val)}
// // // // // // // // //                       variant="scrollable"
// // // // // // // // //                       scrollButtons="auto"
// // // // // // // // //                     >
// // // // // // // // //                       {Object.keys(trendingSkillsData).map((role) => (
// // // // // // // // //                         <Tab label={role} key={role} />
// // // // // // // // //                       ))}
// // // // // // // // //                     </Tabs>
// // // // // // // // //                     {Object.entries(trendingSkillsData).map(
// // // // // // // // //                       ([role, skills], index) => {
// // // // // // // // //                         const sortedSkills = [...skills].sort(
// // // // // // // // //                           (a, b) => b.demand - a.demand
// // // // // // // // //                         );
// // // // // // // // //                         const priorityColors = {
// // // // // // // // //                           High: theme.palette.primary.main,
// // // // // // // // //                           Medium: theme.palette.info.main,
// // // // // // // // //                         };

// // // // // // // // //                         return (
// // // // // // // // //                           <TabPanel
// // // // // // // // //                             value={activeTrendingTab}
// // // // // // // // //                             index={index}
// // // // // // // // //                             key={role}
// // // // // // // // //                           >
// // // // // // // // //                             <Paper
// // // // // // // // //                               sx={{
// // // // // // // // //                                 bgcolor: "background.paper",
// // // // // // // // //                                 borderRadius: 2,
// // // // // // // // //                                 p: { xs: 1, sm: 2 },
// // // // // // // // //                               }}
// // // // // // // // //                             >
// // // // // // // // //                               <Box sx={{ height: 500, width: "100%" }}>
// // // // // // // // //                                 <ResponsiveContainer width="100%" height="100%">
// // // // // // // // //                                   <BarChart
// // // // // // // // //                                     data={sortedSkills}
// // // // // // // // //                                     margin={{
// // // // // // // // //                                       top: 30,
// // // // // // // // //                                       right: 30,
// // // // // // // // //                                       left: 20,
// // // // // // // // //                                       bottom: 120,
// // // // // // // // //                                     }}
// // // // // // // // //                                   >
// // // // // // // // //                                     <CartesianGrid
// // // // // // // // //                                       vertical={false}
// // // // // // // // //                                       stroke={theme.palette.divider}
// // // // // // // // //                                       strokeDasharray="3 3"
// // // // // // // // //                                     />
// // // // // // // // //                                     <XAxis
// // // // // // // // //                                       dataKey="skill"
// // // // // // // // //                                       type="category"
// // // // // // // // //                                       interval={0}
// // // // // // // // //                                       angle={-45}
// // // // // // // // //                                       textAnchor="end"
// // // // // // // // //                                       tick={{
// // // // // // // // //                                         fill: theme.palette.text.secondary,
// // // // // // // // //                                         fontSize: 12,
// // // // // // // // //                                       }}
// // // // // // // // //                                       stroke={"transparent"}
// // // // // // // // //                                     />
// // // // // // // // //                                     <YAxis
// // // // // // // // //                                       type="number"
// // // // // // // // //                                       domain={[0, "dataMax + 15"]}
// // // // // // // // //                                       allowDecimals={false}
// // // // // // // // //                                       tickFormatter={(tick) => `${tick}%`}
// // // // // // // // //                                       stroke={theme.palette.divider}
// // // // // // // // //                                       tick={{
// // // // // // // // //                                         fill: theme.palette.text.secondary,
// // // // // // // // //                                       }}
// // // // // // // // //                                     />
// // // // // // // // //                                     <Tooltip
// // // // // // // // //                                       content={<CustomTooltip />}
// // // // // // // // //                                       cursor={{
// // // // // // // // //                                         fill: alpha(
// // // // // // // // //                                           theme.palette.primary.main,
// // // // // // // // //                                           0.1
// // // // // // // // //                                         ),
// // // // // // // // //                                       }}
// // // // // // // // //                                     />
// // // // // // // // //                                     <Bar
// // // // // // // // //                                       dataKey="demand"
// // // // // // // // //                                       shape={<RoundedVerticalBar />}
// // // // // // // // //                                       animationDuration={800}
// // // // // // // // //                                     >
// // // // // // // // //                                       {sortedSkills.map((entry, idx) => (
// // // // // // // // //                                         <Cell
// // // // // // // // //                                           key={`cell-${idx}`}
// // // // // // // // //                                           fill={
// // // // // // // // //                                             priorityColors[entry.priority] ||
// // // // // // // // //                                             theme.palette.text.disabled
// // // // // // // // //                                           }
// // // // // // // // //                                         />
// // // // // // // // //                                       ))}
// // // // // // // // //                                       <LabelList
// // // // // // // // //                                         dataKey="demand"
// // // // // // // // //                                         position="top"
// // // // // // // // //                                         offset={8}
// // // // // // // // //                                         style={{
// // // // // // // // //                                           fill: theme.palette.text.primary,
// // // // // // // // //                                           fontSize: "12px",
// // // // // // // // //                                           fontWeight: "bold",
// // // // // // // // //                                         }}
// // // // // // // // //                                         formatter={(value) => `${value}%`}
// // // // // // // // //                                       />
// // // // // // // // //                                     </Bar>
// // // // // // // // //                                   </BarChart>
// // // // // // // // //                                 </ResponsiveContainer>
// // // // // // // // //                               </Box>
// // // // // // // // //                             </Paper>
// // // // // // // // //                           </TabPanel>
// // // // // // // // //                         );
// // // // // // // // //                       }
// // // // // // // // //                     )}
// // // // // // // // //                   </Box>
// // // // // // // // //                 ) : (
// // // // // // // // //                   // NEW: Empty state for the chart
// // // // // // // // //                   <Box
// // // // // // // // //                     sx={{
// // // // // // // // //                       display: "flex",
// // // // // // // // //                       flexDirection: "column",
// // // // // // // // //                       alignItems: "center",
// // // // // // // // //                       justifyContent: "center",
// // // // // // // // //                       textAlign: "center",
// // // // // // // // //                       py: 8,
// // // // // // // // //                       minHeight: 400,
// // // // // // // // //                     }}
// // // // // // // // //                   >
// // // // // // // // //                     <Insights
// // // // // // // // //                       sx={{ fontSize: 60, color: "text.disabled", mb: 2 }}
// // // // // // // // //                     />
// // // // // // // // //                     <Typography variant="h6" color="text.secondary">
// // // // // // // // //                       Select a role to view in-demand skills
// // // // // // // // //                     </Typography>
// // // // // // // // //                     <Typography variant="body2" color="text.disabled">
// // // // // // // // //                       The chart will update automatically as you make
// // // // // // // // //                       selections.
// // // // // // // // //                     </Typography>
// // // // // // // // //                   </Box>
// // // // // // // // //                 )}
// // // // // // // // //               </CardContent>
// // // // // // // // //             </Card>
// // // // // // // // //           </Stack>
// // // // // // // // //         </Container>
// // // // // // // // //       </Box>

// // // // // // // // //       {/* --- DIALOGS (No changes below this line) --- */}
// // // // // // // // //       <Dialog
// // // // // // // // //         open={resumeReviewDialog}
// // // // // // // // //         onClose={() => setResumeReviewDialog(false)}
// // // // // // // // //         maxWidth="lg"
// // // // // // // // //         fullWidth
// // // // // // // // //       >
// // // // // // // // //         <DialogTitle
// // // // // // // // //           sx={{ bgcolor: "primary.main", color: "primary.contrastText" }}
// // // // // // // // //         >
// // // // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // // // //             <Assessment />{" "}
// // // // // // // // //             <Typography variant="h6">AI Resume Review</Typography>
// // // // // // // // //           </Stack>
// // // // // // // // //         </DialogTitle>
// // // // // // // // //         <DialogContent dividers>
// // // // // // // // //           <RoleSelector
// // // // // // // // //             selectedRoles={selectedResumeRoles}
// // // // // // // // //             handleRoleChange={(e) =>
// // // // // // // // //               setSelectedResumeRoles((prev) =>
// // // // // // // // //                 e.target.checked
// // // // // // // // //                   ? [...prev, e.target.name]
// // // // // // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // // // // // //               )
// // // // // // // // //             }
// // // // // // // // //           />
// // // // // // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // // // // // //             <Button
// // // // // // // // //               variant="contained"
// // // // // // // // //               onClick={() => fetchResumeReview(selectedResumeRoles)}
// // // // // // // // //             >
// // // // // // // // //               Generate Report
// // // // // // // // //             </Button>
// // // // // // // // //           </Box>
// // // // // // // // //           <Divider />
// // // // // // // // //           {resumeReviewLoading ? (
// // // // // // // // //             <DialogSkeleton />
// // // // // // // // //           ) : (
// // // // // // // // //             resumeReviewData && (
// // // // // // // // //               <>
// // // // // // // // //                 <Tabs
// // // // // // // // //                   value={activeResumeTab}
// // // // // // // // //                   onChange={(e, val) => setActiveResumeTab(val)}
// // // // // // // // //                   centered
// // // // // // // // //                 >
// // // // // // // // //                   {Object.keys(resumeReviewData).map((role) => (
// // // // // // // // //                     <Tab key={role} label={role} />
// // // // // // // // //                   ))}
// // // // // // // // //                 </Tabs>
// // // // // // // // //                 {Object.entries(resumeReviewData).map(([role, data], index) => (
// // // // // // // // //                   <TabPanel value={activeResumeTab} index={index} key={role}>
// // // // // // // // //                     <Grid container spacing={3}>
// // // // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // // // //                         <Paper variant="outlined" sx={{ p: 2, height: "100%" }}>
// // // // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // // // //                             ATS Compatibility: {data.ATS_Compatibility.score}
// // // // // // // // //                             /100
// // // // // // // // //                           </Typography>
// // // // // // // // //                           <LinearProgress
// // // // // // // // //                             variant="determinate"
// // // // // // // // //                             value={data.ATS_Compatibility.score}
// // // // // // // // //                           />
// // // // // // // // //                           <Typography
// // // // // // // // //                             variant="subtitle2"
// // // // // // // // //                             color="error.main"
// // // // // // // // //                             sx={{ mt: 2 }}
// // // // // // // // //                           >
// // // // // // // // //                             Top Issues:
// // // // // // // // //                           </Typography>
// // // // // // // // //                           <List dense>
// // // // // // // // //                             {data.ATS_Compatibility.top_issues.map(
// // // // // // // // //                               (issue, i) => (
// // // // // // // // //                                 <ListItem key={i}>
// // // // // // // // //                                   <ListItemIcon>
// // // // // // // // //                                     <ErrorOutline
// // // // // // // // //                                       fontSize="small"
// // // // // // // // //                                       color="error"
// // // // // // // // //                                     />
// // // // // // // // //                                   </ListItemIcon>
// // // // // // // // //                                   <ListItemText primary={issue} />
// // // // // // // // //                                 </ListItem>
// // // // // // // // //                               )
// // // // // // // // //                             )}
// // // // // // // // //                           </List>
// // // // // // // // //                         </Paper>
// // // // // // // // //                       </Grid>
// // // // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // // // //                         <Paper variant="outlined" sx={{ p: 2, height: "100%" }}>
// // // // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // // // //                             Content & Format
// // // // // // // // //                           </Typography>
// // // // // // // // //                           <Typography variant="body2" paragraph>
// // // // // // // // //                             {data.Content_Quality_Analysis.summary}
// // // // // // // // //                           </Typography>
// // // // // // // // //                           <Typography variant="subtitle2" color="success.main">
// // // // // // // // //                             Top Strengths:
// // // // // // // // //                           </Typography>
// // // // // // // // //                           <List dense>
// // // // // // // // //                             {data.Content_Quality_Analysis.top_strengths.map(
// // // // // // // // //                               (strength, i) => (
// // // // // // // // //                                 <ListItem key={i}>
// // // // // // // // //                                   <ListItemIcon>
// // // // // // // // //                                     <CheckCircle
// // // // // // // // //                                       fontSize="small"
// // // // // // // // //                                       color="success"
// // // // // // // // //                                     />
// // // // // // // // //                                   </ListItemIcon>
// // // // // // // // //                                   <ListItemText primary={strength} />
// // // // // // // // //                                 </ListItem>
// // // // // // // // //                               )
// // // // // // // // //                             )}
// // // // // // // // //                           </List>
// // // // // // // // //                         </Paper>
// // // // // // // // //                       </Grid>
// // // // // // // // //                       <Grid item xs={12}>
// // // // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // // // //                             Keyword & Section Optimization
// // // // // // // // //                           </Typography>
// // // // // // // // //                           <Stack
// // // // // // // // //                             direction={{ xs: "column", sm: "row" }}
// // // // // // // // //                             spacing={2}
// // // // // // // // //                             divider={
// // // // // // // // //                               <Divider orientation="vertical" flexItem />
// // // // // // // // //                             }
// // // // // // // // //                           >
// // // // // // // // //                             <Box flex={1}>
// // // // // // // // //                               <Typography variant="subtitle1" fontWeight="bold">
// // // // // // // // //                                 Missing Keywords
// // // // // // // // //                               </Typography>
// // // // // // // // //                               <Box
// // // // // // // // //                                 sx={{
// // // // // // // // //                                   display: "flex",
// // // // // // // // //                                   flexWrap: "wrap",
// // // // // // // // //                                   gap: 1,
// // // // // // // // //                                   mt: 1,
// // // // // // // // //                                 }}
// // // // // // // // //                               >
// // // // // // // // //                                 {data.Keyword_Optimization.missing_keywords.map(
// // // // // // // // //                                   (kw, i) => (
// // // // // // // // //                                     <Chip
// // // // // // // // //                                       key={i}
// // // // // // // // //                                       label={kw}
// // // // // // // // //                                       color="info"
// // // // // // // // //                                       size="small"
// // // // // // // // //                                     />
// // // // // // // // //                                   )
// // // // // // // // //                                 )}
// // // // // // // // //                               </Box>
// // // // // // // // //                             </Box>
// // // // // // // // //                             <Box flex={1}>
// // // // // // // // //                               <Typography variant="subtitle1" fontWeight="bold">
// // // // // // // // //                                 Missing Sections
// // // // // // // // //                               </Typography>
// // // // // // // // //                               <Box
// // // // // // // // //                                 sx={{
// // // // // // // // //                                   display: "flex",
// // // // // // // // //                                   flexWrap: "wrap",
// // // // // // // // //                                   gap: 1,
// // // // // // // // //                                   mt: 1,
// // // // // // // // //                                 }}
// // // // // // // // //                               >
// // // // // // // // //                                 {data.Format_and_Structure_Review.missing_sections.map(
// // // // // // // // //                                   (sec, i) => (
// // // // // // // // //                                     <Chip
// // // // // // // // //                                       key={i}
// // // // // // // // //                                       label={sec}
// // // // // // // // //                                       color="warning"
// // // // // // // // //                                       size="small"
// // // // // // // // //                                     />
// // // // // // // // //                                   )
// // // // // // // // //                                 )}
// // // // // // // // //                               </Box>
// // // // // // // // //                             </Box>
// // // // // // // // //                           </Stack>
// // // // // // // // //                         </Paper>
// // // // // // // // //                       </Grid>
// // // // // // // // //                     </Grid>
// // // // // // // // //                   </TabPanel>
// // // // // // // // //                 ))}
// // // // // // // // //               </>
// // // // // // // // //             )
// // // // // // // // //           )}
// // // // // // // // //         </DialogContent>
// // // // // // // // //         <DialogActions>
// // // // // // // // //           <Button onClick={() => setResumeReviewDialog(false)}>Close</Button>
// // // // // // // // //         </DialogActions>
// // // // // // // // //       </Dialog>
// // // // // // // // //       <Dialog
// // // // // // // // //         open={skillGapDialog}
// // // // // // // // //         onClose={() => setSkillGapDialog(false)}
// // // // // // // // //         maxWidth="lg"
// // // // // // // // //         fullWidth
// // // // // // // // //       >
// // // // // // // // //         <DialogTitle
// // // // // // // // //           sx={{ bgcolor: "success.main", color: "success.contrastText" }}
// // // // // // // // //         >
// // // // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // // // //             <TrendingUp />
// // // // // // // // //             <Typography variant="h6">AI Skill Gap Analysis</Typography>
// // // // // // // // //           </Stack>
// // // // // // // // //         </DialogTitle>
// // // // // // // // //         <DialogContent dividers>
// // // // // // // // //           <RoleSelector
// // // // // // // // //             selectedRoles={selectedSkillGapRoles}
// // // // // // // // //             handleRoleChange={(e) =>
// // // // // // // // //               setSelectedSkillGapRoles((prev) =>
// // // // // // // // //                 e.target.checked
// // // // // // // // //                   ? [...prev, e.target.name]
// // // // // // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // // // // // //               )
// // // // // // // // //             }
// // // // // // // // //           />
// // // // // // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // // // // // //             <Button
// // // // // // // // //               variant="contained"
// // // // // // // // //               color="success"
// // // // // // // // //               onClick={() => fetchSkillGap(selectedSkillGapRoles)}
// // // // // // // // //             >
// // // // // // // // //               Generate Analysis
// // // // // // // // //             </Button>
// // // // // // // // //           </Box>
// // // // // // // // //           <Divider />
// // // // // // // // //           {skillGapLoading ? (
// // // // // // // // //             <DialogSkeleton />
// // // // // // // // //           ) : (
// // // // // // // // //             skillGapData && (
// // // // // // // // //               <>
// // // // // // // // //                 <Tabs
// // // // // // // // //                   value={activeSkillGapTab}
// // // // // // // // //                   onChange={(e, val) => setActiveSkillGapTab(val)}
// // // // // // // // //                   centered
// // // // // // // // //                 >
// // // // // // // // //                   {Object.keys(skillGapData).map((role) => (
// // // // // // // // //                     <Tab key={role} label={role} />
// // // // // // // // //                   ))}
// // // // // // // // //                 </Tabs>
// // // // // // // // //                 {Object.entries(skillGapData).map(([role, data], index) => (
// // // // // // // // //                   <TabPanel value={activeSkillGapTab} index={index} key={role}>
// // // // // // // // //                     <Grid container spacing={2}>
// // // // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // // // //                         <Typography variant="h6" gutterBottom>
// // // // // // // // //                           Your Skills
// // // // // // // // //                         </Typography>
// // // // // // // // //                         <Paper
// // // // // // // // //                           variant="outlined"
// // // // // // // // //                           sx={{
// // // // // // // // //                             p: 2,
// // // // // // // // //                             display: "flex",
// // // // // // // // //                             flexWrap: "wrap",
// // // // // // // // //                             gap: 1,
// // // // // // // // //                           }}
// // // // // // // // //                         >
// // // // // // // // //                           <>
// // // // // // // // //                             {data.Current_Skill_Mapping.map((skill, i) => (
// // // // // // // // //                               <Chip key={i} label={skill} />
// // // // // // // // //                             ))}
// // // // // // // // //                           </>
// // // // // // // // //                         </Paper>
// // // // // // // // //                       </Grid>
// // // // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // // // //                         <Typography variant="h6" gutterBottom>
// // // // // // // // //                           In-Demand Market Skills
// // // // // // // // //                         </Typography>
// // // // // // // // //                         <Paper
// // // // // // // // //                           variant="outlined"
// // // // // // // // //                           sx={{
// // // // // // // // //                             p: 2,
// // // // // // // // //                             display: "flex",
// // // // // // // // //                             flexWrap: "wrap",
// // // // // // // // //                             gap: 1,
// // // // // // // // //                           }}
// // // // // // // // //                         >
// // // // // // // // //                           <>
// // // // // // // // //                             {data.Market_Demand_Analysis.map((skill, i) => (
// // // // // // // // //                               <Chip key={i} label={skill} color="primary" />
// // // // // // // // //                             ))}
// // // // // // // // //                           </>
// // // // // // // // //                         </Paper>
// // // // // // // // //                       </Grid>
// // // // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // // // //                             Recommended Learning Path
// // // // // // // // //                           </Typography>
// // // // // // // // //                           <List dense>
// // // // // // // // //                             {data.Learning_Path.map((path, i) => (
// // // // // // // // //                               <ListItem key={i}>
// // // // // // // // //                                 <ListItemIcon>
// // // // // // // // //                                   <School color="primary" />
// // // // // // // // //                                 </ListItemIcon>
// // // // // // // // //                                 <ListItemText primary={path} />
// // // // // // // // //                               </ListItem>
// // // // // // // // //                             ))}
// // // // // // // // //                           </List>
// // // // // // // // //                         </Paper>
// // // // // // // // //                       </Grid>
// // // // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // // // //                             Suggested Certifications
// // // // // // // // //                           </Typography>
// // // // // // // // //                           <List dense>
// // // // // // // // //                             {data.Certification_Guidance.map((cert, i) => (
// // // // // // // // //                               <ListItem key={i}>
// // // // // // // // //                                 <ListItemIcon>
// // // // // // // // //                                   <MilitaryTech color="success" />
// // // // // // // // //                                 </ListItemIcon>
// // // // // // // // //                                 <ListItemText primary={cert} />
// // // // // // // // //                               </ListItem>
// // // // // // // // //                             ))}
// // // // // // // // //                           </List>
// // // // // // // // //                         </Paper>
// // // // // // // // //                       </Grid>
// // // // // // // // //                     </Grid>
// // // // // // // // //                   </TabPanel>
// // // // // // // // //                 ))}
// // // // // // // // //               </>
// // // // // // // // //             )
// // // // // // // // //           )}
// // // // // // // // //         </DialogContent>
// // // // // // // // //         <DialogActions>
// // // // // // // // //           <Button onClick={() => setSkillGapDialog(false)}>Close</Button>
// // // // // // // // //         </DialogActions>
// // // // // // // // //       </Dialog>
// // // // // // // // //       <Dialog
// // // // // // // // //         open={careerRoadmapDialog}
// // // // // // // // //         onClose={() => setCareerRoadmapDialog(false)}
// // // // // // // // //         maxWidth="lg"
// // // // // // // // //         fullWidth
// // // // // // // // //       >
// // // // // // // // //         <DialogTitle
// // // // // // // // //           sx={{ bgcolor: "warning.main", color: "warning.contrastText" }}
// // // // // // // // //         >
// // // // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // // // //             <Timeline />
// // // // // // // // //             <Typography variant="h6">Personalized Career Roadmap</Typography>
// // // // // // // // //           </Stack>
// // // // // // // // //         </DialogTitle>
// // // // // // // // //         <DialogContent dividers>
// // // // // // // // //           <RoleSelector
// // // // // // // // //             selectedRoles={selectedRoadmapRoles}
// // // // // // // // //             handleRoleChange={(e) =>
// // // // // // // // //               setSelectedRoadmapRoles((prev) =>
// // // // // // // // //                 e.target.checked
// // // // // // // // //                   ? [...prev, e.target.name]
// // // // // // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // // // // // //               )
// // // // // // // // //             }
// // // // // // // // //           />
// // // // // // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // // // // // //             <Button
// // // // // // // // //               variant="contained"
// // // // // // // // //               color="warning"
// // // // // // // // //               onClick={() => fetchCareerRoadmap(selectedRoadmapRoles)}
// // // // // // // // //             >
// // // // // // // // //               Generate Roadmap
// // // // // // // // //             </Button>
// // // // // // // // //           </Box>
// // // // // // // // //           <Divider />
// // // // // // // // //           {careerRoadmapLoading ? (
// // // // // // // // //             <DialogSkeleton />
// // // // // // // // //           ) : (
// // // // // // // // //             careerRoadmapData && (
// // // // // // // // //               <>
// // // // // // // // //                 <Tabs
// // // // // // // // //                   value={activeRoadmapTab}
// // // // // // // // //                   onChange={(e, val) => setActiveRoadmapTab(val)}
// // // // // // // // //                   centered
// // // // // // // // //                 >
// // // // // // // // //                   {Object.keys(careerRoadmapData).map((role) => (
// // // // // // // // //                     <Tab key={role} label={role} />
// // // // // // // // //                   ))}
// // // // // // // // //                 </Tabs>
// // // // // // // // //                 {Object.entries(careerRoadmapData).map(
// // // // // // // // //                   ([role, data], index) => (
// // // // // // // // //                     <TabPanel value={activeRoadmapTab} index={index} key={role}>
// // // // // // // // //                       <Typography variant="h6" gutterBottom>
// // // // // // // // //                         Your AI-Generated Career Path for {role}
// // // // // // // // //                       </Typography>
// // // // // // // // //                       <Typography
// // // // // // // // //                         variant="body1"
// // // // // // // // //                         paragraph
// // // // // // // // //                         color="text.secondary"
// // // // // // // // //                       >
// // // // // // // // //                         Current Position: {data?.Current_Position || "N/A"} with{" "}
// // // // // // // // //                         {data?.Experience_Years || "N/A"} years of experience.
// // // // // // // // //                       </Typography>
// // // // // // // // //                       <Grid container spacing={2} sx={{ mt: 2 }}>
// // // // // // // // //                         <Grid item xs={12} md={6}>
// // // // // // // // //                           <Paper
// // // // // // // // //                             variant="outlined"
// // // // // // // // //                             sx={{ p: 2, height: "100%" }}
// // // // // // // // //                           >
// // // // // // // // //                             <Typography variant="overline" color="warning.main">
// // // // // // // // //                               Next Milestone
// // // // // // // // //                             </Typography>
// // // // // // // // //                             <Typography variant="h6" fontWeight="bold">
// // // // // // // // //                               {data?.Next_Milestone?.title || "Not available"}
// // // // // // // // //                             </Typography>
// // // // // // // // //                             <Chip
// // // // // // // // //                               size="small"
// // // // // // // // //                               label={`Company: ${
// // // // // // // // //                                 data?.Next_Milestone?.company_type || "N/A"
// // // // // // // // //                               }`}
// // // // // // // // //                               sx={{ mt: 1 }}
// // // // // // // // //                             />
// // // // // // // // //                           </Paper>
// // // // // // // // //                         </Grid>
// // // // // // // // //                         <Grid item xs={12} md={6}>
// // // // // // // // //                           <Paper
// // // // // // // // //                             variant="outlined"
// // // // // // // // //                             sx={{ p: 2, height: "100%" }}
// // // // // // // // //                           >
// // // // // // // // //                             <Typography variant="overline" color="success.main">
// // // // // // // // //                               Long-term Goal
// // // // // // // // //                             </Typography>
// // // // // // // // //                             <Typography variant="h6" fontWeight="bold">
// // // // // // // // //                               {data?.Long_Term_Goal?.title || "Not available"}
// // // // // // // // //                             </Typography>
// // // // // // // // //                             <Chip
// // // // // // // // //                               size="small"
// // // // // // // // //                               label={`Company: ${
// // // // // // // // //                                 data?.Long_Term_Goal?.company_type || "N/A"
// // // // // // // // //                               }`}
// // // // // // // // //                               sx={{ mt: 1 }}
// // // // // // // // //                             />
// // // // // // // // //                           </Paper>
// // // // // // // // //                         </Grid>
// // // // // // // // //                       </Grid>
// // // // // // // // //                       <Divider sx={{ my: 3 }}>
// // // // // // // // //                         <Chip label="Recommended Actions" />
// // // // // // // // //                       </Divider>
// // // // // // // // //                       <List>
// // // // // // // // //                         {data?.Recommended_Actions?.map((item, i) => (
// // // // // // // // //                           <ListItem key={i} alignItems="flex-start">
// // // // // // // // //                             <ListItemIcon>
// // // // // // // // //                               <Work color="primary" />
// // // // // // // // //                             </ListItemIcon>
// // // // // // // // //                             <ListItemText
// // // // // // // // //                               primary={item.action}
// // // // // // // // //                               secondary={item.reason}
// // // // // // // // //                             />
// // // // // // // // //                           </ListItem>
// // // // // // // // //                         )) || (
// // // // // // // // //                           <ListItem>
// // // // // // // // //                             <ListItemText primary="No actions recommended." />
// // // // // // // // //                           </ListItem>
// // // // // // // // //                         )}
// // // // // // // // //                       </List>
// // // // // // // // //                     </TabPanel>
// // // // // // // // //                   )
// // // // // // // // //                 )}
// // // // // // // // //               </>
// // // // // // // // //             )
// // // // // // // // //           )}
// // // // // // // // //         </DialogContent>
// // // // // // // // //         <DialogActions>
// // // // // // // // //           <Button onClick={() => setCareerRoadmapDialog(false)}>Close</Button>
// // // // // // // // //         </DialogActions>
// // // // // // // // //       </Dialog>
// // // // // // // // //       <Dialog
// // // // // // // // //         open={mockInterviewDialog}
// // // // // // // // //         onClose={() => setMockInterviewDialog(false)}
// // // // // // // // //         maxWidth="sm"
// // // // // // // // //         fullWidth
// // // // // // // // //       >
// // // // // // // // //         <DialogTitle
// // // // // // // // //           sx={{ bgcolor: "secondary.main", color: "secondary.contrastText" }}
// // // // // // // // //         >
// // // // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // // // //             <VideoCall />
// // // // // // // // //             <Typography variant="h6">Mock Interview Setup</Typography>
// // // // // // // // //           </Stack>
// // // // // // // // //         </DialogTitle>
// // // // // // // // //         <DialogContent sx={{ py: 3 }}>
// // // // // // // // //           <Typography variant="body1" gutterBottom>
// // // // // // // // //             Prepare for your AI-powered mock interview.
// // // // // // // // //           </Typography>
// // // // // // // // //           <Box
// // // // // // // // //             sx={{
// // // // // // // // //               mt: 3,
// // // // // // // // //               p: 3,
// // // // // // // // //               bgcolor: "background.paper",
// // // // // // // // //               borderRadius: 2,
// // // // // // // // //               border: "1px dashed",
// // // // // // // // //               borderColor: "divider",
// // // // // // // // //               textAlign: "center",
// // // // // // // // //             }}
// // // // // // // // //           >
// // // // // // // // //             <Typography variant="subtitle1" color="text.secondary">
// // // // // // // // //               Select interview type:
// // // // // // // // //             </Typography>
// // // // // // // // //             <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
// // // // // // // // //               <Button variant="outlined" fullWidth>
// // // // // // // // //                 Technical
// // // // // // // // //               </Button>
// // // // // // // // //               <Button variant="outlined" fullWidth>
// // // // // // // // //                 Behavioral
// // // // // // // // //               </Button>
// // // // // // // // //               <Button variant="outlined" fullWidth>
// // // // // // // // //                 Case Study
// // // // // // // // //               </Button>
// // // // // // // // //             </Stack>
// // // // // // // // //           </Box>
// // // // // // // // //         </DialogContent>
// // // // // // // // //         <DialogActions>
// // // // // // // // //           <Button onClick={() => setMockInterviewDialog(false)}>Cancel</Button>
// // // // // // // // //           <Button
// // // // // // // // //             variant="contained"
// // // // // // // // //             color="secondary"
// // // // // // // // //             onClick={() => navigate("/gatep/talent/mock-interview")}
// // // // // // // // //             startIcon={<VideoCall />}
// // // // // // // // //           >
// // // // // // // // //             Start Interview
// // // // // // // // //           </Button>
// // // // // // // // //         </DialogActions>
// // // // // // // // //       </Dialog>
// // // // // // // // //       <Dialog
// // // // // // // // //         open={culturalPrepDialog}
// // // // // // // // //         onClose={() => {
// // // // // // // // //           setCulturalPrepDialog(false);
// // // // // // // // //           setCulturalPrepTab(0);
// // // // // // // // //         }}
// // // // // // // // //         maxWidth="md"
// // // // // // // // //         fullWidth
// // // // // // // // //         PaperProps={{ sx: { height: { md: 650 } } }}
// // // // // // // // //       >
// // // // // // // // //         <DialogTitle
// // // // // // // // //           sx={{ bgcolor: "error.main", color: "error.contrastText" }}
// // // // // // // // //         >
// // // // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // // // //             <Psychology />
// // // // // // // // //             <Typography variant="h6">Cultural Preparation Insights</Typography>
// // // // // // // // //           </Stack>
// // // // // // // // //         </DialogTitle>
// // // // // // // // //         <DialogContent
// // // // // // // // //           dividers
// // // // // // // // //           sx={{ display: "flex", p: 0, overflow: "hidden" }}
// // // // // // // // //         >
// // // // // // // // //           {culturalPrepLoading ? (
// // // // // // // // //             <DialogSkeleton />
// // // // // // // // //           ) : (
// // // // // // // // //             culturalPrepData && (
// // // // // // // // //               <>
// // // // // // // // //                 <Tabs
// // // // // // // // //                   orientation="vertical"
// // // // // // // // //                   variant="scrollable"
// // // // // // // // //                   value={culturalPrepTab}
// // // // // // // // //                   onChange={(e, val) => setCulturalPrepTab(val)}
// // // // // // // // //                   sx={{ borderRight: 1, borderColor: "divider", minWidth: 150 }}
// // // // // // // // //                 >
// // // // // // // // //                   {Object.values(culturalPrepData).map((region, index) => (
// // // // // // // // //                     <Tab key={index} label={region.location_name} />
// // // // // // // // //                   ))}
// // // // // // // // //                 </Tabs>
// // // // // // // // //                 <Box sx={{ flex: 1, overflowY: "auto" }}>
// // // // // // // // //                   {Object.values(culturalPrepData).map((region, index) => (
// // // // // // // // //                     <TabPanel value={culturalPrepTab} index={index} key={index}>
// // // // // // // // //                       <Stack spacing={2}>
// // // // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // // //                           <Typography variant="h6">
// // // // // // // // //                             Cultural Insights
// // // // // // // // //                           </Typography>
// // // // // // // // //                           <List dense>
// // // // // // // // //                             {region.cultural_insights.map((insight, i) => (
// // // // // // // // //                               <ListItem key={i}>
// // // // // // // // //                                 <ListItemIcon>
// // // // // // // // //                                   <ArrowForward fontSize="small" />
// // // // // // // // //                                 </ListItemIcon>
// // // // // // // // //                                 <ListItemText primary={insight} />
// // // // // // // // //                               </ListItem>
// // // // // // // // //                             ))}
// // // // // // // // //                           </List>
// // // // // // // // //                         </Paper>
// // // // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // // //                           <Typography variant="h6">
// // // // // // // // //                             Communication Tips
// // // // // // // // //                           </Typography>
// // // // // // // // //                           <List dense>
// // // // // // // // //                             {region.communication_tips.map((tip, i) => (
// // // // // // // // //                               <ListItem key={i}>
// // // // // // // // //                                 <ListItemIcon>
// // // // // // // // //                                   <ArrowForward fontSize="small" />
// // // // // // // // //                                 </ListItemIcon>
// // // // // // // // //                                 <ListItemText primary={tip} />
// // // // // // // // //                               </ListItem>
// // // // // // // // //                             ))}
// // // // // // // // //                           </List>
// // // // // // // // //                         </Paper>
// // // // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // // //                           <Typography variant="h6">Work Etiquette</Typography>
// // // // // // // // //                           <List dense>
// // // // // // // // //                             {region.work_etiquette.map((tip, i) => (
// // // // // // // // //                               <ListItem key={i}>
// // // // // // // // //                                 <ListItemIcon>
// // // // // // // // //                                   <Stars fontSize="small" />
// // // // // // // // //                                 </ListItemIcon>
// // // // // // // // //                                 <ListItemText primary={tip} />
// // // // // // // // //                               </ListItem>
// // // // // // // // //                             ))}
// // // // // // // // //                           </List>
// // // // // // // // //                         </Paper>
// // // // // // // // //                       </Stack>
// // // // // // // // //                     </TabPanel>
// // // // // // // // //                   ))}
// // // // // // // // //                 </Box>
// // // // // // // // //               </>
// // // // // // // // //             )
// // // // // // // // //           )}
// // // // // // // // //         </DialogContent>
// // // // // // // // //         <DialogActions>
// // // // // // // // //           <Button onClick={() => setCulturalPrepDialog(false)}>Close</Button>
// // // // // // // // //         </DialogActions>
// // // // // // // // //       </Dialog>
// // // // // // // // //       <Dialog
// // // // // // // // //         open={salaryInsightsDialog}
// // // // // // // // //         onClose={() => setSalaryInsightsDialog(false)}
// // // // // // // // //         maxWidth="md"
// // // // // // // // //         fullWidth
// // // // // // // // //       >
// // // // // // // // //         <DialogTitle sx={{ bgcolor: "info.main", color: "info.contrastText" }}>
// // // // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // // // //             <Language />
// // // // // // // // //             <Typography variant="h6">Global Salary Insights</Typography>
// // // // // // // // //           </Stack>
// // // // // // // // //         </DialogTitle>
// // // // // // // // //         <DialogContent dividers>
// // // // // // // // //           {salaryInsightsLoading ? (
// // // // // // // // //             <DialogSkeleton />
// // // // // // // // //           ) : (
// // // // // // // // //             salaryInsightsData && (
// // // // // // // // //               <Stack spacing={3} sx={{ py: 2 }}>
// // // // // // // // //                 <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // // //                   <Stack
// // // // // // // // //                     direction="row"
// // // // // // // // //                     spacing={1.5}
// // // // // // // // //                     alignItems="center"
// // // // // // // // //                     mb={2}
// // // // // // // // //                   >
// // // // // // // // //                     <LocationOn color="info" />
// // // // // // // // //                     <Typography variant="h6">
// // // // // // // // //                       Salary Benchmarks by Location
// // // // // // // // //                     </Typography>
// // // // // // // // //                   </Stack>
// // // // // // // // //                   <Grid container spacing={2}>
// // // // // // // // //                     {salaryInsightsData.location_based.map((loc, i) => (
// // // // // // // // //                       <Grid item xs={12} sm={6} key={i}>
// // // // // // // // //                         <Paper sx={{ p: 2, bgcolor: "action.hover" }}>
// // // // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // // // //                             {loc.city} ({loc.role})
// // // // // // // // //                           </Typography>
// // // // // // // // //                           <Stack spacing={0.5}>
// // // // // // // // //                             <Typography variant="body2" color="text.secondary">
// // // // // // // // //                               Min: <strong>{loc.min_salary}</strong>
// // // // // // // // //                             </Typography>
// // // // // // // // //                             <Typography
// // // // // // // // //                               variant="body1"
// // // // // // // // //                               color="text.primary"
// // // // // // // // //                               fontWeight="bold"
// // // // // // // // //                             >
// // // // // // // // //                               Median: <strong>{loc.median_salary}</strong>
// // // // // // // // //                             </Typography>
// // // // // // // // //                             <Typography variant="body2" color="text.secondary">
// // // // // // // // //                               Max: <strong>{loc.max_salary}</strong>
// // // // // // // // //                             </Typography>
// // // // // // // // //                           </Stack>
// // // // // // // // //                         </Paper>
// // // // // // // // //                       </Grid>
// // // // // // // // //                     ))}
// // // // // // // // //                   </Grid>
// // // // // // // // //                 </Paper>
// // // // // // // // //                 <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // // //                   <Stack
// // // // // // // // //                     direction="row"
// // // // // // // // //                     spacing={1.5}
// // // // // // // // //                     alignItems="center"
// // // // // // // // //                     mb={1}
// // // // // // // // //                   >
// // // // // // // // //                     <TrendingUp color="primary" />
// // // // // // // // //                     <Typography variant="h6">
// // // // // // // // //                       Location Demand Impact on Salary
// // // // // // // // //                     </Typography>
// // // // // // // // //                   </Stack>
// // // // // // // // //                   <List dense>
// // // // // // // // //                     {salaryInsightsData.salary_insights_summary.map(
// // // // // // // // //                       (item, i) => (
// // // // // // // // //                         <ListItem key={i} disableGutters>
// // // // // // // // //                           <ListItemText
// // // // // // // // //                             primary={item.role}
// // // // // // // // //                             sx={{ flex: "0 0 40%" }}
// // // // // // // // //                           />
// // // // // // // // //                           <Box sx={{ width: "100%", mr: 1 }}>
// // // // // // // // //                             <LinearProgress
// // // // // // // // //                               variant="determinate"
// // // // // // // // //                               value={item.demand_in_salary_percent}
// // // // // // // // //                               color="primary"
// // // // // // // // //                             />
// // // // // // // // //                           </Box>
// // // // // // // // //                           <Box sx={{ minWidth: 35 }}>
// // // // // // // // //                             <Typography
// // // // // // // // //                               variant="body2"
// // // // // // // // //                               color="text.secondary"
// // // // // // // // //                             >{`${item.demand_in_salary_percent}%`}</Typography>
// // // // // // // // //                           </Box>
// // // // // // // // //                         </ListItem>
// // // // // // // // //                       )
// // // // // // // // //                     )}
// // // // // // // // //                   </List>
// // // // // // // // //                 </Paper>
// // // // // // // // //                 <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // // //                   <Stack
// // // // // // // // //                     direction="row"
// // // // // // // // //                     spacing={1.5}
// // // // // // // // //                     alignItems="center"
// // // // // // // // //                     mb={1}
// // // // // // // // //                   >
// // // // // // // // //                     <MonetizationOn color="success" />
// // // // // // // // //                     <Typography variant="h6">Negotiation Tips</Typography>
// // // // // // // // //                   </Stack>
// // // // // // // // //                   <List dense>
// // // // // // // // //                     {salaryInsightsData.negotiation_tips.map((tip, i) => (
// // // // // // // // //                       <ListItem key={i}>
// // // // // // // // //                         <ListItemIcon>
// // // // // // // // //                           <CheckCircle color="success" fontSize="small" />
// // // // // // // // //                         </ListItemIcon>
// // // // // // // // //                         <ListItemText primary={tip} />
// // // // // // // // //                       </ListItem>
// // // // // // // // //                     ))}
// // // // // // // // //                   </List>
// // // // // // // // //                 </Paper>
// // // // // // // // //                 <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // // //                   <Stack
// // // // // // // // //                     direction="row"
// // // // // // // // //                     spacing={1.5}
// // // // // // // // //                     alignItems="center"
// // // // // // // // //                     mb={1}
// // // // // // // // //                   >
// // // // // // // // //                     <Timeline color="warning" />
// // // // // // // // //                     <Typography variant="h6">Market Trends</Typography>
// // // // // // // // //                   </Stack>
// // // // // // // // //                   <List>
// // // // // // // // //                     {salaryInsightsData.market_trends.map((item, i) => (
// // // // // // // // //                       <ListItem key={i} alignItems="flex-start">
// // // // // // // // //                         <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
// // // // // // // // //                           <TrendingFlat color="warning" />
// // // // // // // // //                         </ListItemIcon>
// // // // // // // // //                         <ListItemText
// // // // // // // // //                           primary={item.trend}
// // // // // // // // //                           secondary={item.insight}
// // // // // // // // //                           primaryTypographyProps={{ fontWeight: 600 }}
// // // // // // // // //                         />
// // // // // // // // //                       </ListItem>
// // // // // // // // //                     ))}
// // // // // // // // //                   </List>
// // // // // // // // //                 </Paper>
// // // // // // // // //               </Stack>
// // // // // // // // //             )
// // // // // // // // //           )}
// // // // // // // // //         </DialogContent>
// // // // // // // // //         <DialogActions>
// // // // // // // // //           <Button onClick={() => setSalaryInsightsDialog(false)}>Close</Button>
// // // // // // // // //         </DialogActions>
// // // // // // // // //       </Dialog>
// // // // // // // // //     </Layout>
// // // // // // // // //   );
// // // // // // // // // };

// // // // // // // // // export default CareerAssistant;
// // // // // // // // import { useState, useEffect } from "react";
// // // // // // // // import {
// // // // // // // //   Grid,
// // // // // // // //   Card,
// // // // // // // //   CardContent,
// // // // // // // //   Container,
// // // // // // // //   Typography,
// // // // // // // //   Box,
// // // // // // // //   Button,
// // // // // // // //   Paper,
// // // // // // // //   Avatar,
// // // // // // // //   Chip,
// // // // // // // //   Dialog,
// // // // // // // //   DialogTitle,
// // // // // // // //   DialogContent,
// // // // // // // //   DialogActions,
// // // // // // // //   List,
// // // // // // // //   ListItem,
// // // // // // // //   ListItemIcon,
// // // // // // // //   ListItemText,
// // // // // // // //   Divider,
// // // // // // // //   Stack,
// // // // // // // //   LinearProgress,
// // // // // // // //   Skeleton,
// // // // // // // //   alpha,
// // // // // // // //   IconButton,
// // // // // // // //   Tabs,
// // // // // // // //   Tab,
// // // // // // // //   FormGroup,
// // // // // // // //   FormControlLabel,
// // // // // // // //   Checkbox,
// // // // // // // //   Alert,
// // // // // // // //   AlertTitle,
// // // // // // // // } from "@mui/material";
// // // // // // // // import { styled, useTheme } from "@mui/material/styles";
// // // // // // // // import {
// // // // // // // //   Psychology,
// // // // // // // //   TrendingUp,
// // // // // // // //   School,
// // // // // // // //   Work,
// // // // // // // //   Language,
// // // // // // // //   Assessment,
// // // // // // // //   VideoCall,
// // // // // // // //   Lightbulb,
// // // // // // // //   Timeline,
// // // // // // // //   CheckCircle,
// // // // // // // //   ErrorOutline,
// // // // // // // //   ArrowForward,
// // // // // // // //   MilitaryTech,
// // // // // // // //   Stars,
// // // // // // // //   RocketLaunch,
// // // // // // // //   TrendingDown,
// // // // // // // //   TrendingFlat,
// // // // // // // //   LocationOn,
// // // // // // // //   MonetizationOn,
// // // // // // // //   AutoAwesome,
// // // // // // // //   Close as CloseIcon, // For the dismissible alert
// // // // // // // //   Insights, // For the chart empty state
// // // // // // // // } from "@mui/icons-material";
// // // // // // // // import {
// // // // // // // //   BarChart,
// // // // // // // //   Bar,
// // // // // // // //   XAxis,
// // // // // // // //   YAxis,
// // // // // // // //   CartesianGrid,
// // // // // // // //   Tooltip,
// // // // // // // //   ResponsiveContainer,
// // // // // // // //   Cell,
// // // // // // // //   LabelList,
// // // // // // // // } from "recharts";
// // // // // // // // import Layout from "../common/Layout";
// // // // // // // // import { useNotification } from "../../context/NotificationContext";
// // // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // // import apiClient from "../../context/apiClient";

// // // // // // // // // --- Helper Components ---

// // // // // // // // const ServiceListItem = styled(Paper)(({ theme, color = "primary" }) => ({
// // // // // // // //   backgroundColor: theme.palette.background.paper, // Changed for better contrast within a Paper container
// // // // // // // //   display: "flex",
// // // // // // // //   flexDirection: "row",
// // // // // // // //   alignItems: "center",
// // // // // // // //   padding: theme.spacing(2),
// // // // // // // //   borderRadius: "12px",
// // // // // // // //   cursor: "pointer",
// // // // // // // //   transition:
// // // // // // // //     "background-color 0.3s ease, border-color 0.3s ease, transform 0.2s ease-in-out",
// // // // // // // //   border: `1px solid ${theme.palette.divider}`,
// // // // // // // //   "&:hover": {
// // // // // // // //     backgroundColor: alpha(
// // // // // // // //       theme.palette[color]?.main || theme.palette.primary.main,
// // // // // // // //       0.08
// // // // // // // //     ),
// // // // // // // //     borderColor: theme.palette[color]?.main || theme.palette.primary.main,
// // // // // // // //     transform: "scale(1.02)",
// // // // // // // //   },
// // // // // // // //   ".MuiAvatar-root": {
// // // // // // // //     backgroundColor: alpha(
// // // // // // // //       theme.palette[color]?.main || theme.palette.primary.main,
// // // // // // // //       0.15
// // // // // // // //     ),
// // // // // // // //     color: theme.palette[color]?.main || theme.palette.primary.main,
// // // // // // // //     marginRight: theme.spacing(2),
// // // // // // // //   },
// // // // // // // // }));

// // // // // // // // function TabPanel(props) {
// // // // // // // //   const { children, value, index, ...other } = props;
// // // // // // // //   return (
// // // // // // // //     <div
// // // // // // // //       role="tabpanel"
// // // // // // // //       hidden={value !== index}
// // // // // // // //       id={`tabpanel-${index}`}
// // // // // // // //       aria-labelledby={`tab-${index}`}
// // // // // // // //       {...other}
// // // // // // // //     >
// // // // // // // //       {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
// // // // // // // //     </div>
// // // // // // // //   );
// // // // // // // // }

// // // // // // // // // --- Main Component ---

// // // // // // // // const CareerAssistant = () => {
// // // // // // // //   const theme = useTheme();
// // // // // // // //   const { showNotification } = useNotification();
// // // // // // // //   const navigate = useNavigate();

// // // // // // // //   const availableRoles = [
// // // // // // // //     "AI/ML Engineer",
// // // // // // // //     "Data Scientist",
// // // // // // // //     "Business Analyst",
// // // // // // // //   ];

// // // // // // // //   // --- State Declarations ---
// // // // // // // //   const [showWelcomeCard, setShowWelcomeCard] = useState(true);
// // // // // // // //   const [mockInterviewDialog, setMockInterviewDialog] = useState(false);
// // // // // // // //   const [resumeReviewDialog, setResumeReviewDialog] = useState(false);
// // // // // // // //   const [skillGapDialog, setSkillGapDialog] = useState(false);
// // // // // // // //   const [careerRoadmapDialog, setCareerRoadmapDialog] = useState(false);
// // // // // // // //   const [culturalPrepDialog, setCulturalPrepDialog] = useState(false);
// // // // // // // //   const [salaryInsightsDialog, setSalaryInsightsDialog] = useState(false);
// // // // // // // //   const [trendingSkillsData, setTrendingSkillsData] = useState({});
// // // // // // // //   const [skillsLoading, setSkillsLoading] = useState(true);
// // // // // // // //   const [selectedTrendingRoles, setSelectedTrendingRoles] = useState([
// // // // // // // //     "AI/ML Engineer",
// // // // // // // //   ]);
// // // // // // // //   const [activeTrendingTab, setActiveTrendingTab] = useState(0);
// // // // // // // //   const [resumeReviewData, setResumeReviewData] = useState(null);
// // // // // // // //   const [resumeReviewLoading, setResumeReviewLoading] = useState(false);
// // // // // // // //   const [selectedResumeRoles, setSelectedResumeRoles] = useState([]);
// // // // // // // //   const [activeResumeTab, setActiveResumeTab] = useState(0);
// // // // // // // //   const [skillGapData, setSkillGapData] = useState(null);
// // // // // // // //   const [skillGapLoading, setSkillGapLoading] = useState(false);
// // // // // // // //   const [selectedSkillGapRoles, setSelectedSkillGapRoles] = useState([]);
// // // // // // // //   const [activeSkillGapTab, setActiveSkillGapTab] = useState(0);
// // // // // // // //   const [careerRoadmapData, setCareerRoadmapData] = useState(null);
// // // // // // // //   const [careerRoadmapLoading, setCareerRoadmapLoading] = useState(false);
// // // // // // // //   const [selectedRoadmapRoles, setSelectedRoadmapRoles] = useState([]);
// // // // // // // //   const [activeRoadmapTab, setActiveRoadmapTab] = useState(0);
// // // // // // // //   const [culturalPrepData, setCulturalPrepData] = useState(null);
// // // // // // // //   const [culturalPrepLoading, setCulturalPrepLoading] = useState(false);
// // // // // // // //   const [culturalPrepTab, setCulturalPrepTab] = useState(0);
// // // // // // // //   const [salaryInsightsData, setSalaryInsightsData] = useState(null);
// // // // // // // //   const [salaryInsightsLoading, setSalaryInsightsLoading] = useState(false);

// // // // // // // //   // --- Data Fetching Functions ---

// // // // // // // //   const fetchTrendingSkills = async (roles) => {
// // // // // // // //     if (!roles || roles.length === 0) {
// // // // // // // //       setTrendingSkillsData({});
// // // // // // // //       setSkillsLoading(false);
// // // // // // // //       return;
// // // // // // // //     }
// // // // // // // //     setSkillsLoading(true);
// // // // // // // //     try {
// // // // // // // //       const response = await apiClient.post("/trending-skills/", {
// // // // // // // //         selected_roles: roles,
// // // // // // // //       });
// // // // // // // //       const transformedData = {};
// // // // // // // //       for (const [role, skills] of Object.entries(response.data)) {
// // // // // // // //         transformedData[role] = skills.map((skill) => ({
// // // // // // // //           skill: skill.skill,
// // // // // // // //           demand: parseInt(skill.demand) || 0,
// // // // // // // //           growth: skill.increase || "N/A",
// // // // // // // //           priority: skill.priority,
// // // // // // // //         }));
// // // // // // // //       }
// // // // // // // //       setTrendingSkillsData(transformedData);
// // // // // // // //       setActiveTrendingTab(0);
// // // // // // // //     } catch (error) {
// // // // // // // //       console.error("Failed to fetch trending skills:", error);
// // // // // // // //       showNotification("Could not load trending skills data.", "error");
// // // // // // // //       setTrendingSkillsData({});
// // // // // // // //     } finally {
// // // // // // // //       setSkillsLoading(false);
// // // // // // // //     }
// // // // // // // //   };

// // // // // // // //   const fetchResumeReview = async (roles) => {
// // // // // // // //     if (!roles || roles.length === 0) {
// // // // // // // //       setResumeReviewData({});
// // // // // // // //       return;
// // // // // // // //     }
// // // // // // // //     setResumeReviewLoading(true);
// // // // // // // //     try {
// // // // // // // //       const response = await apiClient.post("/resume/review-talent/", {
// // // // // // // //         target_roles: roles,
// // // // // // // //       });
// // // // // // // //       setResumeReviewData(response.data);
// // // // // // // //       setActiveResumeTab(0);
// // // // // // // //     } catch (error) {
// // // // // // // //       showNotification("Failed to load resume review data.", "error");
// // // // // // // //     } finally {
// // // // // // // //       setResumeReviewLoading(false);
// // // // // // // //     }
// // // // // // // //   };
// // // // // // // //   const fetchSkillGap = async (roles) => {
// // // // // // // //     if (!roles || roles.length === 0) {
// // // // // // // //       setSkillGapData({});
// // // // // // // //       return;
// // // // // // // //     }
// // // // // // // //     setSkillGapLoading(true);
// // // // // // // //     try {
// // // // // // // //       const response = await apiClient.post("/resume/skill-gap/", {
// // // // // // // //         selected_roles: roles,
// // // // // // // //       });
// // // // // // // //       setSkillGapData(response.data);
// // // // // // // //       setActiveSkillGapTab(0);
// // // // // // // //     } catch (error) {
// // // // // // // //       showNotification("Failed to load skill gap analysis.", "error");
// // // // // // // //     } finally {
// // // // // // // //       setSkillGapLoading(false);
// // // // // // // //     }
// // // // // // // //   };
// // // // // // // //   const fetchCareerRoadmap = async (roles) => {
// // // // // // // //     if (!roles || roles.length === 0) {
// // // // // // // //       setCareerRoadmapData({});
// // // // // // // //       return;
// // // // // // // //     }
// // // // // // // //     setCareerRoadmapLoading(true);
// // // // // // // //     try {
// // // // // // // //       const response = await apiClient.post("/resume/career-roadmap/", {
// // // // // // // //         target_roles: roles,
// // // // // // // //       });
// // // // // // // //       setCareerRoadmapData(response.data);
// // // // // // // //       setActiveRoadmapTab(0);
// // // // // // // //     } catch (error) {
// // // // // // // //       showNotification("Failed to load career roadmap.", "error");
// // // // // // // //       setCareerRoadmapData({});
// // // // // // // //     } finally {
// // // // // // // //       setCareerRoadmapLoading(false);
// // // // // // // //     }
// // // // // // // //   };

// // // // // // // //   // --- Handlers ---
// // // // // // // //   const handleTrendingRoleChange = (event) => {
// // // // // // // //     const { name, checked } = event.target;
// // // // // // // //     setSelectedTrendingRoles((prev) =>
// // // // // // // //       checked ? [...prev, name] : prev.filter((role) => role !== name)
// // // // // // // //     );
// // // // // // // //   };

// // // // // // // //   // --- Child Components ---
// // // // // // // //   const RoleSelector = ({ selectedRoles, handleRoleChange }) => (
// // // // // // // //     <FormGroup row sx={{ mb: 2, justifyContent: "center", flexWrap: "wrap" }}>
// // // // // // // //       {availableRoles.map((role) => (
// // // // // // // //         <FormControlLabel
// // // // // // // //           key={role}
// // // // // // // //           control={
// // // // // // // //             <Checkbox
// // // // // // // //               checked={selectedRoles.includes(role)}
// // // // // // // //               onChange={handleRoleChange}
// // // // // // // //               name={role}
// // // // // // // //             />
// // // // // // // //           }
// // // // // // // //           label={role}
// // // // // // // //         />
// // // // // // // //       ))}
// // // // // // // //     </FormGroup>
// // // // // // // //   );

// // // // // // // //   const CustomTooltip = ({ active, payload, label }) => {
// // // // // // // //     if (active && payload && payload.length) {
// // // // // // // //       const data = payload[0].payload;
// // // // // // // //       const priorityMuiColor = {
// // // // // // // //         High: "primary",
// // // // // // // //         Medium: "info",
// // // // // // // //       };
// // // // // // // //       return (
// // // // // // // //         <Paper
// // // // // // // //           elevation={3}
// // // // // // // //           sx={{
// // // // // // // //             p: 1.5,
// // // // // // // //             minWidth: 220,
// // // // // // // //             bgcolor: "background.paper",
// // // // // // // //             border: `1px solid ${theme.palette.divider}`,
// // // // // // // //             borderRadius: 2,
// // // // // // // //           }}
// // // // // // // //         >
// // // // // // // //           <Typography variant="body1" fontWeight="bold" gutterBottom>
// // // // // // // //             {label}
// // // // // // // //           </Typography>
// // // // // // // //           <Stack spacing={1}>
// // // // // // // //             <Stack
// // // // // // // //               direction="row"
// // // // // // // //               justifyContent="space-between"
// // // // // // // //               alignItems="center"
// // // // // // // //             >
// // // // // // // //               <Typography variant="body2" color="text.secondary">
// // // // // // // //                 Demand:
// // // // // // // //               </Typography>
// // // // // // // //               <Typography
// // // // // // // //                 variant="body2"
// // // // // // // //                 fontWeight="bold"
// // // // // // // //               >{`${data.demand}%`}</Typography>
// // // // // // // //             </Stack>
// // // // // // // //             <Stack
// // // // // // // //               direction="row"
// // // // // // // //               justifyContent="space-between"
// // // // // // // //               alignItems="center"
// // // // // // // //             >
// // // // // // // //               <Typography variant="body2" color="text.secondary">
// // // // // // // //                 Priority:
// // // // // // // //               </Typography>
// // // // // // // //               <Chip
// // // // // // // //                 label={data.priority}
// // // // // // // //                 size="small"
// // // // // // // //                 color={priorityMuiColor[data.priority] || "default"}
// // // // // // // //                 sx={{ fontWeight: 600 }}
// // // // // // // //               />
// // // // // // // //             </Stack>
// // // // // // // //             <Stack
// // // // // // // //               direction="row"
// // // // // // // //               justifyContent="space-between"
// // // // // // // //               alignItems="center"
// // // // // // // //             >
// // // // // // // //               <Typography variant="body2" color="text.secondary">
// // // // // // // //                 Growth:
// // // // // // // //               </Typography>
// // // // // // // //               <Typography
// // // // // // // //                 variant="body2"
// // // // // // // //                 fontWeight="bold"
// // // // // // // //                 color={
// // // // // // // //                   (data.growth || "").startsWith("+")
// // // // // // // //                     ? "success.main"
// // // // // // // //                     : "error.main"
// // // // // // // //                 }
// // // // // // // //               >
// // // // // // // //                 {data.growth}
// // // // // // // //               </Typography>
// // // // // // // //             </Stack>
// // // // // // // //           </Stack>
// // // // // // // //         </Paper>
// // // // // // // //       );
// // // // // // // //     }
// // // // // // // //     return null;
// // // // // // // //   };

// // // // // // // //   const RoundedVerticalBar = (props) => {
// // // // // // // //     const { fill, x, y, width, height } = props;
// // // // // // // //     const radius = 8;
// // // // // // // //     if (height <= 0) return null;
// // // // // // // //     return (
// // // // // // // //       <g>
// // // // // // // //         <path
// // // // // // // //           d={`M${x},${y + radius} A${radius},${radius} 0 0 1 ${
// // // // // // // //             x + radius
// // // // // // // //           },${y} L${x + width - radius},${y} A${radius},${radius} 0 0 1 ${
// // // // // // // //             x + width
// // // // // // // //           },${y + radius} L${x + width},${y + height} L${x},${y + height} Z`}
// // // // // // // //           fill={fill}
// // // // // // // //         />
// // // // // // // //       </g>
// // // // // // // //     );
// // // // // // // //   };

// // // // // // // //   const assistantServices = [
// // // // // // // //     {
// // // // // // // //       id: "resume-review",
// // // // // // // //       title: "AI Resume Review",
// // // // // // // //       description: "Get detailed feedback & ATS optimization suggestions.",
// // // // // // // //       icon: <Assessment />,
// // // // // // // //       color: "primary",
// // // // // // // //     },
// // // // // // // //     {
// // // // // // // //       id: "skill-assessment",
// // // // // // // //       title: "Skill Gap Analysis",
// // // // // // // //       description: "Identify critical skill gaps for your target roles.",
// // // // // // // //       icon: <TrendingUp />,
// // // // // // // //       color: "success",
// // // // // // // //     },
// // // // // // // //     {
// // // // // // // //       id: "career-roadmap",
// // // // // // // //       title: "Career Roadmap",
// // // // // // // //       description: "AI-generated path based on your profile and goals.",
// // // // // // // //       icon: <Timeline />,
// // // // // // // //       color: "warning",
// // // // // // // //     },
// // // // // // // //     {
// // // // // // // //       id: "salary-insights",
// // // // // // // //       title: "Salary Insights",
// // // // // // // //       description: "Real-time salary benchmarks for roles and locations.",
// // // // // // // //       icon: <Language />,
// // // // // // // //       color: "info",
// // // // // // // //     },
// // // // // // // //     {
// // // // // // // //       id: "cultural-prep",
// // // // // // // //       title: "Cultural Preparation",
// // // // // // // //       description: "Master workplace culture for different countries.",
// // // // // // // //       icon: <Psychology />,
// // // // // // // //       color: "error",
// // // // // // // //     },
// // // // // // // //   ];

// // // // // // // //   const handleServiceClick = async (service) => {
// // // // // // // //     const defaultRolePayload = ["AI/ML Engineer"];
// // // // // // // //     switch (service.id) {
// // // // // // // //       case "resume-review":
// // // // // // // //         setResumeReviewDialog(true);
// // // // // // // //         setSelectedResumeRoles(defaultRolePayload);
// // // // // // // //         await fetchResumeReview(defaultRolePayload);
// // // // // // // //         break;
// // // // // // // //       case "mock-interview":
// // // // // // // //         setMockInterviewDialog(true);
// // // // // // // //         break;
// // // // // // // //       case "skill-assessment":
// // // // // // // //         setSkillGapDialog(true);
// // // // // // // //         setSelectedSkillGapRoles(defaultRolePayload);
// // // // // // // //         await fetchSkillGap(defaultRolePayload);
// // // // // // // //         break;
// // // // // // // //       case "career-roadmap":
// // // // // // // //         setCareerRoadmapDialog(true);
// // // // // // // //         setSelectedRoadmapRoles(defaultRolePayload);
// // // // // // // //         await fetchCareerRoadmap(defaultRolePayload);
// // // // // // // //         break;
// // // // // // // //       case "cultural-prep":
// // // // // // // //         setCulturalPrepDialog(true);
// // // // // // // //         if (!culturalPrepData) {
// // // // // // // //           setCulturalPrepLoading(true);
// // // // // // // //           try {
// // // // // // // //             const res = await apiClient.get("/ai/cultural-preparation/");
// // // // // // // //             const validData = Object.fromEntries(
// // // // // // // //               Object.entries(res.data.cultural_preparation).filter(
// // // // // // // //                 ([, value]) => !value.error_message
// // // // // // // //               )
// // // // // // // //             );
// // // // // // // //             setCulturalPrepData(validData);
// // // // // // // //           } catch (err) {
// // // // // // // //             showNotification("Failed to load cultural prep data.", "error");
// // // // // // // //           } finally {
// // // // // // // //             setCulturalPrepLoading(false);
// // // // // // // //           }
// // // // // // // //         }
// // // // // // // //         break;
// // // // // // // //       case "salary-insights":
// // // // // // // //         setSalaryInsightsDialog(true);
// // // // // // // //         if (!salaryInsightsData) {
// // // // // // // //           setSalaryInsightsLoading(true);
// // // // // // // //           try {
// // // // // // // //             const res = await apiClient.get("/ai/salary-insights/");
// // // // // // // //             setSalaryInsightsData(res.data.salary_insights);
// // // // // // // //           } catch (err) {
// // // // // // // //             showNotification("Failed to load salary insights data.", "error");
// // // // // // // //           } finally {
// // // // // // // //             setSalaryInsightsLoading(false);
// // // // // // // //           }
// // // // // // // //         }
// // // // // // // //         break;
// // // // // // // //       default:
// // // // // // // //         showNotification(`${service.title} feature coming soon!`, "info");
// // // // // // // //     }
// // // // // // // //   };

// // // // // // // //   const DialogSkeleton = () => (
// // // // // // // //     <Stack spacing={3} sx={{ p: 2, minHeight: 400 }}>
// // // // // // // //       <Skeleton variant="rounded" width="60%" height={40} />
// // // // // // // //       <Skeleton variant="rounded" width="100%" height={100} />
// // // // // // // //       <Skeleton variant="rounded" width="40%" height={30} />
// // // // // // // //       <Skeleton variant="rounded" width="100%" height={150} />
// // // // // // // //     </Stack>
// // // // // // // //   );

// // // // // // // //   // Initial data fetch on component mount
// // // // // // // //   useEffect(() => {
// // // // // // // //     fetchTrendingSkills(selectedTrendingRoles);
// // // // // // // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // // // // // // //   }, []);

// // // // // // // //   // Debounced effect to fetch trending skills when roles change
// // // // // // // //   useEffect(() => {
// // // // // // // //     const handler = setTimeout(() => {
// // // // // // // //       fetchTrendingSkills(selectedTrendingRoles);
// // // // // // // //     }, 500); // 500ms delay

// // // // // // // //     return () => {
// // // // // // // //       clearTimeout(handler);
// // // // // // // //     };
// // // // // // // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // // // // // // //   }, [selectedTrendingRoles]);

// // // // // // // //   return (
// // // // // // // //     <Layout title="AI Career Assistant">
// // // // // // // //       <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// // // // // // // //         <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
// // // // // // // //           <Stack spacing={4}>
// // // // // // // //             {/* ROW 1: Header Banner */}
// // // // // // // //             <Paper
// // // // // // // //               sx={{
// // // // // // // //                 bgcolor: "mint.main",
// // // // // // // //                 borderRadius: 3,
// // // // // // // //                 p: { xs: 2, sm: 3 },
// // // // // // // //               }}
// // // // // // // //             >
// // // // // // // //               <Stack direction="row" alignItems="center" spacing={2}>
// // // // // // // //                 <Avatar
// // // // // // // //                   sx={{
// // // // // // // //                     bgcolor: "primary.main",
// // // // // // // //                     color: "primary.contrastText",
// // // // // // // //                     width: { xs: 50, sm: 64 },
// // // // // // // //                     height: { xs: 50, sm: 64 },
// // // // // // // //                   }}
// // // // // // // //                 >
// // // // // // // //                   <Psychology sx={{ fontSize: { xs: 28, sm: 36 } }} />
// // // // // // // //                 </Avatar>
// // // // // // // //                 <Box>
// // // // // // // //                   <Typography
// // // // // // // //                     variant="h4"
// // // // // // // //                     component="h1"
// // // // // // // //                     fontWeight="bold"
// // // // // // // //                     sx={{ typography: { xs: "h5", sm: "h4" } }}
// // // // // // // //                   >
// // // // // // // //                     AI Career Assistant
// // // // // // // //                     <AutoAwesome
// // // // // // // //                       sx={{
// // // // // // // //                         fontSize: { xs: 22, sm: 28 },
// // // // // // // //                         ml: 1,
// // // // // // // //                         verticalAlign: "middle",
// // // // // // // //                         color: "primary.main",
// // // // // // // //                       }}
// // // // // // // //                     />
// // // // // // // //                   </Typography>
// // // // // // // //                   <Typography variant="body1" color="text.secondary">
// // // // // // // //                     Your intelligent, multilingual guide to global careers.
// // // // // // // //                   </Typography>
// // // // // // // //                 </Box>
// // // // // // // //               </Stack>
// // // // // // // //             </Paper>

// // // // // // // //             {/* ROW 2: Welcome Alert */}
// // // // // // // //             {showWelcomeCard && (
// // // // // // // //               <Alert
// // // // // // // //                 severity="info"
// // // // // // // //                 variant="filled"
// // // // // // // //                 onClose={() => setShowWelcomeCard(false)}
// // // // // // // //                 action={
// // // // // // // //                   <Button
// // // // // // // //                     color="inherit"
// // // // // // // //                     size="small"
// // // // // // // //                     onClick={() => {
// // // // // // // //                       handleServiceClick(assistantServices[0]);
// // // // // // // //                       setShowWelcomeCard(false);
// // // // // // // //                     }}
// // // // // // // //                   >
// // // // // // // //                     Start Review
// // // // // // // //                   </Button>
// // // // // // // //                 }
// // // // // // // //                 sx={{
// // // // // // // //                   bgcolor: "primary.dark",
// // // // // // // //                   color: "primary.contrastText",
// // // // // // // //                   borderRadius: 2,
// // // // // // // //                 }}
// // // // // // // //               >
// // // // // // // //                 <AlertTitle sx={{ fontWeight: "bold" }}>Welcome!</AlertTitle>
// // // // // // // //                 New here? Start with an AI Resume Review to get personalized
// // // // // // // //                 feedback and unlock other insights.
// // // // // // // //               </Alert>
// // // // // // // //             )}

// // // // // // // //             {/* ROW 3: Services List */}
// // // // // // // //             <Paper
// // // // // // // //               sx={{
// // // // // // // //                 p: { xs: 2, sm: 3 },
// // // // // // // //                 borderRadius: 3,
// // // // // // // //                 bgcolor: "mint.main",
// // // // // // // //               }}
// // // // // // // //             >
// // // // // // // //               <Stack direction="row" alignItems="center" spacing={1} mb={3}>
// // // // // // // //                 <Typography variant="h5" component="h2" fontWeight={600}>
// // // // // // // //                   AI-Powered Career Services
// // // // // // // //                 </Typography>
// // // // // // // //                 <RocketLaunch color="primary" />
// // // // // // // //               </Stack>
// // // // // // // //               {/* --- CHANGE IS HERE: Replaced Grid with Stack for a vertical list --- */}
// // // // // // // //               <Stack spacing={2}>
// // // // // // // //                 {assistantServices.map((service) => (
// // // // // // // //                   <ServiceListItem
// // // // // // // //                     key={service.id}
// // // // // // // //                     color={service.color}
// // // // // // // //                     onClick={() => handleServiceClick(service)}
// // // // // // // //                   >
// // // // // // // //                     <Avatar sx={{ width: 48, height: 48 }}>
// // // // // // // //                       {service.icon}
// // // // // // // //                     </Avatar>
// // // // // // // //                     <Box flexGrow={1}>
// // // // // // // //                       <Typography
// // // // // // // //                         variant="h6"
// // // // // // // //                         component="div"
// // // // // // // //                         fontWeight="bold"
// // // // // // // //                       >
// // // // // // // //                         {service.title}
// // // // // // // //                       </Typography>
// // // // // // // //                       <Typography variant="body2" color="text.secondary">
// // // // // // // //                         {service.description}
// // // // // // // //                       </Typography>
// // // // // // // //                     </Box>
// // // // // // // //                     <IconButton sx={{ ml: 2 }}>
// // // // // // // //                       <ArrowForward />
// // // // // // // //                     </IconButton>
// // // // // // // //                   </ServiceListItem>
// // // // // // // //                 ))}
// // // // // // // //               </Stack>
// // // // // // // //             </Paper>

// // // // // // // //             {/* ROW 4: Trending Skills */}
// // // // // // // //             <Paper
// // // // // // // //               sx={{
// // // // // // // //                 p: { xs: 2, sm: 3 },
// // // // // // // //                 borderRadius: 3,
// // // // // // // //                 bgcolor: "mint.main",
// // // // // // // //               }}
// // // // // // // //             >
// // // // // // // //               <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
// // // // // // // //                 <Lightbulb color="primary" />
// // // // // // // //                 <Typography variant="h6" fontWeight={600}>
// // // // // // // //                   Top In-Demand Skills
// // // // // // // //                 </Typography>
// // // // // // // //               </Stack>
// // // // // // // //               <RoleSelector
// // // // // // // //                 selectedRoles={selectedTrendingRoles}
// // // // // // // //                 handleRoleChange={handleTrendingRoleChange}
// // // // // // // //               />
// // // // // // // //               {skillsLoading ? (
// // // // // // // //                 <DialogSkeleton />
// // // // // // // //               ) : Object.keys(trendingSkillsData).length > 0 ? (
// // // // // // // //                 <Box>
// // // // // // // //                   <Tabs
// // // // // // // //                     value={activeTrendingTab}
// // // // // // // //                     onChange={(e, val) => setActiveTrendingTab(val)}
// // // // // // // //                     variant="scrollable"
// // // // // // // //                     scrollButtons="auto"
// // // // // // // //                   >
// // // // // // // //                     {Object.keys(trendingSkillsData).map((role) => (
// // // // // // // //                       <Tab label={role} key={role} />
// // // // // // // //                     ))}
// // // // // // // //                   </Tabs>
// // // // // // // //                   {Object.entries(trendingSkillsData).map(
// // // // // // // //                     ([role, skills], index) => {
// // // // // // // //                       const sortedSkills = [...skills].sort(
// // // // // // // //                         (a, b) => b.demand - a.demand
// // // // // // // //                       );
// // // // // // // //                       const priorityColors = {
// // // // // // // //                         High: theme.palette.primary.main,
// // // // // // // //                         Medium: theme.palette.info.main,
// // // // // // // //                       };

// // // // // // // //                       return (
// // // // // // // //                         <TabPanel
// // // // // // // //                           value={activeTrendingTab}
// // // // // // // //                           index={index}
// // // // // // // //                           key={role}
// // // // // // // //                         >
// // // // // // // //                           <Paper
// // // // // // // //                             elevation={0}
// // // // // // // //                             sx={{
// // // // // // // //                               bgcolor: "background.paper",
// // // // // // // //                               borderRadius: 2,
// // // // // // // //                               p: { xs: 1, sm: 2 },
// // // // // // // //                             }}
// // // // // // // //                           >
// // // // // // // //                             <Box
// // // // // // // //                               sx={{
// // // // // // // //                                 height: { xs: 400, md: 500 },
// // // // // // // //                                 width: "100%",
// // // // // // // //                               }}
// // // // // // // //                             >
// // // // // // // //                               <ResponsiveContainer width="100%" height="100%">
// // // // // // // //                                 <BarChart
// // // // // // // //                                   data={sortedSkills}
// // // // // // // //                                   margin={{
// // // // // // // //                                     top: 30,
// // // // // // // //                                     right: 30,
// // // // // // // //                                     left: 20,
// // // // // // // //                                     bottom: 120,
// // // // // // // //                                   }}
// // // // // // // //                                 >
// // // // // // // //                                   <CartesianGrid
// // // // // // // //                                     vertical={false}
// // // // // // // //                                     stroke={theme.palette.divider}
// // // // // // // //                                     strokeDasharray="3 3"
// // // // // // // //                                   />
// // // // // // // //                                   <XAxis
// // // // // // // //                                     dataKey="skill"
// // // // // // // //                                     type="category"
// // // // // // // //                                     interval={0}
// // // // // // // //                                     angle={-45}
// // // // // // // //                                     textAnchor="end"
// // // // // // // //                                     tick={{
// // // // // // // //                                       fill: theme.palette.text.secondary,
// // // // // // // //                                       fontSize: 12,
// // // // // // // //                                     }}
// // // // // // // //                                     stroke={"transparent"}
// // // // // // // //                                   />
// // // // // // // //                                   <YAxis
// // // // // // // //                                     type="number"
// // // // // // // //                                     domain={[0, "dataMax + 15"]}
// // // // // // // //                                     allowDecimals={false}
// // // // // // // //                                     tickFormatter={(tick) => `${tick}%`}
// // // // // // // //                                     stroke={theme.palette.divider}
// // // // // // // //                                     tick={{
// // // // // // // //                                       fill: theme.palette.text.secondary,
// // // // // // // //                                     }}
// // // // // // // //                                   />
// // // // // // // //                                   <Tooltip
// // // // // // // //                                     content={<CustomTooltip />}
// // // // // // // //                                     cursor={{
// // // // // // // //                                       fill: alpha(
// // // // // // // //                                         theme.palette.primary.main,
// // // // // // // //                                         0.1
// // // // // // // //                                       ),
// // // // // // // //                                     }}
// // // // // // // //                                   />
// // // // // // // //                                   <Bar
// // // // // // // //                                     dataKey="demand"
// // // // // // // //                                     shape={<RoundedVerticalBar />}
// // // // // // // //                                     animationDuration={800}
// // // // // // // //                                   >
// // // // // // // //                                     {sortedSkills.map((entry, idx) => (
// // // // // // // //                                       <Cell
// // // // // // // //                                         key={`cell-${idx}`}
// // // // // // // //                                         fill={
// // // // // // // //                                           priorityColors[entry.priority] ||
// // // // // // // //                                           theme.palette.text.disabled
// // // // // // // //                                         }
// // // // // // // //                                       />
// // // // // // // //                                     ))}
// // // // // // // //                                     <LabelList
// // // // // // // //                                       dataKey="demand"
// // // // // // // //                                       position="top"
// // // // // // // //                                       offset={8}
// // // // // // // //                                       style={{
// // // // // // // //                                         fill: theme.palette.text.primary,
// // // // // // // //                                         fontSize: "12px",
// // // // // // // //                                         fontWeight: "bold",
// // // // // // // //                                       }}
// // // // // // // //                                       formatter={(value) => `${value}%`}
// // // // // // // //                                     />
// // // // // // // //                                   </Bar>
// // // // // // // //                                 </BarChart>
// // // // // // // //                               </ResponsiveContainer>
// // // // // // // //                             </Box>
// // // // // // // //                           </Paper>
// // // // // // // //                         </TabPanel>
// // // // // // // //                       );
// // // // // // // //                     }
// // // // // // // //                   )}
// // // // // // // //                 </Box>
// // // // // // // //               ) : (
// // // // // // // //                 <Box
// // // // // // // //                   sx={{
// // // // // // // //                     display: "flex",
// // // // // // // //                     flexDirection: "column",
// // // // // // // //                     alignItems: "center",
// // // // // // // //                     justifyContent: "center",
// // // // // // // //                     textAlign: "center",
// // // // // // // //                     py: 8,
// // // // // // // //                     minHeight: 400,
// // // // // // // //                   }}
// // // // // // // //                 >
// // // // // // // //                   <Insights
// // // // // // // //                     sx={{ fontSize: 60, color: "text.disabled", mb: 2 }}
// // // // // // // //                   />
// // // // // // // //                   <Typography variant="h6" color="text.secondary">
// // // // // // // //                     Select a role to view in-demand skills
// // // // // // // //                   </Typography>
// // // // // // // //                   <Typography variant="body2" color="text.disabled">
// // // // // // // //                     The chart will update automatically as you make selections.
// // // // // // // //                   </Typography>
// // // // // // // //                 </Box>
// // // // // // // //               )}
// // // // // // // //             </Paper>
// // // // // // // //           </Stack>
// // // // // // // //         </Container>
// // // // // // // //       </Box>

// // // // // // // //       {/* --- DIALOGS (No layout changes needed below this line) --- */}
// // // // // // // //       <Dialog
// // // // // // // //         open={resumeReviewDialog}
// // // // // // // //         onClose={() => setResumeReviewDialog(false)}
// // // // // // // //         maxWidth="lg"
// // // // // // // //         fullWidth
// // // // // // // //       >
// // // // // // // //         <DialogTitle
// // // // // // // //           sx={{ bgcolor: "primary.main", color: "primary.contrastText" }}
// // // // // // // //         >
// // // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // // //             <Assessment />{" "}
// // // // // // // //             <Typography variant="h6">AI Resume Review</Typography>
// // // // // // // //           </Stack>
// // // // // // // //         </DialogTitle>
// // // // // // // //         <DialogContent dividers>
// // // // // // // //           <RoleSelector
// // // // // // // //             selectedRoles={selectedResumeRoles}
// // // // // // // //             handleRoleChange={(e) =>
// // // // // // // //               setSelectedResumeRoles((prev) =>
// // // // // // // //                 e.target.checked
// // // // // // // //                   ? [...prev, e.target.name]
// // // // // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // // // // //               )
// // // // // // // //             }
// // // // // // // //           />
// // // // // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // // // // //             <Button
// // // // // // // //               variant="contained"
// // // // // // // //               onClick={() => fetchResumeReview(selectedResumeRoles)}
// // // // // // // //             >
// // // // // // // //               Generate Report
// // // // // // // //             </Button>
// // // // // // // //           </Box>
// // // // // // // //           <Divider />
// // // // // // // //           {resumeReviewLoading ? (
// // // // // // // //             <DialogSkeleton />
// // // // // // // //           ) : (
// // // // // // // //             resumeReviewData && (
// // // // // // // //               <>
// // // // // // // //                 <Tabs
// // // // // // // //                   value={activeResumeTab}
// // // // // // // //                   onChange={(e, val) => setActiveResumeTab(val)}
// // // // // // // //                   centered
// // // // // // // //                   variant="scrollable"
// // // // // // // //                   scrollButtons="auto"
// // // // // // // //                 >
// // // // // // // //                   {Object.keys(resumeReviewData).map((role) => (
// // // // // // // //                     <Tab key={role} label={role} />
// // // // // // // //                   ))}
// // // // // // // //                 </Tabs>
// // // // // // // //                 {Object.entries(resumeReviewData).map(([role, data], index) => (
// // // // // // // //                   <TabPanel value={activeResumeTab} index={index} key={role}>
// // // // // // // //                     <Grid container spacing={3}>
// // // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // // //                         <Paper variant="outlined" sx={{ p: 2, height: "100%" }}>
// // // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // // //                             ATS Compatibility: {data.ATS_Compatibility.score}
// // // // // // // //                             /100
// // // // // // // //                           </Typography>
// // // // // // // //                           <LinearProgress
// // // // // // // //                             variant="determinate"
// // // // // // // //                             value={data.ATS_Compatibility.score}
// // // // // // // //                           />
// // // // // // // //                           <Typography
// // // // // // // //                             variant="subtitle2"
// // // // // // // //                             color="error.main"
// // // // // // // //                             sx={{ mt: 2 }}
// // // // // // // //                           >
// // // // // // // //                             Top Issues:
// // // // // // // //                           </Typography>
// // // // // // // //                           <List dense>
// // // // // // // //                             {data.ATS_Compatibility.top_issues.map(
// // // // // // // //                               (issue, i) => (
// // // // // // // //                                 <ListItem key={i}>
// // // // // // // //                                   <ListItemIcon>
// // // // // // // //                                     <ErrorOutline
// // // // // // // //                                       fontSize="small"
// // // // // // // //                                       color="error"
// // // // // // // //                                     />
// // // // // // // //                                   </ListItemIcon>
// // // // // // // //                                   <ListItemText primary={issue} />
// // // // // // // //                                 </ListItem>
// // // // // // // //                               )
// // // // // // // //                             )}
// // // // // // // //                           </List>
// // // // // // // //                         </Paper>
// // // // // // // //                       </Grid>
// // // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // // //                         <Paper variant="outlined" sx={{ p: 2, height: "100%" }}>
// // // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // // //                             Content & Format
// // // // // // // //                           </Typography>
// // // // // // // //                           <Typography variant="body2" paragraph>
// // // // // // // //                             {data.Content_Quality_Analysis.summary}
// // // // // // // //                           </Typography>
// // // // // // // //                           <Typography variant="subtitle2" color="success.main">
// // // // // // // //                             Top Strengths:
// // // // // // // //                           </Typography>
// // // // // // // //                           <List dense>
// // // // // // // //                             {data.Content_Quality_Analysis.top_strengths.map(
// // // // // // // //                               (strength, i) => (
// // // // // // // //                                 <ListItem key={i}>
// // // // // // // //                                   <ListItemIcon>
// // // // // // // //                                     <CheckCircle
// // // // // // // //                                       fontSize="small"
// // // // // // // //                                       color="success"
// // // // // // // //                                     />
// // // // // // // //                                   </ListItemIcon>
// // // // // // // //                                   <ListItemText primary={strength} />
// // // // // // // //                                 </ListItem>
// // // // // // // //                               )
// // // // // // // //                             )}
// // // // // // // //                           </List>
// // // // // // // //                         </Paper>
// // // // // // // //                       </Grid>
// // // // // // // //                       <Grid item xs={12}>
// // // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // // //                             Keyword & Section Optimization
// // // // // // // //                           </Typography>
// // // // // // // //                           <Stack
// // // // // // // //                             direction={{ xs: "column", sm: "row" }}
// // // // // // // //                             spacing={2}
// // // // // // // //                             divider={
// // // // // // // //                               <Divider orientation="vertical" flexItem />
// // // // // // // //                             }
// // // // // // // //                           >
// // // // // // // //                             <Box flex={1}>
// // // // // // // //                               <Typography variant="subtitle1" fontWeight="bold">
// // // // // // // //                                 Missing Keywords
// // // // // // // //                               </Typography>
// // // // // // // //                               <Box
// // // // // // // //                                 sx={{
// // // // // // // //                                   display: "flex",
// // // // // // // //                                   flexWrap: "wrap",
// // // // // // // //                                   gap: 1,
// // // // // // // //                                   mt: 1,
// // // // // // // //                                 }}
// // // // // // // //                               >
// // // // // // // //                                 {data.Keyword_Optimization.missing_keywords.map(
// // // // // // // //                                   (kw, i) => (
// // // // // // // //                                     <Chip
// // // // // // // //                                       key={i}
// // // // // // // //                                       label={kw}
// // // // // // // //                                       color="info"
// // // // // // // //                                       size="small"
// // // // // // // //                                     />
// // // // // // // //                                   )
// // // // // // // //                                 )}
// // // // // // // //                               </Box>
// // // // // // // //                             </Box>
// // // // // // // //                             <Box flex={1}>
// // // // // // // //                               <Typography variant="subtitle1" fontWeight="bold">
// // // // // // // //                                 Missing Sections
// // // // // // // //                               </Typography>
// // // // // // // //                               <Box
// // // // // // // //                                 sx={{
// // // // // // // //                                   display: "flex",
// // // // // // // //                                   flexWrap: "wrap",
// // // // // // // //                                   gap: 1,
// // // // // // // //                                   mt: 1,
// // // // // // // //                                 }}
// // // // // // // //                               >
// // // // // // // //                                 {data.Format_and_Structure_Review.missing_sections.map(
// // // // // // // //                                   (sec, i) => (
// // // // // // // //                                     <Chip
// // // // // // // //                                       key={i}
// // // // // // // //                                       label={sec}
// // // // // // // //                                       color="warning"
// // // // // // // //                                       size="small"
// // // // // // // //                                     />
// // // // // // // //                                   )
// // // // // // // //                                 )}
// // // // // // // //                               </Box>
// // // // // // // //                             </Box>
// // // // // // // //                           </Stack>
// // // // // // // //                         </Paper>
// // // // // // // //                       </Grid>
// // // // // // // //                     </Grid>
// // // // // // // //                   </TabPanel>
// // // // // // // //                 ))}
// // // // // // // //               </>
// // // // // // // //             )
// // // // // // // //           )}
// // // // // // // //         </DialogContent>
// // // // // // // //         <DialogActions>
// // // // // // // //           <Button onClick={() => setResumeReviewDialog(false)}>Close</Button>
// // // // // // // //         </DialogActions>
// // // // // // // //       </Dialog>
// // // // // // // //       <Dialog
// // // // // // // //         open={skillGapDialog}
// // // // // // // //         onClose={() => setSkillGapDialog(false)}
// // // // // // // //         maxWidth="lg"
// // // // // // // //         fullWidth
// // // // // // // //       >
// // // // // // // //         <DialogTitle
// // // // // // // //           sx={{ bgcolor: "success.main", color: "success.contrastText" }}
// // // // // // // //         >
// // // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // // //             <TrendingUp />
// // // // // // // //             <Typography variant="h6">AI Skill Gap Analysis</Typography>
// // // // // // // //           </Stack>
// // // // // // // //         </DialogTitle>
// // // // // // // //         <DialogContent dividers>
// // // // // // // //           <RoleSelector
// // // // // // // //             selectedRoles={selectedSkillGapRoles}
// // // // // // // //             handleRoleChange={(e) =>
// // // // // // // //               setSelectedSkillGapRoles((prev) =>
// // // // // // // //                 e.target.checked
// // // // // // // //                   ? [...prev, e.target.name]
// // // // // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // // // // //               )
// // // // // // // //             }
// // // // // // // //           />
// // // // // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // // // // //             <Button
// // // // // // // //               variant="contained"
// // // // // // // //               color="success"
// // // // // // // //               onClick={() => fetchSkillGap(selectedSkillGapRoles)}
// // // // // // // //             >
// // // // // // // //               Generate Analysis
// // // // // // // //             </Button>
// // // // // // // //           </Box>
// // // // // // // //           <Divider />
// // // // // // // //           {skillGapLoading ? (
// // // // // // // //             <DialogSkeleton />
// // // // // // // //           ) : (
// // // // // // // //             skillGapData && (
// // // // // // // //               <>
// // // // // // // //                 <Tabs
// // // // // // // //                   value={activeSkillGapTab}
// // // // // // // //                   onChange={(e, val) => setActiveSkillGapTab(val)}
// // // // // // // //                   centered
// // // // // // // //                   variant="scrollable"
// // // // // // // //                   scrollButtons="auto"
// // // // // // // //                 >
// // // // // // // //                   {Object.keys(skillGapData).map((role) => (
// // // // // // // //                     <Tab key={role} label={role} />
// // // // // // // //                   ))}
// // // // // // // //                 </Tabs>
// // // // // // // //                 {Object.entries(skillGapData).map(([role, data], index) => (
// // // // // // // //                   <TabPanel value={activeSkillGapTab} index={index} key={role}>
// // // // // // // //                     <Grid container spacing={2}>
// // // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // // //                         <Typography variant="h6" gutterBottom>
// // // // // // // //                           Your Skills
// // // // // // // //                         </Typography>
// // // // // // // //                         <Paper
// // // // // // // //                           variant="outlined"
// // // // // // // //                           sx={{
// // // // // // // //                             p: 2,
// // // // // // // //                             display: "flex",
// // // // // // // //                             flexWrap: "wrap",
// // // // // // // //                             gap: 1,
// // // // // // // //                           }}
// // // // // // // //                         >
// // // // // // // //                           <>
// // // // // // // //                             {data.Current_Skill_Mapping.map((skill, i) => (
// // // // // // // //                               <Chip key={i} label={skill} />
// // // // // // // //                             ))}
// // // // // // // //                           </>
// // // // // // // //                         </Paper>
// // // // // // // //                       </Grid>
// // // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // // //                         <Typography variant="h6" gutterBottom>
// // // // // // // //                           In-Demand Market Skills
// // // // // // // //                         </Typography>
// // // // // // // //                         <Paper
// // // // // // // //                           variant="outlined"
// // // // // // // //                           sx={{
// // // // // // // //                             p: 2,
// // // // // // // //                             display: "flex",
// // // // // // // //                             flexWrap: "wrap",
// // // // // // // //                             gap: 1,
// // // // // // // //                           }}
// // // // // // // //                         >
// // // // // // // //                           <>
// // // // // // // //                             {data.Market_Demand_Analysis.map((skill, i) => (
// // // // // // // //                               <Chip key={i} label={skill} color="primary" />
// // // // // // // //                             ))}
// // // // // // // //                           </>
// // // // // // // //                         </Paper>
// // // // // // // //                       </Grid>
// // // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // // //                             Recommended Learning Path
// // // // // // // //                           </Typography>
// // // // // // // //                           <List dense>
// // // // // // // //                             {data.Learning_Path.map((path, i) => (
// // // // // // // //                               <ListItem key={i}>
// // // // // // // //                                 <ListItemIcon>
// // // // // // // //                                   <School color="primary" />
// // // // // // // //                                 </ListItemIcon>
// // // // // // // //                                 <ListItemText primary={path} />
// // // // // // // //                               </ListItem>
// // // // // // // //                             ))}
// // // // // // // //                           </List>
// // // // // // // //                         </Paper>
// // // // // // // //                       </Grid>
// // // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // // //                             Suggested Certifications
// // // // // // // //                           </Typography>
// // // // // // // //                           <List dense>
// // // // // // // //                             {data.Certification_Guidance.map((cert, i) => (
// // // // // // // //                               <ListItem key={i}>
// // // // // // // //                                 <ListItemIcon>
// // // // // // // //                                   <MilitaryTech color="success" />
// // // // // // // //                                 </ListItemIcon>
// // // // // // // //                                 <ListItemText primary={cert} />
// // // // // // // //                               </ListItem>
// // // // // // // //                             ))}
// // // // // // // //                           </List>
// // // // // // // //                         </Paper>
// // // // // // // //                       </Grid>
// // // // // // // //                     </Grid>
// // // // // // // //                   </TabPanel>
// // // // // // // //                 ))}
// // // // // // // //               </>
// // // // // // // //             )
// // // // // // // //           )}
// // // // // // // //         </DialogContent>
// // // // // // // //         <DialogActions>
// // // // // // // //           <Button onClick={() => setSkillGapDialog(false)}>Close</Button>
// // // // // // // //         </DialogActions>
// // // // // // // //       </Dialog>
// // // // // // // //       <Dialog
// // // // // // // //         open={careerRoadmapDialog}
// // // // // // // //         onClose={() => setCareerRoadmapDialog(false)}
// // // // // // // //         maxWidth="lg"
// // // // // // // //         fullWidth
// // // // // // // //       >
// // // // // // // //         <DialogTitle
// // // // // // // //           sx={{ bgcolor: "warning.main", color: "warning.contrastText" }}
// // // // // // // //         >
// // // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // // //             <Timeline />
// // // // // // // //             <Typography variant="h6">Personalized Career Roadmap</Typography>
// // // // // // // //           </Stack>
// // // // // // // //         </DialogTitle>
// // // // // // // //         <DialogContent dividers>
// // // // // // // //           <RoleSelector
// // // // // // // //             selectedRoles={selectedRoadmapRoles}
// // // // // // // //             handleRoleChange={(e) =>
// // // // // // // //               setSelectedRoadmapRoles((prev) =>
// // // // // // // //                 e.target.checked
// // // // // // // //                   ? [...prev, e.target.name]
// // // // // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // // // // //               )
// // // // // // // //             }
// // // // // // // //           />
// // // // // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // // // // //             <Button
// // // // // // // //               variant="contained"
// // // // // // // //               color="warning"
// // // // // // // //               onClick={() => fetchCareerRoadmap(selectedRoadmapRoles)}
// // // // // // // //             >
// // // // // // // //               Generate Roadmap
// // // // // // // //             </Button>
// // // // // // // //           </Box>
// // // // // // // //           <Divider />
// // // // // // // //           {careerRoadmapLoading ? (
// // // // // // // //             <DialogSkeleton />
// // // // // // // //           ) : (
// // // // // // // //             careerRoadmapData && (
// // // // // // // //               <>
// // // // // // // //                 <Tabs
// // // // // // // //                   value={activeRoadmapTab}
// // // // // // // //                   onChange={(e, val) => setActiveRoadmapTab(val)}
// // // // // // // //                   centered
// // // // // // // //                   variant="scrollable"
// // // // // // // //                   scrollButtons="auto"
// // // // // // // //                 >
// // // // // // // //                   {Object.keys(careerRoadmapData).map((role) => (
// // // // // // // //                     <Tab key={role} label={role} />
// // // // // // // //                   ))}
// // // // // // // //                 </Tabs>
// // // // // // // //                 {Object.entries(careerRoadmapData).map(
// // // // // // // //                   ([role, data], index) => (
// // // // // // // //                     <TabPanel value={activeRoadmapTab} index={index} key={role}>
// // // // // // // //                       <Typography variant="h6" gutterBottom>
// // // // // // // //                         Your AI-Generated Career Path for {role}
// // // // // // // //                       </Typography>
// // // // // // // //                       <Typography
// // // // // // // //                         variant="body1"
// // // // // // // //                         paragraph
// // // // // // // //                         color="text.secondary"
// // // // // // // //                       >
// // // // // // // //                         Current Position: {data?.Current_Position || "N/A"} with{" "}
// // // // // // // //                         {data?.Experience_Years || "N/A"} years of experience.
// // // // // // // //                       </Typography>
// // // // // // // //                       <Grid container spacing={2} sx={{ mt: 2 }}>
// // // // // // // //                         <Grid item xs={12} md={6}>
// // // // // // // //                           <Paper
// // // // // // // //                             variant="outlined"
// // // // // // // //                             sx={{ p: 2, height: "100%" }}
// // // // // // // //                           >
// // // // // // // //                             <Typography variant="overline" color="warning.main">
// // // // // // // //                               Next Milestone
// // // // // // // //                             </Typography>
// // // // // // // //                             <Typography variant="h6" fontWeight="bold">
// // // // // // // //                               {data?.Next_Milestone?.title || "Not available"}
// // // // // // // //                             </Typography>
// // // // // // // //                             <Chip
// // // // // // // //                               size="small"
// // // // // // // //                               label={`Company: ${
// // // // // // // //                                 data?.Next_Milestone?.company_type || "N/A"
// // // // // // // //                               }`}
// // // // // // // //                               sx={{ mt: 1 }}
// // // // // // // //                             />
// // // // // // // //                           </Paper>
// // // // // // // //                         </Grid>
// // // // // // // //                         <Grid item xs={12} md={6}>
// // // // // // // //                           <Paper
// // // // // // // //                             variant="outlined"
// // // // // // // //                             sx={{ p: 2, height: "100%" }}
// // // // // // // //                           >
// // // // // // // //                             <Typography variant="overline" color="success.main">
// // // // // // // //                               Long-term Goal
// // // // // // // //                             </Typography>
// // // // // // // //                             <Typography variant="h6" fontWeight="bold">
// // // // // // // //                               {data?.Long_Term_Goal?.title || "Not available"}
// // // // // // // //                             </Typography>
// // // // // // // //                             <Chip
// // // // // // // //                               size="small"
// // // // // // // //                               label={`Company: ${
// // // // // // // //                                 data?.Long_Term_Goal?.company_type || "N/A"
// // // // // // // //                               }`}
// // // // // // // //                               sx={{ mt: 1 }}
// // // // // // // //                             />
// // // // // // // //                           </Paper>
// // // // // // // //                         </Grid>
// // // // // // // //                       </Grid>
// // // // // // // //                       <Divider sx={{ my: 3 }}>
// // // // // // // //                         <Chip label="Recommended Actions" />
// // // // // // // //                       </Divider>
// // // // // // // //                       <List>
// // // // // // // //                         {data?.Recommended_Actions?.map((item, i) => (
// // // // // // // //                           <ListItem key={i} alignItems="flex-start">
// // // // // // // //                             <ListItemIcon>
// // // // // // // //                               <Work color="primary" />
// // // // // // // //                             </ListItemIcon>
// // // // // // // //                             <ListItemText
// // // // // // // //                               primary={item.action}
// // // // // // // //                               secondary={item.reason}
// // // // // // // //                             />
// // // // // // // //                           </ListItem>
// // // // // // // //                         )) || (
// // // // // // // //                           <ListItem>
// // // // // // // //                             <ListItemText primary="No actions recommended." />
// // // // // // // //                           </ListItem>
// // // // // // // //                         )}
// // // // // // // //                       </List>
// // // // // // // //                     </TabPanel>
// // // // // // // //                   )
// // // // // // // //                 )}
// // // // // // // //               </>
// // // // // // // //             )
// // // // // // // //           )}
// // // // // // // //         </DialogContent>
// // // // // // // //         <DialogActions>
// // // // // // // //           <Button onClick={() => setCareerRoadmapDialog(false)}>Close</Button>
// // // // // // // //         </DialogActions>
// // // // // // // //       </Dialog>

// // // // // // // //       <Dialog
// // // // // // // //         open={culturalPrepDialog}
// // // // // // // //         onClose={() => {
// // // // // // // //           setCulturalPrepDialog(false);
// // // // // // // //           setCulturalPrepTab(0);
// // // // // // // //         }}
// // // // // // // //         maxWidth="md"
// // // // // // // //         fullWidth
// // // // // // // //         PaperProps={{ sx: { height: { md: 650 } } }}
// // // // // // // //       >
// // // // // // // //         <DialogTitle
// // // // // // // //           sx={{ bgcolor: "error.main", color: "error.contrastText" }}
// // // // // // // //         >
// // // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // // //             <Psychology />
// // // // // // // //             <Typography variant="h6">Cultural Preparation Insights</Typography>
// // // // // // // //           </Stack>
// // // // // // // //         </DialogTitle>
// // // // // // // //         <DialogContent
// // // // // // // //           dividers
// // // // // // // //           sx={{
// // // // // // // //             display: "flex",
// // // // // // // //             p: 0,
// // // // // // // //             overflow: "hidden",
// // // // // // // //             flexDirection: { xs: "column", md: "row" },
// // // // // // // //           }}
// // // // // // // //         >
// // // // // // // //           {culturalPrepLoading ? (
// // // // // // // //             <DialogSkeleton />
// // // // // // // //           ) : (
// // // // // // // //             culturalPrepData && (
// // // // // // // //               <>
// // // // // // // //                 <Tabs
// // // // // // // //                   orientation={
// // // // // // // //                     theme.breakpoints.up("md") ? "vertical" : "horizontal"
// // // // // // // //                   }
// // // // // // // //                   variant="scrollable"
// // // // // // // //                   value={culturalPrepTab}
// // // // // // // //                   onChange={(e, val) => setCulturalPrepTab(val)}
// // // // // // // //                   sx={{
// // // // // // // //                     borderRight: { md: 1 },
// // // // // // // //                     borderBottom: { xs: 1, md: 0 },
// // // // // // // //                     borderColor: "divider",
// // // // // // // //                     minWidth: { md: 150 },
// // // // // // // //                   }}
// // // // // // // //                 >
// // // // // // // //                   {Object.values(culturalPrepData).map((region, index) => (
// // // // // // // //                     <Tab key={index} label={region.location_name} />
// // // // // // // //                   ))}
// // // // // // // //                 </Tabs>
// // // // // // // //                 <Box
// // // // // // // //                   sx={{
// // // // // // // //                     flex: { md: 1 },
// // // // // // // //                     overflowY: "auto",
// // // // // // // //                     p: { xs: 2, md: 3 },
// // // // // // // //                   }}
// // // // // // // //                 >
// // // // // // // //                   {Object.values(culturalPrepData).map((region, index) => (
// // // // // // // //                     <TabPanel value={culturalPrepTab} index={index} key={index}>
// // // // // // // //                       <Stack spacing={2} sx={{ p: 0 }}>
// // // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // //                           <Typography variant="h6">
// // // // // // // //                             Cultural Insights
// // // // // // // //                           </Typography>
// // // // // // // //                           <List dense>
// // // // // // // //                             {region.cultural_insights.map((insight, i) => (
// // // // // // // //                               <ListItem key={i}>
// // // // // // // //                                 <ListItemIcon>
// // // // // // // //                                   <ArrowForward fontSize="small" />
// // // // // // // //                                 </ListItemIcon>
// // // // // // // //                                 <ListItemText primary={insight} />
// // // // // // // //                               </ListItem>
// // // // // // // //                             ))}
// // // // // // // //                           </List>
// // // // // // // //                         </Paper>
// // // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // //                           <Typography variant="h6">
// // // // // // // //                             Communication Tips
// // // // // // // //                           </Typography>
// // // // // // // //                           <List dense>
// // // // // // // //                             {region.communication_tips.map((tip, i) => (
// // // // // // // //                               <ListItem key={i}>
// // // // // // // //                                 <ListItemIcon>
// // // // // // // //                                   <ArrowForward fontSize="small" />
// // // // // // // //                                 </ListItemIcon>
// // // // // // // //                                 <ListItemText primary={tip} />
// // // // // // // //                               </ListItem>
// // // // // // // //                             ))}
// // // // // // // //                           </List>
// // // // // // // //                         </Paper>
// // // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // //                           <Typography variant="h6">Work Etiquette</Typography>
// // // // // // // //                           <List dense>
// // // // // // // //                             {region.work_etiquette.map((tip, i) => (
// // // // // // // //                               <ListItem key={i}>
// // // // // // // //                                 <ListItemIcon>
// // // // // // // //                                   <Stars fontSize="small" />
// // // // // // // //                                 </ListItemIcon>
// // // // // // // //                                 <ListItemText primary={tip} />
// // // // // // // //                               </ListItem>
// // // // // // // //                             ))}
// // // // // // // //                           </List>
// // // // // // // //                         </Paper>
// // // // // // // //                       </Stack>
// // // // // // // //                     </TabPanel>
// // // // // // // //                   ))}
// // // // // // // //                 </Box>
// // // // // // // //               </>
// // // // // // // //             )
// // // // // // // //           )}
// // // // // // // //         </DialogContent>
// // // // // // // //         <DialogActions>
// // // // // // // //           <Button onClick={() => setCulturalPrepDialog(false)}>Close</Button>
// // // // // // // //         </DialogActions>
// // // // // // // //       </Dialog>
// // // // // // // //       <Dialog
// // // // // // // //         open={salaryInsightsDialog}
// // // // // // // //         onClose={() => setSalaryInsightsDialog(false)}
// // // // // // // //         maxWidth="md"
// // // // // // // //         fullWidth
// // // // // // // //       >
// // // // // // // //         <DialogTitle sx={{ bgcolor: "info.main", color: "info.contrastText" }}>
// // // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // // //             <Language />
// // // // // // // //             <Typography variant="h6">Global Salary Insights</Typography>
// // // // // // // //           </Stack>
// // // // // // // //         </DialogTitle>
// // // // // // // //         <DialogContent dividers>
// // // // // // // //           {salaryInsightsLoading ? (
// // // // // // // //             <DialogSkeleton />
// // // // // // // //           ) : (
// // // // // // // //             salaryInsightsData && (
// // // // // // // //               <Stack spacing={3} sx={{ py: 2 }}>
// // // // // // // //                 <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // //                   <Stack
// // // // // // // //                     direction="row"
// // // // // // // //                     spacing={1.5}
// // // // // // // //                     alignItems="center"
// // // // // // // //                     mb={2}
// // // // // // // //                   >
// // // // // // // //                     <LocationOn color="info" />
// // // // // // // //                     <Typography variant="h6">
// // // // // // // //                       Salary Benchmarks by Location
// // // // // // // //                     </Typography>
// // // // // // // //                   </Stack>
// // // // // // // //                   <Grid container spacing={2}>
// // // // // // // //                     {salaryInsightsData.location_based.map((loc, i) => (
// // // // // // // //                       <Grid item xs={12} sm={6} key={i}>
// // // // // // // //                         <Paper sx={{ p: 2, bgcolor: "action.hover" }}>
// // // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // // //                             {loc.city} ({loc.role})
// // // // // // // //                           </Typography>
// // // // // // // //                           <Stack spacing={0.5}>
// // // // // // // //                             <Typography variant="body2" color="text.secondary">
// // // // // // // //                               Min: <strong>{loc.min_salary}</strong>
// // // // // // // //                             </Typography>
// // // // // // // //                             <Typography
// // // // // // // //                               variant="body1"
// // // // // // // //                               color="text.primary"
// // // // // // // //                               fontWeight="bold"
// // // // // // // //                             >
// // // // // // // //                               Median: <strong>{loc.median_salary}</strong>
// // // // // // // //                             </Typography>
// // // // // // // //                             <Typography variant="body2" color="text.secondary">
// // // // // // // //                               Max: <strong>{loc.max_salary}</strong>
// // // // // // // //                             </Typography>
// // // // // // // //                           </Stack>
// // // // // // // //                         </Paper>
// // // // // // // //                       </Grid>
// // // // // // // //                     ))}
// // // // // // // //                   </Grid>
// // // // // // // //                 </Paper>
// // // // // // // //                 <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // //                   <Stack
// // // // // // // //                     direction="row"
// // // // // // // //                     spacing={1.5}
// // // // // // // //                     alignItems="center"
// // // // // // // //                     mb={1}
// // // // // // // //                   >
// // // // // // // //                     <TrendingUp color="primary" />
// // // // // // // //                     <Typography variant="h6">
// // // // // // // //                       Location Demand Impact on Salary
// // // // // // // //                     </Typography>
// // // // // // // //                   </Stack>
// // // // // // // //                   <List dense>
// // // // // // // //                     {salaryInsightsData.salary_insights_summary.map(
// // // // // // // //                       (item, i) => (
// // // // // // // //                         <ListItem key={i} disableGutters sx={{ px: 1 }}>
// // // // // // // //                           <Stack
// // // // // // // //                             direction={{ xs: "column", sm: "row" }}
// // // // // // // //                             spacing={{ xs: 0.5, sm: 2 }}
// // // // // // // //                             alignItems="center"
// // // // // // // //                             sx={{ width: "100%" }}
// // // // // // // //                           >
// // // // // // // //                             <ListItemText
// // // // // // // //                               primary={item.role}
// // // // // // // //                               sx={{
// // // // // // // //                                 width: "100%",
// // // // // // // //                                 m: 0,
// // // // // // // //                                 flexBasis: { sm: "40%" },
// // // // // // // //                                 flexShrink: 0,
// // // // // // // //                               }}
// // // // // // // //                             />
// // // // // // // //                             <Box
// // // // // // // //                               sx={{
// // // // // // // //                                 width: "100%",
// // // // // // // //                                 display: "flex",
// // // // // // // //                                 alignItems: "center",
// // // // // // // //                               }}
// // // // // // // //                             >
// // // // // // // //                               <LinearProgress
// // // // // // // //                                 variant="determinate"
// // // // // // // //                                 value={item.demand_in_salary_percent}
// // // // // // // //                                 color="primary"
// // // // // // // //                                 sx={{ width: "100%", mr: 1.5 }}
// // // // // // // //                               />
// // // // // // // //                               <Typography
// // // // // // // //                                 variant="body2"
// // // // // // // //                                 color="text.secondary"
// // // // // // // //                               >{`${item.demand_in_salary_percent}%`}</Typography>
// // // // // // // //                             </Box>
// // // // // // // //                           </Stack>
// // // // // // // //                         </ListItem>
// // // // // // // //                       )
// // // // // // // //                     )}
// // // // // // // //                   </List>
// // // // // // // //                 </Paper>
// // // // // // // //                 <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // //                   <Stack
// // // // // // // //                     direction="row"
// // // // // // // //                     spacing={1.5}
// // // // // // // //                     alignItems="center"
// // // // // // // //                     mb={1}
// // // // // // // //                   >
// // // // // // // //                     <MonetizationOn color="success" />
// // // // // // // //                     <Typography variant="h6">Negotiation Tips</Typography>
// // // // // // // //                   </Stack>
// // // // // // // //                   <List dense>
// // // // // // // //                     {salaryInsightsData.negotiation_tips.map((tip, i) => (
// // // // // // // //                       <ListItem key={i}>
// // // // // // // //                         <ListItemIcon>
// // // // // // // //                           <CheckCircle color="success" fontSize="small" />
// // // // // // // //                         </ListItemIcon>
// // // // // // // //                         <ListItemText primary={tip} />
// // // // // // // //                       </ListItem>
// // // // // // // //                     ))}
// // // // // // // //                   </List>
// // // // // // // //                 </Paper>
// // // // // // // //                 <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // // //                   <Stack
// // // // // // // //                     direction="row"
// // // // // // // //                     spacing={1.5}
// // // // // // // //                     alignItems="center"
// // // // // // // //                     mb={1}
// // // // // // // //                   >
// // // // // // // //                     <Timeline color="warning" />
// // // // // // // //                     <Typography variant="h6">Market Trends</Typography>
// // // // // // // //                   </Stack>
// // // // // // // //                   <List>
// // // // // // // //                     {salaryInsightsData.market_trends.map((item, i) => (
// // // // // // // //                       <ListItem key={i} alignItems="flex-start">
// // // // // // // //                         <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
// // // // // // // //                           <TrendingFlat color="warning" />
// // // // // // // //                         </ListItemIcon>
// // // // // // // //                         <ListItemText
// // // // // // // //                           primary={item.trend}
// // // // // // // //                           secondary={item.insight}
// // // // // // // //                           primaryTypographyProps={{ fontWeight: 600 }}
// // // // // // // //                         />
// // // // // // // //                       </ListItem>
// // // // // // // //                     ))}
// // // // // // // //                   </List>
// // // // // // // //                 </Paper>
// // // // // // // //               </Stack>
// // // // // // // //             )
// // // // // // // //           )}
// // // // // // // //         </DialogContent>
// // // // // // // //         <DialogActions>
// // // // // // // //           <Button onClick={() => setSalaryInsightsDialog(false)}>Close</Button>
// // // // // // // //         </DialogActions>
// // // // // // // //       </Dialog>
// // // // // // // //     </Layout>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default CareerAssistant;
// // // // // // // import { useState, useEffect, useRef } from "react"; // Added useRef
// // // // // // // import {
// // // // // // //   Grid,
// // // // // // //   Card,
// // // // // // //   CardContent,
// // // // // // //   Container,
// // // // // // //   Typography,
// // // // // // //   Box,
// // // // // // //   Button,
// // // // // // //   Paper,
// // // // // // //   Avatar,
// // // // // // //   Chip,
// // // // // // //   Dialog,
// // // // // // //   DialogTitle,
// // // // // // //   DialogContent,
// // // // // // //   DialogActions,
// // // // // // //   List,
// // // // // // //   ListItem,
// // // // // // //   ListItemIcon,
// // // // // // //   ListItemText,
// // // // // // //   Divider,
// // // // // // //   Stack,
// // // // // // //   LinearProgress,
// // // // // // //   Skeleton, // Already imported, great!
// // // // // // //   alpha,
// // // // // // //   IconButton,
// // // // // // //   Tabs,
// // // // // // //   Tab,
// // // // // // //   FormGroup,
// // // // // // //   FormControlLabel,
// // // // // // //   Checkbox,
// // // // // // //   Alert,
// // // // // // //   AlertTitle,
// // // // // // // } from "@mui/material";
// // // // // // // import { styled, useTheme } from "@mui/material/styles";
// // // // // // // import {
// // // // // // //   Psychology,
// // // // // // //   TrendingUp,
// // // // // // //   School,
// // // // // // //   Work,
// // // // // // //   Language,
// // // // // // //   Assessment,
// // // // // // //   VideoCall,
// // // // // // //   Lightbulb,
// // // // // // //   Timeline,
// // // // // // //   CheckCircle,
// // // // // // //   ErrorOutline,
// // // // // // //   ArrowForward,
// // // // // // //   MilitaryTech,
// // // // // // //   Stars,
// // // // // // //   RocketLaunch,
// // // // // // //   TrendingDown,
// // // // // // //   TrendingFlat,
// // // // // // //   LocationOn,
// // // // // // //   MonetizationOn,
// // // // // // //   AutoAwesome,
// // // // // // //   Close as CloseIcon, // For the dismissible alert
// // // // // // //   Insights, // For the chart empty state
// // // // // // // } from "@mui/icons-material";
// // // // // // // import {
// // // // // // //   BarChart,
// // // // // // //   Bar,
// // // // // // //   XAxis,
// // // // // // //   YAxis,
// // // // // // //   CartesianGrid,
// // // // // // //   Tooltip,
// // // // // // //   ResponsiveContainer,
// // // // // // //   Cell,
// // // // // // //   LabelList,
// // // // // // // } from "recharts";
// // // // // // // import Layout from "../common/Layout";
// // // // // // // import { useNotification } from "../../context/NotificationContext";
// // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // import apiClient from "../../context/apiClient";

// // // // // // // // --- Skeleton Components ---

// // // // // // // const HeaderSkeleton = () => (
// // // // // // //   <Paper sx={{ bgcolor: "mint.main", borderRadius: 3, p: { xs: 2, sm: 3 } }}>
// // // // // // //     <Stack direction="row" alignItems="center" spacing={2}>
// // // // // // //       <Skeleton variant="circular" width={64} height={64} />
// // // // // // //       <Box sx={{ flex: 1 }}>
// // // // // // //         <Skeleton variant="text" width="40%" height={48} />
// // // // // // //         <Skeleton variant="text" width="60%" height={24} />
// // // // // // //       </Box>
// // // // // // //     </Stack>
// // // // // // //   </Paper>
// // // // // // // );

// // // // // // // const ServiceListItemSkeleton = () => (
// // // // // // //   <Paper
// // // // // // //     sx={{
// // // // // // //       display: "flex",
// // // // // // //       flexDirection: "row",
// // // // // // //       alignItems: "center",
// // // // // // //       padding: 2,
// // // // // // //       borderRadius: "12px",
// // // // // // //       border: (theme) => `1px solid ${theme.palette.divider}`,
// // // // // // //     }}
// // // // // // //   >
// // // // // // //     <Skeleton variant="circular" width={48} height={48} sx={{ mr: 2 }} />
// // // // // // //     <Box flexGrow={1}>
// // // // // // //       <Skeleton variant="text" height={30} width="50%" />
// // // // // // //       <Skeleton variant="text" height={20} width="80%" />
// // // // // // //     </Box>
// // // // // // //     <Skeleton variant="circular" width={24} height={24} sx={{ ml: 2 }} />
// // // // // // //   </Paper>
// // // // // // // );

// // // // // // // const ServicesSkeleton = () => (
// // // // // // //   <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, bgcolor: "mint.main" }}>
// // // // // // //     <Skeleton variant="text" width="60%" height={40} sx={{ mb: 3 }} />
// // // // // // //     <Stack spacing={2}>
// // // // // // //       {[...Array(5)].map((_, index) => (
// // // // // // //         <ServiceListItemSkeleton key={index} />
// // // // // // //       ))}
// // // // // // //     </Stack>
// // // // // // //   </Paper>
// // // // // // // );

// // // // // // // const TrendingSkillsSkeleton = () => (
// // // // // // //   <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, bgcolor: "mint.main" }}>
// // // // // // //     <Skeleton variant="text" width="40%" height={40} sx={{ mb: 2 }} />
// // // // // // //     <Stack
// // // // // // //       direction="row"
// // // // // // //       spacing={2}
// // // // // // //       sx={{ mb: 3, justifyContent: "center", flexWrap: "wrap", gap: 1 }}
// // // // // // //     >
// // // // // // //       <Skeleton variant="rounded" width={150} height={42} />
// // // // // // //       <Skeleton variant="rounded" width={150} height={42} />
// // // // // // //       <Skeleton variant="rounded" width={150} height={42} />
// // // // // // //     </Stack>
// // // // // // //     <Skeleton variant="rounded" width="100%" height={500} />
// // // // // // //   </Paper>
// // // // // // // );

// // // // // // // const PageSkeleton = () => (
// // // // // // //   <Layout title="AI Career Assistant">
// // // // // // //     <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// // // // // // //       <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
// // // // // // //         <Stack spacing={4}>
// // // // // // //           <HeaderSkeleton />
// // // // // // //           <ServicesSkeleton />
// // // // // // //           <TrendingSkillsSkeleton />
// // // // // // //         </Stack>
// // // // // // //       </Container>
// // // // // // //     </Box>
// // // // // // //   </Layout>
// // // // // // // );

// // // // // // // const ChartSkeleton = () => (
// // // // // // //   <Box sx={{ height: { xs: 400, md: 500 }, width: "100%", pt: 2 }}>
// // // // // // //     <Skeleton variant="rounded" width="100%" height="100%" />
// // // // // // //   </Box>
// // // // // // // );

// // // // // // // // --- Helper Components ---

// // // // // // // const ServiceListItem = styled(Paper)(({ theme, color = "primary" }) => ({
// // // // // // //   backgroundColor: theme.palette.background.paper, // Changed for better contrast within a Paper container
// // // // // // //   display: "flex",
// // // // // // //   flexDirection: "row",
// // // // // // //   alignItems: "center",
// // // // // // //   padding: theme.spacing(2),
// // // // // // //   borderRadius: "12px",
// // // // // // //   cursor: "pointer",
// // // // // // //   transition:
// // // // // // //     "background-color 0.3s ease, border-color 0.3s ease, transform 0.2s ease-in-out",
// // // // // // //   border: `1px solid ${theme.palette.divider}`,
// // // // // // //   "&:hover": {
// // // // // // //     backgroundColor: alpha(
// // // // // // //       theme.palette[color]?.main || theme.palette.primary.main,
// // // // // // //       0.08
// // // // // // //     ),
// // // // // // //     borderColor: theme.palette[color]?.main || theme.palette.primary.main,
// // // // // // //     transform: "scale(1.02)",
// // // // // // //   },
// // // // // // //   ".MuiAvatar-root": {
// // // // // // //     backgroundColor: alpha(
// // // // // // //       theme.palette[color]?.main || theme.palette.primary.main,
// // // // // // //       0.15
// // // // // // //     ),
// // // // // // //     color: theme.palette[color]?.main || theme.palette.primary.main,
// // // // // // //     marginRight: theme.spacing(2),
// // // // // // //   },
// // // // // // // }));

// // // // // // // function TabPanel(props) {
// // // // // // //   const { children, value, index, ...other } = props;
// // // // // // //   return (
// // // // // // //     <div
// // // // // // //       role="tabpanel"
// // // // // // //       hidden={value !== index}
// // // // // // //       id={`tabpanel-${index}`}
// // // // // // //       aria-labelledby={`tab-${index}`}
// // // // // // //       {...other}
// // // // // // //     >
// // // // // // //       {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
// // // // // // //     </div>
// // // // // // //   );
// // // // // // // }

// // // // // // // // --- Main Component ---

// // // // // // // const CareerAssistant = () => {
// // // // // // //   const theme = useTheme();
// // // // // // //   const { showNotification } = useNotification();
// // // // // // //   const navigate = useNavigate();
// // // // // // //   const isInitialMount = useRef(true);

// // // // // // //   const availableRoles = [
// // // // // // //     "AI/ML Engineer",
// // // // // // //     "Data Scientist",
// // // // // // //     "Business Analyst",
// // // // // // //   ];

// // // // // // //   // --- State Declarations ---
// // // // // // //   const [pageLoading, setPageLoading] = useState(true); // For initial page load
// // // // // // //   const [showWelcomeCard, setShowWelcomeCard] = useState(true);
// // // // // // //   const [mockInterviewDialog, setMockInterviewDialog] = useState(false);
// // // // // // //   const [resumeReviewDialog, setResumeReviewDialog] = useState(false);
// // // // // // //   const [skillGapDialog, setSkillGapDialog] = useState(false);
// // // // // // //   const [careerRoadmapDialog, setCareerRoadmapDialog] = useState(false);
// // // // // // //   const [culturalPrepDialog, setCulturalPrepDialog] = useState(false);
// // // // // // //   const [salaryInsightsDialog, setSalaryInsightsDialog] = useState(false);
// // // // // // //   const [trendingSkillsData, setTrendingSkillsData] = useState({});
// // // // // // //   const [skillsLoading, setSkillsLoading] = useState(true);
// // // // // // //   const [selectedTrendingRoles, setSelectedTrendingRoles] = useState([
// // // // // // //     "AI/ML Engineer",
// // // // // // //   ]);
// // // // // // //   const [activeTrendingTab, setActiveTrendingTab] = useState(0);
// // // // // // //   const [resumeReviewData, setResumeReviewData] = useState(null);
// // // // // // //   const [resumeReviewLoading, setResumeReviewLoading] = useState(false);
// // // // // // //   const [selectedResumeRoles, setSelectedResumeRoles] = useState([]);
// // // // // // //   const [activeResumeTab, setActiveResumeTab] = useState(0);
// // // // // // //   const [skillGapData, setSkillGapData] = useState(null);
// // // // // // //   const [skillGapLoading, setSkillGapLoading] = useState(false);
// // // // // // //   const [selectedSkillGapRoles, setSelectedSkillGapRoles] = useState([]);
// // // // // // //   const [activeSkillGapTab, setActiveSkillGapTab] = useState(0);
// // // // // // //   const [careerRoadmapData, setCareerRoadmapData] = useState(null);
// // // // // // //   const [careerRoadmapLoading, setCareerRoadmapLoading] = useState(false);
// // // // // // //   const [selectedRoadmapRoles, setSelectedRoadmapRoles] = useState([]);
// // // // // // //   const [activeRoadmapTab, setActiveRoadmapTab] = useState(0);
// // // // // // //   const [culturalPrepData, setCulturalPrepData] = useState(null);
// // // // // // //   const [culturalPrepLoading, setCulturalPrepLoading] = useState(false);
// // // // // // //   const [culturalPrepTab, setCulturalPrepTab] = useState(0);
// // // // // // //   const [salaryInsightsData, setSalaryInsightsData] = useState(null);
// // // // // // //   const [salaryInsightsLoading, setSalaryInsightsLoading] = useState(false);

// // // // // // //   // --- Data Fetching Functions ---

// // // // // // //   const fetchTrendingSkills = async (roles) => {
// // // // // // //     if (!roles || roles.length === 0) {
// // // // // // //       setTrendingSkillsData({});
// // // // // // //       setSkillsLoading(false);
// // // // // // //       return;
// // // // // // //     }
// // // // // // //     setSkillsLoading(true);
// // // // // // //     try {
// // // // // // //       const response = await apiClient.post("/trending-skills/", {
// // // // // // //         selected_roles: roles,
// // // // // // //       });
// // // // // // //       const transformedData = {};
// // // // // // //       for (const [role, skills] of Object.entries(response.data)) {
// // // // // // //         transformedData[role] = skills.map((skill) => ({
// // // // // // //           skill: skill.skill,
// // // // // // //           demand: parseInt(skill.demand) || 0,
// // // // // // //           growth: skill.increase || "N/A",
// // // // // // //           priority: skill.priority,
// // // // // // //         }));
// // // // // // //       }
// // // // // // //       setTrendingSkillsData(transformedData);
// // // // // // //       setActiveTrendingTab(0);
// // // // // // //     } catch (error) {
// // // // // // //       console.error("Failed to fetch trending skills:", error);
// // // // // // //       showNotification("Could not load trending skills data.", "error");
// // // // // // //       setTrendingSkillsData({});
// // // // // // //     } finally {
// // // // // // //       setSkillsLoading(false);
// // // // // // //     }
// // // // // // //   };

// // // // // // //   const fetchResumeReview = async (roles) => {
// // // // // // //     if (!roles || roles.length === 0) {
// // // // // // //       setResumeReviewData({});
// // // // // // //       return;
// // // // // // //     }
// // // // // // //     setResumeReviewLoading(true);
// // // // // // //     try {
// // // // // // //       const response = await apiClient.post("/resume/review-talent/", {
// // // // // // //         target_roles: roles,
// // // // // // //       });
// // // // // // //       setResumeReviewData(response.data);
// // // // // // //       setActiveResumeTab(0);
// // // // // // //     } catch (error) {
// // // // // // //       showNotification("Failed to load resume review data.", "error");
// // // // // // //     } finally {
// // // // // // //       setResumeReviewLoading(false);
// // // // // // //     }
// // // // // // //   };
// // // // // // //   const fetchSkillGap = async (roles) => {
// // // // // // //     if (!roles || roles.length === 0) {
// // // // // // //       setSkillGapData({});
// // // // // // //       return;
// // // // // // //     }
// // // // // // //     setSkillGapLoading(true);
// // // // // // //     try {
// // // // // // //       const response = await apiClient.post("/resume/skill-gap/", {
// // // // // // //         selected_roles: roles,
// // // // // // //       });
// // // // // // //       setSkillGapData(response.data);
// // // // // // //       setActiveSkillGapTab(0);
// // // // // // //     } catch (error) {
// // // // // // //       showNotification("Failed to load skill gap analysis.", "error");
// // // // // // //     } finally {
// // // // // // //       setSkillGapLoading(false);
// // // // // // //     }
// // // // // // //   };
// // // // // // //   const fetchCareerRoadmap = async (roles) => {
// // // // // // //     if (!roles || roles.length === 0) {
// // // // // // //       setCareerRoadmapData({});
// // // // // // //       return;
// // // // // // //     }
// // // // // // //     setCareerRoadmapLoading(true);
// // // // // // //     try {
// // // // // // //       const response = await apiClient.post("/resume/career-roadmap/", {
// // // // // // //         target_roles: roles,
// // // // // // //       });
// // // // // // //       setCareerRoadmapData(response.data);
// // // // // // //       setActiveRoadmapTab(0);
// // // // // // //     } catch (error) {
// // // // // // //       showNotification("Failed to load career roadmap.", "error");
// // // // // // //       setCareerRoadmapData({});
// // // // // // //     } finally {
// // // // // // //       setCareerRoadmapLoading(false);
// // // // // // //     }
// // // // // // //   };

// // // // // // //   // --- Handlers ---
// // // // // // //   const handleTrendingRoleChange = (event) => {
// // // // // // //     const { name, checked } = event.target;
// // // // // // //     setSelectedTrendingRoles((prev) =>
// // // // // // //       checked ? [...prev, name] : prev.filter((role) => role !== name)
// // // // // // //     );
// // // // // // //   };

// // // // // // //   // --- Child Components ---
// // // // // // //   const RoleSelector = ({ selectedRoles, handleRoleChange }) => (
// // // // // // //     <FormGroup row sx={{ mb: 2, justifyContent: "center", flexWrap: "wrap" }}>
// // // // // // //       {availableRoles.map((role) => (
// // // // // // //         <FormControlLabel
// // // // // // //           key={role}
// // // // // // //           control={
// // // // // // //             <Checkbox
// // // // // // //               checked={selectedRoles.includes(role)}
// // // // // // //               onChange={handleRoleChange}
// // // // // // //               name={role}
// // // // // // //             />
// // // // // // //           }
// // // // // // //           label={role}
// // // // // // //         />
// // // // // // //       ))}
// // // // // // //     </FormGroup>
// // // // // // //   );

// // // // // // //   const CustomTooltip = ({ active, payload, label }) => {
// // // // // // //     if (active && payload && payload.length) {
// // // // // // //       const data = payload[0].payload;
// // // // // // //       const priorityMuiColor = {
// // // // // // //         High: "primary",
// // // // // // //         Medium: "info",
// // // // // // //       };
// // // // // // //       return (
// // // // // // //         <Paper
// // // // // // //           elevation={3}
// // // // // // //           sx={{
// // // // // // //             p: 1.5,
// // // // // // //             minWidth: 220,
// // // // // // //             bgcolor: "background.paper",
// // // // // // //             border: `1px solid ${theme.palette.divider}`,
// // // // // // //             borderRadius: 2,
// // // // // // //           }}
// // // // // // //         >
// // // // // // //           <Typography variant="body1" fontWeight="bold" gutterBottom>
// // // // // // //             {label}
// // // // // // //           </Typography>
// // // // // // //           <Stack spacing={1}>
// // // // // // //             <Stack
// // // // // // //               direction="row"
// // // // // // //               justifyContent="space-between"
// // // // // // //               alignItems="center"
// // // // // // //             >
// // // // // // //               <Typography variant="body2" color="text.secondary">
// // // // // // //                 Demand:
// // // // // // //               </Typography>
// // // // // // //               <Typography
// // // // // // //                 variant="body2"
// // // // // // //                 fontWeight="bold"
// // // // // // //               >{`${data.demand}%`}</Typography>
// // // // // // //             </Stack>
// // // // // // //             <Stack
// // // // // // //               direction="row"
// // // // // // //               justifyContent="space-between"
// // // // // // //               alignItems="center"
// // // // // // //             >
// // // // // // //               <Typography variant="body2" color="text.secondary">
// // // // // // //                 Priority:
// // // // // // //               </Typography>
// // // // // // //               <Chip
// // // // // // //                 label={data.priority}
// // // // // // //                 size="small"
// // // // // // //                 color={priorityMuiColor[data.priority] || "default"}
// // // // // // //                 sx={{ fontWeight: 600 }}
// // // // // // //               />
// // // // // // //             </Stack>
// // // // // // //             <Stack
// // // // // // //               direction="row"
// // // // // // //               justifyContent="space-between"
// // // // // // //               alignItems="center"
// // // // // // //             >
// // // // // // //               <Typography variant="body2" color="text.secondary">
// // // // // // //                 Growth:
// // // // // // //               </Typography>
// // // // // // //               <Typography
// // // // // // //                 variant="body2"
// // // // // // //                 fontWeight="bold"
// // // // // // //                 color={
// // // // // // //                   (data.growth || "").startsWith("+")
// // // // // // //                     ? "success.main"
// // // // // // //                     : "error.main"
// // // // // // //                 }
// // // // // // //               >
// // // // // // //                 {data.growth}
// // // // // // //               </Typography>
// // // // // // //             </Stack>
// // // // // // //           </Stack>
// // // // // // //         </Paper>
// // // // // // //       );
// // // // // // //     }
// // // // // // //     return null;
// // // // // // //   };

// // // // // // //   const RoundedVerticalBar = (props) => {
// // // // // // //     const { fill, x, y, width, height } = props;
// // // // // // //     const radius = 8;
// // // // // // //     if (height <= 0) return null;
// // // // // // //     return (
// // // // // // //       <g>
// // // // // // //         <path
// // // // // // //           d={`M${x},${y + radius} A${radius},${radius} 0 0 1 ${
// // // // // // //             x + radius
// // // // // // //           },${y} L${x + width - radius},${y} A${radius},${radius} 0 0 1 ${
// // // // // // //             x + width
// // // // // // //           },${y + radius} L${x + width},${y + height} L${x},${y + height} Z`}
// // // // // // //           fill={fill}
// // // // // // //         />
// // // // // // //       </g>
// // // // // // //     );
// // // // // // //   };

// // // // // // //   const assistantServices = [
// // // // // // //     {
// // // // // // //       id: "resume-review",
// // // // // // //       title: "AI Resume Review",
// // // // // // //       description: "Get detailed feedback & ATS optimization suggestions.",
// // // // // // //       icon: <Assessment />,
// // // // // // //       color: "primary",
// // // // // // //     },
// // // // // // //     {
// // // // // // //       id: "skill-assessment",
// // // // // // //       title: "Skill Gap Analysis",
// // // // // // //       description: "Identify critical skill gaps for your target roles.",
// // // // // // //       icon: <TrendingUp />,
// // // // // // //       color: "success",
// // // // // // //     },
// // // // // // //     {
// // // // // // //       id: "career-roadmap",
// // // // // // //       title: "Career Roadmap",
// // // // // // //       description: "AI-generated path based on your profile and goals.",
// // // // // // //       icon: <Timeline />,
// // // // // // //       color: "warning",
// // // // // // //     },
// // // // // // //     {
// // // // // // //       id: "salary-insights",
// // // // // // //       title: "Salary Insights",
// // // // // // //       description: "Real-time salary benchmarks for roles and locations.",
// // // // // // //       icon: <Language />,
// // // // // // //       color: "info",
// // // // // // //     },
// // // // // // //     {
// // // // // // //       id: "cultural-prep",
// // // // // // //       title: "Cultural Preparation",
// // // // // // //       description: "Master workplace culture for different countries.",
// // // // // // //       icon: <Psychology />,
// // // // // // //       color: "error",
// // // // // // //     },
// // // // // // //   ];

// // // // // // //   const handleServiceClick = async (service) => {
// // // // // // //     const defaultRolePayload = ["AI/ML Engineer"];
// // // // // // //     switch (service.id) {
// // // // // // //       case "resume-review":
// // // // // // //         setResumeReviewDialog(true);
// // // // // // //         setSelectedResumeRoles(defaultRolePayload);
// // // // // // //         await fetchResumeReview(defaultRolePayload);
// // // // // // //         break;
// // // // // // //       case "mock-interview":
// // // // // // //         setMockInterviewDialog(true);
// // // // // // //         break;
// // // // // // //       case "skill-assessment":
// // // // // // //         setSkillGapDialog(true);
// // // // // // //         setSelectedSkillGapRoles(defaultRolePayload);
// // // // // // //         await fetchSkillGap(defaultRolePayload);
// // // // // // //         break;
// // // // // // //       case "career-roadmap":
// // // // // // //         setCareerRoadmapDialog(true);
// // // // // // //         setSelectedRoadmapRoles(defaultRolePayload);
// // // // // // //         await fetchCareerRoadmap(defaultRolePayload);
// // // // // // //         break;
// // // // // // //       case "cultural-prep":
// // // // // // //         setCulturalPrepDialog(true);
// // // // // // //         if (!culturalPrepData) {
// // // // // // //           setCulturalPrepLoading(true);
// // // // // // //           try {
// // // // // // //             const res = await apiClient.get("/ai/cultural-preparation/");
// // // // // // //             const validData = Object.fromEntries(
// // // // // // //               Object.entries(res.data.cultural_preparation).filter(
// // // // // // //                 ([, value]) => !value.error_message
// // // // // // //               )
// // // // // // //             );
// // // // // // //             setCulturalPrepData(validData);
// // // // // // //           } catch (err) {
// // // // // // //             showNotification("Failed to load cultural prep data.", "error");
// // // // // // //           } finally {
// // // // // // //             setCulturalPrepLoading(false);
// // // // // // //           }
// // // // // // //         }
// // // // // // //         break;
// // // // // // //       case "salary-insights":
// // // // // // //         setSalaryInsightsDialog(true);
// // // // // // //         if (!salaryInsightsData) {
// // // // // // //           setSalaryInsightsLoading(true);
// // // // // // //           try {
// // // // // // //             const res = await apiClient.get("/ai/salary-insights/");
// // // // // // //             setSalaryInsightsData(res.data.salary_insights);
// // // // // // //           } catch (err) {
// // // // // // //             showNotification("Failed to load salary insights data.", "error");
// // // // // // //           } finally {
// // // // // // //             setSalaryInsightsLoading(false);
// // // // // // //           }
// // // // // // //         }
// // // // // // //         break;
// // // // // // //       default:
// // // // // // //         showNotification(`${service.title} feature coming soon!`, "info");
// // // // // // //     }
// // // // // // //   };

// // // // // // //   const DialogSkeleton = () => (
// // // // // // //     <Stack spacing={3} sx={{ p: 2, minHeight: 400 }}>
// // // // // // //       <Skeleton variant="rounded" width="60%" height={40} />
// // // // // // //       <Skeleton variant="rounded" width="100%" height={100} />
// // // // // // //       <Skeleton variant="rounded" width="40%" height={30} />
// // // // // // //       <Skeleton variant="rounded" width="100%" height={150} />
// // // // // // //     </Stack>
// // // // // // //   );

// // // // // // //   // Consolidated useEffect for fetching trending skills
// // // // // // //   useEffect(() => {
// // // // // // //     if (isInitialMount.current) {
// // // // // // //       isInitialMount.current = false;
// // // // // // //       // Initial load without debounce
// // // // // // //       const initialLoad = async () => {
// // // // // // //         await fetchTrendingSkills(selectedTrendingRoles);
// // // // // // //         setPageLoading(false);
// // // // // // //       };
// // // // // // //       initialLoad();
// // // // // // //     } else {
// // // // // // //       // Debounced fetch for subsequent updates
// // // // // // //       const handler = setTimeout(() => {
// // // // // // //         fetchTrendingSkills(selectedTrendingRoles);
// // // // // // //       }, 500);

// // // // // // //       return () => {
// // // // // // //         clearTimeout(handler);
// // // // // // //       };
// // // // // // //     }
// // // // // // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // // // // // //   }, [selectedTrendingRoles]);

// // // // // // //   if (pageLoading) {
// // // // // // //     return <PageSkeleton />;
// // // // // // //   }

// // // // // // //   return (
// // // // // // //     <Layout title="AI Career Assistant">
// // // // // // //       <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// // // // // // //         <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
// // // // // // //           <Stack spacing={4}>
// // // // // // //             {/* ROW 1: Header Banner */}
// // // // // // //             <Paper
// // // // // // //               sx={{
// // // // // // //                 bgcolor: "mint.main",
// // // // // // //                 borderRadius: 3,
// // // // // // //                 p: { xs: 2, sm: 3 },
// // // // // // //               }}
// // // // // // //             >
// // // // // // //               <Stack direction="row" alignItems="center" spacing={2}>
// // // // // // //                 <Avatar
// // // // // // //                   sx={{
// // // // // // //                     bgcolor: "primary.main",
// // // // // // //                     color: "primary.contrastText",
// // // // // // //                     width: { xs: 50, sm: 64 },
// // // // // // //                     height: { xs: 50, sm: 64 },
// // // // // // //                   }}
// // // // // // //                 >
// // // // // // //                   <Psychology sx={{ fontSize: { xs: 28, sm: 36 } }} />
// // // // // // //                 </Avatar>
// // // // // // //                 <Box>
// // // // // // //                   <Typography
// // // // // // //                     variant="h4"
// // // // // // //                     component="h1"
// // // // // // //                     fontWeight="bold"
// // // // // // //                     sx={{ typography: { xs: "h5", sm: "h4" } }}
// // // // // // //                   >
// // // // // // //                     AI Career Assistant
// // // // // // //                     <AutoAwesome
// // // // // // //                       sx={{
// // // // // // //                         fontSize: { xs: 22, sm: 28 },
// // // // // // //                         ml: 1,
// // // // // // //                         verticalAlign: "middle",
// // // // // // //                         color: "primary.main",
// // // // // // //                       }}
// // // // // // //                     />
// // // // // // //                   </Typography>
// // // // // // //                   <Typography variant="body1" color="text.secondary">
// // // // // // //                     Your intelligent, multilingual guide to global careers.
// // // // // // //                   </Typography>
// // // // // // //                 </Box>
// // // // // // //               </Stack>
// // // // // // //             </Paper>

// // // // // // //             {/* ROW 2: Welcome Alert */}
// // // // // // //             {showWelcomeCard && (
// // // // // // //               <Alert
// // // // // // //                 severity="info"
// // // // // // //                 variant="filled"
// // // // // // //                 onClose={() => setShowWelcomeCard(false)}
// // // // // // //                 action={
// // // // // // //                   <Button
// // // // // // //                     color="inherit"
// // // // // // //                     size="small"
// // // // // // //                     onClick={() => {
// // // // // // //                       handleServiceClick(assistantServices[0]);
// // // // // // //                       setShowWelcomeCard(false);
// // // // // // //                     }}
// // // // // // //                   >
// // // // // // //                     Start Review
// // // // // // //                   </Button>
// // // // // // //                 }
// // // // // // //                 sx={{
// // // // // // //                   bgcolor: "primary.dark",
// // // // // // //                   color: "primary.contrastText",
// // // // // // //                   borderRadius: 2,
// // // // // // //                 }}
// // // // // // //               >
// // // // // // //                 <AlertTitle sx={{ fontWeight: "bold" }}>Welcome!</AlertTitle>
// // // // // // //                 New here? Start with an AI Resume Review to get personalized
// // // // // // //                 feedback and unlock other insights.
// // // // // // //               </Alert>
// // // // // // //             )}

// // // // // // //             {/* ROW 3: Services List */}
// // // // // // //             <Paper
// // // // // // //               sx={{
// // // // // // //                 p: { xs: 2, sm: 3 },
// // // // // // //                 borderRadius: 3,
// // // // // // //                 bgcolor: "mint.main",
// // // // // // //               }}
// // // // // // //             >
// // // // // // //               <Stack direction="row" alignItems="center" spacing={1} mb={3}>
// // // // // // //                 <Typography variant="h5" component="h2" fontWeight={600}>
// // // // // // //                   AI-Powered Career Services
// // // // // // //                 </Typography>
// // // // // // //                 <RocketLaunch color="primary" />
// // // // // // //               </Stack>
// // // // // // //               <Stack spacing={2}>
// // // // // // //                 {assistantServices.map((service) => (
// // // // // // //                   <ServiceListItem
// // // // // // //                     key={service.id}
// // // // // // //                     color={service.color}
// // // // // // //                     onClick={() => handleServiceClick(service)}
// // // // // // //                   >
// // // // // // //                     <Avatar sx={{ width: 48, height: 48 }}>
// // // // // // //                       {service.icon}
// // // // // // //                     </Avatar>
// // // // // // //                     <Box flexGrow={1}>
// // // // // // //                       <Typography
// // // // // // //                         variant="h6"
// // // // // // //                         component="div"
// // // // // // //                         fontWeight="bold"
// // // // // // //                       >
// // // // // // //                         {service.title}
// // // // // // //                       </Typography>
// // // // // // //                       <Typography variant="body2" color="text.secondary">
// // // // // // //                         {service.description}
// // // // // // //                       </Typography>
// // // // // // //                     </Box>
// // // // // // //                     <IconButton sx={{ ml: 2 }}>
// // // // // // //                       <ArrowForward />
// // // // // // //                     </IconButton>
// // // // // // //                   </ServiceListItem>
// // // // // // //                 ))}
// // // // // // //               </Stack>
// // // // // // //             </Paper>

// // // // // // //             {/* ROW 4: Trending Skills */}
// // // // // // //             <Paper
// // // // // // //               sx={{
// // // // // // //                 p: { xs: 2, sm: 3 },
// // // // // // //                 borderRadius: 3,
// // // // // // //                 bgcolor: "mint.main",
// // // // // // //               }}
// // // // // // //             >
// // // // // // //               <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
// // // // // // //                 <Lightbulb color="primary" />
// // // // // // //                 <Typography variant="h6" fontWeight={600}>
// // // // // // //                   Top In-Demand Skills
// // // // // // //                 </Typography>
// // // // // // //               </Stack>
// // // // // // //               <RoleSelector
// // // // // // //                 selectedRoles={selectedTrendingRoles}
// // // // // // //                 handleRoleChange={handleTrendingRoleChange}
// // // // // // //               />
// // // // // // //               {skillsLoading ? (
// // // // // // //                 <ChartSkeleton /> // Use specific skeleton for chart area
// // // // // // //               ) : Object.keys(trendingSkillsData).length > 0 ? (
// // // // // // //                 <Box>
// // // // // // //                   <Tabs
// // // // // // //                     value={activeTrendingTab}
// // // // // // //                     onChange={(e, val) => setActiveTrendingTab(val)}
// // // // // // //                     variant="scrollable"
// // // // // // //                     scrollButtons="auto"
// // // // // // //                   >
// // // // // // //                     {Object.keys(trendingSkillsData).map((role) => (
// // // // // // //                       <Tab label={role} key={role} />
// // // // // // //                     ))}
// // // // // // //                   </Tabs>
// // // // // // //                   {Object.entries(trendingSkillsData).map(
// // // // // // //                     ([role, skills], index) => {
// // // // // // //                       const sortedSkills = [...skills].sort(
// // // // // // //                         (a, b) => b.demand - a.demand
// // // // // // //                       );
// // // // // // //                       const priorityColors = {
// // // // // // //                         High: theme.palette.primary.main,
// // // // // // //                         Medium: theme.palette.info.main,
// // // // // // //                       };

// // // // // // //                       return (
// // // // // // //                         <TabPanel
// // // // // // //                           value={activeTrendingTab}
// // // // // // //                           index={index}
// // // // // // //                           key={role}
// // // // // // //                         >
// // // // // // //                           <Paper
// // // // // // //                             elevation={0}
// // // // // // //                             sx={{
// // // // // // //                               bgcolor: "background.paper",
// // // // // // //                               borderRadius: 2,
// // // // // // //                               p: { xs: 1, sm: 2 },
// // // // // // //                             }}
// // // // // // //                           >
// // // // // // //                             <Box
// // // // // // //                               sx={{
// // // // // // //                                 height: { xs: 400, md: 500 },
// // // // // // //                                 width: "100%",
// // // // // // //                               }}
// // // // // // //                             >
// // // // // // //                               <ResponsiveContainer width="100%" height="100%">
// // // // // // //                                 <BarChart
// // // // // // //                                   data={sortedSkills}
// // // // // // //                                   margin={{
// // // // // // //                                     top: 30,
// // // // // // //                                     right: 30,
// // // // // // //                                     left: 20,
// // // // // // //                                     bottom: 120,
// // // // // // //                                   }}
// // // // // // //                                 >
// // // // // // //                                   <CartesianGrid
// // // // // // //                                     vertical={false}
// // // // // // //                                     stroke={theme.palette.divider}
// // // // // // //                                     strokeDasharray="3 3"
// // // // // // //                                   />
// // // // // // //                                   <XAxis
// // // // // // //                                     dataKey="skill"
// // // // // // //                                     type="category"
// // // // // // //                                     interval={0}
// // // // // // //                                     angle={-45}
// // // // // // //                                     textAnchor="end"
// // // // // // //                                     tick={{
// // // // // // //                                       fill: theme.palette.text.secondary,
// // // // // // //                                       fontSize: 12,
// // // // // // //                                     }}
// // // // // // //                                     stroke={"transparent"}
// // // // // // //                                   />
// // // // // // //                                   <YAxis
// // // // // // //                                     type="number"
// // // // // // //                                     domain={[0, "dataMax + 15"]}
// // // // // // //                                     allowDecimals={false}
// // // // // // //                                     tickFormatter={(tick) => `${tick}%`}
// // // // // // //                                     stroke={theme.palette.divider}
// // // // // // //                                     tick={{
// // // // // // //                                       fill: theme.palette.text.secondary,
// // // // // // //                                     }}
// // // // // // //                                   />
// // // // // // //                                   <Tooltip
// // // // // // //                                     content={<CustomTooltip />}
// // // // // // //                                     cursor={{
// // // // // // //                                       fill: alpha(
// // // // // // //                                         theme.palette.primary.main,
// // // // // // //                                         0.1
// // // // // // //                                       ),
// // // // // // //                                     }}
// // // // // // //                                   />
// // // // // // //                                   <Bar
// // // // // // //                                     dataKey="demand"
// // // // // // //                                     shape={<RoundedVerticalBar />}
// // // // // // //                                     animationDuration={800}
// // // // // // //                                   >
// // // // // // //                                     {sortedSkills.map((entry, idx) => (
// // // // // // //                                       <Cell
// // // // // // //                                         key={`cell-${idx}`}
// // // // // // //                                         fill={
// // // // // // //                                           priorityColors[entry.priority] ||
// // // // // // //                                           theme.palette.text.disabled
// // // // // // //                                         }
// // // // // // //                                       />
// // // // // // //                                     ))}
// // // // // // //                                     <LabelList
// // // // // // //                                       dataKey="demand"
// // // // // // //                                       position="top"
// // // // // // //                                       offset={8}
// // // // // // //                                       style={{
// // // // // // //                                         fill: theme.palette.text.primary,
// // // // // // //                                         fontSize: "12px",
// // // // // // //                                         fontWeight: "bold",
// // // // // // //                                       }}
// // // // // // //                                       formatter={(value) => `${value}%`}
// // // // // // //                                     />
// // // // // // //                                   </Bar>
// // // // // // //                                 </BarChart>
// // // // // // //                               </ResponsiveContainer>
// // // // // // //                             </Box>
// // // // // // //                           </Paper>
// // // // // // //                         </TabPanel>
// // // // // // //                       );
// // // // // // //                     }
// // // // // // //                   )}
// // // // // // //                 </Box>
// // // // // // //               ) : (
// // // // // // //                 <Box
// // // // // // //                   sx={{
// // // // // // //                     display: "flex",
// // // // // // //                     flexDirection: "column",
// // // // // // //                     alignItems: "center",
// // // // // // //                     justifyContent: "center",
// // // // // // //                     textAlign: "center",
// // // // // // //                     py: 8,
// // // // // // //                     minHeight: 400,
// // // // // // //                   }}
// // // // // // //                 >
// // // // // // //                   <Insights
// // // // // // //                     sx={{ fontSize: 60, color: "text.disabled", mb: 2 }}
// // // // // // //                   />
// // // // // // //                   <Typography variant="h6" color="text.secondary">
// // // // // // //                     Select a role to view in-demand skills
// // // // // // //                   </Typography>
// // // // // // //                   <Typography variant="body2" color="text.disabled">
// // // // // // //                     The chart will update automatically as you make selections.
// // // // // // //                   </Typography>
// // // // // // //                 </Box>
// // // // // // //               )}
// // // // // // //             </Paper>
// // // // // // //           </Stack>
// // // // // // //         </Container>
// // // // // // //       </Box>

// // // // // // //       {/* --- DIALOGS (No layout changes needed below this line) --- */}
// // // // // // //       <Dialog
// // // // // // //         open={resumeReviewDialog}
// // // // // // //         onClose={() => setResumeReviewDialog(false)}
// // // // // // //         maxWidth="lg"
// // // // // // //         fullWidth
// // // // // // //       >
// // // // // // //         <DialogTitle
// // // // // // //           sx={{ bgcolor: "primary.main", color: "primary.contrastText" }}
// // // // // // //         >
// // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // //             <Assessment />{" "}
// // // // // // //             <Typography variant="h6">AI Resume Review</Typography>
// // // // // // //           </Stack>
// // // // // // //         </DialogTitle>
// // // // // // //         <DialogContent dividers>
// // // // // // //           <RoleSelector
// // // // // // //             selectedRoles={selectedResumeRoles}
// // // // // // //             handleRoleChange={(e) =>
// // // // // // //               setSelectedResumeRoles((prev) =>
// // // // // // //                 e.target.checked
// // // // // // //                   ? [...prev, e.target.name]
// // // // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // // // //               )
// // // // // // //             }
// // // // // // //           />
// // // // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // // // //             <Button
// // // // // // //               variant="contained"
// // // // // // //               onClick={() => fetchResumeReview(selectedResumeRoles)}
// // // // // // //             >
// // // // // // //               Generate Report
// // // // // // //             </Button>
// // // // // // //           </Box>
// // // // // // //           <Divider />
// // // // // // //           {resumeReviewLoading ? (
// // // // // // //             <DialogSkeleton />
// // // // // // //           ) : (
// // // // // // //             resumeReviewData && (
// // // // // // //               <>
// // // // // // //                 <Tabs
// // // // // // //                   value={activeResumeTab}
// // // // // // //                   onChange={(e, val) => setActiveResumeTab(val)}
// // // // // // //                   centered
// // // // // // //                   variant="scrollable"
// // // // // // //                   scrollButtons="auto"
// // // // // // //                 >
// // // // // // //                   {Object.keys(resumeReviewData).map((role) => (
// // // // // // //                     <Tab key={role} label={role} />
// // // // // // //                   ))}
// // // // // // //                 </Tabs>
// // // // // // //                 {Object.entries(resumeReviewData).map(([role, data], index) => (
// // // // // // //                   <TabPanel value={activeResumeTab} index={index} key={role}>
// // // // // // //                     <Grid container spacing={3}>
// // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // //                         <Paper variant="outlined" sx={{ p: 2, height: "100%" }}>
// // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // //                             ATS Compatibility: {data.ATS_Compatibility.score}
// // // // // // //                             /100
// // // // // // //                           </Typography>
// // // // // // //                           <LinearProgress
// // // // // // //                             variant="determinate"
// // // // // // //                             value={data.ATS_Compatibility.score}
// // // // // // //                           />
// // // // // // //                           <Typography
// // // // // // //                             variant="subtitle2"
// // // // // // //                             color="error.main"
// // // // // // //                             sx={{ mt: 2 }}
// // // // // // //                           >
// // // // // // //                             Top Issues:
// // // // // // //                           </Typography>
// // // // // // //                           <List dense>
// // // // // // //                             {data.ATS_Compatibility.top_issues.map(
// // // // // // //                               (issue, i) => (
// // // // // // //                                 <ListItem key={i}>
// // // // // // //                                   <ListItemIcon>
// // // // // // //                                     <ErrorOutline
// // // // // // //                                       fontSize="small"
// // // // // // //                                       color="error"
// // // // // // //                                     />
// // // // // // //                                   </ListItemIcon>
// // // // // // //                                   <ListItemText primary={issue} />
// // // // // // //                                 </ListItem>
// // // // // // //                               )
// // // // // // //                             )}
// // // // // // //                           </List>
// // // // // // //                         </Paper>
// // // // // // //                       </Grid>
// // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // //                         <Paper variant="outlined" sx={{ p: 2, height: "100%" }}>
// // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // //                             Content & Format
// // // // // // //                           </Typography>
// // // // // // //                           <Typography variant="body2" paragraph>
// // // // // // //                             {data.Content_Quality_Analysis.summary}
// // // // // // //                           </Typography>
// // // // // // //                           <Typography variant="subtitle2" color="success.main">
// // // // // // //                             Top Strengths:
// // // // // // //                           </Typography>
// // // // // // //                           <List dense>
// // // // // // //                             {data.Content_Quality_Analysis.top_strengths.map(
// // // // // // //                               (strength, i) => (
// // // // // // //                                 <ListItem key={i}>
// // // // // // //                                   <ListItemIcon>
// // // // // // //                                     <CheckCircle
// // // // // // //                                       fontSize="small"
// // // // // // //                                       color="success"
// // // // // // //                                     />
// // // // // // //                                   </ListItemIcon>
// // // // // // //                                   <ListItemText primary={strength} />
// // // // // // //                                 </ListItem>
// // // // // // //                               )
// // // // // // //                             )}
// // // // // // //                           </List>
// // // // // // //                         </Paper>
// // // // // // //                       </Grid>
// // // // // // //                       <Grid item xs={12}>
// // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // //                             Keyword & Section Optimization
// // // // // // //                           </Typography>
// // // // // // //                           <Stack
// // // // // // //                             direction={{ xs: "column", sm: "row" }}
// // // // // // //                             spacing={2}
// // // // // // //                             divider={
// // // // // // //                               <Divider orientation="vertical" flexItem />
// // // // // // //                             }
// // // // // // //                           >
// // // // // // //                             <Box flex={1}>
// // // // // // //                               <Typography variant="subtitle1" fontWeight="bold">
// // // // // // //                                 Missing Keywords
// // // // // // //                               </Typography>
// // // // // // //                               <Box
// // // // // // //                                 sx={{
// // // // // // //                                   display: "flex",
// // // // // // //                                   flexWrap: "wrap",
// // // // // // //                                   gap: 1,
// // // // // // //                                   mt: 1,
// // // // // // //                                 }}
// // // // // // //                               >
// // // // // // //                                 {data.Keyword_Optimization.missing_keywords.map(
// // // // // // //                                   (kw, i) => (
// // // // // // //                                     <Chip
// // // // // // //                                       key={i}
// // // // // // //                                       label={kw}
// // // // // // //                                       color="info"
// // // // // // //                                       size="small"
// // // // // // //                                     />
// // // // // // //                                   )
// // // // // // //                                 )}
// // // // // // //                               </Box>
// // // // // // //                             </Box>
// // // // // // //                             <Box flex={1}>
// // // // // // //                               <Typography variant="subtitle1" fontWeight="bold">
// // // // // // //                                 Missing Sections
// // // // // // //                               </Typography>
// // // // // // //                               <Box
// // // // // // //                                 sx={{
// // // // // // //                                   display: "flex",
// // // // // // //                                   flexWrap: "wrap",
// // // // // // //                                   gap: 1,
// // // // // // //                                   mt: 1,
// // // // // // //                                 }}
// // // // // // //                               >
// // // // // // //                                 {data.Format_and_Structure_Review.missing_sections.map(
// // // // // // //                                   (sec, i) => (
// // // // // // //                                     <Chip
// // // // // // //                                       key={i}
// // // // // // //                                       label={sec}
// // // // // // //                                       color="warning"
// // // // // // //                                       size="small"
// // // // // // //                                     />
// // // // // // //                                   )
// // // // // // //                                 )}
// // // // // // //                               </Box>
// // // // // // //                             </Box>
// // // // // // //                           </Stack>
// // // // // // //                         </Paper>
// // // // // // //                       </Grid>
// // // // // // //                     </Grid>
// // // // // // //                   </TabPanel>
// // // // // // //                 ))}
// // // // // // //               </>
// // // // // // //             )
// // // // // // //           )}
// // // // // // //         </DialogContent>
// // // // // // //         <DialogActions>
// // // // // // //           <Button onClick={() => setResumeReviewDialog(false)}>Close</Button>
// // // // // // //         </DialogActions>
// // // // // // //       </Dialog>
// // // // // // //       <Dialog
// // // // // // //         open={skillGapDialog}
// // // // // // //         onClose={() => setSkillGapDialog(false)}
// // // // // // //         maxWidth="lg"
// // // // // // //         fullWidth
// // // // // // //       >
// // // // // // //         <DialogTitle
// // // // // // //           sx={{ bgcolor: "success.main", color: "success.contrastText" }}
// // // // // // //         >
// // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // //             <TrendingUp />
// // // // // // //             <Typography variant="h6">AI Skill Gap Analysis</Typography>
// // // // // // //           </Stack>
// // // // // // //         </DialogTitle>
// // // // // // //         <DialogContent dividers>
// // // // // // //           <RoleSelector
// // // // // // //             selectedRoles={selectedSkillGapRoles}
// // // // // // //             handleRoleChange={(e) =>
// // // // // // //               setSelectedSkillGapRoles((prev) =>
// // // // // // //                 e.target.checked
// // // // // // //                   ? [...prev, e.target.name]
// // // // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // // // //               )
// // // // // // //             }
// // // // // // //           />
// // // // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // // // //             <Button
// // // // // // //               variant="contained"
// // // // // // //               color="success"
// // // // // // //               onClick={() => fetchSkillGap(selectedSkillGapRoles)}
// // // // // // //             >
// // // // // // //               Generate Analysis
// // // // // // //             </Button>
// // // // // // //           </Box>
// // // // // // //           <Divider />
// // // // // // //           {skillGapLoading ? (
// // // // // // //             <DialogSkeleton />
// // // // // // //           ) : (
// // // // // // //             skillGapData && (
// // // // // // //               <>
// // // // // // //                 <Tabs
// // // // // // //                   value={activeSkillGapTab}
// // // // // // //                   onChange={(e, val) => setActiveSkillGapTab(val)}
// // // // // // //                   centered
// // // // // // //                   variant="scrollable"
// // // // // // //                   scrollButtons="auto"
// // // // // // //                 >
// // // // // // //                   {Object.keys(skillGapData).map((role) => (
// // // // // // //                     <Tab key={role} label={role} />
// // // // // // //                   ))}
// // // // // // //                 </Tabs>
// // // // // // //                 {Object.entries(skillGapData).map(([role, data], index) => (
// // // // // // //                   <TabPanel value={activeSkillGapTab} index={index} key={role}>
// // // // // // //                     <Grid container spacing={2}>
// // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // //                         <Typography variant="h6" gutterBottom>
// // // // // // //                           Your Skills
// // // // // // //                         </Typography>
// // // // // // //                         <Paper
// // // // // // //                           variant="outlined"
// // // // // // //                           sx={{
// // // // // // //                             p: 2,
// // // // // // //                             display: "flex",
// // // // // // //                             flexWrap: "wrap",
// // // // // // //                             gap: 1,
// // // // // // //                           }}
// // // // // // //                         >
// // // // // // //                           <>
// // // // // // //                             {data.Current_Skill_Mapping.map((skill, i) => (
// // // // // // //                               <Chip key={i} label={skill} />
// // // // // // //                             ))}
// // // // // // //                           </>
// // // // // // //                         </Paper>
// // // // // // //                       </Grid>
// // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // //                         <Typography variant="h6" gutterBottom>
// // // // // // //                           In-Demand Market Skills
// // // // // // //                         </Typography>
// // // // // // //                         <Paper
// // // // // // //                           variant="outlined"
// // // // // // //                           sx={{
// // // // // // //                             p: 2,
// // // // // // //                             display: "flex",
// // // // // // //                             flexWrap: "wrap",
// // // // // // //                             gap: 1,
// // // // // // //                           }}
// // // // // // //                         >
// // // // // // //                           <>
// // // // // // //                             {data.Market_Demand_Analysis.map((skill, i) => (
// // // // // // //                               <Chip key={i} label={skill} color="primary" />
// // // // // // //                             ))}
// // // // // // //                           </>
// // // // // // //                         </Paper>
// // // // // // //                       </Grid>
// // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // //                             Recommended Learning Path
// // // // // // //                           </Typography>
// // // // // // //                           <List dense>
// // // // // // //                             {data.Learning_Path.map((path, i) => (
// // // // // // //                               <ListItem key={i}>
// // // // // // //                                 <ListItemIcon>
// // // // // // //                                   <School color="primary" />
// // // // // // //                                 </ListItemIcon>
// // // // // // //                                 <ListItemText primary={path} />
// // // // // // //                               </ListItem>
// // // // // // //                             ))}
// // // // // // //                           </List>
// // // // // // //                         </Paper>
// // // // // // //                       </Grid>
// // // // // // //                       <Grid item xs={12} md={6}>
// // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // //                             Suggested Certifications
// // // // // // //                           </Typography>
// // // // // // //                           <List dense>
// // // // // // //                             {data.Certification_Guidance.map((cert, i) => (
// // // // // // //                               <ListItem key={i}>
// // // // // // //                                 <ListItemIcon>
// // // // // // //                                   <MilitaryTech color="success" />
// // // // // // //                                 </ListItemIcon>
// // // // // // //                                 <ListItemText primary={cert} />
// // // // // // //                               </ListItem>
// // // // // // //                             ))}
// // // // // // //                           </List>
// // // // // // //                         </Paper>
// // // // // // //                       </Grid>
// // // // // // //                     </Grid>
// // // // // // //                   </TabPanel>
// // // // // // //                 ))}
// // // // // // //               </>
// // // // // // //             )
// // // // // // //           )}
// // // // // // //         </DialogContent>
// // // // // // //         <DialogActions>
// // // // // // //           <Button onClick={() => setSkillGapDialog(false)}>Close</Button>
// // // // // // //         </DialogActions>
// // // // // // //       </Dialog>
// // // // // // //       <Dialog
// // // // // // //         open={careerRoadmapDialog}
// // // // // // //         onClose={() => setCareerRoadmapDialog(false)}
// // // // // // //         maxWidth="lg"
// // // // // // //         fullWidth
// // // // // // //       >
// // // // // // //         <DialogTitle
// // // // // // //           sx={{ bgcolor: "warning.main", color: "warning.contrastText" }}
// // // // // // //         >
// // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // //             <Timeline />
// // // // // // //             <Typography variant="h6">Personalized Career Roadmap</Typography>
// // // // // // //           </Stack>
// // // // // // //         </DialogTitle>
// // // // // // //         <DialogContent dividers>
// // // // // // //           <RoleSelector
// // // // // // //             selectedRoles={selectedRoadmapRoles}
// // // // // // //             handleRoleChange={(e) =>
// // // // // // //               setSelectedRoadmapRoles((prev) =>
// // // // // // //                 e.target.checked
// // // // // // //                   ? [...prev, e.target.name]
// // // // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // // // //               )
// // // // // // //             }
// // // // // // //           />
// // // // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // // // //             <Button
// // // // // // //               variant="contained"
// // // // // // //               color="warning"
// // // // // // //               onClick={() => fetchCareerRoadmap(selectedRoadmapRoles)}
// // // // // // //             >
// // // // // // //               Generate Roadmap
// // // // // // //             </Button>
// // // // // // //           </Box>
// // // // // // //           <Divider />
// // // // // // //           {careerRoadmapLoading ? (
// // // // // // //             <DialogSkeleton />
// // // // // // //           ) : (
// // // // // // //             careerRoadmapData && (
// // // // // // //               <>
// // // // // // //                 <Tabs
// // // // // // //                   value={activeRoadmapTab}
// // // // // // //                   onChange={(e, val) => setActiveRoadmapTab(val)}
// // // // // // //                   centered
// // // // // // //                   variant="scrollable"
// // // // // // //                   scrollButtons="auto"
// // // // // // //                 >
// // // // // // //                   {Object.keys(careerRoadmapData).map((role) => (
// // // // // // //                     <Tab key={role} label={role} />
// // // // // // //                   ))}
// // // // // // //                 </Tabs>
// // // // // // //                 {Object.entries(careerRoadmapData).map(
// // // // // // //                   ([role, data], index) => (
// // // // // // //                     <TabPanel value={activeRoadmapTab} index={index} key={role}>
// // // // // // //                       <Typography variant="h6" gutterBottom>
// // // // // // //                         Your AI-Generated Career Path for {role}
// // // // // // //                       </Typography>
// // // // // // //                       <Typography
// // // // // // //                         variant="body1"
// // // // // // //                         paragraph
// // // // // // //                         color="text.secondary"
// // // // // // //                       >
// // // // // // //                         Current Position: {data?.Current_Position || "N/A"} with{" "}
// // // // // // //                         {data?.Experience_Years || "N/A"} years of experience.
// // // // // // //                       </Typography>
// // // // // // //                       <Grid container spacing={2} sx={{ mt: 2 }}>
// // // // // // //                         <Grid item xs={12} md={6}>
// // // // // // //                           <Paper
// // // // // // //                             variant="outlined"
// // // // // // //                             sx={{ p: 2, height: "100%" }}
// // // // // // //                           >
// // // // // // //                             <Typography variant="overline" color="warning.main">
// // // // // // //                               Next Milestone
// // // // // // //                             </Typography>
// // // // // // //                             <Typography variant="h6" fontWeight="bold">
// // // // // // //                               {data?.Next_Milestone?.title || "Not available"}
// // // // // // //                             </Typography>
// // // // // // //                             <Chip
// // // // // // //                               size="small"
// // // // // // //                               label={`Company: ${
// // // // // // //                                 data?.Next_Milestone?.company_type || "N/A"
// // // // // // //                               }`}
// // // // // // //                               sx={{ mt: 1 }}
// // // // // // //                             />
// // // // // // //                           </Paper>
// // // // // // //                         </Grid>
// // // // // // //                         <Grid item xs={12} md={6}>
// // // // // // //                           <Paper
// // // // // // //                             variant="outlined"
// // // // // // //                             sx={{ p: 2, height: "100%" }}
// // // // // // //                           >
// // // // // // //                             <Typography variant="overline" color="success.main">
// // // // // // //                               Long-term Goal
// // // // // // //                             </Typography>
// // // // // // //                             <Typography variant="h6" fontWeight="bold">
// // // // // // //                               {data?.Long_Term_Goal?.title || "Not available"}
// // // // // // //                             </Typography>
// // // // // // //                             <Chip
// // // // // // //                               size="small"
// // // // // // //                               label={`Company: ${
// // // // // // //                                 data?.Long_Term_Goal?.company_type || "N/A"
// // // // // // //                               }`}
// // // // // // //                               sx={{ mt: 1 }}
// // // // // // //                             />
// // // // // // //                           </Paper>
// // // // // // //                         </Grid>
// // // // // // //                       </Grid>
// // // // // // //                       <Divider sx={{ my: 3 }}>
// // // // // // //                         <Chip label="Recommended Actions" />
// // // // // // //                       </Divider>
// // // // // // //                       <List>
// // // // // // //                         {data?.Recommended_Actions?.map((item, i) => (
// // // // // // //                           <ListItem key={i} alignItems="flex-start">
// // // // // // //                             <ListItemIcon>
// // // // // // //                               <Work color="primary" />
// // // // // // //                             </ListItemIcon>
// // // // // // //                             <ListItemText
// // // // // // //                               primary={item.action}
// // // // // // //                               secondary={item.reason}
// // // // // // //                             />
// // // // // // //                           </ListItem>
// // // // // // //                         )) || (
// // // // // // //                           <ListItem>
// // // // // // //                             <ListItemText primary="No actions recommended." />
// // // // // // //                           </ListItem>
// // // // // // //                         )}
// // // // // // //                       </List>
// // // // // // //                     </TabPanel>
// // // // // // //                   )
// // // // // // //                 )}
// // // // // // //               </>
// // // // // // //             )
// // // // // // //           )}
// // // // // // //         </DialogContent>
// // // // // // //         <DialogActions>
// // // // // // //           <Button onClick={() => setCareerRoadmapDialog(false)}>Close</Button>
// // // // // // //         </DialogActions>
// // // // // // //       </Dialog>

// // // // // // //       <Dialog
// // // // // // //         open={culturalPrepDialog}
// // // // // // //         onClose={() => {
// // // // // // //           setCulturalPrepDialog(false);
// // // // // // //           setCulturalPrepTab(0);
// // // // // // //         }}
// // // // // // //         maxWidth="md"
// // // // // // //         fullWidth
// // // // // // //         PaperProps={{ sx: { height: { md: 650 } } }}
// // // // // // //       >
// // // // // // //         <DialogTitle
// // // // // // //           sx={{ bgcolor: "error.main", color: "error.contrastText" }}
// // // // // // //         >
// // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // //             <Psychology />
// // // // // // //             <Typography variant="h6">Cultural Preparation Insights</Typography>
// // // // // // //           </Stack>
// // // // // // //         </DialogTitle>
// // // // // // //         <DialogContent
// // // // // // //           dividers
// // // // // // //           sx={{
// // // // // // //             display: "flex",
// // // // // // //             p: 0,
// // // // // // //             overflow: "hidden",
// // // // // // //             flexDirection: { xs: "column", md: "row" },
// // // // // // //           }}
// // // // // // //         >
// // // // // // //           {culturalPrepLoading ? (
// // // // // // //             <DialogSkeleton />
// // // // // // //           ) : (
// // // // // // //             culturalPrepData && (
// // // // // // //               <>
// // // // // // //                 <Tabs
// // // // // // //                   orientation={
// // // // // // //                     theme.breakpoints.up("md") ? "vertical" : "horizontal"
// // // // // // //                   }
// // // // // // //                   variant="scrollable"
// // // // // // //                   value={culturalPrepTab}
// // // // // // //                   onChange={(e, val) => setCulturalPrepTab(val)}
// // // // // // //                   sx={{
// // // // // // //                     borderRight: { md: 1 },
// // // // // // //                     borderBottom: { xs: 1, md: 0 },
// // // // // // //                     borderColor: "divider",
// // // // // // //                     minWidth: { md: 150 },
// // // // // // //                   }}
// // // // // // //                 >
// // // // // // //                   {Object.values(culturalPrepData).map((region, index) => (
// // // // // // //                     <Tab key={index} label={region.location_name} />
// // // // // // //                   ))}
// // // // // // //                 </Tabs>
// // // // // // //                 <Box
// // // // // // //                   sx={{
// // // // // // //                     flex: { md: 1 },
// // // // // // //                     overflowY: "auto",
// // // // // // //                     p: { xs: 2, md: 3 },
// // // // // // //                   }}
// // // // // // //                 >
// // // // // // //                   {Object.values(culturalPrepData).map((region, index) => (
// // // // // // //                     <TabPanel value={culturalPrepTab} index={index} key={index}>
// // // // // // //                       <Stack spacing={2} sx={{ p: 0 }}>
// // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // //                           <Typography variant="h6">
// // // // // // //                             Cultural Insights
// // // // // // //                           </Typography>
// // // // // // //                           <List dense>
// // // // // // //                             {region.cultural_insights.map((insight, i) => (
// // // // // // //                               <ListItem key={i}>
// // // // // // //                                 <ListItemIcon>
// // // // // // //                                   <ArrowForward fontSize="small" />
// // // // // // //                                 </ListItemIcon>
// // // // // // //                                 <ListItemText primary={insight} />
// // // // // // //                               </ListItem>
// // // // // // //                             ))}
// // // // // // //                           </List>
// // // // // // //                         </Paper>
// // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // //                           <Typography variant="h6">
// // // // // // //                             Communication Tips
// // // // // // //                           </Typography>
// // // // // // //                           <List dense>
// // // // // // //                             {region.communication_tips.map((tip, i) => (
// // // // // // //                               <ListItem key={i}>
// // // // // // //                                 <ListItemIcon>
// // // // // // //                                   <ArrowForward fontSize="small" />
// // // // // // //                                 </ListItemIcon>
// // // // // // //                                 <ListItemText primary={tip} />
// // // // // // //                               </ListItem>
// // // // // // //                             ))}
// // // // // // //                           </List>
// // // // // // //                         </Paper>
// // // // // // //                         <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // //                           <Typography variant="h6">Work Etiquette</Typography>
// // // // // // //                           <List dense>
// // // // // // //                             {region.work_etiquette.map((tip, i) => (
// // // // // // //                               <ListItem key={i}>
// // // // // // //                                 <ListItemIcon>
// // // // // // //                                   <Stars fontSize="small" />
// // // // // // //                                 </ListItemIcon>
// // // // // // //                                 <ListItemText primary={tip} />
// // // // // // //                               </ListItem>
// // // // // // //                             ))}
// // // // // // //                           </List>
// // // // // // //                         </Paper>
// // // // // // //                       </Stack>
// // // // // // //                     </TabPanel>
// // // // // // //                   ))}
// // // // // // //                 </Box>
// // // // // // //               </>
// // // // // // //             )
// // // // // // //           )}
// // // // // // //         </DialogContent>
// // // // // // //         <DialogActions>
// // // // // // //           <Button onClick={() => setCulturalPrepDialog(false)}>Close</Button>
// // // // // // //         </DialogActions>
// // // // // // //       </Dialog>
// // // // // // //       <Dialog
// // // // // // //         open={salaryInsightsDialog}
// // // // // // //         onClose={() => setSalaryInsightsDialog(false)}
// // // // // // //         maxWidth="md"
// // // // // // //         fullWidth
// // // // // // //       >
// // // // // // //         <DialogTitle sx={{ bgcolor: "info.main", color: "info.contrastText" }}>
// // // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // // //             <Language />
// // // // // // //             <Typography variant="h6">Global Salary Insights</Typography>
// // // // // // //           </Stack>
// // // // // // //         </DialogTitle>
// // // // // // //         <DialogContent dividers>
// // // // // // //           {salaryInsightsLoading ? (
// // // // // // //             <DialogSkeleton />
// // // // // // //           ) : (
// // // // // // //             salaryInsightsData && (
// // // // // // //               <Stack spacing={3} sx={{ py: 2 }}>
// // // // // // //                 <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // //                   <Stack
// // // // // // //                     direction="row"
// // // // // // //                     spacing={1.5}
// // // // // // //                     alignItems="center"
// // // // // // //                     mb={2}
// // // // // // //                   >
// // // // // // //                     <LocationOn color="info" />
// // // // // // //                     <Typography variant="h6">
// // // // // // //                       Salary Benchmarks by Location
// // // // // // //                     </Typography>
// // // // // // //                   </Stack>
// // // // // // //                   <Grid container spacing={2}>
// // // // // // //                     {salaryInsightsData.location_based.map((loc, i) => (
// // // // // // //                       <Grid item xs={12} sm={6} key={i}>
// // // // // // //                         <Paper sx={{ p: 2, bgcolor: "action.hover" }}>
// // // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // // //                             {loc.city} ({loc.role})
// // // // // // //                           </Typography>
// // // // // // //                           <Stack spacing={0.5}>
// // // // // // //                             <Typography variant="body2" color="text.secondary">
// // // // // // //                               Min: <strong>{loc.min_salary}</strong>
// // // // // // //                             </Typography>
// // // // // // //                             <Typography
// // // // // // //                               variant="body1"
// // // // // // //                               color="text.primary"
// // // // // // //                               fontWeight="bold"
// // // // // // //                             >
// // // // // // //                               Median: <strong>{loc.median_salary}</strong>
// // // // // // //                             </Typography>
// // // // // // //                             <Typography variant="body2" color="text.secondary">
// // // // // // //                               Max: <strong>{loc.max_salary}</strong>
// // // // // // //                             </Typography>
// // // // // // //                           </Stack>
// // // // // // //                         </Paper>
// // // // // // //                       </Grid>
// // // // // // //                     ))}
// // // // // // //                   </Grid>
// // // // // // //                 </Paper>
// // // // // // //                 <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // //                   <Stack
// // // // // // //                     direction="row"
// // // // // // //                     spacing={1.5}
// // // // // // //                     alignItems="center"
// // // // // // //                     mb={1}
// // // // // // //                   >
// // // // // // //                     <TrendingUp color="primary" />
// // // // // // //                     <Typography variant="h6">
// // // // // // //                       Location Demand Impact on Salary
// // // // // // //                     </Typography>
// // // // // // //                   </Stack>
// // // // // // //                   <List dense>
// // // // // // //                     {salaryInsightsData.salary_insights_summary.map(
// // // // // // //                       (item, i) => (
// // // // // // //                         <ListItem key={i} disableGutters sx={{ px: 1 }}>
// // // // // // //                           <Stack
// // // // // // //                             direction={{ xs: "column", sm: "row" }}
// // // // // // //                             spacing={{ xs: 0.5, sm: 2 }}
// // // // // // //                             alignItems="center"
// // // // // // //                             sx={{ width: "100%" }}
// // // // // // //                           >
// // // // // // //                             <ListItemText
// // // // // // //                               primary={item.role}
// // // // // // //                               sx={{
// // // // // // //                                 width: "100%",
// // // // // // //                                 m: 0,
// // // // // // //                                 flexBasis: { sm: "40%" },
// // // // // // //                                 flexShrink: 0,
// // // // // // //                               }}
// // // // // // //                             />
// // // // // // //                             <Box
// // // // // // //                               sx={{
// // // // // // //                                 width: "100%",
// // // // // // //                                 display: "flex",
// // // // // // //                                 alignItems: "center",
// // // // // // //                               }}
// // // // // // //                             >
// // // // // // //                               <LinearProgress
// // // // // // //                                 variant="determinate"
// // // // // // //                                 value={item.demand_in_salary_percent}
// // // // // // //                                 color="primary"
// // // // // // //                                 sx={{ width: "100%", mr: 1.5 }}
// // // // // // //                               />
// // // // // // //                               <Typography
// // // // // // //                                 variant="body2"
// // // // // // //                                 color="text.secondary"
// // // // // // //                               >{`${item.demand_in_salary_percent}%`}</Typography>
// // // // // // //                             </Box>
// // // // // // //                           </Stack>
// // // // // // //                         </ListItem>
// // // // // // //                       )
// // // // // // //                     )}
// // // // // // //                   </List>
// // // // // // //                 </Paper>
// // // // // // //                 <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // //                   <Stack
// // // // // // //                     direction="row"
// // // // // // //                     spacing={1.5}
// // // // // // //                     alignItems="center"
// // // // // // //                     mb={1}
// // // // // // //                   >
// // // // // // //                     <MonetizationOn color="success" />
// // // // // // //                     <Typography variant="h6">Negotiation Tips</Typography>
// // // // // // //                   </Stack>
// // // // // // //                   <List dense>
// // // // // // //                     {salaryInsightsData.negotiation_tips.map((tip, i) => (
// // // // // // //                       <ListItem key={i}>
// // // // // // //                         <ListItemIcon>
// // // // // // //                           <CheckCircle color="success" fontSize="small" />
// // // // // // //                         </ListItemIcon>
// // // // // // //                         <ListItemText primary={tip} />
// // // // // // //                       </ListItem>
// // // // // // //                     ))}
// // // // // // //                   </List>
// // // // // // //                 </Paper>
// // // // // // //                 <Paper variant="outlined" sx={{ p: 2 }}>
// // // // // // //                   <Stack
// // // // // // //                     direction="row"
// // // // // // //                     spacing={1.5}
// // // // // // //                     alignItems="center"
// // // // // // //                     mb={1}
// // // // // // //                   >
// // // // // // //                     <Timeline color="warning" />
// // // // // // //                     <Typography variant="h6">Market Trends</Typography>
// // // // // // //                   </Stack>
// // // // // // //                   <List>
// // // // // // //                     {salaryInsightsData.market_trends.map((item, i) => (
// // // // // // //                       <ListItem key={i} alignItems="flex-start">
// // // // // // //                         <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
// // // // // // //                           <TrendingFlat color="warning" />
// // // // // // //                         </ListItemIcon>
// // // // // // //                         <ListItemText
// // // // // // //                           primary={item.trend}
// // // // // // //                           secondary={item.insight}
// // // // // // //                           primaryTypographyProps={{ fontWeight: 600 }}
// // // // // // //                         />
// // // // // // //                       </ListItem>
// // // // // // //                     ))}
// // // // // // //                   </List>
// // // // // // //                 </Paper>
// // // // // // //               </Stack>
// // // // // // //             )
// // // // // // //           )}
// // // // // // //         </DialogContent>
// // // // // // //         <DialogActions>
// // // // // // //           <Button onClick={() => setSalaryInsightsDialog(false)}>Close</Button>
// // // // // // //         </DialogActions>
// // // // // // //       </Dialog>
// // // // // // //     </Layout>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default CareerAssistant;
// // // // // // import { useState, useEffect, useRef } from "react"; // Added useRef
// // // // // // import {
// // // // // //   Grid,
// // // // // //   Card,
// // // // // //   CardContent,
// // // // // //   Container,
// // // // // //   Typography,
// // // // // //   Box,
// // // // // //   Button,
// // // // // //   Paper,
// // // // // //   Avatar,
// // // // // //   Chip,
// // // // // //   Dialog,
// // // // // //   DialogTitle,
// // // // // //   DialogContent,
// // // // // //   DialogActions,
// // // // // //   List,
// // // // // //   ListItem,
// // // // // //   ListItemIcon,
// // // // // //   ListItemText,
// // // // // //   Divider,
// // // // // //   Stack,
// // // // // //   LinearProgress,
// // // // // //   Skeleton, // Already imported, great!
// // // // // //   alpha,
// // // // // //   IconButton,
// // // // // //   Tabs,
// // // // // //   Tab,
// // // // // //   FormGroup,
// // // // // //   FormControlLabel,
// // // // // //   Checkbox,
// // // // // //   Alert,
// // // // // //   AlertTitle,
// // // // // // } from "@mui/material";
// // // // // // import { styled, useTheme } from "@mui/material/styles";
// // // // // // import {
// // // // // //   Psychology,
// // // // // //   TrendingUp,
// // // // // //   School,
// // // // // //   Work,
// // // // // //   Language,
// // // // // //   Assessment,
// // // // // //   VideoCall,
// // // // // //   Lightbulb,
// // // // // //   Timeline,
// // // // // //   CheckCircle,
// // // // // //   ErrorOutline,
// // // // // //   ArrowForward,
// // // // // //   MilitaryTech,
// // // // // //   Stars,
// // // // // //   RocketLaunch,
// // // // // //   TrendingDown,
// // // // // //   TrendingFlat,
// // // // // //   LocationOn,
// // // // // //   MonetizationOn,
// // // // // //   AutoAwesome,
// // // // // //   Close as CloseIcon, // For the dismissible alert
// // // // // //   Insights, // For the chart empty state
// // // // // //   Person,
// // // // // // } from "@mui/icons-material";
// // // // // // import {
// // // // // //   BarChart,
// // // // // //   Bar,
// // // // // //   XAxis,
// // // // // //   YAxis,
// // // // // //   CartesianGrid,
// // // // // //   Tooltip,
// // // // // //   ResponsiveContainer,
// // // // // //   Cell,
// // // // // //   LabelList,
// // // // // // } from "recharts";
// // // // // // import Layout from "../common/Layout";
// // // // // // import { useNotification } from "../../context/NotificationContext";
// // // // // // import { useNavigate } from "react-router-dom";
// // // // // // import apiClient from "../../context/apiClient";

// // // // // // // --- Skeleton Components ---

// // // // // // const HeaderSkeleton = () => (
// // // // // //   <Paper sx={{ bgcolor: "mint.main", borderRadius: 3, p: { xs: 2, sm: 3 } }}>
// // // // // //     <Stack direction="row" alignItems="center" spacing={2}>
// // // // // //       <Skeleton variant="circular" width={64} height={64} />
// // // // // //       <Box sx={{ flex: 1 }}>
// // // // // //         <Skeleton variant="text" width="40%" height={48} />
// // // // // //         <Skeleton variant="text" width="60%" height={24} />
// // // // // //       </Box>
// // // // // //     </Stack>
// // // // // //   </Paper>
// // // // // // );

// // // // // // const ServiceListItemSkeleton = () => (
// // // // // //   <Paper
// // // // // //     sx={{
// // // // // //       display: "flex",
// // // // // //       flexDirection: "row",
// // // // // //       alignItems: "center",
// // // // // //       padding: 2,
// // // // // //       borderRadius: "12px",
// // // // // //       border: (theme) => `1px solid ${theme.palette.divider}`,
// // // // // //     }}
// // // // // //   >
// // // // // //     <Skeleton variant="circular" width={48} height={48} sx={{ mr: 2 }} />
// // // // // //     <Box flexGrow={1}>
// // // // // //       <Skeleton variant="text" height={30} width="50%" />
// // // // // //       <Skeleton variant="text" height={20} width="80%" />
// // // // // //     </Box>
// // // // // //     <Skeleton variant="circular" width={24} height={24} sx={{ ml: 2 }} />
// // // // // //   </Paper>
// // // // // // );

// // // // // // const ServicesSkeleton = () => (
// // // // // //   <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, bgcolor: "mint.main" }}>
// // // // // //     <Skeleton variant="text" width="60%" height={40} sx={{ mb: 3 }} />
// // // // // //     <Stack spacing={2}>
// // // // // //       {[...Array(5)].map((_, index) => (
// // // // // //         <ServiceListItemSkeleton key={index} />
// // // // // //       ))}
// // // // // //     </Stack>
// // // // // //   </Paper>
// // // // // // );

// // // // // // const TrendingSkillsSkeleton = () => (
// // // // // //   <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, bgcolor: "mint.main" }}>
// // // // // //     <Skeleton variant="text" width="40%" height={40} sx={{ mb: 2 }} />
// // // // // //     <Stack
// // // // // //       direction="row"
// // // // // //       spacing={2}
// // // // // //       sx={{ mb: 3, justifyContent: "center", flexWrap: "wrap", gap: 1 }}
// // // // // //     >
// // // // // //       <Skeleton variant="rounded" width={150} height={42} />
// // // // // //       <Skeleton variant="rounded" width={150} height={42} />
// // // // // //       <Skeleton variant="rounded" width={150} height={42} />
// // // // // //     </Stack>
// // // // // //     <Skeleton variant="rounded" width="100%" height={500} />
// // // // // //   </Paper>
// // // // // // );

// // // // // // const PageSkeleton = () => (
// // // // // //   <Layout title="AI Career Assistant">
// // // // // //     <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// // // // // //       <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
// // // // // //         <Stack spacing={4}>
// // // // // //           <HeaderSkeleton />
// // // // // //           <ServicesSkeleton />
// // // // // //           <TrendingSkillsSkeleton />
// // // // // //         </Stack>
// // // // // //       </Container>
// // // // // //     </Box>
// // // // // //   </Layout>
// // // // // // );

// // // // // // const ChartSkeleton = () => (
// // // // // //   <Box sx={{ height: { xs: 400, md: 500 }, width: "100%", pt: 2 }}>
// // // // // //     <Skeleton variant="rounded" width="100%" height="100%" />
// // // // // //   </Box>
// // // // // // );

// // // // // // // --- Helper Components ---

// // // // // // const ServiceListItem = styled(Paper)(({ theme, color = "primary" }) => ({
// // // // // //   backgroundColor: theme.palette.background.paper, // Changed for better contrast within a Paper container
// // // // // //   display: "flex",
// // // // // //   flexDirection: "row",
// // // // // //   alignItems: "center",
// // // // // //   padding: theme.spacing(2),
// // // // // //   borderRadius: "12px",
// // // // // //   cursor: "pointer",
// // // // // //   transition:
// // // // // //     "background-color 0.3s ease, border-color 0.3s ease, transform 0.2s ease-in-out",
// // // // // //   border: `1px solid ${theme.palette.divider}`,
// // // // // //   "&:hover": {
// // // // // //     backgroundColor: alpha(
// // // // // //       theme.palette[color]?.main || theme.palette.primary.main,
// // // // // //       0.08
// // // // // //     ),
// // // // // //     borderColor: theme.palette[color]?.main || theme.palette.primary.main,
// // // // // //     transform: "scale(1.02)",
// // // // // //   },
// // // // // //   ".MuiAvatar-root": {
// // // // // //     backgroundColor: alpha(
// // // // // //       theme.palette[color]?.main || theme.palette.primary.main,
// // // // // //       0.15
// // // // // //     ),
// // // // // //     color: theme.palette[color]?.main || theme.palette.primary.main,
// // // // // //     marginRight: theme.spacing(2),
// // // // // //   },
// // // // // // }));

// // // // // // function TabPanel(props) {
// // // // // //   const { children, value, index, ...other } = props;
// // // // // //   return (
// // // // // //     <div
// // // // // //       role="tabpanel"
// // // // // //       hidden={value !== index}
// // // // // //       id={`tabpanel-${index}`}
// // // // // //       aria-labelledby={`tab-${index}`}
// // // // // //       {...other}
// // // // // //     >
// // // // // //       {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
// // // // // //     </div>
// // // // // //   );
// // // // // // }

// // // // // // // --- Main Component ---

// // // // // // const CareerAssistant = () => {
// // // // // //   const theme = useTheme();
// // // // // //   const { showNotification } = useNotification();
// // // // // //   const navigate = useNavigate();
// // // // // //   const isInitialMount = useRef(true);

// // // // // //   const availableRoles = [
// // // // // //     "AI/ML Engineer",
// // // // // //     "Data Scientist",
// // // // // //     "Business Analyst",
// // // // // //   ];

// // // // // //   // --- State Declarations ---
// // // // // //   const [pageLoading, setPageLoading] = useState(true); // For initial page load
// // // // // //   const [showWelcomeCard, setShowWelcomeCard] = useState(true);
// // // // // //   const [mockInterviewDialog, setMockInterviewDialog] = useState(false);
// // // // // //   const [resumeReviewDialog, setResumeReviewDialog] = useState(false);
// // // // // //   const [skillGapDialog, setSkillGapDialog] = useState(false);
// // // // // //   const [careerRoadmapDialog, setCareerRoadmapDialog] = useState(false);
// // // // // //   const [culturalPrepDialog, setCulturalPrepDialog] = useState(false);
// // // // // //   const [salaryInsightsDialog, setSalaryInsightsDialog] = useState(false);
// // // // // //   const [trendingSkillsData, setTrendingSkillsData] = useState({});
// // // // // //   const [skillsLoading, setSkillsLoading] = useState(true);
// // // // // //   const [selectedTrendingRoles, setSelectedTrendingRoles] = useState([
// // // // // //     "AI/ML Engineer",
// // // // // //   ]);
// // // // // //   const [activeTrendingTab, setActiveTrendingTab] = useState(0);
// // // // // //   const [resumeReviewData, setResumeReviewData] = useState(null);
// // // // // //   const [resumeReviewLoading, setResumeReviewLoading] = useState(false);
// // // // // //   const [selectedResumeRoles, setSelectedResumeRoles] = useState([]);
// // // // // //   const [activeResumeTab, setActiveResumeTab] = useState(0);
// // // // // //   const [skillGapData, setSkillGapData] = useState(null);
// // // // // //   const [skillGapLoading, setSkillGapLoading] = useState(false);
// // // // // //   const [selectedSkillGapRoles, setSelectedSkillGapRoles] = useState([]);
// // // // // //   const [activeSkillGapTab, setActiveSkillGapTab] = useState(0);
// // // // // //   const [careerRoadmapData, setCareerRoadmapData] = useState(null);
// // // // // //   const [careerRoadmapLoading, setCareerRoadmapLoading] = useState(false);
// // // // // //   const [selectedRoadmapRoles, setSelectedRoadmapRoles] = useState([]);
// // // // // //   const [activeRoadmapTab, setActiveRoadmapTab] = useState(0);
// // // // // //   const [culturalPrepData, setCulturalPrepData] = useState(null);
// // // // // //   const [culturalPrepLoading, setCulturalPrepLoading] = useState(false);
// // // // // //   const [culturalPrepTab, setCulturalPrepTab] = useState(0);
// // // // // //   const [salaryInsightsData, setSalaryInsightsData] = useState(null);
// // // // // //   const [salaryInsightsLoading, setSalaryInsightsLoading] = useState(false);

// // // // // //   // --- Data Fetching Functions ---

// // // // // //   const fetchTrendingSkills = async (roles) => {
// // // // // //     if (!roles || roles.length === 0) {
// // // // // //       setTrendingSkillsData({});
// // // // // //       setSkillsLoading(false);
// // // // // //       return;
// // // // // //     }
// // // // // //     setSkillsLoading(true);
// // // // // //     try {
// // // // // //       const response = await apiClient.post("/trending-skills/", {
// // // // // //         selected_roles: roles,
// // // // // //       });
// // // // // //       const transformedData = {};
// // // // // //       for (const [role, skills] of Object.entries(response.data)) {
// // // // // //         transformedData[role] = skills.map((skill) => ({
// // // // // //           skill: skill.skill,
// // // // // //           demand: parseInt(skill.demand) || 0,
// // // // // //           growth: skill.increase || "N/A",
// // // // // //           priority: skill.priority,
// // // // // //         }));
// // // // // //       }
// // // // // //       setTrendingSkillsData(transformedData);
// // // // // //       setActiveTrendingTab(0);
// // // // // //     } catch (error) {
// // // // // //       console.error("Failed to fetch trending skills:", error);
// // // // // //       showNotification("Could not load trending skills data.", "error");
// // // // // //       setTrendingSkillsData({});
// // // // // //     } finally {
// // // // // //       setSkillsLoading(false);
// // // // // //     }
// // // // // //   };

// // // // // //   const fetchResumeReview = async (roles) => {
// // // // // //     if (!roles || roles.length === 0) {
// // // // // //       setResumeReviewData({});
// // // // // //       return;
// // // // // //     }
// // // // // //     setResumeReviewLoading(true);
// // // // // //     try {
// // // // // //       const response = await apiClient.post("/resume/review-talent/", {
// // // // // //         target_roles: roles,
// // // // // //       });
// // // // // //       setResumeReviewData(response.data);
// // // // // //       setActiveResumeTab(0);
// // // // // //     } catch (error) {
// // // // // //       showNotification("Failed to load resume review data.", "error");
// // // // // //     } finally {
// // // // // //       setResumeReviewLoading(false);
// // // // // //     }
// // // // // //   };
// // // // // //   const fetchSkillGap = async (roles) => {
// // // // // //     if (!roles || roles.length === 0) {
// // // // // //       setSkillGapData({});
// // // // // //       return;
// // // // // //     }
// // // // // //     setSkillGapLoading(true);
// // // // // //     try {
// // // // // //       const response = await apiClient.post("/resume/skill-gap/", {
// // // // // //         selected_roles: roles,
// // // // // //       });
// // // // // //       setSkillGapData(response.data);
// // // // // //       setActiveSkillGapTab(0);
// // // // // //     } catch (error) {
// // // // // //       showNotification("Failed to load skill gap analysis.", "error");
// // // // // //     } finally {
// // // // // //       setSkillGapLoading(false);
// // // // // //     }
// // // // // //   };
// // // // // //   const fetchCareerRoadmap = async (roles) => {
// // // // // //     if (!roles || roles.length === 0) {
// // // // // //       setCareerRoadmapData({});
// // // // // //       return;
// // // // // //     }
// // // // // //     setCareerRoadmapLoading(true);
// // // // // //     try {
// // // // // //       const response = await apiClient.post("/resume/career-roadmap/", {
// // // // // //         target_roles: roles,
// // // // // //       });
// // // // // //       setCareerRoadmapData(response.data);
// // // // // //       setActiveRoadmapTab(0);
// // // // // //     } catch (error) {
// // // // // //       showNotification("Failed to load career roadmap.", "error");
// // // // // //       setCareerRoadmapData({});
// // // // // //     } finally {
// // // // // //       setCareerRoadmapLoading(false);
// // // // // //     }
// // // // // //   };

// // // // // //   // --- Handlers ---
// // // // // //   const handleTrendingRoleChange = (event) => {
// // // // // //     const { name, checked } = event.target;
// // // // // //     setSelectedTrendingRoles((prev) =>
// // // // // //       checked ? [...prev, name] : prev.filter((role) => role !== name)
// // // // // //     );
// // // // // //   };

// // // // // //   // --- Child Components ---
// // // // // //   const RoleSelector = ({ selectedRoles, handleRoleChange }) => (
// // // // // //     <FormGroup row sx={{ mb: 2, justifyContent: "center", flexWrap: "wrap" }}>
// // // // // //       {availableRoles.map((role) => (
// // // // // //         <FormControlLabel
// // // // // //           key={role}
// // // // // //           control={
// // // // // //             <Checkbox
// // // // // //               checked={selectedRoles.includes(role)}
// // // // // //               onChange={handleRoleChange}
// // // // // //               name={role}
// // // // // //             />
// // // // // //           }
// // // // // //           label={role}
// // // // // //         />
// // // // // //       ))}
// // // // // //     </FormGroup>
// // // // // //   );

// // // // // //   const CustomTooltip = ({ active, payload, label }) => {
// // // // // //     if (active && payload && payload.length) {
// // // // // //       const data = payload[0].payload;
// // // // // //       const priorityMuiColor = {
// // // // // //         High: "primary",
// // // // // //         Medium: "info",
// // // // // //       };
// // // // // //       return (
// // // // // //         <Paper
// // // // // //           elevation={3}
// // // // // //           sx={{
// // // // // //             p: 1.5,
// // // // // //             minWidth: 220,
// // // // // //             bgcolor: "background.paper",
// // // // // //             border: `1px solid ${theme.palette.divider}`,
// // // // // //             borderRadius: 2,
// // // // // //           }}
// // // // // //         >
// // // // // //           <Typography variant="body1" fontWeight="bold" gutterBottom>
// // // // // //             {label}
// // // // // //           </Typography>
// // // // // //           <Stack spacing={1}>
// // // // // //             <Stack
// // // // // //               direction="row"
// // // // // //               justifyContent="space-between"
// // // // // //               alignItems="center"
// // // // // //             >
// // // // // //               <Typography variant="body2" color="text.secondary">
// // // // // //                 Demand:
// // // // // //               </Typography>
// // // // // //               <Typography
// // // // // //                 variant="body2"
// // // // // //                 fontWeight="bold"
// // // // // //               >{`${data.demand}%`}</Typography>
// // // // // //             </Stack>
// // // // // //             <Stack
// // // // // //               direction="row"
// // // // // //               justifyContent="space-between"
// // // // // //               alignItems="center"
// // // // // //             >
// // // // // //               <Typography variant="body2" color="text.secondary">
// // // // // //                 Priority:
// // // // // //               </Typography>
// // // // // //               <Chip
// // // // // //                 label={data.priority}
// // // // // //                 size="small"
// // // // // //                 color={priorityMuiColor[data.priority] || "default"}
// // // // // //                 sx={{ fontWeight: 600 }}
// // // // // //               />
// // // // // //             </Stack>
// // // // // //             <Stack
// // // // // //               direction="row"
// // // // // //               justifyContent="space-between"
// // // // // //               alignItems="center"
// // // // // //             >
// // // // // //               <Typography variant="body2" color="text.secondary">
// // // // // //                 Growth:
// // // // // //               </Typography>
// // // // // //               <Typography
// // // // // //                 variant="body2"
// // // // // //                 fontWeight="bold"
// // // // // //                 color={
// // // // // //                   (data.growth || "").startsWith("+")
// // // // // //                     ? "success.main"
// // // // // //                     : "error.main"
// // // // // //                 }
// // // // // //               >
// // // // // //                 {data.growth}
// // // // // //               </Typography>
// // // // // //             </Stack>
// // // // // //           </Stack>
// // // // // //         </Paper>
// // // // // //       );
// // // // // //     }
// // // // // //     return null;
// // // // // //   };

// // // // // //   const RoundedVerticalBar = (props) => {
// // // // // //     const { fill, x, y, width, height } = props;
// // // // // //     const radius = 8;
// // // // // //     if (height <= 0) return null;
// // // // // //     return (
// // // // // //       <g>
// // // // // //         <path
// // // // // //           d={`M${x},${y + radius} A${radius},${radius} 0 0 1 ${
// // // // // //             x + radius
// // // // // //           },${y} L${x + width - radius},${y} A${radius},${radius} 0 0 1 ${
// // // // // //             x + width
// // // // // //           },${y + radius} L${x + width},${y + height} L${x},${y + height} Z`}
// // // // // //           fill={fill}
// // // // // //         />
// // // // // //       </g>
// // // // // //     );
// // // // // //   };

// // // // // //   const assistantServices = [
// // // // // //     {
// // // // // //       id: "resume-review",
// // // // // //       title: "AI Resume Review",
// // // // // //       description: "Get detailed feedback & ATS optimization suggestions.",
// // // // // //       icon: <Assessment />,
// // // // // //       color: "primary",
// // // // // //     },
// // // // // //     {
// // // // // //       id: "skill-assessment",
// // // // // //       title: "Skill Gap Analysis",
// // // // // //       description: "Identify critical skill gaps for your target roles.",
// // // // // //       icon: <TrendingUp />,
// // // // // //       color: "success",
// // // // // //     },
// // // // // //     {
// // // // // //       id: "career-roadmap",
// // // // // //       title: "Career Roadmap",
// // // // // //       description: "AI-generated path based on your profile and goals.",
// // // // // //       icon: <Timeline />,
// // // // // //       color: "warning",
// // // // // //     },
// // // // // //     {
// // // // // //       id: "salary-insights",
// // // // // //       title: "Salary Insights",
// // // // // //       description: "Real-time salary benchmarks for roles and locations.",
// // // // // //       icon: <Language />,
// // // // // //       color: "info",
// // // // // //     },
// // // // // //     {
// // // // // //       id: "cultural-prep",
// // // // // //       title: "Cultural Preparation",
// // // // // //       description: "Master workplace culture for different countries.",
// // // // // //       icon: <Psychology />,
// // // // // //       color: "error",
// // // // // //     },
// // // // // //   ];

// // // // // //   const handleServiceClick = async (service) => {
// // // // // //     const defaultRolePayload = ["AI/ML Engineer"];
// // // // // //     switch (service.id) {
// // // // // //       case "resume-review":
// // // // // //         setResumeReviewDialog(true);
// // // // // //         setSelectedResumeRoles(defaultRolePayload);
// // // // // //         await fetchResumeReview(defaultRolePayload);
// // // // // //         break;
// // // // // //       case "mock-interview":
// // // // // //         setMockInterviewDialog(true);
// // // // // //         break;
// // // // // //       case "skill-assessment":
// // // // // //         setSkillGapDialog(true);
// // // // // //         setSelectedSkillGapRoles(defaultRolePayload);
// // // // // //         await fetchSkillGap(defaultRolePayload);
// // // // // //         break;
// // // // // //       case "career-roadmap":
// // // // // //         setCareerRoadmapDialog(true);
// // // // // //         setSelectedRoadmapRoles(defaultRolePayload);
// // // // // //         await fetchCareerRoadmap(defaultRolePayload);
// // // // // //         break;
// // // // // //       case "cultural-prep":
// // // // // //         setCulturalPrepDialog(true);
// // // // // //         if (!culturalPrepData) {
// // // // // //           setCulturalPrepLoading(true);
// // // // // //           try {
// // // // // //             const res = await apiClient.get("/ai/cultural-preparation/");
// // // // // //             const validData = Object.fromEntries(
// // // // // //               Object.entries(res.data.cultural_preparation).filter(
// // // // // //                 ([, value]) => !value.error_message
// // // // // //               )
// // // // // //             );
// // // // // //             setCulturalPrepData(validData);
// // // // // //           } catch (err) {
// // // // // //             showNotification("Failed to load cultural prep data.", "error");
// // // // // //           } finally {
// // // // // //             setCulturalPrepLoading(false);
// // // // // //           }
// // // // // //         }
// // // // // //         break;
// // // // // //       case "salary-insights":
// // // // // //         setSalaryInsightsDialog(true);
// // // // // //         if (!salaryInsightsData) {
// // // // // //           setSalaryInsightsLoading(true);
// // // // // //           try {
// // // // // //             const res = await apiClient.get("/ai/salary-insights/");
// // // // // //             setSalaryInsightsData(res.data.salary_insights);
// // // // // //           } catch (err) {
// // // // // //             showNotification("Failed to load salary insights data.", "error");
// // // // // //           } finally {
// // // // // //             setSalaryInsightsLoading(false);
// // // // // //           }
// // // // // //         }
// // // // // //         break;
// // // // // //       default:
// // // // // //         showNotification(`${service.title} feature coming soon!`, "info");
// // // // // //     }
// // // // // //   };

// // // // // //   const DialogSkeleton = () => (
// // // // // //     <Stack spacing={3} sx={{ p: 2, minHeight: 400 }}>
// // // // // //       <Skeleton variant="rounded" width="60%" height={40} />
// // // // // //       <Skeleton variant="rounded" width="100%" height={100} />
// // // // // //       <Skeleton variant="rounded" width="40%" height={30} />
// // // // // //       <Skeleton variant="rounded" width="100%" height={150} />
// // // // // //     </Stack>
// // // // // //   );

// // // // // //   // Consolidated useEffect for fetching trending skills
// // // // // //   useEffect(() => {
// // // // // //     if (isInitialMount.current) {
// // // // // //       isInitialMount.current = false;
// // // // // //       // Initial load without debounce
// // // // // //       const initialLoad = async () => {
// // // // // //         await fetchTrendingSkills(selectedTrendingRoles);
// // // // // //         setPageLoading(false);
// // // // // //       };
// // // // // //       initialLoad();
// // // // // //     } else {
// // // // // //       // Debounced fetch for subsequent updates
// // // // // //       const handler = setTimeout(() => {
// // // // // //         fetchTrendingSkills(selectedTrendingRoles);
// // // // // //       }, 500);

// // // // // //       return () => {
// // // // // //         clearTimeout(handler);
// // // // // //       };
// // // // // //     }
// // // // // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // // // // //   }, [selectedTrendingRoles]);

// // // // // //   if (pageLoading) {
// // // // // //     return <PageSkeleton />;
// // // // // //   }

// // // // // //   return (
// // // // // //     <Layout title="AI Career Assistant">
// // // // // //       <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// // // // // //         <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
// // // // // //           <Stack spacing={4}>
// // // // // //             {/* ROW 1: Header Banner */}
// // // // // //             <Paper
// // // // // //               sx={{
// // // // // //                 bgcolor: "mint.main",
// // // // // //                 borderRadius: 3,
// // // // // //                 p: { xs: 2, sm: 3 },
// // // // // //               }}
// // // // // //             >
// // // // // //               <Stack direction="row" alignItems="center" spacing={2}>
// // // // // //                 <Avatar
// // // // // //                   sx={{
// // // // // //                     bgcolor: "primary.main",
// // // // // //                     color: "primary.contrastText",
// // // // // //                     width: { xs: 50, sm: 64 },
// // // // // //                     height: { xs: 50, sm: 64 },
// // // // // //                   }}
// // // // // //                 >
// // // // // //                   <Psychology sx={{ fontSize: { xs: 28, sm: 36 } }} />
// // // // // //                 </Avatar>
// // // // // //                 <Box>
// // // // // //                   <Typography
// // // // // //                     variant="h4"
// // // // // //                     component="h1"
// // // // // //                     fontWeight="bold"
// // // // // //                     sx={{ typography: { xs: "h5", sm: "h4" } }}
// // // // // //                   >
// // // // // //                     AI Career Assistant
// // // // // //                     <AutoAwesome
// // // // // //                       sx={{
// // // // // //                         fontSize: { xs: 22, sm: 28 },
// // // // // //                         ml: 1,
// // // // // //                         verticalAlign: "middle",
// // // // // //                         color: "primary.main",
// // // // // //                       }}
// // // // // //                     />
// // // // // //                   </Typography>
// // // // // //                   <Typography variant="body1" color="text.secondary">
// // // // // //                     Your intelligent, multilingual guide to global careers.
// // // // // //                   </Typography>
// // // // // //                 </Box>
// // // // // //               </Stack>
// // // // // //             </Paper>

// // // // // //             {/* ROW 2: Welcome Alert */}
// // // // // //             {showWelcomeCard && (
// // // // // //               <Alert
// // // // // //                 severity="info"
// // // // // //                 variant="filled"
// // // // // //                 onClose={() => setShowWelcomeCard(false)}
// // // // // //                 action={
// // // // // //                   <Button
// // // // // //                     color="inherit"
// // // // // //                     size="small"
// // // // // //                     onClick={() => {
// // // // // //                       handleServiceClick(assistantServices[0]);
// // // // // //                       setShowWelcomeCard(false);
// // // // // //                     }}
// // // // // //                   >
// // // // // //                     Start Review
// // // // // //                   </Button>
// // // // // //                 }
// // // // // //                 sx={{
// // // // // //                   bgcolor: "primary.dark",
// // // // // //                   color: "primary.contrastText",
// // // // // //                   borderRadius: 2,
// // // // // //                 }}
// // // // // //               >
// // // // // //                 <AlertTitle sx={{ fontWeight: "bold" }}>Welcome!</AlertTitle>
// // // // // //                 New here? Start with an AI Resume Review to get personalized
// // // // // //                 feedback and unlock other insights.
// // // // // //               </Alert>
// // // // // //             )}

// // // // // //             {/* ROW 3: Services List */}
// // // // // //             <Paper
// // // // // //               sx={{
// // // // // //                 p: { xs: 2, sm: 3 },
// // // // // //                 borderRadius: 3,
// // // // // //                 bgcolor: "mint.main",
// // // // // //               }}
// // // // // //             >
// // // // // //               <Stack direction="row" alignItems="center" spacing={1} mb={3}>
// // // // // //                 <Typography variant="h5" component="h2" fontWeight={600}>
// // // // // //                   AI-Powered Career Services
// // // // // //                 </Typography>
// // // // // //                 <RocketLaunch color="primary" />
// // // // // //               </Stack>
// // // // // //               <Stack spacing={2}>
// // // // // //                 {assistantServices.map((service) => (
// // // // // //                   <ServiceListItem
// // // // // //                     key={service.id}
// // // // // //                     color={service.color}
// // // // // //                     onClick={() => handleServiceClick(service)}
// // // // // //                   >
// // // // // //                     <Avatar sx={{ width: 48, height: 48 }}>
// // // // // //                       {service.icon}
// // // // // //                     </Avatar>
// // // // // //                     <Box flexGrow={1}>
// // // // // //                       <Typography
// // // // // //                         variant="h6"
// // // // // //                         component="div"
// // // // // //                         fontWeight="bold"
// // // // // //                       >
// // // // // //                         {service.title}
// // // // // //                       </Typography>
// // // // // //                       <Typography variant="body2" color="text.secondary">
// // // // // //                         {service.description}
// // // // // //                       </Typography>
// // // // // //                     </Box>
// // // // // //                     <IconButton sx={{ ml: 2 }}>
// // // // // //                       <ArrowForward />
// // // // // //                     </IconButton>
// // // // // //                   </ServiceListItem>
// // // // // //                 ))}
// // // // // //               </Stack>
// // // // // //             </Paper>

// // // // // //             {/* ROW 4: Trending Skills */}
// // // // // //             <Paper
// // // // // //               sx={{
// // // // // //                 p: { xs: 2, sm: 3 },
// // // // // //                 borderRadius: 3,
// // // // // //                 bgcolor: "mint.main",
// // // // // //               }}
// // // // // //             >
// // // // // //               <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
// // // // // //                 <Lightbulb color="primary" />
// // // // // //                 <Typography variant="h6" fontWeight={600}>
// // // // // //                   Top In-Demand Skills
// // // // // //                 </Typography>
// // // // // //               </Stack>
// // // // // //               <RoleSelector
// // // // // //                 selectedRoles={selectedTrendingRoles}
// // // // // //                 handleRoleChange={handleTrendingRoleChange}
// // // // // //               />
// // // // // //               {skillsLoading ? (
// // // // // //                 <ChartSkeleton /> // Use specific skeleton for chart area
// // // // // //               ) : Object.keys(trendingSkillsData).length > 0 ? (
// // // // // //                 <Box>
// // // // // //                   <Tabs
// // // // // //                     value={activeTrendingTab}
// // // // // //                     onChange={(e, val) => setActiveTrendingTab(val)}
// // // // // //                     variant="scrollable"
// // // // // //                     scrollButtons="auto"
// // // // // //                   >
// // // // // //                     {Object.keys(trendingSkillsData).map((role) => (
// // // // // //                       <Tab label={role} key={role} />
// // // // // //                     ))}
// // // // // //                   </Tabs>
// // // // // //                   {Object.entries(trendingSkillsData).map(
// // // // // //                     ([role, skills], index) => {
// // // // // //                       const sortedSkills = [...skills].sort(
// // // // // //                         (a, b) => b.demand - a.demand
// // // // // //                       );
// // // // // //                       const priorityColors = {
// // // // // //                         High: theme.palette.primary.main,
// // // // // //                         Medium: theme.palette.info.main,
// // // // // //                       };

// // // // // //                       return (
// // // // // //                         <TabPanel
// // // // // //                           value={activeTrendingTab}
// // // // // //                           index={index}
// // // // // //                           key={role}
// // // // // //                         >
// // // // // //                           <Paper
// // // // // //                             elevation={0}
// // // // // //                             sx={{
// // // // // //                               bgcolor: "background.paper",
// // // // // //                               borderRadius: 2,
// // // // // //                               p: { xs: 1, sm: 2 },
// // // // // //                             }}
// // // // // //                           >
// // // // // //                             <Box
// // // // // //                               sx={{
// // // // // //                                 height: { xs: 400, md: 500 },
// // // // // //                                 width: "100%",
// // // // // //                               }}
// // // // // //                             >
// // // // // //                               <ResponsiveContainer width="100%" height="100%">
// // // // // //                                 <BarChart
// // // // // //                                   data={sortedSkills}
// // // // // //                                   margin={{
// // // // // //                                     top: 30,
// // // // // //                                     right: 30,
// // // // // //                                     left: 20,
// // // // // //                                     bottom: 120,
// // // // // //                                   }}
// // // // // //                                 >
// // // // // //                                   <CartesianGrid
// // // // // //                                     vertical={false}
// // // // // //                                     stroke={theme.palette.divider}
// // // // // //                                     strokeDasharray="3 3"
// // // // // //                                   />
// // // // // //                                   <XAxis
// // // // // //                                     dataKey="skill"
// // // // // //                                     type="category"
// // // // // //                                     interval={0}
// // // // // //                                     angle={-45}
// // // // // //                                     textAnchor="end"
// // // // // //                                     tick={{
// // // // // //                                       fill: theme.palette.text.secondary,
// // // // // //                                       fontSize: 12,
// // // // // //                                     }}
// // // // // //                                     stroke={"transparent"}
// // // // // //                                   />
// // // // // //                                   <YAxis
// // // // // //                                     type="number"
// // // // // //                                     domain={[0, "dataMax + 15"]}
// // // // // //                                     allowDecimals={false}
// // // // // //                                     tickFormatter={(tick) => `${tick}%`}
// // // // // //                                     stroke={theme.palette.divider}
// // // // // //                                     tick={{
// // // // // //                                       fill: theme.palette.text.secondary,
// // // // // //                                     }}
// // // // // //                                   />
// // // // // //                                   <Tooltip
// // // // // //                                     content={<CustomTooltip />}
// // // // // //                                     cursor={{
// // // // // //                                       fill: alpha(
// // // // // //                                         theme.palette.primary.main,
// // // // // //                                         0.1
// // // // // //                                       ),
// // // // // //                                     }}
// // // // // //                                   />
// // // // // //                                   <Bar
// // // // // //                                     dataKey="demand"
// // // // // //                                     shape={<RoundedVerticalBar />}
// // // // // //                                     animationDuration={800}
// // // // // //                                   >
// // // // // //                                     {sortedSkills.map((entry, idx) => (
// // // // // //                                       <Cell
// // // // // //                                         key={`cell-${idx}`}
// // // // // //                                         fill={
// // // // // //                                           priorityColors[entry.priority] ||
// // // // // //                                           theme.palette.text.disabled
// // // // // //                                         }
// // // // // //                                       />
// // // // // //                                     ))}
// // // // // //                                     <LabelList
// // // // // //                                       dataKey="demand"
// // // // // //                                       position="top"
// // // // // //                                       offset={8}
// // // // // //                                       style={{
// // // // // //                                         fill: theme.palette.text.primary,
// // // // // //                                         fontSize: "12px",
// // // // // //                                         fontWeight: "bold",
// // // // // //                                       }}
// // // // // //                                       formatter={(value) => `${value}%`}
// // // // // //                                     />
// // // // // //                                   </Bar>
// // // // // //                                 </BarChart>
// // // // // //                               </ResponsiveContainer>
// // // // // //                             </Box>
// // // // // //                           </Paper>
// // // // // //                         </TabPanel>
// // // // // //                       );
// // // // // //                     }
// // // // // //                   )}
// // // // // //                 </Box>
// // // // // //               ) : (
// // // // // //                 <Box
// // // // // //                   sx={{
// // // // // //                     display: "flex",
// // // // // //                     flexDirection: "column",
// // // // // //                     alignItems: "center",
// // // // // //                     justifyContent: "center",
// // // // // //                     textAlign: "center",
// // // // // //                     py: 8,
// // // // // //                     minHeight: 400,
// // // // // //                   }}
// // // // // //                 >
// // // // // //                   <Insights
// // // // // //                     sx={{ fontSize: 60, color: "text.disabled", mb: 2 }}
// // // // // //                   />
// // // // // //                   <Typography variant="h6" color="text.secondary">
// // // // // //                     Select a role to view in-demand skills
// // // // // //                   </Typography>
// // // // // //                   <Typography variant="body2" color="text.disabled">
// // // // // //                     The chart will update automatically as you make selections.
// // // // // //                   </Typography>
// // // // // //                 </Box>
// // // // // //               )}
// // // // // //             </Paper>
// // // // // //           </Stack>
// // // // // //         </Container>
// // // // // //       </Box>

// // // // // //       {/* --- DIALOGS (UI ENHANCEMENTS APPLIED) --- */}
// // // // // //       <Dialog
// // // // // //         open={resumeReviewDialog}
// // // // // //         onClose={() => setResumeReviewDialog(false)}
// // // // // //         maxWidth="lg"
// // // // // //         fullWidth
// // // // // //       >
// // // // // //         <DialogTitle
// // // // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // // // //         >
// // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // //             <Assessment />
// // // // // //             <Typography variant="h6">AI Resume Review</Typography>
// // // // // //           </Stack>
// // // // // //         </DialogTitle>
// // // // // //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// // // // // //           <RoleSelector
// // // // // //             selectedRoles={selectedResumeRoles}
// // // // // //             handleRoleChange={(e) =>
// // // // // //               setSelectedResumeRoles((prev) =>
// // // // // //                 e.target.checked
// // // // // //                   ? [...prev, e.target.name]
// // // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // // //               )
// // // // // //             }
// // // // // //           />
// // // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // // //             <Button
// // // // // //               variant="contained"
// // // // // //               onClick={() => fetchResumeReview(selectedResumeRoles)}
// // // // // //             >
// // // // // //               Generate Report
// // // // // //             </Button>
// // // // // //           </Box>
// // // // // //           <Divider sx={{ mb: 2 }} />
// // // // // //           {resumeReviewLoading ? (
// // // // // //             <DialogSkeleton />
// // // // // //           ) : (
// // // // // //             resumeReviewData && (
// // // // // //               <>
// // // // // //                 <Tabs
// // // // // //                   value={activeResumeTab}
// // // // // //                   onChange={(e, val) => setActiveResumeTab(val)}
// // // // // //                   centered
// // // // // //                   variant="scrollable"
// // // // // //                   scrollButtons="auto"
// // // // // //                 >
// // // // // //                   {Object.keys(resumeReviewData).map((role) => (
// // // // // //                     <Tab key={role} label={role} />
// // // // // //                   ))}
// // // // // //                 </Tabs>
// // // // // //                 {Object.entries(resumeReviewData).map(([role, data], index) => (
// // // // // //                   <TabPanel value={activeResumeTab} index={index} key={role}>
// // // // // //                     <Grid container spacing={3}>
// // // // // //                       <Grid item xs={12} md={6}>
// // // // // //                         <Paper
// // // // // //                           elevation={0}
// // // // // //                           sx={{
// // // // // //                             p: 2.5,
// // // // // //                             height: "100%",
// // // // // //                             borderRadius: 2,
// // // // // //                             border: 1,
// // // // // //                             borderColor: "divider",
// // // // // //                             bgcolor: "action.hover",
// // // // // //                           }}
// // // // // //                         >
// // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // //                             ATS Compatibility: {data.ATS_Compatibility.score}
// // // // // //                             /100
// // // // // //                           </Typography>
// // // // // //                           <LinearProgress
// // // // // //                             variant="determinate"
// // // // // //                             value={data.ATS_Compatibility.score}
// // // // // //                           />
// // // // // //                           <Typography
// // // // // //                             variant="subtitle2"
// // // // // //                             color="error.main"
// // // // // //                             sx={{ mt: 2 }}
// // // // // //                           >
// // // // // //                             Top Issues:
// // // // // //                           </Typography>
// // // // // //                           <List dense>
// // // // // //                             {data.ATS_Compatibility.top_issues.map(
// // // // // //                               (issue, i) => (
// // // // // //                                 <ListItem key={i} sx={{ py: 0 }}>
// // // // // //                                   <ListItemIcon sx={{ minWidth: 32 }}>
// // // // // //                                     <ErrorOutline
// // // // // //                                       fontSize="small"
// // // // // //                                       color="error"
// // // // // //                                     />
// // // // // //                                   </ListItemIcon>
// // // // // //                                   <ListItemText primary={issue} />
// // // // // //                                 </ListItem>
// // // // // //                               )
// // // // // //                             )}
// // // // // //                           </List>
// // // // // //                         </Paper>
// // // // // //                       </Grid>
// // // // // //                       <Grid item xs={12} md={6}>
// // // // // //                         <Paper
// // // // // //                           elevation={0}
// // // // // //                           sx={{
// // // // // //                             p: 2.5,
// // // // // //                             height: "100%",
// // // // // //                             borderRadius: 2,
// // // // // //                             border: 1,
// // // // // //                             borderColor: "divider",
// // // // // //                             bgcolor: "action.hover",
// // // // // //                           }}
// // // // // //                         >
// // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // //                             Content & Format
// // // // // //                           </Typography>
// // // // // //                           <Typography variant="body2" paragraph>
// // // // // //                             {data.Content_Quality_Analysis.summary}
// // // // // //                           </Typography>
// // // // // //                           <Typography variant="subtitle2" color="success.main">
// // // // // //                             Top Strengths:
// // // // // //                           </Typography>
// // // // // //                           <List dense>
// // // // // //                             {data.Content_Quality_Analysis.top_strengths.map(
// // // // // //                               (strength, i) => (
// // // // // //                                 <ListItem key={i} sx={{ py: 0 }}>
// // // // // //                                   <ListItemIcon sx={{ minWidth: 32 }}>
// // // // // //                                     <CheckCircle
// // // // // //                                       fontSize="small"
// // // // // //                                       color="success"
// // // // // //                                     />
// // // // // //                                   </ListItemIcon>
// // // // // //                                   <ListItemText primary={strength} />
// // // // // //                                 </ListItem>
// // // // // //                               )
// // // // // //                             )}
// // // // // //                           </List>
// // // // // //                         </Paper>
// // // // // //                       </Grid>
// // // // // //                       <Grid item xs={12}>
// // // // // //                         <Paper
// // // // // //                           elevation={0}
// // // // // //                           sx={{
// // // // // //                             p: 2.5,
// // // // // //                             borderRadius: 2,
// // // // // //                             border: 1,
// // // // // //                             borderColor: "divider",
// // // // // //                             bgcolor: "action.hover",
// // // // // //                           }}
// // // // // //                         >
// // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // //                             Keyword & Section Optimization
// // // // // //                           </Typography>
// // // // // //                           <Stack
// // // // // //                             direction={{ xs: "column", sm: "row" }}
// // // // // //                             spacing={2}
// // // // // //                             divider={
// // // // // //                               <Divider orientation="vertical" flexItem />
// // // // // //                             }
// // // // // //                           >
// // // // // //                             <Box flex={1}>
// // // // // //                               <Typography variant="subtitle1" fontWeight="bold">
// // // // // //                                 Missing Keywords
// // // // // //                               </Typography>
// // // // // //                               <Box
// // // // // //                                 sx={{
// // // // // //                                   display: "flex",
// // // // // //                                   flexWrap: "wrap",
// // // // // //                                   gap: 1,
// // // // // //                                   mt: 1,
// // // // // //                                 }}
// // // // // //                               >
// // // // // //                                 {data.Keyword_Optimization.missing_keywords.map(
// // // // // //                                   (kw, i) => (
// // // // // //                                     <Chip
// // // // // //                                       key={i}
// // // // // //                                       label={kw}
// // // // // //                                       color="info"
// // // // // //                                       size="small"
// // // // // //                                     />
// // // // // //                                   )
// // // // // //                                 )}
// // // // // //                               </Box>
// // // // // //                             </Box>
// // // // // //                             <Box flex={1}>
// // // // // //                               <Typography variant="subtitle1" fontWeight="bold">
// // // // // //                                 Missing Sections
// // // // // //                               </Typography>
// // // // // //                               <Box
// // // // // //                                 sx={{
// // // // // //                                   display: "flex",
// // // // // //                                   flexWrap: "wrap",
// // // // // //                                   gap: 1,
// // // // // //                                   mt: 1,
// // // // // //                                 }}
// // // // // //                               >
// // // // // //                                 {data.Format_and_Structure_Review.missing_sections.map(
// // // // // //                                   (sec, i) => (
// // // // // //                                     <Chip
// // // // // //                                       key={i}
// // // // // //                                       label={sec}
// // // // // //                                       color="warning"
// // // // // //                                       size="small"
// // // // // //                                     />
// // // // // //                                   )
// // // // // //                                 )}
// // // // // //                               </Box>
// // // // // //                             </Box>
// // // // // //                           </Stack>
// // // // // //                         </Paper>
// // // // // //                       </Grid>
// // // // // //                     </Grid>
// // // // // //                   </TabPanel>
// // // // // //                 ))}
// // // // // //               </>
// // // // // //             )
// // // // // //           )}
// // // // // //         </DialogContent>
// // // // // //         <DialogActions>
// // // // // //           <Button onClick={() => setResumeReviewDialog(false)}>Close</Button>
// // // // // //         </DialogActions>
// // // // // //       </Dialog>
// // // // // //       <Dialog
// // // // // //         open={skillGapDialog}
// // // // // //         onClose={() => setSkillGapDialog(false)}
// // // // // //         maxWidth="lg"
// // // // // //         fullWidth
// // // // // //       >
// // // // // //         <DialogTitle
// // // // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // // // //         >
// // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // //             <TrendingUp />
// // // // // //             <Typography variant="h6">AI Skill Gap Analysis</Typography>
// // // // // //           </Stack>
// // // // // //         </DialogTitle>
// // // // // //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// // // // // //           <RoleSelector
// // // // // //             selectedRoles={selectedSkillGapRoles}
// // // // // //             handleRoleChange={(e) =>
// // // // // //               setSelectedSkillGapRoles((prev) =>
// // // // // //                 e.target.checked
// // // // // //                   ? [...prev, e.target.name]
// // // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // // //               )
// // // // // //             }
// // // // // //           />
// // // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // // //             <Button
// // // // // //               variant="contained"
// // // // // //               color="primary"
// // // // // //               onClick={() => fetchSkillGap(selectedSkillGapRoles)}
// // // // // //             >
// // // // // //               Generate Analysis
// // // // // //             </Button>
// // // // // //           </Box>
// // // // // //           <Divider sx={{ mb: 2 }} />
// // // // // //           {skillGapLoading ? (
// // // // // //             <DialogSkeleton />
// // // // // //           ) : (
// // // // // //             skillGapData && (
// // // // // //               <>
// // // // // //                 <Tabs
// // // // // //                   value={activeSkillGapTab}
// // // // // //                   onChange={(e, val) => setActiveSkillGapTab(val)}
// // // // // //                   centered
// // // // // //                   variant="scrollable"
// // // // // //                   scrollButtons="auto"
// // // // // //                 >
// // // // // //                   {Object.keys(skillGapData).map((role) => (
// // // // // //                     <Tab key={role} label={role} />
// // // // // //                   ))}
// // // // // //                 </Tabs>
// // // // // //                 {Object.entries(skillGapData).map(([role, data], index) => (
// // // // // //                   <TabPanel value={activeSkillGapTab} index={index} key={role}>
// // // // // //                     <Grid container spacing={2}>
// // // // // //                       <Grid item xs={12} md={6}>
// // // // // //                         <Paper
// // // // // //                           elevation={0}
// // // // // //                           sx={{
// // // // // //                             p: 2.5,
// // // // // //                             display: "flex",
// // // // // //                             flexDirection: "column",
// // // // // //                             gap: 1,
// // // // // //                             borderRadius: 2,
// // // // // //                             border: 1,
// // // // // //                             borderColor: "divider",
// // // // // //                             bgcolor: "action.hover",
// // // // // //                           }}
// // // // // //                         >
// // // // // //                           <Stack
// // // // // //                             direction="row"
// // // // // //                             spacing={1}
// // // // // //                             alignItems="center"
// // // // // //                             mb={1}
// // // // // //                           >
// // // // // //                             <Person color="primary" />
// // // // // //                             <Typography variant="h6">Your Skills</Typography>
// // // // // //                           </Stack>
// // // // // //                           <Box
// // // // // //                             sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
// // // // // //                           >
// // // // // //                             {data.Current_Skill_Mapping.map((skill, i) => (
// // // // // //                               <Chip key={i} label={skill} />
// // // // // //                             ))}
// // // // // //                           </Box>
// // // // // //                         </Paper>
// // // // // //                       </Grid>
// // // // // //                       <Grid item xs={12} md={6}>
// // // // // //                         <Paper
// // // // // //                           elevation={0}
// // // // // //                           sx={{
// // // // // //                             p: 2.5,
// // // // // //                             display: "flex",
// // // // // //                             flexDirection: "column",
// // // // // //                             gap: 1,
// // // // // //                             borderRadius: 2,
// // // // // //                             border: 1,
// // // // // //                             borderColor: "divider",
// // // // // //                             bgcolor: "action.hover",
// // // // // //                           }}
// // // // // //                         >
// // // // // //                           <Stack
// // // // // //                             direction="row"
// // // // // //                             spacing={1}
// // // // // //                             alignItems="center"
// // // // // //                             mb={1}
// // // // // //                           >
// // // // // //                             <TrendingUp color="primary" />
// // // // // //                             <Typography variant="h6">
// // // // // //                               In-Demand Market Skills
// // // // // //                             </Typography>
// // // // // //                           </Stack>
// // // // // //                           <Box
// // // // // //                             sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
// // // // // //                           >
// // // // // //                             {data.Market_Demand_Analysis.map((skill, i) => (
// // // // // //                               <Chip key={i} label={skill} color="primary" />
// // // // // //                             ))}
// // // // // //                           </Box>
// // // // // //                         </Paper>
// // // // // //                       </Grid>
// // // // // //                       <Grid item xs={12}>
// // // // // //                         <Divider sx={{ my: 1 }} />
// // // // // //                       </Grid>
// // // // // //                       <Grid item xs={12} md={6}>
// // // // // //                         <Paper
// // // // // //                           elevation={0}
// // // // // //                           sx={{
// // // // // //                             p: 2.5,
// // // // // //                             borderRadius: 2,
// // // // // //                             border: 1,
// // // // // //                             borderColor: "divider",
// // // // // //                             bgcolor: "action.hover",
// // // // // //                             height: "100%",
// // // // // //                           }}
// // // // // //                         >
// // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // //                             Recommended Learning Path
// // // // // //                           </Typography>
// // // // // //                           <List dense>
// // // // // //                             {data.Learning_Path.map((path, i) => (
// // // // // //                               <ListItem key={i} sx={{ py: 0.5 }}>
// // // // // //                                 <ListItemIcon sx={{ minWidth: 36 }}>
// // // // // //                                   <School color="primary" />
// // // // // //                                 </ListItemIcon>
// // // // // //                                 <ListItemText primary={path} />
// // // // // //                               </ListItem>
// // // // // //                             ))}
// // // // // //                           </List>
// // // // // //                         </Paper>
// // // // // //                       </Grid>
// // // // // //                       <Grid item xs={12} md={6}>
// // // // // //                         <Paper
// // // // // //                           elevation={0}
// // // // // //                           sx={{
// // // // // //                             p: 2.5,
// // // // // //                             borderRadius: 2,
// // // // // //                             border: 1,
// // // // // //                             borderColor: "divider",
// // // // // //                             bgcolor: "action.hover",
// // // // // //                             height: "100%",
// // // // // //                           }}
// // // // // //                         >
// // // // // //                           <Typography variant="h6" gutterBottom>
// // // // // //                             Suggested Certifications
// // // // // //                           </Typography>
// // // // // //                           <List dense>
// // // // // //                             {data.Certification_Guidance.map((cert, i) => (
// // // // // //                               <ListItem key={i} sx={{ py: 0.5 }}>
// // // // // //                                 <ListItemIcon sx={{ minWidth: 36 }}>
// // // // // //                                   <MilitaryTech color="success" />
// // // // // //                                 </ListItemIcon>
// // // // // //                                 <ListItemText primary={cert} />
// // // // // //                               </ListItem>
// // // // // //                             ))}
// // // // // //                           </List>
// // // // // //                         </Paper>
// // // // // //                       </Grid>
// // // // // //                     </Grid>
// // // // // //                   </TabPanel>
// // // // // //                 ))}
// // // // // //               </>
// // // // // //             )
// // // // // //           )}
// // // // // //         </DialogContent>
// // // // // //         <DialogActions>
// // // // // //           <Button onClick={() => setSkillGapDialog(false)}>Close</Button>
// // // // // //         </DialogActions>
// // // // // //       </Dialog>
// // // // // //       <Dialog
// // // // // //         open={careerRoadmapDialog}
// // // // // //         onClose={() => setCareerRoadmapDialog(false)}
// // // // // //         maxWidth="lg"
// // // // // //         fullWidth
// // // // // //       >
// // // // // //         <DialogTitle
// // // // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // // // //         >
// // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // //             <Timeline />
// // // // // //             <Typography variant="h6">Personalized Career Roadmap</Typography>
// // // // // //           </Stack>
// // // // // //         </DialogTitle>
// // // // // //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// // // // // //           <RoleSelector
// // // // // //             selectedRoles={selectedRoadmapRoles}
// // // // // //             handleRoleChange={(e) =>
// // // // // //               setSelectedRoadmapRoles((prev) =>
// // // // // //                 e.target.checked
// // // // // //                   ? [...prev, e.target.name]
// // // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // // //               )
// // // // // //             }
// // // // // //           />
// // // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // // //             <Button
// // // // // //               variant="contained"
// // // // // //               color="primary"
// // // // // //               onClick={() => fetchCareerRoadmap(selectedRoadmapRoles)}
// // // // // //             >
// // // // // //               Generate Roadmap
// // // // // //             </Button>
// // // // // //           </Box>
// // // // // //           <Divider sx={{ mb: 2 }} />
// // // // // //           {careerRoadmapLoading ? (
// // // // // //             <DialogSkeleton />
// // // // // //           ) : (
// // // // // //             careerRoadmapData && (
// // // // // //               <>
// // // // // //                 <Tabs
// // // // // //                   value={activeRoadmapTab}
// // // // // //                   onChange={(e, val) => setActiveRoadmapTab(val)}
// // // // // //                   centered
// // // // // //                   variant="scrollable"
// // // // // //                   scrollButtons="auto"
// // // // // //                 >
// // // // // //                   {Object.keys(careerRoadmapData).map((role) => (
// // // // // //                     <Tab key={role} label={role} />
// // // // // //                   ))}
// // // // // //                 </Tabs>
// // // // // //                 {Object.entries(careerRoadmapData).map(
// // // // // //                   ([role, data], index) => (
// // // // // //                     <TabPanel value={activeRoadmapTab} index={index} key={role}>
// // // // // //                       <Typography variant="h5" gutterBottom align="center">
// // // // // //                         Your AI-Generated Path to <strong>{role}</strong>
// // // // // //                       </Typography>
// // // // // //                       <Typography
// // // // // //                         variant="body1"
// // // // // //                         paragraph
// // // // // //                         color="text.secondary"
// // // // // //                         align="center"
// // // // // //                       >
// // // // // //                         Based on your current role:{" "}
// // // // // //                         <strong>{data?.Current_Position || "N/A"}</strong> with{" "}
// // // // // //                         <strong>{data?.Experience_Years || "N/A"}</strong> years
// // // // // //                         of experience.
// // // // // //                       </Typography>
// // // // // //                       <Grid container spacing={2} sx={{ mt: 1 }}>
// // // // // //                         <Grid item xs={12} md={6}>
// // // // // //                           <Paper
// // // // // //                             elevation={0}
// // // // // //                             sx={{
// // // // // //                               p: 2.5,
// // // // // //                               height: "100%",
// // // // // //                               borderRadius: 2,
// // // // // //                               border: 1,
// // // // // //                               borderColor: "divider",
// // // // // //                               bgcolor: "action.hover",
// // // // // //                             }}
// // // // // //                           >
// // // // // //                             <Stack
// // // // // //                               direction="row"
// // // // // //                               spacing={2}
// // // // // //                               alignItems="center"
// // // // // //                             >
// // // // // //                               <Avatar
// // // // // //                                 sx={{
// // // // // //                                   bgcolor: "primary.light",
// // // // // //                                   width: 56,
// // // // // //                                   height: 56,
// // // // // //                                 }}
// // // // // //                               >
// // // // // //                                 <RocketLaunch />
// // // // // //                               </Avatar>
// // // // // //                               <Box>
// // // // // //                                 <Typography
// // // // // //                                   variant="overline"
// // // // // //                                   color="primary.main"
// // // // // //                                 >
// // // // // //                                   Next Milestone
// // // // // //                                 </Typography>
// // // // // //                                 <Typography variant="h6" fontWeight="bold">
// // // // // //                                   {data?.Next_Milestone?.title ||
// // // // // //                                     "Not available"}
// // // // // //                                 </Typography>
// // // // // //                                 <Chip
// // // // // //                                   size="small"
// // // // // //                                   label={`Company: ${
// // // // // //                                     data?.Next_Milestone?.company_type || "N/A"
// // // // // //                                   }`}
// // // // // //                                   sx={{ mt: 1 }}
// // // // // //                                 />
// // // // // //                               </Box>
// // // // // //                             </Stack>
// // // // // //                           </Paper>
// // // // // //                         </Grid>
// // // // // //                         <Grid item xs={12} md={6}>
// // // // // //                           <Paper
// // // // // //                             elevation={0}
// // // // // //                             sx={{
// // // // // //                               p: 2.5,
// // // // // //                               height: "100%",
// // // // // //                               borderRadius: 2,
// // // // // //                               border: 1,
// // // // // //                               borderColor: "divider",
// // // // // //                               bgcolor: "action.hover",
// // // // // //                             }}
// // // // // //                           >
// // // // // //                             <Stack
// // // // // //                               direction="row"
// // // // // //                               spacing={2}
// // // // // //                               alignItems="center"
// // // // // //                             >
// // // // // //                               <Avatar
// // // // // //                                 sx={{
// // // // // //                                   bgcolor: "success.light",
// // // // // //                                   width: 56,
// // // // // //                                   height: 56,
// // // // // //                                 }}
// // // // // //                               >
// // // // // //                                 <Stars />
// // // // // //                               </Avatar>
// // // // // //                               <Box>
// // // // // //                                 <Typography
// // // // // //                                   variant="overline"
// // // // // //                                   color="success.main"
// // // // // //                                 >
// // // // // //                                   Long-term Goal
// // // // // //                                 </Typography>
// // // // // //                                 <Typography variant="h6" fontWeight="bold">
// // // // // //                                   {data?.Long_Term_Goal?.title ||
// // // // // //                                     "Not available"}
// // // // // //                                 </Typography>
// // // // // //                                 <Chip
// // // // // //                                   size="small"
// // // // // //                                   label={`Company: ${
// // // // // //                                     data?.Long_Term_Goal?.company_type || "N/A"
// // // // // //                                   }`}
// // // // // //                                   sx={{ mt: 1 }}
// // // // // //                                 />
// // // // // //                               </Box>
// // // // // //                             </Stack>
// // // // // //                           </Paper>
// // // // // //                         </Grid>
// // // // // //                       </Grid>
// // // // // //                       <Divider sx={{ my: 3 }}>
// // // // // //                         <Chip label="Recommended Actions" color="primary" />
// // // // // //                       </Divider>
// // // // // //                       <List>
// // // // // //                         {data?.Recommended_Actions?.map((item, i) => (
// // // // // //                           <ListItem key={i} alignItems="flex-start">
// // // // // //                             <ListItemIcon>
// // // // // //                               <Work color="primary" />
// // // // // //                             </ListItemIcon>
// // // // // //                             <ListItemText
// // // // // //                               primary={item.action}
// // // // // //                               secondary={item.reason}
// // // // // //                             />
// // // // // //                           </ListItem>
// // // // // //                         )) || (
// // // // // //                           <ListItem>
// // // // // //                             <ListItemText primary="No actions recommended." />
// // // // // //                           </ListItem>
// // // // // //                         )}
// // // // // //                       </List>
// // // // // //                     </TabPanel>
// // // // // //                   )
// // // // // //                 )}
// // // // // //               </>
// // // // // //             )
// // // // // //           )}
// // // // // //         </DialogContent>
// // // // // //         <DialogActions>
// // // // // //           <Button onClick={() => setCareerRoadmapDialog(false)}>Close</Button>
// // // // // //         </DialogActions>
// // // // // //       </Dialog>
// // // // // //       <Dialog
// // // // // //         open={culturalPrepDialog}
// // // // // //         onClose={() => {
// // // // // //           setCulturalPrepDialog(false);
// // // // // //           setCulturalPrepTab(0);
// // // // // //         }}
// // // // // //         maxWidth="md"
// // // // // //         fullWidth
// // // // // //         PaperProps={{ sx: { height: { md: 650 } } }}
// // // // // //       >
// // // // // //         <DialogTitle
// // // // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // // // //         >
// // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // //             <Psychology />
// // // // // //             <Typography variant="h6">Cultural Preparation Insights</Typography>
// // // // // //           </Stack>
// // // // // //         </DialogTitle>
// // // // // //         <DialogContent
// // // // // //           dividers
// // // // // //           sx={{
// // // // // //             display: "flex",
// // // // // //             p: 0,
// // // // // //             overflow: "hidden",
// // // // // //             flexDirection: { xs: "column", md: "row" },
// // // // // //           }}
// // // // // //         >
// // // // // //           {culturalPrepLoading ? (
// // // // // //             <DialogSkeleton />
// // // // // //           ) : (
// // // // // //             culturalPrepData && (
// // // // // //               <>
// // // // // //                 <Tabs
// // // // // //                   orientation={
// // // // // //                     theme.breakpoints.up("md") ? "vertical" : "horizontal"
// // // // // //                   }
// // // // // //                   variant="scrollable"
// // // // // //                   value={culturalPrepTab}
// // // // // //                   onChange={(e, val) => setCulturalPrepTab(val)}
// // // // // //                   sx={{
// // // // // //                     borderRight: { md: 1 },
// // // // // //                     borderBottom: { xs: 1, md: 0 },
// // // // // //                     borderColor: "divider",
// // // // // //                     minWidth: { md: 150 },
// // // // // //                   }}
// // // // // //                 >
// // // // // //                   {Object.values(culturalPrepData).map((region, index) => (
// // // // // //                     <Tab key={index} label={region.location_name} />
// // // // // //                   ))}
// // // // // //                 </Tabs>
// // // // // //                 <Box
// // // // // //                   sx={{
// // // // // //                     flex: { md: 1 },
// // // // // //                     overflowY: "auto",
// // // // // //                     p: { xs: 2, md: 3 },
// // // // // //                     bgcolor: "background.default",
// // // // // //                   }}
// // // // // //                 >
// // // // // //                   {Object.values(culturalPrepData).map((region, index) => (
// // // // // //                     <TabPanel value={culturalPrepTab} index={index} key={index}>
// // // // // //                       <Stack spacing={2}>
// // // // // //                         <Paper
// // // // // //                           elevation={0}
// // // // // //                           sx={{
// // // // // //                             p: 2,
// // // // // //                             borderRadius: 2,
// // // // // //                             border: 1,
// // // // // //                             borderColor: "divider",
// // // // // //                           }}
// // // // // //                         >
// // // // // //                           <Stack
// // // // // //                             direction="row"
// // // // // //                             spacing={1}
// // // // // //                             alignItems="center"
// // // // // //                             mb={1}
// // // // // //                           >
// // // // // //                             <Insights color="primary" />
// // // // // //                             <Typography variant="h6">
// // // // // //                               Cultural Insights
// // // // // //                             </Typography>
// // // // // //                           </Stack>
// // // // // //                           <List dense>
// // // // // //                             {region.cultural_insights.map((insight, i) => (
// // // // // //                               <ListItem key={i}>
// // // // // //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// // // // // //                                   <ArrowForward fontSize="small" />
// // // // // //                                 </ListItemIcon>
// // // // // //                                 <ListItemText primary={insight} />
// // // // // //                               </ListItem>
// // // // // //                             ))}
// // // // // //                           </List>
// // // // // //                         </Paper>
// // // // // //                         <Paper
// // // // // //                           elevation={0}
// // // // // //                           sx={{
// // // // // //                             p: 2,
// // // // // //                             borderRadius: 2,
// // // // // //                             border: 1,
// // // // // //                             borderColor: "divider",
// // // // // //                           }}
// // // // // //                         >
// // // // // //                           <Stack
// // // // // //                             direction="row"
// // // // // //                             spacing={1}
// // // // // //                             alignItems="center"
// // // // // //                             mb={1}
// // // // // //                           >
// // // // // //                             <VideoCall color="primary" />
// // // // // //                             <Typography variant="h6">
// // // // // //                               Communication Tips
// // // // // //                             </Typography>
// // // // // //                           </Stack>
// // // // // //                           <List dense>
// // // // // //                             {region.communication_tips.map((tip, i) => (
// // // // // //                               <ListItem key={i}>
// // // // // //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// // // // // //                                   <ArrowForward fontSize="small" />
// // // // // //                                 </ListItemIcon>
// // // // // //                                 <ListItemText primary={tip} />
// // // // // //                               </ListItem>
// // // // // //                             ))}
// // // // // //                           </List>
// // // // // //                         </Paper>
// // // // // //                         <Paper
// // // // // //                           elevation={0}
// // // // // //                           sx={{
// // // // // //                             p: 2,
// // // // // //                             borderRadius: 2,
// // // // // //                             border: 1,
// // // // // //                             borderColor: "divider",
// // // // // //                           }}
// // // // // //                         >
// // // // // //                           <Stack
// // // // // //                             direction="row"
// // // // // //                             spacing={1}
// // // // // //                             alignItems="center"
// // // // // //                             mb={1}
// // // // // //                           >
// // // // // //                             <Work color="primary" />
// // // // // //                             <Typography variant="h6">Work Etiquette</Typography>
// // // // // //                           </Stack>
// // // // // //                           <List dense>
// // // // // //                             {region.work_etiquette.map((tip, i) => (
// // // // // //                               <ListItem key={i}>
// // // // // //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// // // // // //                                   <Stars fontSize="small" />
// // // // // //                                 </ListItemIcon>
// // // // // //                                 <ListItemText primary={tip} />
// // // // // //                               </ListItem>
// // // // // //                             ))}
// // // // // //                           </List>
// // // // // //                         </Paper>
// // // // // //                       </Stack>
// // // // // //                     </TabPanel>
// // // // // //                   ))}
// // // // // //                 </Box>
// // // // // //               </>
// // // // // //             )
// // // // // //           )}
// // // // // //         </DialogContent>
// // // // // //         <DialogActions>
// // // // // //           <Button onClick={() => setCulturalPrepDialog(false)}>Close</Button>
// // // // // //         </DialogActions>
// // // // // //       </Dialog>
// // // // // //       <Dialog
// // // // // //         open={salaryInsightsDialog}
// // // // // //         onClose={() => setSalaryInsightsDialog(false)}
// // // // // //         maxWidth="md"
// // // // // //         fullWidth
// // // // // //       >
// // // // // //         <DialogTitle
// // // // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // // // //         >
// // // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // // //             <Language />
// // // // // //             <Typography variant="h6">Global Salary Insights</Typography>
// // // // // //           </Stack>
// // // // // //         </DialogTitle>
// // // // // //         <DialogContent dividers sx={{ bgcolor: "background.default" }}>
// // // // // //           {salaryInsightsLoading ? (
// // // // // //             <DialogSkeleton />
// // // // // //           ) : (
// // // // // //             salaryInsightsData && (
// // // // // //               <Stack spacing={3} sx={{ py: 2 }}>
// // // // // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // // // // //                   <Stack
// // // // // //                     direction="row"
// // // // // //                     spacing={1.5}
// // // // // //                     alignItems="center"
// // // // // //                     mb={2}
// // // // // //                   >
// // // // // //                     <LocationOn color="primary" />
// // // // // //                     <Typography variant="h6">
// // // // // //                       Salary Benchmarks by Location
// // // // // //                     </Typography>
// // // // // //                   </Stack>
// // // // // //                   <Grid container spacing={2}>
// // // // // //                     {salaryInsightsData.location_based.map((loc, i) => (
// // // // // //                       <Grid item xs={12} sm={6} key={i}>
// // // // // //                         <Card variant="outlined">
// // // // // //                           <CardContent>
// // // // // //                             <Typography
// // // // // //                               variant="h6"
// // // // // //                               component="div"
// // // // // //                               gutterBottom
// // // // // //                             >
// // // // // //                               {loc.city}
// // // // // //                             </Typography>
// // // // // //                             {/* <Chip
// // // // // //                               label={loc.role}
// // // // // //                               size="small"
// // // // // //                               color="primary"
// // // // // //                               sx={{ mb: 1.5 }}
// // // // // //                             /> */}
// // // // // //                             <Stack spacing={0.5}>
// // // // // //                               <Typography
// // // // // //                                 variant="body2"
// // // // // //                                 color="text.secondary"
// // // // // //                               >
// // // // // //                                 Min: <strong>{loc.min_salary}</strong>
// // // // // //                               </Typography>
// // // // // //                               <Typography
// // // // // //                                 variant="body1"
// // // // // //                                 color="text.primary"
// // // // // //                                 fontWeight="bold"
// // // // // //                               >
// // // // // //                                 Median: <strong>{loc.median_salary}</strong>
// // // // // //                               </Typography>
// // // // // //                               <Typography
// // // // // //                                 variant="body2"
// // // // // //                                 color="text.secondary"
// // // // // //                               >
// // // // // //                                 Max: <strong>{loc.max_salary}</strong>
// // // // // //                               </Typography>
// // // // // //                             </Stack>
// // // // // //                           </CardContent>
// // // // // //                         </Card>
// // // // // //                       </Grid>
// // // // // //                     ))}
// // // // // //                   </Grid>
// // // // // //                 </Paper>
// // // // // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // // // // //                   <Stack
// // // // // //                     direction="row"
// // // // // //                     spacing={1.5}
// // // // // //                     alignItems="center"
// // // // // //                     mb={1}
// // // // // //                   >
// // // // // //                     <TrendingUp color="primary" />
// // // // // //                     <Typography variant="h6">Location Demand Impact</Typography>
// // // // // //                   </Stack>
// // // // // //                   <List dense>
// // // // // //                     {salaryInsightsData.salary_insights_summary.map(
// // // // // //                       (item, i) => (
// // // // // //                         <ListItem key={i} disableGutters sx={{ px: 1 }}>
// // // // // //                           <Stack
// // // // // //                             direction={{ xs: "column", sm: "row" }}
// // // // // //                             spacing={{ xs: 0.5, sm: 2 }}
// // // // // //                             alignItems="center"
// // // // // //                             sx={{ width: "100%" }}
// // // // // //                           >
// // // // // //                             <ListItemText
// // // // // //                               primary={item.role}
// // // // // //                               sx={{
// // // // // //                                 width: "100%",
// // // // // //                                 m: 0,
// // // // // //                                 flexBasis: { sm: "40%" },
// // // // // //                                 flexShrink: 0,
// // // // // //                               }}
// // // // // //                             />
// // // // // //                             <Box
// // // // // //                               sx={{
// // // // // //                                 width: "100%",
// // // // // //                                 display: "flex",
// // // // // //                                 alignItems: "center",
// // // // // //                               }}
// // // // // //                             >
// // // // // //                               <LinearProgress
// // // // // //                                 variant="determinate"
// // // // // //                                 value={item.demand_in_salary_percent}
// // // // // //                                 color="primary"
// // // // // //                                 sx={{
// // // // // //                                   width: "100%",
// // // // // //                                   mr: 1.5,
// // // // // //                                   height: 8,
// // // // // //                                   borderRadius: 4,
// // // // // //                                 }}
// // // // // //                               />
// // // // // //                               <Typography
// // // // // //                                 variant="body2"
// // // // // //                                 color="text.secondary"
// // // // // //                               >{`${item.demand_in_salary_percent}%`}</Typography>
// // // // // //                             </Box>
// // // // // //                           </Stack>
// // // // // //                         </ListItem>
// // // // // //                       )
// // // // // //                     )}
// // // // // //                   </List>
// // // // // //                 </Paper>
// // // // // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // // // // //                   <Stack
// // // // // //                     direction="row"
// // // // // //                     spacing={1.5}
// // // // // //                     alignItems="center"
// // // // // //                     mb={1}
// // // // // //                   >
// // // // // //                     <MonetizationOn color="success" />
// // // // // //                     <Typography variant="h6">Negotiation Tips</Typography>
// // // // // //                   </Stack>
// // // // // //                   <List dense>
// // // // // //                     {salaryInsightsData.negotiation_tips.map((tip, i) => (
// // // // // //                       <ListItem key={i}>
// // // // // //                         <ListItemIcon sx={{ minWidth: 32 }}>
// // // // // //                           <CheckCircle color="success" fontSize="small" />
// // // // // //                         </ListItemIcon>
// // // // // //                         <ListItemText primary={tip} />
// // // // // //                       </ListItem>
// // // // // //                     ))}
// // // // // //                   </List>
// // // // // //                 </Paper>
// // // // // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // // // // //                   <Stack
// // // // // //                     direction="row"
// // // // // //                     spacing={1.5}
// // // // // //                     alignItems="center"
// // // // // //                     mb={1}
// // // // // //                   >
// // // // // //                     <Timeline color="warning" />
// // // // // //                     <Typography variant="h6">Market Trends</Typography>
// // // // // //                   </Stack>
// // // // // //                   <List>
// // // // // //                     {salaryInsightsData.market_trends.map((item, i) => (
// // // // // //                       <ListItem key={i} alignItems="flex-start">
// // // // // //                         <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
// // // // // //                           <TrendingFlat color="warning" />
// // // // // //                         </ListItemIcon>
// // // // // //                         <ListItemText
// // // // // //                           primary={item.trend}
// // // // // //                           secondary={item.insight}
// // // // // //                           primaryTypographyProps={{ fontWeight: 600 }}
// // // // // //                         />
// // // // // //                       </ListItem>
// // // // // //                     ))}
// // // // // //                   </List>
// // // // // //                 </Paper>
// // // // // //               </Stack>
// // // // // //             )
// // // // // //           )}
// // // // // //         </DialogContent>
// // // // // //         <DialogActions>
// // // // // //           <Button onClick={() => setSalaryInsightsDialog(false)}>Close</Button>
// // // // // //         </DialogActions>
// // // // // //       </Dialog>
// // // // // //     </Layout>
// // // // // //   );
// // // // // // };

// // // // // // export default CareerAssistant;
// // // // // import { useState, useEffect, useRef } from "react";
// // // // // import {
// // // // //   Grid,
// // // // //   Card,
// // // // //   CardContent,
// // // // //   Container,
// // // // //   Typography,
// // // // //   Box,
// // // // //   Button,
// // // // //   Paper,
// // // // //   Avatar,
// // // // //   Chip,
// // // // //   Dialog,
// // // // //   DialogTitle,
// // // // //   DialogContent,
// // // // //   DialogActions,
// // // // //   List,
// // // // //   ListItem,
// // // // //   ListItemIcon,
// // // // //   ListItemText,
// // // // //   Divider,
// // // // //   Stack,
// // // // //   LinearProgress,
// // // // //   Skeleton,
// // // // //   alpha,
// // // // //   IconButton,
// // // // //   Tabs,
// // // // //   Tab,
// // // // //   FormGroup,
// // // // //   FormControlLabel,
// // // // //   Checkbox,
// // // // //   Alert,
// // // // //   AlertTitle,
// // // // // } from "@mui/material";
// // // // // import { styled, useTheme } from "@mui/material/styles";
// // // // // import {
// // // // //   Psychology,
// // // // //   TrendingUp,
// // // // //   School,
// // // // //   Work,
// // // // //   Language,
// // // // //   Assessment,
// // // // //   VideoCall,
// // // // //   Lightbulb,
// // // // //   Timeline,
// // // // //   CheckCircle,
// // // // //   ErrorOutline,
// // // // //   ArrowForward,
// // // // //   MilitaryTech,
// // // // //   Stars,
// // // // //   RocketLaunch,
// // // // //   TrendingDown,
// // // // //   TrendingFlat,
// // // // //   LocationOn,
// // // // //   MonetizationOn,
// // // // //   AutoAwesome,
// // // // //   Close as CloseIcon,
// // // // //   Insights,
// // // // //   Person,
// // // // // } from "@mui/icons-material";
// // // // // import {
// // // // //   BarChart,
// // // // //   Bar,
// // // // //   XAxis,
// // // // //   YAxis,
// // // // //   CartesianGrid,
// // // // //   Tooltip,
// // // // //   ResponsiveContainer,
// // // // //   Cell,
// // // // //   LabelList,
// // // // // } from "recharts";
// // // // // import Layout from "../common/Layout";
// // // // // import { useNotification } from "../../context/NotificationContext";
// // // // // import { useNavigate } from "react-router-dom";
// // // // // import apiClient from "../../context/apiClient";

// // // // // // --- Skeleton Components ---

// // // // // const HeaderSkeleton = () => (
// // // // //   <Paper sx={{ bgcolor: "mint.main", borderRadius: 3, p: { xs: 2, sm: 3 } }}>
// // // // //     <Stack direction="row" alignItems="center" spacing={2}>
// // // // //       <Skeleton variant="circular" width={64} height={64} />
// // // // //       <Box sx={{ flex: 1 }}>
// // // // //         <Skeleton variant="text" width="40%" height={48} />
// // // // //         <Skeleton variant="text" width="60%" height={24} />
// // // // //       </Box>
// // // // //     </Stack>
// // // // //   </Paper>
// // // // // );

// // // // // const ServiceListItemSkeleton = () => (
// // // // //   <Paper
// // // // //     sx={{
// // // // //       display: "flex",
// // // // //       flexDirection: "row",
// // // // //       alignItems: "center",
// // // // //       padding: 2,
// // // // //       borderRadius: "12px",
// // // // //       border: (theme) => `1px solid ${theme.palette.divider}`,
// // // // //     }}
// // // // //   >
// // // // //     <Skeleton variant="circular" width={48} height={48} sx={{ mr: 2 }} />
// // // // //     <Box flexGrow={1}>
// // // // //       <Skeleton variant="text" height={30} width="50%" />
// // // // //       <Skeleton variant="text" height={20} width="80%" />
// // // // //     </Box>
// // // // //     <Skeleton variant="circular" width={24} height={24} sx={{ ml: 2 }} />
// // // // //   </Paper>
// // // // // );

// // // // // const ServicesSkeleton = () => (
// // // // //   <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, bgcolor: "mint.main" }}>
// // // // //     <Skeleton variant="text" width="60%" height={40} sx={{ mb: 3 }} />
// // // // //     <Stack spacing={2}>
// // // // //       {[...Array(5)].map((_, index) => (
// // // // //         <ServiceListItemSkeleton key={index} />
// // // // //       ))}
// // // // //     </Stack>
// // // // //   </Paper>
// // // // // );

// // // // // const TrendingSkillsSkeleton = () => (
// // // // //   <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, bgcolor: "mint.main" }}>
// // // // //     <Skeleton variant="text" width="40%" height={40} sx={{ mb: 2 }} />
// // // // //     <Stack
// // // // //       direction="row"
// // // // //       spacing={2}
// // // // //       sx={{ mb: 3, justifyContent: "center", flexWrap: "wrap", gap: 1 }}
// // // // //     >
// // // // //       <Skeleton variant="rounded" width={150} height={42} />
// // // // //       <Skeleton variant="rounded" width={150} height={42} />
// // // // //       <Skeleton variant="rounded" width={150} height={42} />
// // // // //     </Stack>
// // // // //     <Skeleton variant="rounded" width="100%" height={500} />
// // // // //   </Paper>
// // // // // );

// // // // // const PageSkeleton = () => (
// // // // //   <Layout title="AI Career Assistant">
// // // // //     <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// // // // //       <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
// // // // //         <Stack spacing={4}>
// // // // //           <HeaderSkeleton />
// // // // //           <ServicesSkeleton />
// // // // //           <TrendingSkillsSkeleton />
// // // // //         </Stack>
// // // // //       </Container>
// // // // //     </Box>
// // // // //   </Layout>
// // // // // );

// // // // // const ChartSkeleton = () => (
// // // // //   <Box sx={{ height: { xs: 400, md: 500 }, width: "100%", pt: 2 }}>
// // // // //     <Skeleton variant="rounded" width="100%" height="100%" />
// // // // //   </Box>
// // // // // );

// // // // // // --- Helper Components ---

// // // // // const ServiceListItem = styled(Paper)(({ theme, color = "primary" }) => ({
// // // // //   backgroundColor: theme.palette.background.paper,
// // // // //   display: "flex",
// // // // //   flexDirection: "row",
// // // // //   alignItems: "center",
// // // // //   padding: theme.spacing(2),
// // // // //   borderRadius: "12px",
// // // // //   cursor: "pointer",
// // // // //   transition:
// // // // //     "background-color 0.3s ease, border-color 0.3s ease, transform 0.2s ease-in-out",
// // // // //   border: `1px solid ${theme.palette.divider}`,
// // // // //   "&:hover": {
// // // // //     backgroundColor: alpha(
// // // // //       theme.palette[color]?.main || theme.palette.primary.main,
// // // // //       0.08
// // // // //     ),
// // // // //     borderColor: theme.palette[color]?.main || theme.palette.primary.main,
// // // // //     transform: "scale(1.02)",
// // // // //   },
// // // // //   ".MuiAvatar-root": {
// // // // //     backgroundColor: alpha(
// // // // //       theme.palette[color]?.main || theme.palette.primary.main,
// // // // //       0.15
// // // // //     ),
// // // // //     color: theme.palette[color]?.main || theme.palette.primary.main,
// // // // //     marginRight: theme.spacing(2),
// // // // //   },
// // // // // }));

// // // // // function TabPanel(props) {
// // // // //   const { children, value, index, ...other } = props;
// // // // //   return (
// // // // //     <div
// // // // //       role="tabpanel"
// // // // //       hidden={value !== index}
// // // // //       id={`tabpanel-${index}`}
// // // // //       aria-labelledby={`tab-${index}`}
// // // // //       {...other}
// // // // //     >
// // // // //       {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
// // // // //     </div>
// // // // //   );
// // // // // }

// // // // // // --- Main Component ---

// // // // // const CareerAssistant = () => {
// // // // //   const theme = useTheme();
// // // // //   const { showNotification } = useNotification();
// // // // //   const navigate = useNavigate();
// // // // //   const isInitialMount = useRef(true);

// // // // //   const availableRoles = [
// // // // //     "AI/ML Engineer",
// // // // //     "Data Scientist",
// // // // //     "Business Analyst",
// // // // //   ];

// // // // //   // --- State Declarations ---
// // // // //   const [pageLoading, setPageLoading] = useState(true);
// // // // //   const [showWelcomeCard, setShowWelcomeCard] = useState(true);
// // // // //   const [mockInterviewDialog, setMockInterviewDialog] = useState(false);
// // // // //   const [resumeReviewDialog, setResumeReviewDialog] = useState(false);
// // // // //   const [skillGapDialog, setSkillGapDialog] = useState(false);
// // // // //   const [careerRoadmapDialog, setCareerRoadmapDialog] = useState(false);
// // // // //   const [culturalPrepDialog, setCulturalPrepDialog] = useState(false);
// // // // //   const [salaryInsightsDialog, setSalaryInsightsDialog] = useState(false);
// // // // //   const [trendingSkillsData, setTrendingSkillsData] = useState({});
// // // // //   const [skillsLoading, setSkillsLoading] = useState(true);
// // // // //   const [selectedTrendingRoles, setSelectedTrendingRoles] = useState([
// // // // //     "AI/ML Engineer",
// // // // //   ]);
// // // // //   const [activeTrendingTab, setActiveTrendingTab] = useState(0);
// // // // //   const [resumeReviewData, setResumeReviewData] = useState(null);
// // // // //   const [resumeReviewLoading, setResumeReviewLoading] = useState(false);
// // // // //   const [selectedResumeRoles, setSelectedResumeRoles] = useState([]);
// // // // //   const [activeResumeTab, setActiveResumeTab] = useState(0);
// // // // //   const [skillGapData, setSkillGapData] = useState(null);
// // // // //   const [skillGapLoading, setSkillGapLoading] = useState(false);
// // // // //   const [selectedSkillGapRoles, setSelectedSkillGapRoles] = useState([]);
// // // // //   const [activeSkillGapTab, setActiveSkillGapTab] = useState(0);
// // // // //   const [careerRoadmapData, setCareerRoadmapData] = useState(null);
// // // // //   const [careerRoadmapLoading, setCareerRoadmapLoading] = useState(false);
// // // // //   const [selectedRoadmapRoles, setSelectedRoadmapRoles] = useState([]);
// // // // //   const [activeRoadmapTab, setActiveRoadmapTab] = useState(0);
// // // // //   const [culturalPrepData, setCulturalPrepData] = useState(null);
// // // // //   const [culturalPrepLoading, setCulturalPrepLoading] = useState(false);
// // // // //   const [culturalPrepTab, setCulturalPrepTab] = useState(0);
// // // // //   const [salaryInsightsData, setSalaryInsightsData] = useState(null);
// // // // //   const [salaryInsightsLoading, setSalaryInsightsLoading] = useState(false);

// // // // //   // --- Data Fetching Functions ---

// // // // //   const fetchTrendingSkills = async (roles) => {
// // // // //     if (!roles || roles.length === 0) {
// // // // //       setTrendingSkillsData({});
// // // // //       setSkillsLoading(false);
// // // // //       return;
// // // // //     }
// // // // //     setSkillsLoading(true);
// // // // //     try {
// // // // //       const response = await apiClient.post("/trending-skills/", {
// // // // //         selected_roles: roles,
// // // // //       });
// // // // //       const transformedData = {};
// // // // //       for (const [role, skills] of Object.entries(response.data)) {
// // // // //         transformedData[role] = skills.map((skill) => ({
// // // // //           skill: skill.skill,
// // // // //           demand: parseInt(skill.demand) || 0,
// // // // //           growth: skill.increase || "N/A",
// // // // //           priority: skill.priority,
// // // // //         }));
// // // // //       }
// // // // //       setTrendingSkillsData(transformedData);
// // // // //       setActiveTrendingTab(0);
// // // // //     } catch (error) {
// // // // //       console.error("Failed to fetch trending skills:", error);
// // // // //       showNotification("Could not load trending skills data.", "error");
// // // // //       setTrendingSkillsData({});
// // // // //     } finally {
// // // // //       setSkillsLoading(false);
// // // // //     }
// // // // //   };

// // // // //   const fetchResumeReview = async (roles) => {
// // // // //     if (!roles || roles.length === 0) {
// // // // //       setResumeReviewData({});
// // // // //       return;
// // // // //     }
// // // // //     setResumeReviewLoading(true);
// // // // //     try {
// // // // //       const response = await apiClient.post("/resume/review-talent/", {
// // // // //         target_roles: roles,
// // // // //       });
// // // // //       setResumeReviewData(response.data);
// // // // //       setActiveResumeTab(0);
// // // // //     } catch (error) {
// // // // //       showNotification("Failed to load resume review data.", "error");
// // // // //     } finally {
// // // // //       setResumeReviewLoading(false);
// // // // //     }
// // // // //   };
// // // // //   const fetchSkillGap = async (roles) => {
// // // // //     if (!roles || roles.length === 0) {
// // // // //       setSkillGapData({});
// // // // //       return;
// // // // //     }
// // // // //     setSkillGapLoading(true);
// // // // //     try {
// // // // //       const response = await apiClient.post("/resume/skill-gap/", {
// // // // //         selected_roles: roles,
// // // // //       });
// // // // //       setSkillGapData(response.data);
// // // // //       setActiveSkillGapTab(0);
// // // // //     } catch (error) {
// // // // //       showNotification("Failed to load skill gap analysis.", "error");
// // // // //     } finally {
// // // // //       setSkillGapLoading(false);
// // // // //     }
// // // // //   };
// // // // //   const fetchCareerRoadmap = async (roles) => {
// // // // //     if (!roles || roles.length === 0) {
// // // // //       setCareerRoadmapData({});
// // // // //       return;
// // // // //     }
// // // // //     setCareerRoadmapLoading(true);
// // // // //     try {
// // // // //       const response = await apiClient.post("/resume/career-roadmap/", {
// // // // //         target_roles: roles,
// // // // //       });
// // // // //       setCareerRoadmapData(response.data);
// // // // //       setActiveRoadmapTab(0);
// // // // //     } catch (error) {
// // // // //       showNotification("Failed to load career roadmap.", "error");
// // // // //       setCareerRoadmapData({});
// // // // //     } finally {
// // // // //       setCareerRoadmapLoading(false);
// // // // //     }
// // // // //   };

// // // // //   // --- Handlers ---
// // // // //   const handleTrendingRoleChange = (event) => {
// // // // //     const { name, checked } = event.target;
// // // // //     setSelectedTrendingRoles((prev) =>
// // // // //       checked ? [...prev, name] : prev.filter((role) => role !== name)
// // // // //     );
// // // // //   };

// // // // //   // --- Child Components ---
// // // // //   const RoleSelector = ({ selectedRoles, handleRoleChange }) => (
// // // // //     <FormGroup row sx={{ mb: 2, justifyContent: "center", flexWrap: "wrap" }}>
// // // // //       {availableRoles.map((role) => (
// // // // //         <FormControlLabel
// // // // //           key={role}
// // // // //           control={
// // // // //             <Checkbox
// // // // //               checked={selectedRoles.includes(role)}
// // // // //               onChange={handleRoleChange}
// // // // //               name={role}
// // // // //             />
// // // // //           }
// // // // //           label={role}
// // // // //         />
// // // // //       ))}
// // // // //     </FormGroup>
// // // // //   );

// // // // //   const CustomTooltip = ({ active, payload, label }) => {
// // // // //     if (active && payload && payload.length) {
// // // // //       const data = payload[0].payload;
// // // // //       const priorityMuiColor = {
// // // // //         High: "primary",
// // // // //         Medium: "info",
// // // // //       };
// // // // //       return (
// // // // //         <Paper
// // // // //           elevation={3}
// // // // //           sx={{
// // // // //             p: 1.5,
// // // // //             minWidth: 220,
// // // // //             bgcolor: "background.paper",
// // // // //             border: `1px solid ${theme.palette.divider}`,
// // // // //             borderRadius: 2,
// // // // //           }}
// // // // //         >
// // // // //           <Typography variant="body1" fontWeight="bold" gutterBottom>
// // // // //             {label}
// // // // //           </Typography>
// // // // //           <Stack spacing={1}>
// // // // //             <Stack
// // // // //               direction="row"
// // // // //               justifyContent="space-between"
// // // // //               alignItems="center"
// // // // //             >
// // // // //               <Typography variant="body2" color="text.secondary">
// // // // //                 Demand:
// // // // //               </Typography>
// // // // //               <Typography
// // // // //                 variant="body2"
// // // // //                 fontWeight="bold"
// // // // //               >{`${data.demand}%`}</Typography>
// // // // //             </Stack>
// // // // //             <Stack
// // // // //               direction="row"
// // // // //               justifyContent="space-between"
// // // // //               alignItems="center"
// // // // //             >
// // // // //               <Typography variant="body2" color="text.secondary">
// // // // //                 Priority:
// // // // //               </Typography>
// // // // //               <Chip
// // // // //                 label={data.priority}
// // // // //                 size="small"
// // // // //                 color={priorityMuiColor[data.priority] || "default"}
// // // // //                 sx={{ fontWeight: 600 }}
// // // // //               />
// // // // //             </Stack>
// // // // //             <Stack
// // // // //               direction="row"
// // // // //               justifyContent="space-between"
// // // // //               alignItems="center"
// // // // //             >
// // // // //               <Typography variant="body2" color="text.secondary">
// // // // //                 Growth:
// // // // //               </Typography>
// // // // //               <Typography
// // // // //                 variant="body2"
// // // // //                 fontWeight="bold"
// // // // //                 color={
// // // // //                   (data.growth || "").startsWith("+")
// // // // //                     ? "success.main"
// // // // //                     : "error.main"
// // // // //                 }
// // // // //               >
// // // // //                 {data.growth}
// // // // //               </Typography>
// // // // //             </Stack>
// // // // //           </Stack>
// // // // //         </Paper>
// // // // //       );
// // // // //     }
// // // // //     return null;
// // // // //   };

// // // // //   const RoundedVerticalBar = (props) => {
// // // // //     const { fill, x, y, width, height } = props;
// // // // //     const radius = 8;
// // // // //     if (height <= 0) return null;
// // // // //     return (
// // // // //       <g>
// // // // //         <path
// // // // //           d={`M${x},${y + radius} A${radius},${radius} 0 0 1 ${
// // // // //             x + radius
// // // // //           },${y} L${x + width - radius},${y} A${radius},${radius} 0 0 1 ${
// // // // //             x + width
// // // // //           },${y + radius} L${x + width},${y + height} L${x},${y + height} Z`}
// // // // //           fill={fill}
// // // // //         />
// // // // //       </g>
// // // // //     );
// // // // //   };

// // // // //   const assistantServices = [
// // // // //     {
// // // // //       id: "resume-review",
// // // // //       title: "AI Resume Review",
// // // // //       description: "Get detailed feedback & ATS optimization suggestions.",
// // // // //       icon: <Assessment />,
// // // // //       color: "primary",
// // // // //     },
// // // // //     {
// // // // //       id: "skill-assessment",
// // // // //       title: "Skill Gap Analysis",
// // // // //       description: "Identify critical skill gaps for your target roles.",
// // // // //       icon: <TrendingUp />,
// // // // //       color: "success",
// // // // //     },
// // // // //     {
// // // // //       id: "career-roadmap",
// // // // //       title: "Career Roadmap",
// // // // //       description: "AI-generated path based on your profile and goals.",
// // // // //       icon: <Timeline />,
// // // // //       color: "warning",
// // // // //     },
// // // // //     {
// // // // //       id: "salary-insights",
// // // // //       title: "Salary Insights",
// // // // //       description: "Real-time salary benchmarks for roles and locations.",
// // // // //       icon: <Language />,
// // // // //       color: "info",
// // // // //     },
// // // // //     {
// // // // //       id: "cultural-prep",
// // // // //       title: "Cultural Preparation",
// // // // //       description: "Master workplace culture for different countries.",
// // // // //       icon: <Psychology />,
// // // // //       color: "error",
// // // // //     },
// // // // //   ];

// // // // //   const handleServiceClick = async (service) => {
// // // // //     const defaultRolePayload = ["AI/ML Engineer"];
// // // // //     switch (service.id) {
// // // // //       case "resume-review":
// // // // //         setResumeReviewDialog(true);
// // // // //         setSelectedResumeRoles(defaultRolePayload);
// // // // //         await fetchResumeReview(defaultRolePayload);
// // // // //         break;
// // // // //       case "mock-interview":
// // // // //         setMockInterviewDialog(true);
// // // // //         break;
// // // // //       case "skill-assessment":
// // // // //         setSkillGapDialog(true);
// // // // //         setSelectedSkillGapRoles(defaultRolePayload);
// // // // //         await fetchSkillGap(defaultRolePayload);
// // // // //         break;
// // // // //       case "career-roadmap":
// // // // //         setCareerRoadmapDialog(true);
// // // // //         setSelectedRoadmapRoles(defaultRolePayload);
// // // // //         await fetchCareerRoadmap(defaultRolePayload);
// // // // //         break;
// // // // //       case "cultural-prep":
// // // // //         setCulturalPrepDialog(true);
// // // // //         if (!culturalPrepData) {
// // // // //           setCulturalPrepLoading(true);
// // // // //           try {
// // // // //             const res = await apiClient.get("/ai/cultural-preparation/");
// // // // //             const validData = Object.fromEntries(
// // // // //               Object.entries(res.data.cultural_preparation).filter(
// // // // //                 ([, value]) => !value.error_message
// // // // //               )
// // // // //             );
// // // // //             setCulturalPrepData(validData);
// // // // //           } catch (err) {
// // // // //             showNotification("Failed to load cultural prep data.", "error");
// // // // //           } finally {
// // // // //             setCulturalPrepLoading(false);
// // // // //           }
// // // // //         }
// // // // //         break;
// // // // //       case "salary-insights":
// // // // //         setSalaryInsightsDialog(true);
// // // // //         if (!salaryInsightsData) {
// // // // //           setSalaryInsightsLoading(true);
// // // // //           try {
// // // // //             const res = await apiClient.get("/ai/salary-insights/");
// // // // //             setSalaryInsightsData(res.data.salary_insights);
// // // // //           } catch (err) {
// // // // //             showNotification("Failed to load salary insights data.", "error");
// // // // //           } finally {
// // // // //             setSalaryInsightsLoading(false);
// // // // //           }
// // // // //         }
// // // // //         break;
// // // // //       default:
// // // // //         showNotification(`${service.title} feature coming soon!`, "info");
// // // // //     }
// // // // //   };

// // // // //   const DialogSkeleton = () => (
// // // // //     <Stack spacing={3} sx={{ p: 2, minHeight: 400 }}>
// // // // //       <Skeleton variant="rounded" width="60%" height={40} />
// // // // //       <Skeleton variant="rounded" width="100%" height={100} />
// // // // //       <Skeleton variant="rounded" width="40%" height={30} />
// // // // //       <Skeleton variant="rounded" width="100%" height={150} />
// // // // //     </Stack>
// // // // //   );

// // // // //   // Consolidated useEffect for fetching trending skills
// // // // //   useEffect(() => {
// // // // //     if (isInitialMount.current) {
// // // // //       isInitialMount.current = false;
// // // // //       // Initial load without debounce
// // // // //       const initialLoad = async () => {
// // // // //         await fetchTrendingSkills(selectedTrendingRoles);
// // // // //         setPageLoading(false);
// // // // //       };
// // // // //       initialLoad();
// // // // //     } else {
// // // // //       // Debounced fetch for subsequent updates
// // // // //       const handler = setTimeout(() => {
// // // // //         fetchTrendingSkills(selectedTrendingRoles);
// // // // //       }, 500);

// // // // //       return () => {
// // // // //         clearTimeout(handler);
// // // // //       };
// // // // //     }
// // // // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // // // //   }, [selectedTrendingRoles]);

// // // // //   if (pageLoading) {
// // // // //     return <PageSkeleton />;
// // // // //   }

// // // // //   return (
// // // // //     <Layout title="AI Career Assistant">
// // // // //       <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// // // // //         <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
// // // // //           <Stack spacing={4}>
// // // // //             {/* ROW 1: Header Banner */}
// // // // //             <Paper
// // // // //               sx={{
// // // // //                 bgcolor: "mint.main",
// // // // //                 borderRadius: 3,
// // // // //                 p: { xs: 2, sm: 3 },
// // // // //               }}
// // // // //             >
// // // // //               <Stack direction="row" alignItems="center" spacing={2}>
// // // // //                 <Avatar
// // // // //                   sx={{
// // // // //                     bgcolor: "primary.main",
// // // // //                     color: "primary.contrastText",
// // // // //                     width: { xs: 50, sm: 64 },
// // // // //                     height: { xs: 50, sm: 64 },
// // // // //                   }}
// // // // //                 >
// // // // //                   <Psychology sx={{ fontSize: { xs: 28, sm: 36 } }} />
// // // // //                 </Avatar>
// // // // //                 <Box>
// // // // //                   <Typography
// // // // //                     variant="h4"
// // // // //                     component="h1"
// // // // //                     fontWeight="bold"
// // // // //                     sx={{ typography: { xs: "h5", sm: "h4" } }}
// // // // //                   >
// // // // //                     AI Career Assistant
// // // // //                     <AutoAwesome
// // // // //                       sx={{
// // // // //                         fontSize: { xs: 22, sm: 28 },
// // // // //                         ml: 1,
// // // // //                         verticalAlign: "middle",
// // // // //                         color: "primary.main",
// // // // //                       }}
// // // // //                     />
// // // // //                   </Typography>
// // // // //                   <Typography variant="body1" color="text.secondary">
// // // // //                     Your intelligent, multilingual guide to global careers.
// // // // //                   </Typography>
// // // // //                 </Box>
// // // // //               </Stack>
// // // // //             </Paper>

// // // // //             {/* ROW 2: Welcome Alert */}
// // // // //             {showWelcomeCard && (
// // // // //               <Alert
// // // // //                 severity="info"
// // // // //                 variant="filled"
// // // // //                 onClose={() => setShowWelcomeCard(false)}
// // // // //                 action={
// // // // //                   <Button
// // // // //                     color="inherit"
// // // // //                     size="small"
// // // // //                     onClick={() => {
// // // // //                       handleServiceClick(assistantServices[0]);
// // // // //                       setShowWelcomeCard(false);
// // // // //                     }}
// // // // //                   >
// // // // //                     Start Review
// // // // //                   </Button>
// // // // //                 }
// // // // //                 sx={{
// // // // //                   bgcolor: "primary.dark",
// // // // //                   color: "primary.contrastText",
// // // // //                   borderRadius: 2,
// // // // //                 }}
// // // // //               >
// // // // //                 <AlertTitle sx={{ fontWeight: "bold" }}>Welcome!</AlertTitle>
// // // // //                 New here? Start with an AI Resume Review to get personalized
// // // // //                 feedback and unlock other insights.
// // // // //               </Alert>
// // // // //             )}

// // // // //             {/* ROW 3: Services List */}
// // // // //             <Paper
// // // // //               sx={{
// // // // //                 p: { xs: 2, sm: 3 },
// // // // //                 borderRadius: 3,
// // // // //                 bgcolor: "mint.main",
// // // // //               }}
// // // // //             >
// // // // //               <Stack direction="row" alignItems="center" spacing={1} mb={3}>
// // // // //                 <Typography variant="h5" component="h2" fontWeight={600}>
// // // // //                   AI-Powered Career Services
// // // // //                 </Typography>
// // // // //                 <RocketLaunch color="primary" />
// // // // //               </Stack>
// // // // //               <Stack spacing={2}>
// // // // //                 {assistantServices.map((service) => (
// // // // //                   <ServiceListItem
// // // // //                     key={service.id}
// // // // //                     color={service.color}
// // // // //                     onClick={() => handleServiceClick(service)}
// // // // //                   >
// // // // //                     <Avatar sx={{ width: 48, height: 48 }}>
// // // // //                       {service.icon}
// // // // //                     </Avatar>
// // // // //                     <Box flexGrow={1}>
// // // // //                       <Typography
// // // // //                         variant="h6"
// // // // //                         component="div"
// // // // //                         fontWeight="bold"
// // // // //                       >
// // // // //                         {service.title}
// // // // //                       </Typography>
// // // // //                       <Typography variant="body2" color="text.secondary">
// // // // //                         {service.description}
// // // // //                       </Typography>
// // // // //                     </Box>
// // // // //                     <IconButton sx={{ ml: 2 }}>
// // // // //                       <ArrowForward />
// // // // //                     </IconButton>
// // // // //                   </ServiceListItem>
// // // // //                 ))}
// // // // //               </Stack>
// // // // //             </Paper>

// // // // //             {/* ROW 4: Trending Skills */}
// // // // //             <Paper
// // // // //               sx={{
// // // // //                 p: { xs: 2, sm: 3 },
// // // // //                 borderRadius: 3,
// // // // //                 bgcolor: "mint.main",
// // // // //               }}
// // // // //             >
// // // // //               <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
// // // // //                 <Lightbulb color="primary" />
// // // // //                 <Typography variant="h6" fontWeight={600}>
// // // // //                   Top In-Demand Skills
// // // // //                 </Typography>
// // // // //               </Stack>
// // // // //               <RoleSelector
// // // // //                 selectedRoles={selectedTrendingRoles}
// // // // //                 handleRoleChange={handleTrendingRoleChange}
// // // // //               />
// // // // //               {skillsLoading ? (
// // // // //                 <ChartSkeleton />
// // // // //               ) : Object.keys(trendingSkillsData).length > 0 ? (
// // // // //                 <Box>
// // // // //                   <Tabs
// // // // //                     value={activeTrendingTab}
// // // // //                     onChange={(e, val) => setActiveTrendingTab(val)}
// // // // //                     variant="scrollable"
// // // // //                     scrollButtons="auto"
// // // // //                   >
// // // // //                     {Object.keys(trendingSkillsData).map((role) => (
// // // // //                       <Tab label={role} key={role} />
// // // // //                     ))}
// // // // //                   </Tabs>
// // // // //                   {Object.entries(trendingSkillsData).map(
// // // // //                     ([role, skills], index) => {
// // // // //                       const sortedSkills = [...skills].sort(
// // // // //                         (a, b) => b.demand - a.demand
// // // // //                       );
// // // // //                       const priorityColors = {
// // // // //                         High: theme.palette.primary.main,
// // // // //                         Medium: theme.palette.info.main,
// // // // //                       };

// // // // //                       return (
// // // // //                         <TabPanel
// // // // //                           value={activeTrendingTab}
// // // // //                           index={index}
// // // // //                           key={role}
// // // // //                         >
// // // // //                           <Paper
// // // // //                             elevation={0}
// // // // //                             sx={{
// // // // //                               bgcolor: "background.paper",
// // // // //                               borderRadius: 2,
// // // // //                               p: { xs: 1, sm: 2 },
// // // // //                             }}
// // // // //                           >
// // // // //                             <Box
// // // // //                               sx={{
// // // // //                                 height: { xs: 400, md: 500 },
// // // // //                                 width: "100%",
// // // // //                               }}
// // // // //                             >
// // // // //                               <ResponsiveContainer width="100%" height="100%">
// // // // //                                 <BarChart
// // // // //                                   data={sortedSkills}
// // // // //                                   margin={{
// // // // //                                     top: 30,
// // // // //                                     right: 30,
// // // // //                                     left: 20,
// // // // //                                     bottom: 120,
// // // // //                                   }}
// // // // //                                 >
// // // // //                                   <CartesianGrid
// // // // //                                     vertical={false}
// // // // //                                     stroke={theme.palette.divider}
// // // // //                                     strokeDasharray="3 3"
// // // // //                                   />
// // // // //                                   <XAxis
// // // // //                                     dataKey="skill"
// // // // //                                     type="category"
// // // // //                                     interval={0}
// // // // //                                     angle={-45}
// // // // //                                     textAnchor="end"
// // // // //                                     tick={{
// // // // //                                       fill: theme.palette.text.secondary,
// // // // //                                       fontSize: 12,
// // // // //                                     }}
// // // // //                                     stroke={"transparent"}
// // // // //                                   />
// // // // //                                   <YAxis
// // // // //                                     type="number"
// // // // //                                     domain={[0, "dataMax + 15"]}
// // // // //                                     allowDecimals={false}
// // // // //                                     tickFormatter={(tick) => `${tick}%`}
// // // // //                                     stroke={theme.palette.divider}
// // // // //                                     tick={{
// // // // //                                       fill: theme.palette.text.secondary,
// // // // //                                     }}
// // // // //                                   />
// // // // //                                   <Tooltip
// // // // //                                     content={<CustomTooltip />}
// // // // //                                     cursor={{
// // // // //                                       fill: alpha(
// // // // //                                         theme.palette.primary.main,
// // // // //                                         0.1
// // // // //                                       ),
// // // // //                                     }}
// // // // //                                   />
// // // // //                                   <Bar
// // // // //                                     dataKey="demand"
// // // // //                                     shape={<RoundedVerticalBar />}
// // // // //                                     animationDuration={800}
// // // // //                                   >
// // // // //                                     {sortedSkills.map((entry, idx) => (
// // // // //                                       <Cell
// // // // //                                         key={`cell-${idx}`}
// // // // //                                         fill={
// // // // //                                           priorityColors[entry.priority] ||
// // // // //                                           theme.palette.text.disabled
// // // // //                                         }
// // // // //                                       />
// // // // //                                     ))}
// // // // //                                     <LabelList
// // // // //                                       dataKey="demand"
// // // // //                                       position="top"
// // // // //                                       offset={8}
// // // // //                                       style={{
// // // // //                                         fill: theme.palette.text.primary,
// // // // //                                         fontSize: "12px",
// // // // //                                         fontWeight: "bold",
// // // // //                                       }}
// // // // //                                       formatter={(value) => `${value}%`}
// // // // //                                     />
// // // // //                                   </Bar>
// // // // //                                 </BarChart>
// // // // //                               </ResponsiveContainer>
// // // // //                             </Box>
// // // // //                           </Paper>
// // // // //                         </TabPanel>
// // // // //                       );
// // // // //                     }
// // // // //                   )}
// // // // //                 </Box>
// // // // //               ) : (
// // // // //                 <Box
// // // // //                   sx={{
// // // // //                     display: "flex",
// // // // //                     flexDirection: "column",
// // // // //                     alignItems: "center",
// // // // //                     justifyContent: "center",
// // // // //                     textAlign: "center",
// // // // //                     py: 8,
// // // // //                     minHeight: 400,
// // // // //                   }}
// // // // //                 >
// // // // //                   <Insights
// // // // //                     sx={{ fontSize: 60, color: "text.disabled", mb: 2 }}
// // // // //                   />
// // // // //                   <Typography variant="h6" color="text.secondary">
// // // // //                     Select a role to view in-demand skills
// // // // //                   </Typography>
// // // // //                   <Typography variant="body2" color="text.disabled">
// // // // //                     The chart will update automatically as you make selections.
// // // // //                   </Typography>
// // // // //                 </Box>
// // // // //               )}
// // // // //             </Paper>
// // // // //           </Stack>
// // // // //         </Container>
// // // // //       </Box>

// // // // //       {/* --- DIALOGS (UI ENHANCEMENTS APPLIED) --- */}
// // // // //       <Dialog
// // // // //         open={resumeReviewDialog}
// // // // //         onClose={() => setResumeReviewDialog(false)}
// // // // //         maxWidth="lg"
// // // // //         fullWidth
// // // // //       >
// // // // //         <DialogTitle
// // // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // // //         >
// // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // //             <Assessment />
// // // // //             <Typography variant="h6">AI Resume Review</Typography>
// // // // //           </Stack>
// // // // //         </DialogTitle>
// // // // //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// // // // //           <RoleSelector
// // // // //             selectedRoles={selectedResumeRoles}
// // // // //             handleRoleChange={(e) =>
// // // // //               setSelectedResumeRoles((prev) =>
// // // // //                 e.target.checked
// // // // //                   ? [...prev, e.target.name]
// // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // //               )
// // // // //             }
// // // // //           />
// // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // //             <Button
// // // // //               variant="contained"
// // // // //               onClick={() => fetchResumeReview(selectedResumeRoles)}
// // // // //             >
// // // // //               Generate Report
// // // // //             </Button>
// // // // //           </Box>
// // // // //           <Divider sx={{ mb: 2 }} />
// // // // //           {resumeReviewLoading ? (
// // // // //             <DialogSkeleton />
// // // // //           ) : (
// // // // //             resumeReviewData && (
// // // // //               <>
// // // // //                 <Tabs
// // // // //                   value={activeResumeTab}
// // // // //                   onChange={(e, val) => setActiveResumeTab(val)}
// // // // //                   centered
// // // // //                   variant="scrollable"
// // // // //                   scrollButtons="auto"
// // // // //                 >
// // // // //                   {Object.keys(resumeReviewData).map((role) => (
// // // // //                     <Tab key={role} label={role} />
// // // // //                   ))}
// // // // //                 </Tabs>
// // // // //                 {Object.entries(resumeReviewData).map(([role, data], index) => (
// // // // //                   <TabPanel value={activeResumeTab} index={index} key={role}>
// // // // //                     <Grid container spacing={3}>
// // // // //                       <Grid item xs={12} md={6}>
// // // // //                         <Paper
// // // // //                           variant="outlined"
// // // // //                           sx={{ p: 2.5, height: "100%", borderRadius: 2 }}
// // // // //                         >
// // // // //                           <Box
// // // // //                             sx={{
// // // // //                               p: 2,
// // // // //                               mb: 2,
// // // // //                               borderRadius: 1.5,
// // // // //                               background: (theme) =>
// // // // //                                 `linear-gradient(135deg, ${alpha(
// // // // //                                   theme.palette.error.light,
// // // // //                                   0.2
// // // // //                                 )}, ${alpha(theme.palette.error.dark, 0.2)})`,
// // // // //                             }}
// // // // //                           >
// // // // //                             <Typography variant="h6" fontWeight="500">
// // // // //                               ATS Compatibility
// // // // //                             </Typography>
// // // // //                             <Typography
// // // // //                               variant="h3"
// // // // //                               fontWeight="bold"
// // // // //                               color="error.dark"
// // // // //                             >
// // // // //                               {data.ATS_Compatibility.score}
// // // // //                               <Typography
// // // // //                                 component="span"
// // // // //                                 variant="h5"
// // // // //                                 color="text.secondary"
// // // // //                               >
// // // // //                                 /100
// // // // //                               </Typography>
// // // // //                             </Typography>
// // // // //                             <LinearProgress
// // // // //                               variant="determinate"
// // // // //                               value={data.ATS_Compatibility.score}
// // // // //                               color="error"
// // // // //                               sx={{ height: 6, borderRadius: 3 }}
// // // // //                             />
// // // // //                           </Box>
// // // // //                           <Typography variant="subtitle1" fontWeight="bold">
// // // // //                             Top Issues:
// // // // //                           </Typography>
// // // // //                           <List dense>
// // // // //                             {data.ATS_Compatibility.top_issues.map(
// // // // //                               (issue, i) => (
// // // // //                                 <ListItem key={i} sx={{ py: 0 }}>
// // // // //                                   <ListItemIcon sx={{ minWidth: 32 }}>
// // // // //                                     <ErrorOutline
// // // // //                                       fontSize="small"
// // // // //                                       color="error"
// // // // //                                     />
// // // // //                                   </ListItemIcon>
// // // // //                                   <ListItemText primary={issue} />
// // // // //                                 </ListItem>
// // // // //                               )
// // // // //                             )}
// // // // //                           </List>
// // // // //                         </Paper>
// // // // //                       </Grid>
// // // // //                       <Grid item xs={12} md={6}>
// // // // //                         <Paper
// // // // //                           variant="outlined"
// // // // //                           sx={{ p: 2.5, height: "100%", borderRadius: 2 }}
// // // // //                         >
// // // // //                           <Box
// // // // //                             sx={{
// // // // //                               p: 2,
// // // // //                               mb: 2,
// // // // //                               borderRadius: 1.5,
// // // // //                               background: (theme) =>
// // // // //                                 `linear-gradient(135deg, ${alpha(
// // // // //                                   theme.palette.success.light,
// // // // //                                   0.2
// // // // //                                 )}, ${alpha(theme.palette.success.dark, 0.2)})`,
// // // // //                             }}
// // // // //                           >
// // // // //                             <Typography variant="h6" fontWeight="500">
// // // // //                               Content & Format Quality
// // // // //                             </Typography>
// // // // //                             <Typography
// // // // //                               variant="body2"
// // // // //                               paragraph
// // // // //                               color="text.secondary"
// // // // //                             >
// // // // //                               {data.Content_Quality_Analysis.summary}
// // // // //                             </Typography>
// // // // //                           </Box>
// // // // //                           <Typography variant="subtitle1" fontWeight="bold">
// // // // //                             Top Strengths:
// // // // //                           </Typography>
// // // // //                           <List dense>
// // // // //                             {data.Content_Quality_Analysis.top_strengths.map(
// // // // //                               (strength, i) => (
// // // // //                                 <ListItem key={i} sx={{ py: 0 }}>
// // // // //                                   <ListItemIcon sx={{ minWidth: 32 }}>
// // // // //                                     <CheckCircle
// // // // //                                       fontSize="small"
// // // // //                                       color="success"
// // // // //                                     />
// // // // //                                   </ListItemIcon>
// // // // //                                   <ListItemText primary={strength} />
// // // // //                                 </ListItem>
// // // // //                               )
// // // // //                             )}
// // // // //                           </List>
// // // // //                         </Paper>
// // // // //                       </Grid>
// // // // //                       <Grid item xs={12}>
// // // // //                         <Paper
// // // // //                           variant="outlined"
// // // // //                           sx={{ p: 2.5, borderRadius: 2 }}
// // // // //                         >
// // // // //                           <Typography variant="h6" gutterBottom>
// // // // //                             Keyword & Section Optimization
// // // // //                           </Typography>
// // // // //                           <Stack
// // // // //                             direction={{ xs: "column", sm: "row" }}
// // // // //                             spacing={3}
// // // // //                             divider={
// // // // //                               <Divider orientation="vertical" flexItem />
// // // // //                             }
// // // // //                           >
// // // // //                             <Box flex={1}>
// // // // //                               <Typography variant="subtitle1" fontWeight="bold">
// // // // //                                 Missing Keywords
// // // // //                               </Typography>
// // // // //                               <Box
// // // // //                                 sx={{
// // // // //                                   display: "flex",
// // // // //                                   flexWrap: "wrap",
// // // // //                                   gap: 1,
// // // // //                                   mt: 1,
// // // // //                                 }}
// // // // //                               >
// // // // //                                 {data.Keyword_Optimization.missing_keywords.map(
// // // // //                                   (kw, i) => (
// // // // //                                     <Chip
// // // // //                                       key={i}
// // // // //                                       label={kw}
// // // // //                                       color="info"
// // // // //                                       size="small"
// // // // //                                     />
// // // // //                                   )
// // // // //                                 )}
// // // // //                               </Box>
// // // // //                             </Box>
// // // // //                             <Box flex={1}>
// // // // //                               <Typography variant="subtitle1" fontWeight="bold">
// // // // //                                 Missing Sections
// // // // //                               </Typography>
// // // // //                               <Box
// // // // //                                 sx={{
// // // // //                                   display: "flex",
// // // // //                                   flexWrap: "wrap",
// // // // //                                   gap: 1,
// // // // //                                   mt: 1,
// // // // //                                 }}
// // // // //                               >
// // // // //                                 {data.Format_and_Structure_Review.missing_sections.map(
// // // // //                                   (sec, i) => (
// // // // //                                     <Chip
// // // // //                                       key={i}
// // // // //                                       label={sec}
// // // // //                                       color="warning"
// // // // //                                       size="small"
// // // // //                                     />
// // // // //                                   )
// // // // //                                 )}
// // // // //                               </Box>
// // // // //                             </Box>
// // // // //                           </Stack>
// // // // //                         </Paper>
// // // // //                       </Grid>
// // // // //                     </Grid>
// // // // //                   </TabPanel>
// // // // //                 ))}
// // // // //               </>
// // // // //             )
// // // // //           )}
// // // // //         </DialogContent>
// // // // //         <DialogActions>
// // // // //           <Button onClick={() => setResumeReviewDialog(false)}>Close</Button>
// // // // //         </DialogActions>
// // // // //       </Dialog>
// // // // //       <Dialog
// // // // //         open={skillGapDialog}
// // // // //         onClose={() => setSkillGapDialog(false)}
// // // // //         maxWidth="lg"
// // // // //         fullWidth
// // // // //       >
// // // // //         <DialogTitle
// // // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // // //         >
// // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // //             <TrendingUp />
// // // // //             <Typography variant="h6">AI Skill Gap Analysis</Typography>
// // // // //           </Stack>
// // // // //         </DialogTitle>
// // // // //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// // // // //           <RoleSelector
// // // // //             selectedRoles={selectedSkillGapRoles}
// // // // //             handleRoleChange={(e) =>
// // // // //               setSelectedSkillGapRoles((prev) =>
// // // // //                 e.target.checked
// // // // //                   ? [...prev, e.target.name]
// // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // //               )
// // // // //             }
// // // // //           />
// // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // //             <Button
// // // // //               variant="contained"
// // // // //               color="primary"
// // // // //               onClick={() => fetchSkillGap(selectedSkillGapRoles)}
// // // // //             >
// // // // //               Generate Analysis
// // // // //             </Button>
// // // // //           </Box>
// // // // //           <Divider sx={{ mb: 2 }} />
// // // // //           {skillGapLoading ? (
// // // // //             <DialogSkeleton />
// // // // //           ) : (
// // // // //             skillGapData && (
// // // // //               <>
// // // // //                 <Tabs
// // // // //                   value={activeSkillGapTab}
// // // // //                   onChange={(e, val) => setActiveSkillGapTab(val)}
// // // // //                   centered
// // // // //                   variant="scrollable"
// // // // //                   scrollButtons="auto"
// // // // //                 >
// // // // //                   {Object.keys(skillGapData).map((role) => (
// // // // //                     <Tab key={role} label={role} />
// // // // //                   ))}
// // // // //                 </Tabs>
// // // // //                 {Object.entries(skillGapData).map(([role, data], index) => (
// // // // //                   <TabPanel value={activeSkillGapTab} index={index} key={role}>
// // // // //                     <Grid container spacing={2}>
// // // // //                       <Grid item xs={12} md={6}>
// // // // //                         <Paper
// // // // //                           variant="outlined"
// // // // //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// // // // //                         >
// // // // //                           <Stack
// // // // //                             direction="row"
// // // // //                             spacing={1.5}
// // // // //                             alignItems="center"
// // // // //                             mb={1.5}
// // // // //                           >
// // // // //                             <Avatar sx={{ bgcolor: "primary.light" }}>
// // // // //                               <Person />
// // // // //                             </Avatar>
// // // // //                             <Typography variant="h6">Your Skills</Typography>
// // // // //                           </Stack>
// // // // //                           <Box
// // // // //                             sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
// // // // //                           >
// // // // //                             {data.Current_Skill_Mapping.map((skill, i) => (
// // // // //                               <Chip key={i} label={skill} variant="outlined" />
// // // // //                             ))}
// // // // //                           </Box>
// // // // //                         </Paper>
// // // // //                       </Grid>
// // // // //                       <Grid item xs={12} md={6}>
// // // // //                         <Paper
// // // // //                           variant="outlined"
// // // // //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// // // // //                         >
// // // // //                           <Stack
// // // // //                             direction="row"
// // // // //                             spacing={1.5}
// // // // //                             alignItems="center"
// // // // //                             mb={1.5}
// // // // //                           >
// // // // //                             <Avatar sx={{ bgcolor: "secondary.light" }}>
// // // // //                               <TrendingUp />
// // // // //                             </Avatar>
// // // // //                             <Typography variant="h6">
// // // // //                               In-Demand Market Skills
// // // // //                             </Typography>
// // // // //                           </Stack>
// // // // //                           <Box
// // // // //                             sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
// // // // //                           >
// // // // //                             {data.Market_Demand_Analysis.map((skill, i) => (
// // // // //                               <Chip key={i} label={skill} color="primary" />
// // // // //                             ))}
// // // // //                           </Box>
// // // // //                         </Paper>
// // // // //                       </Grid>
// // // // //                       <Grid item xs={12} md={6}>
// // // // //                         <Paper
// // // // //                           variant="outlined"
// // // // //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// // // // //                         >
// // // // //                           <Stack
// // // // //                             direction="row"
// // // // //                             spacing={1.5}
// // // // //                             alignItems="center"
// // // // //                             mb={1.5}
// // // // //                           >
// // // // //                             <Avatar sx={{ bgcolor: "info.light" }}>
// // // // //                               <School />
// // // // //                             </Avatar>
// // // // //                             <Typography variant="h6">
// // // // //                               Recommended Learning Path
// // // // //                             </Typography>
// // // // //                           </Stack>
// // // // //                           <List dense>
// // // // //                             {data.Learning_Path.map((path, i) => (
// // // // //                               <ListItem key={i} sx={{ py: 0.5 }}>
// // // // //                                 <ListItemIcon sx={{ minWidth: 36 }}>
// // // // //                                   <ArrowForward fontSize="small" color="info" />
// // // // //                                 </ListItemIcon>
// // // // //                                 <ListItemText primary={path} />
// // // // //                               </ListItem>
// // // // //                             ))}
// // // // //                           </List>
// // // // //                         </Paper>
// // // // //                       </Grid>
// // // // //                       <Grid item xs={12} md={6}>
// // // // //                         <Paper
// // // // //                           variant="outlined"
// // // // //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// // // // //                         >
// // // // //                           <Stack
// // // // //                             direction="row"
// // // // //                             spacing={1.5}
// // // // //                             alignItems="center"
// // // // //                             mb={1.5}
// // // // //                           >
// // // // //                             <Avatar sx={{ bgcolor: "success.light" }}>
// // // // //                               <MilitaryTech />
// // // // //                             </Avatar>
// // // // //                             <Typography variant="h6">
// // // // //                               Suggested Certifications
// // // // //                             </Typography>
// // // // //                           </Stack>
// // // // //                           <List dense>
// // // // //                             {data.Certification_Guidance.map((cert, i) => (
// // // // //                               <ListItem key={i} sx={{ py: 0.5 }}>
// // // // //                                 <ListItemIcon sx={{ minWidth: 36 }}>
// // // // //                                   <CheckCircle
// // // // //                                     fontSize="small"
// // // // //                                     color="success"
// // // // //                                   />
// // // // //                                 </ListItemIcon>
// // // // //                                 <ListItemText primary={cert} />
// // // // //                               </ListItem>
// // // // //                             ))}
// // // // //                           </List>
// // // // //                         </Paper>
// // // // //                       </Grid>
// // // // //                     </Grid>
// // // // //                   </TabPanel>
// // // // //                 ))}
// // // // //               </>
// // // // //             )
// // // // //           )}
// // // // //         </DialogContent>
// // // // //         <DialogActions>
// // // // //           <Button onClick={() => setSkillGapDialog(false)}>Close</Button>
// // // // //         </DialogActions>
// // // // //       </Dialog>
// // // // //       <Dialog
// // // // //         open={careerRoadmapDialog}
// // // // //         onClose={() => setCareerRoadmapDialog(false)}
// // // // //         maxWidth="lg"
// // // // //         fullWidth
// // // // //       >
// // // // //         <DialogTitle
// // // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // // //         >
// // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // //             <Timeline />
// // // // //             <Typography variant="h6">Personalized Career Roadmap</Typography>
// // // // //           </Stack>
// // // // //         </DialogTitle>
// // // // //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// // // // //           <RoleSelector
// // // // //             selectedRoles={selectedRoadmapRoles}
// // // // //             handleRoleChange={(e) =>
// // // // //               setSelectedRoadmapRoles((prev) =>
// // // // //                 e.target.checked
// // // // //                   ? [...prev, e.target.name]
// // // // //                   : prev.filter((r) => r !== e.target.name)
// // // // //               )
// // // // //             }
// // // // //           />
// // // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // // //             <Button
// // // // //               variant="contained"
// // // // //               color="primary"
// // // // //               onClick={() => fetchCareerRoadmap(selectedRoadmapRoles)}
// // // // //             >
// // // // //               Generate Roadmap
// // // // //             </Button>
// // // // //           </Box>
// // // // //           <Divider sx={{ mb: 2 }} />
// // // // //           {careerRoadmapLoading ? (
// // // // //             <DialogSkeleton />
// // // // //           ) : (
// // // // //             careerRoadmapData && (
// // // // //               <>
// // // // //                 <Tabs
// // // // //                   value={activeRoadmapTab}
// // // // //                   onChange={(e, val) => setActiveRoadmapTab(val)}
// // // // //                   centered
// // // // //                   variant="scrollable"
// // // // //                   scrollButtons="auto"
// // // // //                 >
// // // // //                   {Object.keys(careerRoadmapData).map((role) => (
// // // // //                     <Tab key={role} label={role} />
// // // // //                   ))}
// // // // //                 </Tabs>
// // // // //                 {Object.entries(careerRoadmapData).map(
// // // // //                   ([role, data], index) => (
// // // // //                     <TabPanel value={activeRoadmapTab} index={index} key={role}>
// // // // //                       <Typography variant="h5" gutterBottom align="center">
// // // // //                         Your AI-Generated Path to <strong>{role}</strong>
// // // // //                       </Typography>
// // // // //                       <Typography
// // // // //                         variant="body1"
// // // // //                         paragraph
// // // // //                         color="text.secondary"
// // // // //                         align="center"
// // // // //                       >
// // // // //                         Based on your current role:{" "}
// // // // //                         <strong>{data?.Current_Position || "N/A"}</strong> with{" "}
// // // // //                         <strong>{data?.Experience_Years || "N/A"}</strong> years
// // // // //                         of experience.
// // // // //                       </Typography>
// // // // //                       <Grid container spacing={2} sx={{ mt: 1 }}>
// // // // //                         <Grid item xs={12} md={6}>
// // // // //                           <Paper
// // // // //                             variant="outlined"
// // // // //                             sx={{
// // // // //                               p: 2.5,
// // // // //                               height: "100%",
// // // // //                               borderRadius: 2,
// // // // //                             }}
// // // // //                           >
// // // // //                             <Stack
// // // // //                               direction="row"
// // // // //                               spacing={2}
// // // // //                               alignItems="center"
// // // // //                             >
// // // // //                               <Avatar
// // // // //                                 sx={{
// // // // //                                   bgcolor: "primary.light",
// // // // //                                   width: 56,
// // // // //                                   height: 56,
// // // // //                                 }}
// // // // //                               >
// // // // //                                 <RocketLaunch />
// // // // //                               </Avatar>
// // // // //                               <Box>
// // // // //                                 <Typography
// // // // //                                   variant="overline"
// // // // //                                   color="primary.main"
// // // // //                                 >
// // // // //                                   Next Milestone
// // // // //                                 </Typography>
// // // // //                                 <Typography variant="h6" fontWeight="bold">
// // // // //                                   {data?.Next_Milestone?.title ||
// // // // //                                     "Not available"}
// // // // //                                 </Typography>
// // // // //                                 <Chip
// // // // //                                   size="small"
// // // // //                                   label={`Company: ${
// // // // //                                     data?.Next_Milestone?.company_type || "N/A"
// // // // //                                   }`}
// // // // //                                   sx={{ mt: 1 }}
// // // // //                                 />
// // // // //                               </Box>
// // // // //                             </Stack>
// // // // //                           </Paper>
// // // // //                         </Grid>
// // // // //                         <Grid item xs={12} md={6}>
// // // // //                           <Paper
// // // // //                             variant="outlined"
// // // // //                             sx={{
// // // // //                               p: 2.5,
// // // // //                               height: "100%",
// // // // //                               borderRadius: 2,
// // // // //                             }}
// // // // //                           >
// // // // //                             <Stack
// // // // //                               direction="row"
// // // // //                               spacing={2}
// // // // //                               alignItems="center"
// // // // //                             >
// // // // //                               <Avatar
// // // // //                                 sx={{
// // // // //                                   bgcolor: "success.light",
// // // // //                                   width: 56,
// // // // //                                   height: 56,
// // // // //                                 }}
// // // // //                               >
// // // // //                                 <Stars />
// // // // //                               </Avatar>
// // // // //                               <Box>
// // // // //                                 <Typography
// // // // //                                   variant="overline"
// // // // //                                   color="success.main"
// // // // //                                 >
// // // // //                                   Long-term Goal
// // // // //                                 </Typography>
// // // // //                                 <Typography variant="h6" fontWeight="bold">
// // // // //                                   {data?.Long_Term_Goal?.title ||
// // // // //                                     "Not available"}
// // // // //                                 </Typography>
// // // // //                                 <Chip
// // // // //                                   size="small"
// // // // //                                   label={`Company: ${
// // // // //                                     data?.Long_Term_Goal?.company_type || "N/A"
// // // // //                                   }`}
// // // // //                                   sx={{ mt: 1 }}
// // // // //                                 />
// // // // //                               </Box>
// // // // //                             </Stack>
// // // // //                           </Paper>
// // // // //                         </Grid>
// // // // //                       </Grid>
// // // // //                       <Divider sx={{ my: 3 }}>
// // // // //                         <Chip label="Recommended Actions" color="primary" />
// // // // //                       </Divider>
// // // // //                       <List>
// // // // //                         {data?.Recommended_Actions?.map((item, i) => (
// // // // //                           <ListItem key={i} alignItems="flex-start">
// // // // //                             <ListItemIcon>
// // // // //                               <Work color="primary" />
// // // // //                             </ListItemIcon>
// // // // //                             <ListItemText
// // // // //                               primary={item.action}
// // // // //                               secondary={item.reason}
// // // // //                             />
// // // // //                           </ListItem>
// // // // //                         )) || (
// // // // //                           <ListItem>
// // // // //                             <ListItemText primary="No actions recommended." />
// // // // //                           </ListItem>
// // // // //                         )}
// // // // //                       </List>
// // // // //                     </TabPanel>
// // // // //                   )
// // // // //                 )}
// // // // //               </>
// // // // //             )
// // // // //           )}
// // // // //         </DialogContent>
// // // // //         <DialogActions>
// // // // //           <Button onClick={() => setCareerRoadmapDialog(false)}>Close</Button>
// // // // //         </DialogActions>
// // // // //       </Dialog>
// // // // //       <Dialog
// // // // //         open={culturalPrepDialog}
// // // // //         onClose={() => {
// // // // //           setCulturalPrepDialog(false);
// // // // //           setCulturalPrepTab(0);
// // // // //         }}
// // // // //         maxWidth="md"
// // // // //         fullWidth
// // // // //         PaperProps={{ sx: { height: { md: 650 } } }}
// // // // //       >
// // // // //         <DialogTitle
// // // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // // //         >
// // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // //             <Psychology />
// // // // //             <Typography variant="h6">Cultural Preparation Insights</Typography>
// // // // //           </Stack>
// // // // //         </DialogTitle>
// // // // //         <DialogContent
// // // // //           dividers
// // // // //           sx={{
// // // // //             display: "flex",
// // // // //             p: 0,
// // // // //             overflow: "hidden",
// // // // //             flexDirection: { xs: "column", md: "row" },
// // // // //           }}
// // // // //         >
// // // // //           {culturalPrepLoading ? (
// // // // //             <DialogSkeleton />
// // // // //           ) : (
// // // // //             culturalPrepData && (
// // // // //               <>
// // // // //                 <Tabs
// // // // //                   orientation={
// // // // //                     theme.breakpoints.up("md") ? "vertical" : "horizontal"
// // // // //                   }
// // // // //                   variant="scrollable"
// // // // //                   value={culturalPrepTab}
// // // // //                   onChange={(e, val) => setCulturalPrepTab(val)}
// // // // //                   sx={{
// // // // //                     borderRight: { md: 1 },
// // // // //                     borderBottom: { xs: 1, md: 0 },
// // // // //                     borderColor: "divider",
// // // // //                     minWidth: { md: 150 },
// // // // //                   }}
// // // // //                 >
// // // // //                   {Object.values(culturalPrepData).map((region, index) => (
// // // // //                     <Tab key={index} label={region.location_name} />
// // // // //                   ))}
// // // // //                 </Tabs>
// // // // //                 <Box
// // // // //                   sx={{
// // // // //                     flex: { md: 1 },
// // // // //                     overflowY: "auto",
// // // // //                     p: { xs: 2, md: 3 },
// // // // //                     bgcolor: "background.default",
// // // // //                   }}
// // // // //                 >
// // // // //                   {Object.values(culturalPrepData).map((region, index) => (
// // // // //                     <TabPanel value={culturalPrepTab} index={index} key={index}>
// // // // //                       <Stack spacing={2}>
// // // // //                         <Paper
// // // // //                           elevation={0}
// // // // //                           sx={{
// // // // //                             p: 2,
// // // // //                             borderRadius: 2,
// // // // //                             border: 1,
// // // // //                             borderColor: "divider",
// // // // //                           }}
// // // // //                         >
// // // // //                           <Stack
// // // // //                             direction="row"
// // // // //                             spacing={1}
// // // // //                             alignItems="center"
// // // // //                             mb={1}
// // // // //                           >
// // // // //                             <Insights color="primary" />
// // // // //                             <Typography variant="h6">
// // // // //                               Cultural Insights
// // // // //                             </Typography>
// // // // //                           </Stack>
// // // // //                           <List dense>
// // // // //                             {region.cultural_insights.map((insight, i) => (
// // // // //                               <ListItem key={i}>
// // // // //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// // // // //                                   <ArrowForward fontSize="small" />
// // // // //                                 </ListItemIcon>
// // // // //                                 <ListItemText primary={insight} />
// // // // //                               </ListItem>
// // // // //                             ))}
// // // // //                           </List>
// // // // //                         </Paper>
// // // // //                         <Paper
// // // // //                           elevation={0}
// // // // //                           sx={{
// // // // //                             p: 2,
// // // // //                             borderRadius: 2,
// // // // //                             border: 1,
// // // // //                             borderColor: "divider",
// // // // //                           }}
// // // // //                         >
// // // // //                           <Stack
// // // // //                             direction="row"
// // // // //                             spacing={1}
// // // // //                             alignItems="center"
// // // // //                             mb={1}
// // // // //                           >
// // // // //                             <VideoCall color="primary" />
// // // // //                             <Typography variant="h6">
// // // // //                               Communication Tips
// // // // //                             </Typography>
// // // // //                           </Stack>
// // // // //                           <List dense>
// // // // //                             {region.communication_tips.map((tip, i) => (
// // // // //                               <ListItem key={i}>
// // // // //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// // // // //                                   <ArrowForward fontSize="small" />
// // // // //                                 </ListItemIcon>
// // // // //                                 <ListItemText primary={tip} />
// // // // //                               </ListItem>
// // // // //                             ))}
// // // // //                           </List>
// // // // //                         </Paper>
// // // // //                         <Paper
// // // // //                           elevation={0}
// // // // //                           sx={{
// // // // //                             p: 2,
// // // // //                             borderRadius: 2,
// // // // //                             border: 1,
// // // // //                             borderColor: "divider",
// // // // //                           }}
// // // // //                         >
// // // // //                           <Stack
// // // // //                             direction="row"
// // // // //                             spacing={1}
// // // // //                             alignItems="center"
// // // // //                             mb={1}
// // // // //                           >
// // // // //                             <Work color="primary" />
// // // // //                             <Typography variant="h6">Work Etiquette</Typography>
// // // // //                           </Stack>
// // // // //                           <List dense>
// // // // //                             {region.work_etiquette.map((tip, i) => (
// // // // //                               <ListItem key={i}>
// // // // //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// // // // //                                   <Stars fontSize="small" />
// // // // //                                 </ListItemIcon>
// // // // //                                 <ListItemText primary={tip} />
// // // // //                               </ListItem>
// // // // //                             ))}
// // // // //                           </List>
// // // // //                         </Paper>
// // // // //                       </Stack>
// // // // //                     </TabPanel>
// // // // //                   ))}
// // // // //                 </Box>
// // // // //               </>
// // // // //             )
// // // // //           )}
// // // // //         </DialogContent>
// // // // //         <DialogActions>
// // // // //           <Button onClick={() => setCulturalPrepDialog(false)}>Close</Button>
// // // // //         </DialogActions>
// // // // //       </Dialog>
// // // // //       <Dialog
// // // // //         open={salaryInsightsDialog}
// // // // //         onClose={() => setSalaryInsightsDialog(false)}
// // // // //         maxWidth="md"
// // // // //         fullWidth
// // // // //       >
// // // // //         <DialogTitle
// // // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // // //         >
// // // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // // //             <Language />
// // // // //             <Typography variant="h6">Global Salary Insights</Typography>
// // // // //           </Stack>
// // // // //         </DialogTitle>
// // // // //         <DialogContent dividers sx={{ bgcolor: "background.default" }}>
// // // // //           {salaryInsightsLoading ? (
// // // // //             <DialogSkeleton />
// // // // //           ) : (
// // // // //             salaryInsightsData && (
// // // // //               <Stack spacing={3} sx={{ py: 2 }}>
// // // // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // // // //                   <Stack
// // // // //                     direction="row"
// // // // //                     spacing={1.5}
// // // // //                     alignItems="center"
// // // // //                     mb={2}
// // // // //                   >
// // // // //                     <LocationOn color="primary" />
// // // // //                     <Typography variant="h6">
// // // // //                       Salary Benchmarks by Location
// // // // //                     </Typography>
// // // // //                   </Stack>
// // // // //                   <Grid container spacing={2}>
// // // // //                     {salaryInsightsData.location_based.map((loc, i) => (
// // // // //                       <Grid item xs={12} sm={6} key={i}>
// // // // //                         <Card
// // // // //                           variant="outlined"
// // // // //                           sx={{ height: "100%", borderRadius: 2 }}
// // // // //                         >
// // // // //                           <CardContent
// // // // //                             sx={{
// // // // //                               display: "flex",
// // // // //                               flexDirection: "column",
// // // // //                               height: "100%",
// // // // //                             }}
// // // // //                           >
// // // // //                             <Box sx={{ flexGrow: 1 }}>
// // // // //                               <Typography variant="h6" component="div">
// // // // //                                 {loc.city}
// // // // //                               </Typography>
// // // // //                               <Chip
// // // // //                                 label={loc.role}
// // // // //                                 size="small"
// // // // //                                 color="primary"
// // // // //                                 sx={{ mb: 2 }}
// // // // //                               />
// // // // //                             </Box>
// // // // //                             <Stack
// // // // //                               direction="row"
// // // // //                               alignItems="center"
// // // // //                               justifyContent="space-around"
// // // // //                               spacing={1}
// // // // //                             >
// // // // //                               <Box textAlign="center">
// // // // //                                 <Typography
// // // // //                                   variant="caption"
// // // // //                                   color="text.secondary"
// // // // //                                 >
// // // // //                                   MIN
// // // // //                                 </Typography>
// // // // //                                 <Typography variant="body2" fontWeight="bold">
// // // // //                                   {loc.min_salary}
// // // // //                                 </Typography>
// // // // //                               </Box>
// // // // //                               <Divider orientation="vertical" flexItem />
// // // // //                               <Box textAlign="center">
// // // // //                                 <Typography
// // // // //                                   variant="caption"
// // // // //                                   color="text.secondary"
// // // // //                                 >
// // // // //                                   MEDIAN
// // // // //                                 </Typography>
// // // // //                                 <Typography
// // // // //                                   variant="h5"
// // // // //                                   fontWeight="bold"
// // // // //                                   color="primary.main"
// // // // //                                 >
// // // // //                                   {loc.median_salary}
// // // // //                                 </Typography>
// // // // //                               </Box>
// // // // //                               <Divider orientation="vertical" flexItem />
// // // // //                               <Box textAlign="center">
// // // // //                                 <Typography
// // // // //                                   variant="caption"
// // // // //                                   color="text.secondary"
// // // // //                                 >
// // // // //                                   MAX
// // // // //                                 </Typography>
// // // // //                                 <Typography variant="body2" fontWeight="bold">
// // // // //                                   {loc.max_salary}
// // // // //                                 </Typography>
// // // // //                               </Box>
// // // // //                             </Stack>
// // // // //                           </CardContent>
// // // // //                         </Card>
// // // // //                       </Grid>
// // // // //                     ))}
// // // // //                   </Grid>
// // // // //                 </Paper>
// // // // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // // // //                   <Stack
// // // // //                     direction="row"
// // // // //                     spacing={1.5}
// // // // //                     alignItems="center"
// // // // //                     mb={1}
// // // // //                   >
// // // // //                     <TrendingUp color="primary" />
// // // // //                     <Typography variant="h6">Location Demand Impact</Typography>
// // // // //                   </Stack>
// // // // //                   <List dense>
// // // // //                     {salaryInsightsData.salary_insights_summary.map(
// // // // //                       (item, i) => (
// // // // //                         <ListItem key={i} disableGutters sx={{ px: 1 }}>
// // // // //                           <Stack
// // // // //                             direction={{ xs: "column", sm: "row" }}
// // // // //                             spacing={{ xs: 0.5, sm: 2 }}
// // // // //                             alignItems="center"
// // // // //                             sx={{ width: "100%" }}
// // // // //                           >
// // // // //                             <ListItemText
// // // // //                               primary={item.role}
// // // // //                               sx={{
// // // // //                                 width: "100%",
// // // // //                                 m: 0,
// // // // //                                 flexBasis: { sm: "40%" },
// // // // //                                 flexShrink: 0,
// // // // //                               }}
// // // // //                             />
// // // // //                             <Box
// // // // //                               sx={{
// // // // //                                 width: "100%",
// // // // //                                 display: "flex",
// // // // //                                 alignItems: "center",
// // // // //                               }}
// // // // //                             >
// // // // //                               <LinearProgress
// // // // //                                 variant="determinate"
// // // // //                                 value={item.demand_in_salary_percent}
// // // // //                                 color="primary"
// // // // //                                 sx={{
// // // // //                                   width: "100%",
// // // // //                                   mr: 1.5,
// // // // //                                   height: 8,
// // // // //                                   borderRadius: 4,
// // // // //                                 }}
// // // // //                               />
// // // // //                               <Typography
// // // // //                                 variant="body2"
// // // // //                                 color="text.secondary"
// // // // //                               >{`${item.demand_in_salary_percent}%`}</Typography>
// // // // //                             </Box>
// // // // //                           </Stack>
// // // // //                         </ListItem>
// // // // //                       )
// // // // //                     )}
// // // // //                   </List>
// // // // //                 </Paper>
// // // // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // // // //                   <Stack
// // // // //                     direction="row"
// // // // //                     spacing={1.5}
// // // // //                     alignItems="center"
// // // // //                     mb={1}
// // // // //                   >
// // // // //                     <MonetizationOn color="success" />
// // // // //                     <Typography variant="h6">Negotiation Tips</Typography>
// // // // //                   </Stack>
// // // // //                   <List dense>
// // // // //                     {salaryInsightsData.negotiation_tips.map((tip, i) => (
// // // // //                       <ListItem key={i}>
// // // // //                         <ListItemIcon sx={{ minWidth: 32 }}>
// // // // //                           <CheckCircle color="success" fontSize="small" />
// // // // //                         </ListItemIcon>
// // // // //                         <ListItemText primary={tip} />
// // // // //                       </ListItem>
// // // // //                     ))}
// // // // //                   </List>
// // // // //                 </Paper>
// // // // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // // // //                   <Stack
// // // // //                     direction="row"
// // // // //                     spacing={1.5}
// // // // //                     alignItems="center"
// // // // //                     mb={1}
// // // // //                   >
// // // // //                     <Timeline color="warning" />
// // // // //                     <Typography variant="h6">Market Trends</Typography>
// // // // //                   </Stack>
// // // // //                   <List>
// // // // //                     {salaryInsightsData.market_trends.map((item, i) => (
// // // // //                       <ListItem key={i} alignItems="flex-start">
// // // // //                         <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
// // // // //                           <TrendingFlat color="warning" />
// // // // //                         </ListItemIcon>
// // // // //                         <ListItemText
// // // // //                           primary={item.trend}
// // // // //                           secondary={item.insight}
// // // // //                           primaryTypographyProps={{ fontWeight: 600 }}
// // // // //                         />
// // // // //                       </ListItem>
// // // // //                     ))}
// // // // //                   </List>
// // // // //                 </Paper>
// // // // //               </Stack>
// // // // //             )
// // // // //           )}
// // // // //         </DialogContent>
// // // // //         <DialogActions>
// // // // //           <Button onClick={() => setSalaryInsightsDialog(false)}>Close</Button>
// // // // //         </DialogActions>
// // // // //       </Dialog>
// // // // //     </Layout>
// // // // //   );
// // // // // };

// // // // // export default CareerAssistant;
// // // // import { useState, useEffect, useRef } from "react";
// // // // import {
// // // //   Grid,
// // // //   Card,
// // // //   CardContent,
// // // //   Container,
// // // //   Typography,
// // // //   Box,
// // // //   Button,
// // // //   Paper,
// // // //   Avatar,
// // // //   Chip,
// // // //   Dialog,
// // // //   DialogTitle,
// // // //   DialogContent,
// // // //   DialogActions,
// // // //   List,
// // // //   ListItem,
// // // //   ListItemIcon,
// // // //   ListItemText,
// // // //   Divider,
// // // //   Stack,
// // // //   LinearProgress,
// // // //   Skeleton,
// // // //   alpha,
// // // //   IconButton,
// // // //   Tabs,
// // // //   Tab,
// // // //   FormGroup,
// // // //   FormControlLabel,
// // // //   Checkbox,
// // // //   Alert,
// // // //   AlertTitle,
// // // // } from "@mui/material";
// // // // import { styled, useTheme } from "@mui/material/styles";
// // // // import {
// // // //   Psychology,
// // // //   TrendingUp,
// // // //   School,
// // // //   Work,
// // // //   Language,
// // // //   Assessment,
// // // //   VideoCall,
// // // //   Lightbulb,
// // // //   Timeline,
// // // //   CheckCircle,
// // // //   ErrorOutline,
// // // //   ArrowForward,
// // // //   MilitaryTech,
// // // //   Stars,
// // // //   RocketLaunch,
// // // //   TrendingDown,
// // // //   TrendingFlat,
// // // //   LocationOn,
// // // //   MonetizationOn,
// // // //   AutoAwesome,
// // // //   Close as CloseIcon,
// // // //   Insights,
// // // //   Person,
// // // // } from "@mui/icons-material";
// // // // import {
// // // //   BarChart,
// // // //   Bar,
// // // //   XAxis,
// // // //   YAxis,
// // // //   CartesianGrid,
// // // //   Tooltip,
// // // //   ResponsiveContainer,
// // // //   Cell,
// // // //   LabelList,
// // // // } from "recharts";
// // // // import Layout from "../common/Layout";
// // // // import { useNotification } from "../../context/NotificationContext";
// // // // import { useNavigate } from "react-router-dom";
// // // // import apiClient from "../../context/apiClient";

// // // // // --- Skeleton Components ---

// // // // const HeaderSkeleton = () => (
// // // //   <Paper sx={{ bgcolor: "mint.main", borderRadius: 3, p: { xs: 2, sm: 3 } }}>
// // // //     <Stack direction="row" alignItems="center" spacing={2}>
// // // //       <Skeleton variant="circular" width={64} height={64} />
// // // //       <Box sx={{ flex: 1 }}>
// // // //         <Skeleton variant="text" width="40%" height={48} />
// // // //         <Skeleton variant="text" width="60%" height={24} />
// // // //       </Box>
// // // //     </Stack>
// // // //   </Paper>
// // // // );

// // // // const ServiceListItemSkeleton = () => (
// // // //   <Paper
// // // //     sx={{
// // // //       display: "flex",
// // // //       flexDirection: "row",
// // // //       alignItems: "center",
// // // //       padding: 2,
// // // //       borderRadius: "12px",
// // // //       border: (theme) => `1px solid ${theme.palette.divider}`,
// // // //     }}
// // // //   >
// // // //     <Skeleton variant="circular" width={48} height={48} sx={{ mr: 2 }} />
// // // //     <Box flexGrow={1}>
// // // //       <Skeleton variant="text" height={30} width="50%" />
// // // //       <Skeleton variant="text" height={20} width="80%" />
// // // //     </Box>
// // // //     <Skeleton variant="circular" width={24} height={24} sx={{ ml: 2 }} />
// // // //   </Paper>
// // // // );

// // // // const ServicesSkeleton = () => (
// // // //   <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, bgcolor: "mint.main" }}>
// // // //     <Skeleton variant="text" width="60%" height={40} sx={{ mb: 3 }} />
// // // //     <Stack spacing={2}>
// // // //       {[...Array(5)].map((_, index) => (
// // // //         <ServiceListItemSkeleton key={index} />
// // // //       ))}
// // // //     </Stack>
// // // //   </Paper>
// // // // );

// // // // const TrendingSkillsSkeleton = () => (
// // // //   <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, bgcolor: "mint.main" }}>
// // // //     <Skeleton variant="text" width="40%" height={40} sx={{ mb: 2 }} />
// // // //     <Stack
// // // //       direction="row"
// // // //       spacing={2}
// // // //       sx={{ mb: 3, justifyContent: "center", flexWrap: "wrap", gap: 1 }}
// // // //     >
// // // //       <Skeleton variant="rounded" width={150} height={42} />
// // // //       <Skeleton variant="rounded" width={150} height={42} />
// // // //       <Skeleton variant="rounded" width={150} height={42} />
// // // //     </Stack>
// // // //     <Skeleton variant="rounded" width="100%" height={500} />
// // // //   </Paper>
// // // // );

// // // // const PageSkeleton = () => (
// // // //   <Layout title="AI Career Assistant">
// // // //     <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// // // //       <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
// // // //         <Stack spacing={4}>
// // // //           <HeaderSkeleton />
// // // //           <ServicesSkeleton />
// // // //           <TrendingSkillsSkeleton />
// // // //         </Stack>
// // // //       </Container>
// // // //     </Box>
// // // //   </Layout>
// // // // );

// // // // const ChartSkeleton = () => (
// // // //   <Box sx={{ height: { xs: 400, md: 500 }, width: "100%", pt: 2 }}>
// // // //     <Skeleton variant="rounded" width="100%" height="100%" />
// // // //   </Box>
// // // // );

// // // // // --- Helper Components ---

// // // // const ServiceListItem = styled(Paper)(({ theme, color = "primary" }) => ({
// // // //   backgroundColor: theme.palette.background.paper,
// // // //   display: "flex",
// // // //   flexDirection: "row",
// // // //   alignItems: "center",
// // // //   padding: theme.spacing(2),
// // // //   borderRadius: "12px",
// // // //   cursor: "pointer",
// // // //   transition:
// // // //     "background-color 0.3s ease, border-color 0.3s ease, transform 0.2s ease-in-out",
// // // //   border: `1px solid ${theme.palette.divider}`,
// // // //   "&:hover": {
// // // //     backgroundColor: alpha(
// // // //       theme.palette[color]?.main || theme.palette.primary.main,
// // // //       0.08
// // // //     ),
// // // //     borderColor: theme.palette[color]?.main || theme.palette.primary.main,
// // // //     transform: "scale(1.02)",
// // // //   },
// // // //   ".MuiAvatar-root": {
// // // //     backgroundColor: alpha(
// // // //       theme.palette[color]?.main || theme.palette.primary.main,
// // // //       0.15
// // // //     ),
// // // //     color: theme.palette[color]?.main || theme.palette.primary.main,
// // // //     marginRight: theme.spacing(2),
// // // //   },
// // // // }));

// // // // function TabPanel(props) {
// // // //   const { children, value, index, ...other } = props;
// // // //   return (
// // // //     <div
// // // //       role="tabpanel"
// // // //       hidden={value !== index}
// // // //       id={`tabpanel-${index}`}
// // // //       aria-labelledby={`tab-${index}`}
// // // //       {...other}
// // // //     >
// // // //       {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
// // // //     </div>
// // // //   );
// // // // }

// // // // // --- Main Component ---

// // // // const CareerAssistant = () => {
// // // //   const theme = useTheme();
// // // //   const { showNotification } = useNotification();
// // // //   const navigate = useNavigate();
// // // //   const isInitialMount = useRef(true);

// // // //   const availableRoles = [
// // // //     "AI/ML Engineer",
// // // //     "Data Scientist",
// // // //     "Business Analyst",
// // // //   ];

// // // //   // --- State Declarations ---
// // // //   const [pageLoading, setPageLoading] = useState(true);
// // // //   const [showWelcomeCard, setShowWelcomeCard] = useState(true);
// // // //   const [mockInterviewDialog, setMockInterviewDialog] = useState(false);
// // // //   const [resumeReviewDialog, setResumeReviewDialog] = useState(false);
// // // //   const [skillGapDialog, setSkillGapDialog] = useState(false);
// // // //   const [careerRoadmapDialog, setCareerRoadmapDialog] = useState(false);
// // // //   const [culturalPrepDialog, setCulturalPrepDialog] = useState(false);
// // // //   const [salaryInsightsDialog, setSalaryInsightsDialog] = useState(false);
// // // //   const [trendingSkillsData, setTrendingSkillsData] = useState({});
// // // //   const [skillsLoading, setSkillsLoading] = useState(true);
// // // //   const [selectedTrendingRoles, setSelectedTrendingRoles] = useState([
// // // //     "AI/ML Engineer",
// // // //   ]);
// // // //   const [activeTrendingTab, setActiveTrendingTab] = useState(0);
// // // //   const [resumeReviewData, setResumeReviewData] = useState(null);
// // // //   const [resumeReviewLoading, setResumeReviewLoading] = useState(false);
// // // //   const [selectedResumeRoles, setSelectedResumeRoles] = useState([]);
// // // //   const [activeResumeTab, setActiveResumeTab] = useState(0);
// // // //   const [skillGapData, setSkillGapData] = useState(null);
// // // //   const [skillGapLoading, setSkillGapLoading] = useState(false);
// // // //   const [selectedSkillGapRoles, setSelectedSkillGapRoles] = useState([]);
// // // //   const [activeSkillGapTab, setActiveSkillGapTab] = useState(0);
// // // //   const [careerRoadmapData, setCareerRoadmapData] = useState(null);
// // // //   const [careerRoadmapLoading, setCareerRoadmapLoading] = useState(false);
// // // //   const [selectedRoadmapRoles, setSelectedRoadmapRoles] = useState([]);
// // // //   const [activeRoadmapTab, setActiveRoadmapTab] = useState(0);
// // // //   const [culturalPrepData, setCulturalPrepData] = useState(null);
// // // //   const [culturalPrepLoading, setCulturalPrepLoading] = useState(false);
// // // //   const [culturalPrepTab, setCulturalPrepTab] = useState(0);
// // // //   const [salaryInsightsData, setSalaryInsightsData] = useState(null);
// // // //   const [salaryInsightsLoading, setSalaryInsightsLoading] = useState(false);

// // // //   // --- Data Fetching Functions ---

// // // //   const fetchTrendingSkills = async (roles) => {
// // // //     if (!roles || roles.length === 0) {
// // // //       setTrendingSkillsData({});
// // // //       setSkillsLoading(false);
// // // //       return;
// // // //     }
// // // //     setSkillsLoading(true);
// // // //     try {
// // // //       const response = await apiClient.post("/trending-skills/", {
// // // //         selected_roles: roles,
// // // //       });
// // // //       const transformedData = {};
// // // //       for (const [role, skills] of Object.entries(response.data)) {
// // // //         transformedData[role] = skills.map((skill) => ({
// // // //           skill: skill.skill,
// // // //           demand: parseInt(skill.demand) || 0,
// // // //           growth: skill.increase || "N/A",
// // // //           priority: skill.priority,
// // // //         }));
// // // //       }
// // // //       setTrendingSkillsData(transformedData);
// // // //       setActiveTrendingTab(0);
// // // //     } catch (error) {
// // // //       console.error("Failed to fetch trending skills:", error);
// // // //       showNotification("Could not load trending skills data.", "error");
// // // //       setTrendingSkillsData({});
// // // //     } finally {
// // // //       setSkillsLoading(false);
// // // //     }
// // // //   };

// // // //   const fetchResumeReview = async (roles) => {
// // // //     if (!roles || roles.length === 0) {
// // // //       setResumeReviewData({});
// // // //       return;
// // // //     }
// // // //     setResumeReviewLoading(true);
// // // //     try {
// // // //       const response = await apiClient.post("/resume/review-talent/", {
// // // //         target_roles: roles,
// // // //       });
// // // //       setResumeReviewData(response.data);
// // // //       setActiveResumeTab(0);
// // // //     } catch (error) {
// // // //       showNotification("Failed to load resume review data.", "error");
// // // //     } finally {
// // // //       setResumeReviewLoading(false);
// // // //     }
// // // //   };
// // // //   const fetchSkillGap = async (roles) => {
// // // //     if (!roles || roles.length === 0) {
// // // //       setSkillGapData({});
// // // //       return;
// // // //     }
// // // //     setSkillGapLoading(true);
// // // //     try {
// // // //       const response = await apiClient.post("/resume/skill-gap/", {
// // // //         selected_roles: roles,
// // // //       });
// // // //       setSkillGapData(response.data);
// // // //       setActiveSkillGapTab(0);
// // // //     } catch (error) {
// // // //       showNotification("Failed to load skill gap analysis.", "error");
// // // //     } finally {
// // // //       setSkillGapLoading(false);
// // // //     }
// // // //   };
// // // //   const fetchCareerRoadmap = async (roles) => {
// // // //     if (!roles || roles.length === 0) {
// // // //       setCareerRoadmapData({});
// // // //       return;
// // // //     }
// // // //     setCareerRoadmapLoading(true);
// // // //     try {
// // // //       const response = await apiClient.post("/resume/career-roadmap/", {
// // // //         target_roles: roles,
// // // //       });
// // // //       setCareerRoadmapData(response.data);
// // // //       setActiveRoadmapTab(0);
// // // //     } catch (error) {
// // // //       showNotification("Failed to load career roadmap.", "error");
// // // //       setCareerRoadmapData({});
// // // //     } finally {
// // // //       setCareerRoadmapLoading(false);
// // // //     }
// // // //   };

// // // //   // --- Handlers ---
// // // //   const handleTrendingRoleChange = (event) => {
// // // //     const { name, checked } = event.target;
// // // //     setSelectedTrendingRoles((prev) =>
// // // //       checked ? [...prev, name] : prev.filter((role) => role !== name)
// // // //     );
// // // //   };

// // // //   // --- Child Components ---
// // // //   const RoleSelector = ({ selectedRoles, handleRoleChange }) => (
// // // //     <FormGroup row sx={{ mb: 2, justifyContent: "center", flexWrap: "wrap" }}>
// // // //       {availableRoles.map((role) => (
// // // //         <FormControlLabel
// // // //           key={role}
// // // //           control={
// // // //             <Checkbox
// // // //               checked={selectedRoles.includes(role)}
// // // //               onChange={handleRoleChange}
// // // //               name={role}
// // // //             />
// // // //           }
// // // //           label={role}
// // // //         />
// // // //       ))}
// // // //     </FormGroup>
// // // //   );

// // // //   const CustomTooltip = ({ active, payload, label }) => {
// // // //     if (active && payload && payload.length) {
// // // //       const data = payload[0].payload;
// // // //       const priorityMuiColor = {
// // // //         High: "primary",
// // // //         Medium: "info",
// // // //       };
// // // //       return (
// // // //         <Paper
// // // //           elevation={3}
// // // //           sx={{
// // // //             p: 1.5,
// // // //             minWidth: 220,
// // // //             bgcolor: "background.paper",
// // // //             border: `1px solid ${theme.palette.divider}`,
// // // //             borderRadius: 2,
// // // //           }}
// // // //         >
// // // //           <Typography variant="body1" fontWeight="bold" gutterBottom>
// // // //             {label}
// // // //           </Typography>
// // // //           <Stack spacing={1}>
// // // //             <Stack
// // // //               direction="row"
// // // //               justifyContent="space-between"
// // // //               alignItems="center"
// // // //             >
// // // //               <Typography variant="body2" color="text.secondary">
// // // //                 Demand:
// // // //               </Typography>
// // // //               <Typography
// // // //                 variant="body2"
// // // //                 fontWeight="bold"
// // // //               >{`${data.demand}%`}</Typography>
// // // //             </Stack>
// // // //             <Stack
// // // //               direction="row"
// // // //               justifyContent="space-between"
// // // //               alignItems="center"
// // // //             >
// // // //               <Typography variant="body2" color="text.secondary">
// // // //                 Priority:
// // // //               </Typography>
// // // //               <Chip
// // // //                 label={data.priority}
// // // //                 size="small"
// // // //                 color={priorityMuiColor[data.priority] || "default"}
// // // //                 sx={{ fontWeight: 600 }}
// // // //               />
// // // //             </Stack>
// // // //             <Stack
// // // //               direction="row"
// // // //               justifyContent="space-between"
// // // //               alignItems="center"
// // // //             >
// // // //               <Typography variant="body2" color="text.secondary">
// // // //                 Growth:
// // // //               </Typography>
// // // //               <Typography
// // // //                 variant="body2"
// // // //                 fontWeight="bold"
// // // //                 color={
// // // //                   (data.growth || "").startsWith("+")
// // // //                     ? "success.main"
// // // //                     : "error.main"
// // // //                 }
// // // //               >
// // // //                 {data.growth}
// // // //               </Typography>
// // // //             </Stack>
// // // //           </Stack>
// // // //         </Paper>
// // // //       );
// // // //     }
// // // //     return null;
// // // //   };

// // // //   const RoundedVerticalBar = (props) => {
// // // //     const { fill, x, y, width, height } = props;
// // // //     const radius = 8;
// // // //     if (height <= 0) return null;
// // // //     return (
// // // //       <g>
// // // //         <path
// // // //           d={`M${x},${y + radius} A${radius},${radius} 0 0 1 ${
// // // //             x + radius
// // // //           },${y} L${x + width - radius},${y} A${radius},${radius} 0 0 1 ${
// // // //             x + width
// // // //           },${y + radius} L${x + width},${y + height} L${x},${y + height} Z`}
// // // //           fill={fill}
// // // //         />
// // // //       </g>
// // // //     );
// // // //   };

// // // //   const assistantServices = [
// // // //     {
// // // //       id: "resume-review",
// // // //       title: "AI Resume Review",
// // // //       description: "Get detailed feedback & ATS optimization suggestions.",
// // // //       icon: <Assessment />,
// // // //       color: "primary",
// // // //     },
// // // //     {
// // // //       id: "skill-assessment",
// // // //       title: "Skill Gap Analysis",
// // // //       description: "Identify critical skill gaps for your target roles.",
// // // //       icon: <TrendingUp />,
// // // //       color: "success",
// // // //     },
// // // //     {
// // // //       id: "career-roadmap",
// // // //       title: "Career Roadmap",
// // // //       description: "AI-generated path based on your profile and goals.",
// // // //       icon: <Timeline />,
// // // //       color: "warning",
// // // //     },
// // // //     {
// // // //       id: "salary-insights",
// // // //       title: "Salary Insights",
// // // //       description: "Real-time salary benchmarks for roles and locations.",
// // // //       icon: <Language />,
// // // //       color: "info",
// // // //     },
// // // //     {
// // // //       id: "cultural-prep",
// // // //       title: "Cultural Preparation",
// // // //       description: "Master workplace culture for different countries.",
// // // //       icon: <Psychology />,
// // // //       color: "error",
// // // //     },
// // // //   ];

// // // //   const handleServiceClick = async (service) => {
// // // //     const defaultRolePayload = ["AI/ML Engineer"];
// // // //     switch (service.id) {
// // // //       case "resume-review":
// // // //         setResumeReviewDialog(true);
// // // //         setSelectedResumeRoles(defaultRolePayload);
// // // //         await fetchResumeReview(defaultRolePayload);
// // // //         break;
// // // //       case "mock-interview":
// // // //         setMockInterviewDialog(true);
// // // //         break;
// // // //       case "skill-assessment":
// // // //         setSkillGapDialog(true);
// // // //         setSelectedSkillGapRoles(defaultRolePayload);
// // // //         await fetchSkillGap(defaultRolePayload);
// // // //         break;
// // // //       case "career-roadmap":
// // // //         setCareerRoadmapDialog(true);
// // // //         setSelectedRoadmapRoles(defaultRolePayload);
// // // //         await fetchCareerRoadmap(defaultRolePayload);
// // // //         break;
// // // //       case "cultural-prep":
// // // //         setCulturalPrepDialog(true);
// // // //         if (!culturalPrepData) {
// // // //           setCulturalPrepLoading(true);
// // // //           try {
// // // //             const res = await apiClient.get("/ai/cultural-preparation/");
// // // //             const validData = Object.fromEntries(
// // // //               Object.entries(res.data.cultural_preparation).filter(
// // // //                 ([, value]) => !value.error_message
// // // //               )
// // // //             );
// // // //             setCulturalPrepData(validData);
// // // //           } catch (err) {
// // // //             showNotification("Failed to load cultural prep data.", "error");
// // // //           } finally {
// // // //             setCulturalPrepLoading(false);
// // // //           }
// // // //         }
// // // //         break;
// // // //       case "salary-insights":
// // // //         setSalaryInsightsDialog(true);
// // // //         if (!salaryInsightsData) {
// // // //           setSalaryInsightsLoading(true);
// // // //           try {
// // // //             const res = await apiClient.get("/ai/salary-insights/");
// // // //             setSalaryInsightsData(res.data.salary_insights);
// // // //           } catch (err) {
// // // //             showNotification("Failed to load salary insights data.", "error");
// // // //           } finally {
// // // //             setSalaryInsightsLoading(false);
// // // //           }
// // // //         }
// // // //         break;
// // // //       default:
// // // //         showNotification(`${service.title} feature coming soon!`, "info");
// // // //     }
// // // //   };

// // // //   const DialogSkeleton = () => (
// // // //     <Stack spacing={3} sx={{ p: 2, minHeight: 400 }}>
// // // //       <Skeleton variant="rounded" width="60%" height={40} />
// // // //       <Skeleton variant="rounded" width="100%" height={100} />
// // // //       <Skeleton variant="rounded" width="40%" height={30} />
// // // //       <Skeleton variant="rounded" width="100%" height={150} />
// // // //     </Stack>
// // // //   );

// // // //   // Consolidated useEffect for fetching trending skills
// // // //   useEffect(() => {
// // // //     if (isInitialMount.current) {
// // // //       isInitialMount.current = false;
// // // //       // Initial load without debounce
// // // //       const initialLoad = async () => {
// // // //         await fetchTrendingSkills(selectedTrendingRoles);
// // // //         setPageLoading(false);
// // // //       };
// // // //       initialLoad();
// // // //     } else {
// // // //       // Debounced fetch for subsequent updates
// // // //       const handler = setTimeout(() => {
// // // //         fetchTrendingSkills(selectedTrendingRoles);
// // // //       }, 500);

// // // //       return () => {
// // // //         clearTimeout(handler);
// // // //       };
// // // //     }
// // // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // // //   }, [selectedTrendingRoles]);

// // // //   if (pageLoading) {
// // // //     return <PageSkeleton />;
// // // //   }

// // // //   return (
// // // //     <Layout title="AI Career Assistant">
// // // //       <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// // // //         <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
// // // //           <Stack spacing={4}>
// // // //             {/* ROW 1: Header Banner */}
// // // //             <Paper
// // // //               sx={{
// // // //                 bgcolor: "mint.main",
// // // //                 borderRadius: 3,
// // // //                 p: { xs: 2, sm: 3 },
// // // //               }}
// // // //             >
// // // //               <Stack direction="row" alignItems="center" spacing={2}>
// // // //                 <Avatar
// // // //                   sx={{
// // // //                     bgcolor: "primary.main",
// // // //                     color: "primary.contrastText",
// // // //                     width: { xs: 50, sm: 64 },
// // // //                     height: { xs: 50, sm: 64 },
// // // //                   }}
// // // //                 >
// // // //                   <Psychology sx={{ fontSize: { xs: 28, sm: 36 } }} />
// // // //                 </Avatar>
// // // //                 <Box>
// // // //                   <Typography
// // // //                     variant="h4"
// // // //                     component="h1"
// // // //                     fontWeight="bold"
// // // //                     sx={{ typography: { xs: "h5", sm: "h4" } }}
// // // //                   >
// // // //                     AI Career Assistant
// // // //                     <AutoAwesome
// // // //                       sx={{
// // // //                         fontSize: { xs: 22, sm: 28 },
// // // //                         ml: 1,
// // // //                         verticalAlign: "middle",
// // // //                         color: "primary.main",
// // // //                       }}
// // // //                     />
// // // //                   </Typography>
// // // //                   <Typography variant="body1" color="text.secondary">
// // // //                     Your intelligent, multilingual guide to global careers.
// // // //                   </Typography>
// // // //                 </Box>
// // // //               </Stack>
// // // //             </Paper>

// // // //             {/* ROW 2: Welcome Alert */}
// // // //             {showWelcomeCard && (
// // // //               <Alert
// // // //                 severity="info"
// // // //                 variant="filled"
// // // //                 onClose={() => setShowWelcomeCard(false)}
// // // //                 action={
// // // //                   <Button
// // // //                     color="inherit"
// // // //                     size="small"
// // // //                     onClick={() => {
// // // //                       handleServiceClick(assistantServices[0]);
// // // //                       setShowWelcomeCard(false);
// // // //                     }}
// // // //                   >
// // // //                     Start Review
// // // //                   </Button>
// // // //                 }
// // // //                 sx={{
// // // //                   bgcolor: "primary.dark",
// // // //                   color: "primary.contrastText",
// // // //                   borderRadius: 2,
// // // //                 }}
// // // //               >
// // // //                 <AlertTitle sx={{ fontWeight: "bold" }}>Welcome!</AlertTitle>
// // // //                 New here? Start with an AI Resume Review to get personalized
// // // //                 feedback and unlock other insights.
// // // //               </Alert>
// // // //             )}

// // // //             {/* ROW 3: Services List */}
// // // //             <Paper
// // // //               sx={{
// // // //                 p: { xs: 2, sm: 3 },
// // // //                 borderRadius: 3,
// // // //                 bgcolor: "mint.main",
// // // //               }}
// // // //             >
// // // //               <Stack direction="row" alignItems="center" spacing={1} mb={3}>
// // // //                 <Typography variant="h5" component="h2" fontWeight={600}>
// // // //                   AI-Powered Career Services
// // // //                 </Typography>
// // // //                 <RocketLaunch color="primary" />
// // // //               </Stack>
// // // //               <Stack spacing={2}>
// // // //                 {assistantServices.map((service) => (
// // // //                   <ServiceListItem
// // // //                     key={service.id}
// // // //                     color={service.color}
// // // //                     onClick={() => handleServiceClick(service)}
// // // //                   >
// // // //                     <Avatar sx={{ width: 48, height: 48 }}>
// // // //                       {service.icon}
// // // //                     </Avatar>
// // // //                     <Box flexGrow={1}>
// // // //                       <Typography
// // // //                         variant="h6"
// // // //                         component="div"
// // // //                         fontWeight="bold"
// // // //                       >
// // // //                         {service.title}
// // // //                       </Typography>
// // // //                       <Typography variant="body2" color="text.secondary">
// // // //                         {service.description}
// // // //                       </Typography>
// // // //                     </Box>
// // // //                     <IconButton sx={{ ml: 2 }}>
// // // //                       <ArrowForward />
// // // //                     </IconButton>
// // // //                   </ServiceListItem>
// // // //                 ))}
// // // //               </Stack>
// // // //             </Paper>

// // // //             {/* ROW 4: Trending Skills */}
// // // //             <Paper
// // // //               sx={{
// // // //                 p: { xs: 2, sm: 3 },
// // // //                 borderRadius: 3,
// // // //                 bgcolor: "mint.main",
// // // //               }}
// // // //             >
// // // //               <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
// // // //                 <Lightbulb color="primary" />
// // // //                 <Typography variant="h6" fontWeight={600}>
// // // //                   Top In-Demand Skills
// // // //                 </Typography>
// // // //               </Stack>
// // // //               <RoleSelector
// // // //                 selectedRoles={selectedTrendingRoles}
// // // //                 handleRoleChange={handleTrendingRoleChange}
// // // //               />
// // // //               {skillsLoading ? (
// // // //                 <ChartSkeleton />
// // // //               ) : Object.keys(trendingSkillsData).length > 0 ? (
// // // //                 <Box>
// // // //                   <Tabs
// // // //                     value={activeTrendingTab}
// // // //                     onChange={(e, val) => setActiveTrendingTab(val)}
// // // //                     variant="scrollable"
// // // //                     scrollButtons="auto"
// // // //                   >
// // // //                     {Object.keys(trendingSkillsData).map((role) => (
// // // //                       <Tab label={role} key={role} />
// // // //                     ))}
// // // //                   </Tabs>
// // // //                   {Object.entries(trendingSkillsData).map(
// // // //                     ([role, skills], index) => {
// // // //                       const sortedSkills = [...skills].sort(
// // // //                         (a, b) => b.demand - a.demand
// // // //                       );
// // // //                       const priorityColors = {
// // // //                         High: theme.palette.primary.main,
// // // //                         Medium: theme.palette.info.main,
// // // //                       };

// // // //                       return (
// // // //                         <TabPanel
// // // //                           value={activeTrendingTab}
// // // //                           index={index}
// // // //                           key={role}
// // // //                         >
// // // //                           <Paper
// // // //                             elevation={0}
// // // //                             sx={{
// // // //                               bgcolor: "background.paper",
// // // //                               borderRadius: 2,
// // // //                               p: { xs: 1, sm: 2 },
// // // //                             }}
// // // //                           >
// // // //                             <Box
// // // //                               sx={{
// // // //                                 height: { xs: 400, md: 500 },
// // // //                                 width: "100%",
// // // //                               }}
// // // //                             >
// // // //                               <ResponsiveContainer width="100%" height="100%">
// // // //                                 <BarChart
// // // //                                   data={sortedSkills}
// // // //                                   margin={{
// // // //                                     top: 30,
// // // //                                     right: 30,
// // // //                                     left: 20,
// // // //                                     bottom: 120,
// // // //                                   }}
// // // //                                 >
// // // //                                   <CartesianGrid
// // // //                                     vertical={false}
// // // //                                     stroke={theme.palette.divider}
// // // //                                     strokeDasharray="3 3"
// // // //                                   />
// // // //                                   <XAxis
// // // //                                     dataKey="skill"
// // // //                                     type="category"
// // // //                                     interval={0}
// // // //                                     angle={-45}
// // // //                                     textAnchor="end"
// // // //                                     tick={{
// // // //                                       fill: theme.palette.text.secondary,
// // // //                                       fontSize: 12,
// // // //                                     }}
// // // //                                     stroke={"transparent"}
// // // //                                   />
// // // //                                   <YAxis
// // // //                                     type="number"
// // // //                                     domain={[0, "dataMax + 15"]}
// // // //                                     allowDecimals={false}
// // // //                                     tickFormatter={(tick) => `${tick}%`}
// // // //                                     stroke={theme.palette.divider}
// // // //                                     tick={{
// // // //                                       fill: theme.palette.text.secondary,
// // // //                                     }}
// // // //                                   />
// // // //                                   <Tooltip
// // // //                                     content={<CustomTooltip />}
// // // //                                     cursor={{
// // // //                                       fill: alpha(
// // // //                                         theme.palette.primary.main,
// // // //                                         0.1
// // // //                                       ),
// // // //                                     }}
// // // //                                   />
// // // //                                   <Bar
// // // //                                     dataKey="demand"
// // // //                                     shape={<RoundedVerticalBar />}
// // // //                                     animationDuration={800}
// // // //                                   >
// // // //                                     {sortedSkills.map((entry, idx) => (
// // // //                                       <Cell
// // // //                                         key={`cell-${idx}`}
// // // //                                         fill={
// // // //                                           priorityColors[entry.priority] ||
// // // //                                           theme.palette.text.disabled
// // // //                                         }
// // // //                                       />
// // // //                                     ))}
// // // //                                     <LabelList
// // // //                                       dataKey="demand"
// // // //                                       position="top"
// // // //                                       offset={8}
// // // //                                       style={{
// // // //                                         fill: theme.palette.text.primary,
// // // //                                         fontSize: "12px",
// // // //                                         fontWeight: "bold",
// // // //                                       }}
// // // //                                       formatter={(value) => `${value}%`}
// // // //                                     />
// // // //                                   </Bar>
// // // //                                 </BarChart>
// // // //                               </ResponsiveContainer>
// // // //                             </Box>
// // // //                           </Paper>
// // // //                         </TabPanel>
// // // //                       );
// // // //                     }
// // // //                   )}
// // // //                 </Box>
// // // //               ) : (
// // // //                 <Box
// // // //                   sx={{
// // // //                     display: "flex",
// // // //                     flexDirection: "column",
// // // //                     alignItems: "center",
// // // //                     justifyContent: "center",
// // // //                     textAlign: "center",
// // // //                     py: 8,
// // // //                     minHeight: 400,
// // // //                   }}
// // // //                 >
// // // //                   <Insights
// // // //                     sx={{ fontSize: 60, color: "text.disabled", mb: 2 }}
// // // //                   />
// // // //                   <Typography variant="h6" color="text.secondary">
// // // //                     Select a role to view in-demand skills
// // // //                   </Typography>
// // // //                   <Typography variant="body2" color="text.disabled">
// // // //                     The chart will update automatically as you make selections.
// // // //                   </Typography>
// // // //                 </Box>
// // // //               )}
// // // //             </Paper>
// // // //           </Stack>
// // // //         </Container>
// // // //       </Box>

// // // //       {/* --- DIALOGS (UI ENHANCEMENTS APPLIED) --- */}
// // // //       <Dialog
// // // //         open={resumeReviewDialog}
// // // //         onClose={() => setResumeReviewDialog(false)}
// // // //         maxWidth="lg"
// // // //         fullWidth
// // // //       >
// // // //         <DialogTitle
// // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // //         >
// // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // //             <Assessment />
// // // //             <Typography variant="h6">AI Resume Review</Typography>
// // // //           </Stack>
// // // //         </DialogTitle>
// // // //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// // // //           <RoleSelector
// // // //             selectedRoles={selectedResumeRoles}
// // // //             handleRoleChange={(e) =>
// // // //               setSelectedResumeRoles((prev) =>
// // // //                 e.target.checked
// // // //                   ? [...prev, e.target.name]
// // // //                   : prev.filter((r) => r !== e.target.name)
// // // //               )
// // // //             }
// // // //           />
// // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // //             <Button
// // // //               variant="contained"
// // // //               onClick={() => fetchResumeReview(selectedResumeRoles)}
// // // //             >
// // // //               Generate Report
// // // //             </Button>
// // // //           </Box>
// // // //           <Divider sx={{ mb: 2 }} />
// // // //           {resumeReviewLoading ? (
// // // //             <DialogSkeleton />
// // // //           ) : (
// // // //             resumeReviewData && (
// // // //               <>
// // // //                 <Tabs
// // // //                   value={activeResumeTab}
// // // //                   onChange={(e, val) => setActiveResumeTab(val)}
// // // //                   centered
// // // //                   variant="scrollable"
// // // //                   scrollButtons="auto"
// // // //                 >
// // // //                   {Object.keys(resumeReviewData).map((role) => (
// // // //                     <Tab key={role} label={role} />
// // // //                   ))}
// // // //                 </Tabs>
// // // //                 {Object.entries(resumeReviewData).map(([role, data], index) => (
// // // //                   <TabPanel value={activeResumeTab} index={index} key={role}>
// // // //                     <Grid container spacing={3}>
// // // //                       <Grid item xs={12} md={6}>
// // // //                         <Paper
// // // //                           variant="outlined"
// // // //                           sx={{ p: 2.5, height: "100%", borderRadius: 2 }}
// // // //                         >
// // // //                           <Box
// // // //                             sx={{
// // // //                               p: 2,
// // // //                               mb: 2,
// // // //                               borderRadius: 1.5,
// // // //                               background: (theme) =>
// // // //                                 `linear-gradient(135deg, ${alpha(
// // // //                                   theme.palette.error.light,
// // // //                                   0.2
// // // //                                 )}, ${alpha(theme.palette.error.dark, 0.2)})`,
// // // //                             }}
// // // //                           >
// // // //                             <Typography variant="h6" fontWeight="500">
// // // //                               ATS Compatibility
// // // //                             </Typography>
// // // //                             <Typography
// // // //                               variant="h3"
// // // //                               fontWeight="bold"
// // // //                               color="error.dark"
// // // //                             >
// // // //                               {data.ATS_Compatibility.score}
// // // //                               <Typography
// // // //                                 component="span"
// // // //                                 variant="h5"
// // // //                                 color="text.secondary"
// // // //                               >
// // // //                                 /100
// // // //                               </Typography>
// // // //                             </Typography>
// // // //                             <LinearProgress
// // // //                               variant="determinate"
// // // //                               value={data.ATS_Compatibility.score}
// // // //                               color="error"
// // // //                               sx={{ height: 6, borderRadius: 3 }}
// // // //                             />
// // // //                           </Box>
// // // //                           <Typography variant="subtitle1" fontWeight="bold">
// // // //                             Top Issues:
// // // //                           </Typography>
// // // //                           <List dense>
// // // //                             {data.ATS_Compatibility.top_issues.map(
// // // //                               (issue, i) => (
// // // //                                 <ListItem key={i} sx={{ py: 0 }}>
// // // //                                   <ListItemIcon sx={{ minWidth: 32 }}>
// // // //                                     <ErrorOutline
// // // //                                       fontSize="small"
// // // //                                       color="error"
// // // //                                     />
// // // //                                   </ListItemIcon>
// // // //                                   <ListItemText primary={issue} />
// // // //                                 </ListItem>
// // // //                               )
// // // //                             )}
// // // //                           </List>
// // // //                         </Paper>
// // // //                       </Grid>
// // // //                       <Grid item xs={12} md={6}>
// // // //                         <Paper
// // // //                           variant="outlined"
// // // //                           sx={{ p: 2.5, height: "100%", borderRadius: 2 }}
// // // //                         >
// // // //                           <Box
// // // //                             sx={{
// // // //                               p: 2,
// // // //                               mb: 2,
// // // //                               borderRadius: 1.5,
// // // //                               background: (theme) =>
// // // //                                 `linear-gradient(135deg, ${alpha(
// // // //                                   theme.palette.success.light,
// // // //                                   0.2
// // // //                                 )}, ${alpha(theme.palette.success.dark, 0.2)})`,
// // // //                             }}
// // // //                           >
// // // //                             <Typography variant="h6" fontWeight="500">
// // // //                               Content & Format Quality
// // // //                             </Typography>
// // // //                             <Typography
// // // //                               variant="body2"
// // // //                               paragraph
// // // //                               color="text.secondary"
// // // //                             >
// // // //                               {data.Content_Quality_Analysis.summary}
// // // //                             </Typography>
// // // //                           </Box>
// // // //                           <Typography variant="subtitle1" fontWeight="bold">
// // // //                             Top Strengths:
// // // //                           </Typography>
// // // //                           <List dense>
// // // //                             {data.Content_Quality_Analysis.top_strengths.map(
// // // //                               (strength, i) => (
// // // //                                 <ListItem key={i} sx={{ py: 0 }}>
// // // //                                   <ListItemIcon sx={{ minWidth: 32 }}>
// // // //                                     <CheckCircle
// // // //                                       fontSize="small"
// // // //                                       color="success"
// // // //                                     />
// // // //                                   </ListItemIcon>
// // // //                                   <ListItemText primary={strength} />
// // // //                                 </ListItem>
// // // //                               )
// // // //                             )}
// // // //                           </List>
// // // //                         </Paper>
// // // //                       </Grid>
// // // //                       <Grid item xs={12}>
// // // //                         <Paper
// // // //                           variant="outlined"
// // // //                           sx={{ p: 2.5, borderRadius: 2 }}
// // // //                         >
// // // //                           <Typography variant="h6" gutterBottom>
// // // //                             Keyword & Section Optimization
// // // //                           </Typography>
// // // //                           <Stack
// // // //                             direction={{ xs: "column", sm: "row" }}
// // // //                             spacing={3}
// // // //                             divider={
// // // //                               <Divider orientation="vertical" flexItem />
// // // //                             }
// // // //                           >
// // // //                             <Box flex={1}>
// // // //                               <Typography variant="subtitle1" fontWeight="bold">
// // // //                                 Missing Keywords
// // // //                               </Typography>
// // // //                               <Box
// // // //                                 sx={{
// // // //                                   display: "flex",
// // // //                                   flexWrap: "wrap",
// // // //                                   gap: 1,
// // // //                                   mt: 1,
// // // //                                 }}
// // // //                               >
// // // //                                 {data.Keyword_Optimization.missing_keywords.map(
// // // //                                   (kw, i) => (
// // // //                                     <Chip
// // // //                                       key={i}
// // // //                                       label={kw}
// // // //                                       color="info"
// // // //                                       size="small"
// // // //                                     />
// // // //                                   )
// // // //                                 )}
// // // //                               </Box>
// // // //                             </Box>
// // // //                             <Box flex={1}>
// // // //                               <Typography variant="subtitle1" fontWeight="bold">
// // // //                                 Missing Sections
// // // //                               </Typography>
// // // //                               <Box
// // // //                                 sx={{
// // // //                                   display: "flex",
// // // //                                   flexWrap: "wrap",
// // // //                                   gap: 1,
// // // //                                   mt: 1,
// // // //                                 }}
// // // //                               >
// // // //                                 {data.Format_and_Structure_Review.missing_sections.map(
// // // //                                   (sec, i) => (
// // // //                                     <Chip
// // // //                                       key={i}
// // // //                                       label={sec}
// // // //                                       color="warning"
// // // //                                       size="small"
// // // //                                     />
// // // //                                   )
// // // //                                 )}
// // // //                               </Box>
// // // //                             </Box>
// // // //                           </Stack>
// // // //                         </Paper>
// // // //                       </Grid>
// // // //                     </Grid>
// // // //                   </TabPanel>
// // // //                 ))}
// // // //               </>
// // // //             )
// // // //           )}
// // // //         </DialogContent>
// // // //         <DialogActions>
// // // //           <Button onClick={() => setResumeReviewDialog(false)}>Close</Button>
// // // //         </DialogActions>
// // // //       </Dialog>
// // // //       <Dialog
// // // //         open={skillGapDialog}
// // // //         onClose={() => setSkillGapDialog(false)}
// // // //         maxWidth="lg"
// // // //         fullWidth
// // // //       >
// // // //         <DialogTitle
// // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // //         >
// // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // //             <TrendingUp />
// // // //             <Typography variant="h6">AI Skill Gap Analysis</Typography>
// // // //           </Stack>
// // // //         </DialogTitle>
// // // //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// // // //           <RoleSelector
// // // //             selectedRoles={selectedSkillGapRoles}
// // // //             handleRoleChange={(e) =>
// // // //               setSelectedSkillGapRoles((prev) =>
// // // //                 e.target.checked
// // // //                   ? [...prev, e.target.name]
// // // //                   : prev.filter((r) => r !== e.target.name)
// // // //               )
// // // //             }
// // // //           />
// // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // //             <Button
// // // //               variant="contained"
// // // //               color="primary"
// // // //               onClick={() => fetchSkillGap(selectedSkillGapRoles)}
// // // //             >
// // // //               Generate Analysis
// // // //             </Button>
// // // //           </Box>
// // // //           <Divider sx={{ mb: 2 }} />
// // // //           {skillGapLoading ? (
// // // //             <DialogSkeleton />
// // // //           ) : (
// // // //             skillGapData && (
// // // //               <>
// // // //                 <Tabs
// // // //                   value={activeSkillGapTab}
// // // //                   onChange={(e, val) => setActiveSkillGapTab(val)}
// // // //                   centered
// // // //                   variant="scrollable"
// // // //                   scrollButtons="auto"
// // // //                 >
// // // //                   {Object.keys(skillGapData).map((role) => (
// // // //                     <Tab key={role} label={role} />
// // // //                   ))}
// // // //                 </Tabs>
// // // //                 {Object.entries(skillGapData).map(([role, data], index) => (
// // // //                   <TabPanel value={activeSkillGapTab} index={index} key={role}>
// // // //                     <Grid container spacing={2}>
// // // //                       <Grid item xs={12} md={6}>
// // // //                         <Paper
// // // //                           variant="outlined"
// // // //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// // // //                         >
// // // //                           <Stack
// // // //                             direction="row"
// // // //                             spacing={1.5}
// // // //                             alignItems="center"
// // // //                             mb={1.5}
// // // //                           >
// // // //                             <Avatar sx={{ bgcolor: "primary.light" }}>
// // // //                               <Person />
// // // //                             </Avatar>
// // // //                             <Typography variant="h6">Your Skills</Typography>
// // // //                           </Stack>
// // // //                           <Box
// // // //                             sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
// // // //                           >
// // // //                             {data.Current_Skill_Mapping.map((skill, i) => (
// // // //                               <Chip key={i} label={skill} variant="outlined" />
// // // //                             ))}
// // // //                           </Box>
// // // //                         </Paper>
// // // //                       </Grid>
// // // //                       <Grid item xs={12} md={6}>
// // // //                         <Paper
// // // //                           variant="outlined"
// // // //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// // // //                         >
// // // //                           <Stack
// // // //                             direction="row"
// // // //                             spacing={1.5}
// // // //                             alignItems="center"
// // // //                             mb={1.5}
// // // //                           >
// // // //                             <Avatar sx={{ bgcolor: "secondary.light" }}>
// // // //                               <TrendingUp />
// // // //                             </Avatar>
// // // //                             <Typography variant="h6">
// // // //                               In-Demand Market Skills
// // // //                             </Typography>
// // // //                           </Stack>
// // // //                           <Box
// // // //                             sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
// // // //                           >
// // // //                             {data.Market_Demand_Analysis.map((skill, i) => (
// // // //                               <Chip key={i} label={skill} color="primary" />
// // // //                             ))}
// // // //                           </Box>
// // // //                         </Paper>
// // // //                       </Grid>
// // // //                       <Grid item xs={12} md={6}>
// // // //                         <Paper
// // // //                           variant="outlined"
// // // //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// // // //                         >
// // // //                           <Stack
// // // //                             direction="row"
// // // //                             spacing={1.5}
// // // //                             alignItems="center"
// // // //                             mb={1.5}
// // // //                           >
// // // //                             <Avatar sx={{ bgcolor: "info.light" }}>
// // // //                               <School />
// // // //                             </Avatar>
// // // //                             <Typography variant="h6">
// // // //                               Recommended Learning Path
// // // //                             </Typography>
// // // //                           </Stack>
// // // //                           <List dense>
// // // //                             {data.Learning_Path.map((path, i) => (
// // // //                               <ListItem key={i} sx={{ py: 0.5 }}>
// // // //                                 <ListItemIcon sx={{ minWidth: 36 }}>
// // // //                                   <ArrowForward fontSize="small" color="info" />
// // // //                                 </ListItemIcon>
// // // //                                 <ListItemText primary={path} />
// // // //                               </ListItem>
// // // //                             ))}
// // // //                           </List>
// // // //                         </Paper>
// // // //                       </Grid>
// // // //                       <Grid item xs={12} md={6}>
// // // //                         <Paper
// // // //                           variant="outlined"
// // // //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// // // //                         >
// // // //                           <Stack
// // // //                             direction="row"
// // // //                             spacing={1.5}
// // // //                             alignItems="center"
// // // //                             mb={1.5}
// // // //                           >
// // // //                             <Avatar sx={{ bgcolor: "success.light" }}>
// // // //                               <MilitaryTech />
// // // //                             </Avatar>
// // // //                             <Typography variant="h6">
// // // //                               Suggested Certifications
// // // //                             </Typography>
// // // //                           </Stack>
// // // //                           <List dense>
// // // //                             {data.Certification_Guidance.map((cert, i) => (
// // // //                               <ListItem key={i} sx={{ py: 0.5 }}>
// // // //                                 <ListItemIcon sx={{ minWidth: 36 }}>
// // // //                                   <CheckCircle
// // // //                                     fontSize="small"
// // // //                                     color="success"
// // // //                                   />
// // // //                                 </ListItemIcon>
// // // //                                 <ListItemText primary={cert} />
// // // //                               </ListItem>
// // // //                             ))}
// // // //                           </List>
// // // //                         </Paper>
// // // //                       </Grid>
// // // //                     </Grid>
// // // //                   </TabPanel>
// // // //                 ))}
// // // //               </>
// // // //             )
// // // //           )}
// // // //         </DialogContent>
// // // //         <DialogActions>
// // // //           <Button onClick={() => setSkillGapDialog(false)}>Close</Button>
// // // //         </DialogActions>
// // // //       </Dialog>
// // // //       <Dialog
// // // //         open={careerRoadmapDialog}
// // // //         onClose={() => setCareerRoadmapDialog(false)}
// // // //         maxWidth="lg"
// // // //         fullWidth
// // // //       >
// // // //         <DialogTitle
// // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // //         >
// // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // //             <Timeline />
// // // //             <Typography variant="h6">Personalized Career Roadmap</Typography>
// // // //           </Stack>
// // // //         </DialogTitle>
// // // //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// // // //           <RoleSelector
// // // //             selectedRoles={selectedRoadmapRoles}
// // // //             handleRoleChange={(e) =>
// // // //               setSelectedRoadmapRoles((prev) =>
// // // //                 e.target.checked
// // // //                   ? [...prev, e.target.name]
// // // //                   : prev.filter((r) => r !== e.target.name)
// // // //               )
// // // //             }
// // // //           />
// // // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // // //             <Button
// // // //               variant="contained"
// // // //               color="primary"
// // // //               onClick={() => fetchCareerRoadmap(selectedRoadmapRoles)}
// // // //             >
// // // //               Generate Roadmap
// // // //             </Button>
// // // //           </Box>
// // // //           <Divider sx={{ mb: 2 }} />
// // // //           {careerRoadmapLoading ? (
// // // //             <DialogSkeleton />
// // // //           ) : (
// // // //             careerRoadmapData && (
// // // //               <>
// // // //                 <Tabs
// // // //                   value={activeRoadmapTab}
// // // //                   onChange={(e, val) => setActiveRoadmapTab(val)}
// // // //                   centered
// // // //                   variant="scrollable"
// // // //                   scrollButtons="auto"
// // // //                 >
// // // //                   {Object.keys(careerRoadmapData).map((role) => (
// // // //                     <Tab key={role} label={role} />
// // // //                   ))}
// // // //                 </Tabs>
// // // //                 {Object.entries(careerRoadmapData).map(
// // // //                   ([role, data], index) => (
// // // //                     <TabPanel value={activeRoadmapTab} index={index} key={role}>
// // // //                       <Typography variant="h5" gutterBottom align="center">
// // // //                         Your AI-Generated Path to <strong>{role}</strong>
// // // //                       </Typography>
// // // //                       <Typography
// // // //                         variant="body1"
// // // //                         paragraph
// // // //                         color="text.secondary"
// // // //                         align="center"
// // // //                       >
// // // //                         Based on your current role:{" "}
// // // //                         <strong>{data?.Current_Position || "N/A"}</strong> with{" "}
// // // //                         <strong>{data?.Experience_Years || "N/A"}</strong> years
// // // //                         of experience.
// // // //                       </Typography>
// // // //                       <Grid container spacing={2} sx={{ mt: 1 }}>
// // // //                         <Grid item xs={12} md={6}>
// // // //                           <Paper
// // // //                             variant="outlined"
// // // //                             sx={{
// // // //                               p: 2.5,
// // // //                               height: "100%",
// // // //                               borderRadius: 2,
// // // //                             }}
// // // //                           >
// // // //                             <Stack
// // // //                               direction="row"
// // // //                               spacing={2}
// // // //                               alignItems="center"
// // // //                             >
// // // //                               <Avatar
// // // //                                 sx={{
// // // //                                   bgcolor: "primary.light",
// // // //                                   width: 56,
// // // //                                   height: 56,
// // // //                                 }}
// // // //                               >
// // // //                                 <RocketLaunch />
// // // //                               </Avatar>
// // // //                               <Box>
// // // //                                 <Typography
// // // //                                   variant="overline"
// // // //                                   color="primary.main"
// // // //                                 >
// // // //                                   Next Milestone
// // // //                                 </Typography>
// // // //                                 <Typography variant="h6" fontWeight="bold">
// // // //                                   {data?.Next_Milestone?.title ||
// // // //                                     "Not available"}
// // // //                                 </Typography>
// // // //                                 <Chip
// // // //                                   size="small"
// // // //                                   label={`Company: ${
// // // //                                     data?.Next_Milestone?.company_type || "N/A"
// // // //                                   }`}
// // // //                                   sx={{ mt: 1 }}
// // // //                                 />
// // // //                               </Box>
// // // //                             </Stack>
// // // //                           </Paper>
// // // //                         </Grid>
// // // //                         <Grid item xs={12} md={6}>
// // // //                           <Paper
// // // //                             variant="outlined"
// // // //                             sx={{
// // // //                               p: 2.5,
// // // //                               height: "100%",
// // // //                               borderRadius: 2,
// // // //                             }}
// // // //                           >
// // // //                             <Stack
// // // //                               direction="row"
// // // //                               spacing={2}
// // // //                               alignItems="center"
// // // //                             >
// // // //                               <Avatar
// // // //                                 sx={{
// // // //                                   bgcolor: "success.light",
// // // //                                   width: 56,
// // // //                                   height: 56,
// // // //                                 }}
// // // //                               >
// // // //                                 <Stars />
// // // //                               </Avatar>
// // // //                               <Box>
// // // //                                 <Typography
// // // //                                   variant="overline"
// // // //                                   color="success.main"
// // // //                                 >
// // // //                                   Long-term Goal
// // // //                                 </Typography>
// // // //                                 <Typography variant="h6" fontWeight="bold">
// // // //                                   {data?.Long_Term_Goal?.title ||
// // // //                                     "Not available"}
// // // //                                 </Typography>
// // // //                                 <Chip
// // // //                                   size="small"
// // // //                                   label={`Company: ${
// // // //                                     data?.Long_Term_Goal?.company_type || "N/A"
// // // //                                   }`}
// // // //                                   sx={{ mt: 1 }}
// // // //                                 />
// // // //                               </Box>
// // // //                             </Stack>
// // // //                           </Paper>
// // // //                         </Grid>
// // // //                       </Grid>
// // // //                       <Divider sx={{ my: 3 }}>
// // // //                         <Chip label="Recommended Actions" color="primary" />
// // // //                       </Divider>
// // // //                       <List>
// // // //                         {data?.Recommended_Actions?.map((item, i) => (
// // // //                           <ListItem key={i} alignItems="flex-start">
// // // //                             <ListItemIcon>
// // // //                               <Work color="primary" />
// // // //                             </ListItemIcon>
// // // //                             <ListItemText
// // // //                               primary={item.action}
// // // //                               secondary={item.reason}
// // // //                             />
// // // //                           </ListItem>
// // // //                         )) || (
// // // //                           <ListItem>
// // // //                             <ListItemText primary="No actions recommended." />
// // // //                           </ListItem>
// // // //                         )}
// // // //                       </List>
// // // //                     </TabPanel>
// // // //                   )
// // // //                 )}
// // // //               </>
// // // //             )
// // // //           )}
// // // //         </DialogContent>
// // // //         <DialogActions>
// // // //           <Button onClick={() => setCareerRoadmapDialog(false)}>Close</Button>
// // // //         </DialogActions>
// // // //       </Dialog>
// // // //       <Dialog
// // // //         open={culturalPrepDialog}
// // // //         onClose={() => {
// // // //           setCulturalPrepDialog(false);
// // // //           setCulturalPrepTab(0);
// // // //         }}
// // // //         maxWidth="md"
// // // //         fullWidth
// // // //         PaperProps={{ sx: { height: { md: 650 } } }}
// // // //       >
// // // //         <DialogTitle
// // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // //         >
// // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // //             <Psychology />
// // // //             <Typography variant="h6">Cultural Preparation Insights</Typography>
// // // //           </Stack>
// // // //         </DialogTitle>
// // // //         <DialogContent
// // // //           dividers
// // // //           sx={{
// // // //             display: "flex",
// // // //             p: 0,
// // // //             overflow: "hidden",
// // // //             flexDirection: { xs: "column", md: "row" },
// // // //           }}
// // // //         >
// // // //           {culturalPrepLoading ? (
// // // //             <DialogSkeleton />
// // // //           ) : (
// // // //             culturalPrepData && (
// // // //               <>
// // // //                 <Tabs
// // // //                   orientation={
// // // //                     theme.breakpoints.up("md") ? "vertical" : "horizontal"
// // // //                   }
// // // //                   variant="scrollable"
// // // //                   value={culturalPrepTab}
// // // //                   onChange={(e, val) => setCulturalPrepTab(val)}
// // // //                   sx={{
// // // //                     borderRight: { md: 1 },
// // // //                     borderBottom: { xs: 1, md: 0 },
// // // //                     borderColor: "divider",
// // // //                     minWidth: { md: 150 },
// // // //                   }}
// // // //                 >
// // // //                   {Object.values(culturalPrepData).map((region, index) => (
// // // //                     <Tab key={index} label={region.location_name} />
// // // //                   ))}
// // // //                 </Tabs>
// // // //                 <Box
// // // //                   sx={{
// // // //                     flex: { md: 1 },
// // // //                     overflowY: "auto",
// // // //                     p: { xs: 2, md: 3 },
// // // //                     bgcolor: "background.default",
// // // //                   }}
// // // //                 >
// // // //                   {Object.values(culturalPrepData).map((region, index) => (
// // // //                     <TabPanel value={culturalPrepTab} index={index} key={index}>
// // // //                       <Stack spacing={2}>
// // // //                         <Paper
// // // //                           elevation={0}
// // // //                           sx={{
// // // //                             p: 2,
// // // //                             borderRadius: 2,
// // // //                             border: 1,
// // // //                             borderColor: "divider",
// // // //                           }}
// // // //                         >
// // // //                           <Stack
// // // //                             direction="row"
// // // //                             spacing={1}
// // // //                             alignItems="center"
// // // //                             mb={1}
// // // //                           >
// // // //                             <Insights color="primary" />
// // // //                             <Typography variant="h6">
// // // //                               Cultural Insights
// // // //                             </Typography>
// // // //                           </Stack>
// // // //                           <List dense>
// // // //                             {region.cultural_insights.map((insight, i) => (
// // // //                               <ListItem key={i}>
// // // //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// // // //                                   <ArrowForward fontSize="small" />
// // // //                                 </ListItemIcon>
// // // //                                 <ListItemText primary={insight} />
// // // //                               </ListItem>
// // // //                             ))}
// // // //                           </List>
// // // //                         </Paper>
// // // //                         <Paper
// // // //                           elevation={0}
// // // //                           sx={{
// // // //                             p: 2,
// // // //                             borderRadius: 2,
// // // //                             border: 1,
// // // //                             borderColor: "divider",
// // // //                           }}
// // // //                         >
// // // //                           <Stack
// // // //                             direction="row"
// // // //                             spacing={1}
// // // //                             alignItems="center"
// // // //                             mb={1}
// // // //                           >
// // // //                             <VideoCall color="primary" />
// // // //                             <Typography variant="h6">
// // // //                               Communication Tips
// // // //                             </Typography>
// // // //                           </Stack>
// // // //                           <List dense>
// // // //                             {region.communication_tips.map((tip, i) => (
// // // //                               <ListItem key={i}>
// // // //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// // // //                                   <ArrowForward fontSize="small" />
// // // //                                 </ListItemIcon>
// // // //                                 <ListItemText primary={tip} />
// // // //                               </ListItem>
// // // //                             ))}
// // // //                           </List>
// // // //                         </Paper>
// // // //                         <Paper
// // // //                           elevation={0}
// // // //                           sx={{
// // // //                             p: 2,
// // // //                             borderRadius: 2,
// // // //                             border: 1,
// // // //                             borderColor: "divider",
// // // //                           }}
// // // //                         >
// // // //                           <Stack
// // // //                             direction="row"
// // // //                             spacing={1}
// // // //                             alignItems="center"
// // // //                             mb={1}
// // // //                           >
// // // //                             <Work color="primary" />
// // // //                             <Typography variant="h6">Work Etiquette</Typography>
// // // //                           </Stack>
// // // //                           <List dense>
// // // //                             {region.work_etiquette.map((tip, i) => (
// // // //                               <ListItem key={i}>
// // // //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// // // //                                   <Stars fontSize="small" />
// // // //                                 </ListItemIcon>
// // // //                                 <ListItemText primary={tip} />
// // // //                               </ListItem>
// // // //                             ))}
// // // //                           </List>
// // // //                         </Paper>
// // // //                       </Stack>
// // // //                     </TabPanel>
// // // //                   ))}
// // // //                 </Box>
// // // //               </>
// // // //             )
// // // //           )}
// // // //         </DialogContent>
// // // //         <DialogActions>
// // // //           <Button onClick={() => setCulturalPrepDialog(false)}>Close</Button>
// // // //         </DialogActions>
// // // //       </Dialog>
// // // //       <Dialog
// // // //         open={salaryInsightsDialog}
// // // //         onClose={() => setSalaryInsightsDialog(false)}
// // // //         maxWidth="md"
// // // //         fullWidth
// // // //       >
// // // //         <DialogTitle
// // // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // // //         >
// // // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // // //             <Language />
// // // //             <Typography variant="h6">Global Salary Insights</Typography>
// // // //           </Stack>
// // // //         </DialogTitle>
// // // //         <DialogContent dividers sx={{ bgcolor: "background.default" }}>
// // // //           {salaryInsightsLoading ? (
// // // //             <DialogSkeleton />
// // // //           ) : (
// // // //             salaryInsightsData && (
// // // //               <Stack spacing={3} sx={{ py: 2 }}>
// // // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // // //                   <Stack
// // // //                     direction="row"
// // // //                     spacing={1.5}
// // // //                     alignItems="center"
// // // //                     mb={2}
// // // //                   >
// // // //                     <LocationOn color="primary" />
// // // //                     <Typography variant="h6">
// // // //                       Salary Benchmarks by Location
// // // //                     </Typography>
// // // //                   </Stack>
// // // //                   <Box
// // // //                     sx={{
// // // //                       display: "grid",
// // // //                       gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
// // // //                       gap: 2, // theme.spacing(2)
// // // //                     }}
// // // //                   >
// // // //                     {salaryInsightsData.location_based.map((loc, i) => (
// // // //                       <Card
// // // //                         key={i}
// // // //                         variant="elevation"
// // // //                         elevation={4}
// // // //                         sx={{
// // // //                           borderRadius: 3,
// // // //                           background: (theme) =>
// // // //                             `linear-gradient(145deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
// // // //                           color: "primary.contrastText",
// // // //                           transition: "transform 0.3s ease-in-out",
// // // //                           "&:hover": {
// // // //                             transform: "translateY(-4px)",
// // // //                           },
// // // //                         }}
// // // //                       >
// // // //                         <CardContent
// // // //                           sx={{
// // // //                             display: "flex",
// // // //                             flexDirection: "column",
// // // //                             height: "100%",
// // // //                             p: 2.5,
// // // //                           }}
// // // //                         >
// // // //                           <Stack
// // // //                             direction="row"
// // // //                             spacing={1}
// // // //                             alignItems="center"
// // // //                           >
// // // //                             <LocationOn sx={{ opacity: 0.8 }} />
// // // //                             <Typography
// // // //                               variant="h6"
// // // //                               component="div"
// // // //                               fontWeight={600}
// // // //                             >
// // // //                               {loc.city}
// // // //                             </Typography>
// // // //                           </Stack>

// // // //                           <Box
// // // //                             sx={{
// // // //                               flexGrow: 1,
// // // //                               display: "flex",
// // // //                               flexDirection: "column",
// // // //                               justifyContent: "center",
// // // //                               alignItems: "center",
// // // //                               my: 2,
// // // //                             }}
// // // //                           >
// // // //                             <Typography variant="caption" sx={{ opacity: 0.8 }}>
// // // //                               MEDIAN SALARY
// // // //                             </Typography>
// // // //                             <Typography variant="h4" fontWeight="bold">
// // // //                               {loc.median_salary}
// // // //                             </Typography>
// // // //                           </Box>

// // // //                           <Divider
// // // //                             sx={{ bgcolor: "rgba(255,255,255,0.2)", mb: 1.5 }}
// // // //                           />

// // // //                           <Stack
// // // //                             direction="row"
// // // //                             justifyContent="space-between"
// // // //                             alignItems="center"
// // // //                           >
// // // //                             <Box textAlign="center">
// // // //                               <Typography
// // // //                                 variant="caption"
// // // //                                 sx={{ opacity: 0.8 }}
// // // //                               >
// // // //                                 MIN
// // // //                               </Typography>
// // // //                               <Typography fontWeight="medium">
// // // //                                 {loc.min_salary}
// // // //                               </Typography>
// // // //                             </Box>
// // // //                             <Box textAlign="center">
// // // //                               <Typography
// // // //                                 variant="caption"
// // // //                                 sx={{ opacity: 0.8 }}
// // // //                               >
// // // //                                 MAX
// // // //                               </Typography>
// // // //                               <Typography fontWeight="medium">
// // // //                                 {loc.max_salary}
// // // //                               </Typography>
// // // //                             </Box>
// // // //                           </Stack>
// // // //                         </CardContent>
// // // //                       </Card>
// // // //                     ))}
// // // //                   </Box>
// // // //                 </Paper>
// // // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // // //                   <Stack
// // // //                     direction="row"
// // // //                     spacing={1.5}
// // // //                     alignItems="center"
// // // //                     mb={1}
// // // //                   >
// // // //                     <TrendingUp color="primary" />
// // // //                     <Typography variant="h6">Location Demand Impact</Typography>
// // // //                   </Stack>
// // // //                   <List dense>
// // // //                     {salaryInsightsData.salary_insights_summary.map(
// // // //                       (item, i) => (
// // // //                         <ListItem key={i} disableGutters sx={{ px: 1 }}>
// // // //                           <Stack
// // // //                             direction={{ xs: "column", sm: "row" }}
// // // //                             spacing={{ xs: 0.5, sm: 2 }}
// // // //                             alignItems="center"
// // // //                             sx={{ width: "100%" }}
// // // //                           >
// // // //                             <ListItemText
// // // //                               primary={item.role}
// // // //                               sx={{
// // // //                                 width: "100%",
// // // //                                 m: 0,
// // // //                                 flexBasis: { sm: "40%" },
// // // //                                 flexShrink: 0,
// // // //                               }}
// // // //                             />
// // // //                             <Box
// // // //                               sx={{
// // // //                                 width: "100%",
// // // //                                 display: "flex",
// // // //                                 alignItems: "center",
// // // //                               }}
// // // //                             >
// // // //                               <LinearProgress
// // // //                                 variant="determinate"
// // // //                                 value={item.demand_in_salary_percent}
// // // //                                 color="primary"
// // // //                                 sx={{
// // // //                                   width: "100%",
// // // //                                   mr: 1.5,
// // // //                                   height: 8,
// // // //                                   borderRadius: 4,
// // // //                                 }}
// // // //                               />
// // // //                               <Typography
// // // //                                 variant="body2"
// // // //                                 color="text.secondary"
// // // //                               >{`${item.demand_in_salary_percent}%`}</Typography>
// // // //                             </Box>
// // // //                           </Stack>
// // // //                         </ListItem>
// // // //                       )
// // // //                     )}
// // // //                   </List>
// // // //                 </Paper>
// // // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // // //                   <Stack
// // // //                     direction="row"
// // // //                     spacing={1.5}
// // // //                     alignItems="center"
// // // //                     mb={1}
// // // //                   >
// // // //                     <MonetizationOn color="success" />
// // // //                     <Typography variant="h6">Negotiation Tips</Typography>
// // // //                   </Stack>
// // // //                   <List dense>
// // // //                     {salaryInsightsData.negotiation_tips.map((tip, i) => (
// // // //                       <ListItem key={i}>
// // // //                         <ListItemIcon sx={{ minWidth: 32 }}>
// // // //                           <CheckCircle color="success" fontSize="small" />
// // // //                         </ListItemIcon>
// // // //                         <ListItemText primary={tip} />
// // // //                       </ListItem>
// // // //                     ))}
// // // //                   </List>
// // // //                 </Paper>
// // // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // // //                   <Stack
// // // //                     direction="row"
// // // //                     spacing={1.5}
// // // //                     alignItems="center"
// // // //                     mb={1}
// // // //                   >
// // // //                     <Timeline color="warning" />
// // // //                     <Typography variant="h6">Market Trends</Typography>
// // // //                   </Stack>
// // // //                   <List>
// // // //                     {salaryInsightsData.market_trends.map((item, i) => (
// // // //                       <ListItem key={i} alignItems="flex-start">
// // // //                         <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
// // // //                           <TrendingFlat color="warning" />
// // // //                         </ListItemIcon>
// // // //                         <ListItemText
// // // //                           primary={item.trend}
// // // //                           secondary={item.insight}
// // // //                           primaryTypographyProps={{ fontWeight: 600 }}
// // // //                         />
// // // //                       </ListItem>
// // // //                     ))}
// // // //                   </List>
// // // //                 </Paper>
// // // //               </Stack>
// // // //             )
// // // //           )}
// // // //         </DialogContent>
// // // //         <DialogActions>
// // // //           <Button onClick={() => setSalaryInsightsDialog(false)}>Close</Button>
// // // //         </DialogActions>
// // // //       </Dialog>
// // // //     </Layout>
// // // //   );
// // // // };

// // // // export default CareerAssistant;
// // // import { useState, useEffect, useRef } from "react";
// // // import {
// // //   Grid,
// // //   Card,
// // //   CardContent,
// // //   Container,
// // //   Typography,
// // //   Box,
// // //   Button,
// // //   Paper,
// // //   Avatar,
// // //   Chip,
// // //   Dialog,
// // //   DialogTitle,
// // //   DialogContent,
// // //   DialogActions,
// // //   List,
// // //   ListItem,
// // //   ListItemIcon,
// // //   ListItemText,
// // //   Divider,
// // //   Stack,
// // //   LinearProgress,
// // //   Skeleton,
// // //   alpha,
// // //   IconButton,
// // //   Tabs,
// // //   Tab,
// // //   FormGroup,
// // //   FormControlLabel,
// // //   Checkbox,
// // //   Alert,
// // //   AlertTitle,
// // // } from "@mui/material";
// // // import { styled, useTheme } from "@mui/material/styles";
// // // import {
// // //   Psychology,
// // //   TrendingUp,
// // //   School,
// // //   Work,
// // //   Language,
// // //   Assessment,
// // //   VideoCall,
// // //   Lightbulb,
// // //   Timeline,
// // //   CheckCircle,
// // //   ErrorOutline,
// // //   ArrowForward,
// // //   MilitaryTech,
// // //   Stars,
// // //   RocketLaunch,
// // //   TrendingDown,
// // //   TrendingFlat,
// // //   LocationOn,
// // //   MonetizationOn,
// // //   AutoAwesome,
// // //   Close as CloseIcon,
// // //   Insights,
// // //   Person,
// // // } from "@mui/icons-material";
// // // import {
// // //   BarChart,
// // //   Bar,
// // //   XAxis,
// // //   YAxis,
// // //   CartesianGrid,
// // //   Tooltip,
// // //   ResponsiveContainer,
// // //   Cell,
// // //   LabelList,
// // // } from "recharts";
// // // import Layout from "../common/Layout";
// // // import { useNotification } from "../../context/NotificationContext";
// // // import { useNavigate } from "react-router-dom";
// // // import apiClient from "../../context/apiClient";

// // // // --- Skeleton Components ---

// // // const HeaderSkeleton = () => (
// // //   <Paper sx={{ bgcolor: "mint.main", borderRadius: 3, p: { xs: 2, sm: 3 } }}>
// // //     <Stack direction="row" alignItems="center" spacing={2}>
// // //       <Skeleton variant="circular" width={64} height={64} />
// // //       <Box sx={{ flex: 1 }}>
// // //         <Skeleton variant="text" width="40%" height={48} />
// // //         <Skeleton variant="text" width="60%" height={24} />
// // //       </Box>
// // //     </Stack>
// // //   </Paper>
// // // );

// // // const ServiceListItemSkeleton = () => (
// // //   <Paper
// // //     sx={{
// // //       display: "flex",
// // //       flexDirection: "row",
// // //       alignItems: "center",
// // //       padding: 2,
// // //       borderRadius: "12px",
// // //       border: (theme) => `1px solid ${theme.palette.divider}`,
// // //     }}
// // //   >
// // //     <Skeleton variant="circular" width={48} height={48} sx={{ mr: 2 }} />
// // //     <Box flexGrow={1}>
// // //       <Skeleton variant="text" height={30} width="50%" />
// // //       <Skeleton variant="text" height={20} width="80%" />
// // //     </Box>
// // //     <Skeleton variant="circular" width={24} height={24} sx={{ ml: 2 }} />
// // //   </Paper>
// // // );

// // // const ServicesSkeleton = () => (
// // //   <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, bgcolor: "mint.main" }}>
// // //     <Skeleton variant="text" width="60%" height={40} sx={{ mb: 3 }} />
// // //     <Stack spacing={2}>
// // //       {[...Array(5)].map((_, index) => (
// // //         <ServiceListItemSkeleton key={index} />
// // //       ))}
// // //     </Stack>
// // //   </Paper>
// // // );

// // // const TrendingSkillsSkeleton = () => (
// // //   <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, bgcolor: "mint.main" }}>
// // //     <Skeleton variant="text" width="40%" height={40} sx={{ mb: 2 }} />
// // //     <Stack
// // //       direction="row"
// // //       spacing={2}
// // //       sx={{ mb: 3, justifyContent: "center", flexWrap: "wrap", gap: 1 }}
// // //     >
// // //       <Skeleton variant="rounded" width={150} height={42} />
// // //       <Skeleton variant="rounded" width={150} height={42} />
// // //       <Skeleton variant="rounded" width={150} height={42} />
// // //     </Stack>
// // //     <Skeleton variant="rounded" width="100%" height={500} />
// // //   </Paper>
// // // );

// // // const PageSkeleton = () => (
// // //   <Layout title="AI Career Assistant">
// // //     <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// // //       <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
// // //         <Stack spacing={4}>
// // //           <HeaderSkeleton />
// // //           <ServicesSkeleton />
// // //           <TrendingSkillsSkeleton />
// // //         </Stack>
// // //       </Container>
// // //     </Box>
// // //   </Layout>
// // // );

// // // const ChartSkeleton = () => (
// // //   <Box sx={{ height: { xs: 400, md: 500 }, width: "100%", pt: 2 }}>
// // //     <Skeleton variant="rounded" width="100%" height="100%" />
// // //   </Box>
// // // );

// // // // --- Helper Components ---

// // // const ServiceListItem = styled(Paper)(({ theme, color = "primary" }) => ({
// // //   backgroundColor: theme.palette.background.paper,
// // //   display: "flex",
// // //   flexDirection: "row",
// // //   alignItems: "center",
// // //   padding: theme.spacing(2),
// // //   borderRadius: "12px",
// // //   cursor: "pointer",
// // //   transition:
// // //     "background-color 0.3s ease, border-color 0.3s ease, transform 0.2s ease-in-out",
// // //   border: `1px solid ${theme.palette.divider}`,
// // //   "&:hover": {
// // //     backgroundColor: alpha(
// // //       theme.palette[color]?.main || theme.palette.primary.main,
// // //       0.08
// // //     ),
// // //     borderColor: theme.palette[color]?.main || theme.palette.primary.main,
// // //     transform: "scale(1.02)",
// // //   },
// // //   ".MuiAvatar-root": {
// // //     backgroundColor: alpha(
// // //       theme.palette[color]?.main || theme.palette.primary.main,
// // //       0.15
// // //     ),
// // //     color: theme.palette[color]?.main || theme.palette.primary.main,
// // //     marginRight: theme.spacing(2),
// // //   },
// // // }));

// // // function TabPanel(props) {
// // //   const { children, value, index, ...other } = props;
// // //   return (
// // //     <div
// // //       role="tabpanel"
// // //       hidden={value !== index}
// // //       id={`tabpanel-${index}`}
// // //       aria-labelledby={`tab-${index}`}
// // //       {...other}
// // //     >
// // //       {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
// // //     </div>
// // //   );
// // // }

// // // // --- Main Component ---

// // // const CareerAssistant = () => {
// // //   const theme = useTheme();
// // //   const { showNotification } = useNotification();
// // //   const navigate = useNavigate();
// // //   const isInitialMount = useRef(true);

// // //   const availableRoles = [
// // //     "AI/ML Engineer",
// // //     "Data Scientist",
// // //     "Business Analyst",
// // //   ];

// // //   // --- State Declarations ---
// // //   const [pageLoading, setPageLoading] = useState(true);
// // //   const [showWelcomeCard, setShowWelcomeCard] = useState(true);
// // //   const [mockInterviewDialog, setMockInterviewDialog] = useState(false);
// // //   const [resumeReviewDialog, setResumeReviewDialog] = useState(false);
// // //   const [skillGapDialog, setSkillGapDialog] = useState(false);
// // //   const [careerRoadmapDialog, setCareerRoadmapDialog] = useState(false);
// // //   const [culturalPrepDialog, setCulturalPrepDialog] = useState(false);
// // //   const [salaryInsightsDialog, setSalaryInsightsDialog] = useState(false);
// // //   const [trendingSkillsData, setTrendingSkillsData] = useState({});
// // //   const [skillsLoading, setSkillsLoading] = useState(true);
// // //   const [selectedTrendingRoles, setSelectedTrendingRoles] = useState([
// // //     "AI/ML Engineer",
// // //   ]);
// // //   const [activeTrendingTab, setActiveTrendingTab] = useState(0);
// // //   const [resumeReviewData, setResumeReviewData] = useState(null);
// // //   const [resumeReviewLoading, setResumeReviewLoading] = useState(false);
// // //   const [selectedResumeRoles, setSelectedResumeRoles] = useState([]);
// // //   const [activeResumeTab, setActiveResumeTab] = useState(0);
// // //   const [skillGapData, setSkillGapData] = useState(null);
// // //   const [skillGapLoading, setSkillGapLoading] = useState(false);
// // //   const [selectedSkillGapRoles, setSelectedSkillGapRoles] = useState([]);
// // //   const [activeSkillGapTab, setActiveSkillGapTab] = useState(0);
// // //   const [careerRoadmapData, setCareerRoadmapData] = useState(null);
// // //   const [careerRoadmapLoading, setCareerRoadmapLoading] = useState(false);
// // //   const [selectedRoadmapRoles, setSelectedRoadmapRoles] = useState([]);
// // //   const [activeRoadmapTab, setActiveRoadmapTab] = useState(0);
// // //   const [culturalPrepData, setCulturalPrepData] = useState(null);
// // //   const [culturalPrepLoading, setCulturalPrepLoading] = useState(false);
// // //   const [culturalPrepTab, setCulturalPrepTab] = useState(0);
// // //   const [salaryInsightsData, setSalaryInsightsData] = useState(null);
// // //   const [salaryInsightsLoading, setSalaryInsightsLoading] = useState(false);

// // //   // --- Data Fetching Functions ---

// // //   const fetchTrendingSkills = async (roles) => {
// // //     if (!roles || roles.length === 0) {
// // //       setTrendingSkillsData({});
// // //       setSkillsLoading(false);
// // //       return;
// // //     }
// // //     setSkillsLoading(true);
// // //     try {
// // //       const response = await apiClient.post("/trending-skills/", {
// // //         selected_roles: roles,
// // //       });
// // //       const transformedData = {};
// // //       for (const [role, skills] of Object.entries(response.data)) {
// // //         transformedData[role] = skills.map((skill) => ({
// // //           skill: skill.skill,
// // //           demand: parseInt(skill.demand) || 0,
// // //           growth: skill.increase || "N/A",
// // //           priority: skill.priority,
// // //         }));
// // //       }
// // //       setTrendingSkillsData(transformedData);
// // //       setActiveTrendingTab(0);
// // //     } catch (error) {
// // //       console.error("Failed to fetch trending skills:", error);
// // //       showNotification("Could not load trending skills data.", "error");
// // //       setTrendingSkillsData({});
// // //     } finally {
// // //       setSkillsLoading(false);
// // //     }
// // //   };

// // //   const fetchResumeReview = async (roles) => {
// // //     if (!roles || roles.length === 0) {
// // //       setResumeReviewData({});
// // //       return;
// // //     }
// // //     setResumeReviewLoading(true);
// // //     try {
// // //       const response = await apiClient.post("/resume/review-talent/", {
// // //         target_roles: roles,
// // //       });
// // //       setResumeReviewData(response.data);
// // //       setActiveResumeTab(0);
// // //     } catch (error) {
// // //       showNotification("Failed to load resume review data.", "error");
// // //     } finally {
// // //       setResumeReviewLoading(false);
// // //     }
// // //   };
// // //   const fetchSkillGap = async (roles) => {
// // //     if (!roles || roles.length === 0) {
// // //       setSkillGapData({});
// // //       return;
// // //     }
// // //     setSkillGapLoading(true);
// // //     try {
// // //       const response = await apiClient.post("/resume/skill-gap/", {
// // //         selected_roles: roles,
// // //       });
// // //       setSkillGapData(response.data);
// // //       setActiveSkillGapTab(0);
// // //     } catch (error) {
// // //       showNotification("Failed to load skill gap analysis.", "error");
// // //     } finally {
// // //       setSkillGapLoading(false);
// // //     }
// // //   };
// // //   const fetchCareerRoadmap = async (roles) => {
// // //     if (!roles || roles.length === 0) {
// // //       setCareerRoadmapData({});
// // //       return;
// // //     }
// // //     setCareerRoadmapLoading(true);
// // //     try {
// // //       const response = await apiClient.post("/resume/career-roadmap/", {
// // //         target_roles: roles,
// // //       });
// // //       setCareerRoadmapData(response.data);
// // //       setActiveRoadmapTab(0);
// // //     } catch (error) {
// // //       showNotification("Failed to load career roadmap.", "error");
// // //       setCareerRoadmapData({});
// // //     } finally {
// // //       setCareerRoadmapLoading(false);
// // //     }
// // //   };

// // //   // --- Handlers ---
// // //   const handleTrendingRoleChange = (event) => {
// // //     const { name, checked } = event.target;
// // //     setSelectedTrendingRoles((prev) =>
// // //       checked ? [...prev, name] : prev.filter((role) => role !== name)
// // //     );
// // //   };

// // //   // --- Child Components ---
// // //   const RoleSelector = ({ selectedRoles, handleRoleChange }) => (
// // //     <FormGroup row sx={{ mb: 2, justifyContent: "center", flexWrap: "wrap" }}>
// // //       {availableRoles.map((role) => (
// // //         <FormControlLabel
// // //           key={role}
// // //           control={
// // //             <Checkbox
// // //               checked={selectedRoles.includes(role)}
// // //               onChange={handleRoleChange}
// // //               name={role}
// // //             />
// // //           }
// // //           label={role}
// // //         />
// // //       ))}
// // //     </FormGroup>
// // //   );

// // //   const CustomTooltip = ({ active, payload, label }) => {
// // //     if (active && payload && payload.length) {
// // //       const data = payload[0].payload;
// // //       const priorityMuiColor = {
// // //         High: "primary",
// // //         Medium: "info",
// // //       };
// // //       return (
// // //         <Paper
// // //           elevation={3}
// // //           sx={{
// // //             p: 1.5,
// // //             minWidth: 220,
// // //             bgcolor: "background.paper",
// // //             border: `1px solid ${theme.palette.divider}`,
// // //             borderRadius: 2,
// // //           }}
// // //         >
// // //           <Typography variant="body1" fontWeight="bold" gutterBottom>
// // //             {label}
// // //           </Typography>
// // //           <Stack spacing={1}>
// // //             <Stack
// // //               direction="row"
// // //               justifyContent="space-between"
// // //               alignItems="center"
// // //             >
// // //               <Typography variant="body2" color="text.secondary">
// // //                 Demand:
// // //               </Typography>
// // //               <Typography
// // //                 variant="body2"
// // //                 fontWeight="bold"
// // //               >{`${data.demand}%`}</Typography>
// // //             </Stack>
// // //             <Stack
// // //               direction="row"
// // //               justifyContent="space-between"
// // //               alignItems="center"
// // //             >
// // //               <Typography variant="body2" color="text.secondary">
// // //                 Priority:
// // //               </Typography>
// // //               <Chip
// // //                 label={data.priority}
// // //                 size="small"
// // //                 color={priorityMuiColor[data.priority] || "default"}
// // //                 sx={{ fontWeight: 600 }}
// // //               />
// // //             </Stack>
// // //             <Stack
// // //               direction="row"
// // //               justifyContent="space-between"
// // //               alignItems="center"
// // //             >
// // //               <Typography variant="body2" color="text.secondary">
// // //                 Growth:
// // //               </Typography>
// // //               <Typography
// // //                 variant="body2"
// // //                 fontWeight="bold"
// // //                 color={
// // //                   (data.growth || "").startsWith("+")
// // //                     ? "success.main"
// // //                     : "error.main"
// // //                 }
// // //               >
// // //                 {data.growth}
// // //               </Typography>
// // //             </Stack>
// // //           </Stack>
// // //         </Paper>
// // //       );
// // //     }
// // //     return null;
// // //   };

// // //   const RoundedVerticalBar = (props) => {
// // //     const { fill, x, y, width, height } = props;
// // //     const radius = 8;
// // //     if (height <= 0) return null;
// // //     return (
// // //       <g>
// // //         <path
// // //           d={`M${x},${y + radius} A${radius},${radius} 0 0 1 ${
// // //             x + radius
// // //           },${y} L${x + width - radius},${y} A${radius},${radius} 0 0 1 ${
// // //             x + width
// // //           },${y + radius} L${x + width},${y + height} L${x},${y + height} Z`}
// // //           fill={fill}
// // //         />
// // //       </g>
// // //     );
// // //   };

// // //   const assistantServices = [
// // //     {
// // //       id: "resume-review",
// // //       title: "AI Resume Review",
// // //       description: "Get detailed feedback & ATS optimization suggestions.",
// // //       icon: <Assessment />,
// // //       color: "primary",
// // //     },
// // //     {
// // //       id: "skill-assessment",
// // //       title: "Skill Gap Analysis",
// // //       description: "Identify critical skill gaps for your target roles.",
// // //       icon: <TrendingUp />,
// // //       color: "success",
// // //     },
// // //     {
// // //       id: "career-roadmap",
// // //       title: "Career Roadmap",
// // //       description: "AI-generated path based on your profile and goals.",
// // //       icon: <Timeline />,
// // //       color: "warning",
// // //     },
// // //     {
// // //       id: "salary-insights",
// // //       title: "Salary Insights",
// // //       description: "Real-time salary benchmarks for roles and locations.",
// // //       icon: <Language />,
// // //       color: "info",
// // //     },
// // //     {
// // //       id: "cultural-prep",
// // //       title: "Cultural Preparation",
// // //       description: "Master workplace culture for different countries.",
// // //       icon: <Psychology />,
// // //       color: "error",
// // //     },
// // //   ];

// // //   const handleServiceClick = async (service) => {
// // //     const defaultRolePayload = ["AI/ML Engineer"];
// // //     switch (service.id) {
// // //       case "resume-review":
// // //         setResumeReviewDialog(true);
// // //         setSelectedResumeRoles(defaultRolePayload);
// // //         await fetchResumeReview(defaultRolePayload);
// // //         break;
// // //       case "mock-interview":
// // //         setMockInterviewDialog(true);
// // //         break;
// // //       case "skill-assessment":
// // //         setSkillGapDialog(true);
// // //         setSelectedSkillGapRoles(defaultRolePayload);
// // //         await fetchSkillGap(defaultRolePayload);
// // //         break;
// // //       case "career-roadmap":
// // //         setCareerRoadmapDialog(true);
// // //         setSelectedRoadmapRoles(defaultRolePayload);
// // //         await fetchCareerRoadmap(defaultRolePayload);
// // //         break;
// // //       case "cultural-prep":
// // //         setCulturalPrepDialog(true);
// // //         if (!culturalPrepData) {
// // //           setCulturalPrepLoading(true);
// // //           try {
// // //             const res = await apiClient.get("/ai/cultural-preparation/");
// // //             const validData = Object.fromEntries(
// // //               Object.entries(res.data.cultural_preparation).filter(
// // //                 ([, value]) => !value.error_message
// // //               )
// // //             );
// // //             setCulturalPrepData(validData);
// // //           } catch (err) {
// // //             showNotification("Failed to load cultural prep data.", "error");
// // //           } finally {
// // //             setCulturalPrepLoading(false);
// // //           }
// // //         }
// // //         break;
// // //       case "salary-insights":
// // //         setSalaryInsightsDialog(true);
// // //         if (!salaryInsightsData) {
// // //           setSalaryInsightsLoading(true);
// // //           try {
// // //             const res = await apiClient.get("/ai/salary-insights/");
// // //             setSalaryInsightsData(res.data.salary_insights);
// // //           } catch (err) {
// // //             showNotification("Failed to load salary insights data.", "error");
// // //           } finally {
// // //             setSalaryInsightsLoading(false);
// // //           }
// // //         }
// // //         break;
// // //       default:
// // //         showNotification(`${service.title} feature coming soon!`, "info");
// // //     }
// // //   };

// // //   const DialogSkeleton = () => (
// // //     <Stack spacing={3} sx={{ p: 2, minHeight: 400 }}>
// // //       <Skeleton variant="rounded" width="60%" height={40} />
// // //       <Skeleton variant="rounded" width="100%" height={100} />
// // //       <Skeleton variant="rounded" width="40%" height={30} />
// // //       <Skeleton variant="rounded" width="100%" height={150} />
// // //     </Stack>
// // //   );

// // //   // Consolidated useEffect for fetching trending skills
// // //   useEffect(() => {
// // //     if (isInitialMount.current) {
// // //       isInitialMount.current = false;
// // //       // Initial load without debounce
// // //       const initialLoad = async () => {
// // //         await fetchTrendingSkills(selectedTrendingRoles);
// // //         setPageLoading(false);
// // //       };
// // //       initialLoad();
// // //     } else {
// // //       // Debounced fetch for subsequent updates
// // //       const handler = setTimeout(() => {
// // //         fetchTrendingSkills(selectedTrendingRoles);
// // //       }, 500);

// // //       return () => {
// // //         clearTimeout(handler);
// // //       };
// // //     }
// // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // //   }, [selectedTrendingRoles]);

// // //   if (pageLoading) {
// // //     return <PageSkeleton />;
// // //   }

// // //   return (
// // //     <Layout title="AI Career Assistant">
// // //       <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// // //         <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
// // //           <Stack spacing={4}>
// // //             {/* ROW 1: Header Banner */}
// // //             <Paper
// // //               sx={{
// // //                 bgcolor: "mint.main",
// // //                 borderRadius: 3,
// // //                 p: { xs: 2, sm: 3 },
// // //               }}
// // //             >
// // //               <Stack direction="row" alignItems="center" spacing={2}>
// // //                 <Avatar
// // //                   sx={{
// // //                     bgcolor: "primary.main",
// // //                     color: "primary.contrastText",
// // //                     width: { xs: 50, sm: 64 },
// // //                     height: { xs: 50, sm: 64 },
// // //                   }}
// // //                 >
// // //                   <Psychology sx={{ fontSize: { xs: 28, sm: 36 } }} />
// // //                 </Avatar>
// // //                 <Box>
// // //                   <Typography
// // //                     variant="h4"
// // //                     component="h1"
// // //                     fontWeight="bold"
// // //                     sx={{ typography: { xs: "h5", sm: "h4" } }}
// // //                   >
// // //                     AI Career Assistant
// // //                     <AutoAwesome
// // //                       sx={{
// // //                         fontSize: { xs: 22, sm: 28 },
// // //                         ml: 1,
// // //                         verticalAlign: "middle",
// // //                         color: "primary.main",
// // //                       }}
// // //                     />
// // //                   </Typography>
// // //                   <Typography variant="body1" color="text.secondary">
// // //                     Your intelligent, multilingual guide to global careers.
// // //                   </Typography>
// // //                 </Box>
// // //               </Stack>
// // //             </Paper>

// // //             {/* ROW 2: Welcome Alert */}
// // //             {showWelcomeCard && (
// // //               <Alert
// // //                 severity="info"
// // //                 variant="filled"
// // //                 onClose={() => setShowWelcomeCard(false)}
// // //                 action={
// // //                   <Button
// // //                     color="inherit"
// // //                     size="small"
// // //                     onClick={() => {
// // //                       handleServiceClick(assistantServices[0]);
// // //                       setShowWelcomeCard(false);
// // //                     }}
// // //                   >
// // //                     Start Review
// // //                   </Button>
// // //                 }
// // //                 sx={{
// // //                   bgcolor: "primary.dark",
// // //                   color: "primary.contrastText",
// // //                   borderRadius: 2,
// // //                 }}
// // //               >
// // //                 <AlertTitle sx={{ fontWeight: "bold" }}>Welcome!</AlertTitle>
// // //                 New here? Start with an AI Resume Review to get personalized
// // //                 feedback and unlock other insights.
// // //               </Alert>
// // //             )}

// // //             {/* ROW 3: Services List */}
// // //             <Paper
// // //               sx={{
// // //                 p: { xs: 2, sm: 3 },
// // //                 borderRadius: 3,
// // //                 bgcolor: "mint.main",
// // //               }}
// // //             >
// // //               <Stack direction="row" alignItems="center" spacing={1} mb={3}>
// // //                 <Typography variant="h5" component="h2" fontWeight={600}>
// // //                   AI-Powered Career Services
// // //                 </Typography>
// // //                 <RocketLaunch color="primary" />
// // //               </Stack>
// // //               <Stack spacing={2}>
// // //                 {assistantServices.map((service) => (
// // //                   <ServiceListItem
// // //                     key={service.id}
// // //                     color={service.color}
// // //                     onClick={() => handleServiceClick(service)}
// // //                   >
// // //                     <Avatar sx={{ width: 48, height: 48 }}>
// // //                       {service.icon}
// // //                     </Avatar>
// // //                     <Box flexGrow={1}>
// // //                       <Typography
// // //                         variant="h6"
// // //                         component="div"
// // //                         fontWeight="bold"
// // //                       >
// // //                         {service.title}
// // //                       </Typography>
// // //                       <Typography variant="body2" color="text.secondary">
// // //                         {service.description}
// // //                       </Typography>
// // //                     </Box>
// // //                     <IconButton sx={{ ml: 2 }}>
// // //                       <ArrowForward />
// // //                     </IconButton>
// // //                   </ServiceListItem>
// // //                 ))}
// // //               </Stack>
// // //             </Paper>

// // //             {/* ROW 4: Trending Skills */}
// // //             <Paper
// // //               sx={{
// // //                 p: { xs: 2, sm: 3 },
// // //                 borderRadius: 3,
// // //                 bgcolor: "mint.main",
// // //               }}
// // //             >
// // //               <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
// // //                 <Lightbulb color="primary" />
// // //                 <Typography variant="h6" fontWeight={600}>
// // //                   Top In-Demand Skills
// // //                 </Typography>
// // //               </Stack>
// // //               <RoleSelector
// // //                 selectedRoles={selectedTrendingRoles}
// // //                 handleRoleChange={handleTrendingRoleChange}
// // //               />
// // //               {skillsLoading ? (
// // //                 <ChartSkeleton />
// // //               ) : Object.keys(trendingSkillsData).length > 0 ? (
// // //                 <Box>
// // //                   <Tabs
// // //                     value={activeTrendingTab}
// // //                     onChange={(e, val) => setActiveTrendingTab(val)}
// // //                     variant="scrollable"
// // //                     scrollButtons="auto"
// // //                   >
// // //                     {Object.keys(trendingSkillsData).map((role) => (
// // //                       <Tab label={role} key={role} />
// // //                     ))}
// // //                   </Tabs>
// // //                   {Object.entries(trendingSkillsData).map(
// // //                     ([role, skills], index) => {
// // //                       const sortedSkills = [...skills].sort(
// // //                         (a, b) => b.demand - a.demand
// // //                       );
// // //                       const priorityColors = {
// // //                         High: theme.palette.primary.main,
// // //                         Medium: theme.palette.info.main,
// // //                       };

// // //                       return (
// // //                         <TabPanel
// // //                           value={activeTrendingTab}
// // //                           index={index}
// // //                           key={role}
// // //                         >
// // //                           <Paper
// // //                             elevation={0}
// // //                             sx={{
// // //                               bgcolor: "background.paper",
// // //                               borderRadius: 2,
// // //                               p: { xs: 1, sm: 2 },
// // //                             }}
// // //                           >
// // //                             <Box
// // //                               sx={{
// // //                                 height: { xs: 400, md: 500 },
// // //                                 width: "100%",
// // //                               }}
// // //                             >
// // //                               <ResponsiveContainer width="100%" height="100%">
// // //                                 <BarChart
// // //                                   data={sortedSkills}
// // //                                   margin={{
// // //                                     top: 30,
// // //                                     right: 30,
// // //                                     left: 20,
// // //                                     bottom: 120,
// // //                                   }}
// // //                                 >
// // //                                   <CartesianGrid
// // //                                     vertical={false}
// // //                                     stroke={theme.palette.divider}
// // //                                     strokeDasharray="3 3"
// // //                                   />
// // //                                   <XAxis
// // //                                     dataKey="skill"
// // //                                     type="category"
// // //                                     interval={0}
// // //                                     angle={-45}
// // //                                     textAnchor="end"
// // //                                     tick={{
// // //                                       fill: theme.palette.text.secondary,
// // //                                       fontSize: 12,
// // //                                     }}
// // //                                     stroke={"transparent"}
// // //                                   />
// // //                                   <YAxis
// // //                                     type="number"
// // //                                     domain={[0, "dataMax + 15"]}
// // //                                     allowDecimals={false}
// // //                                     tickFormatter={(tick) => `${tick}%`}
// // //                                     stroke={theme.palette.divider}
// // //                                     tick={{
// // //                                       fill: theme.palette.text.secondary,
// // //                                     }}
// // //                                   />
// // //                                   <Tooltip
// // //                                     content={<CustomTooltip />}
// // //                                     cursor={{
// // //                                       fill: alpha(
// // //                                         theme.palette.primary.main,
// // //                                         0.1
// // //                                       ),
// // //                                     }}
// // //                                   />
// // //                                   <Bar
// // //                                     dataKey="demand"
// // //                                     shape={<RoundedVerticalBar />}
// // //                                     animationDuration={800}
// // //                                   >
// // //                                     {sortedSkills.map((entry, idx) => (
// // //                                       <Cell
// // //                                         key={`cell-${idx}`}
// // //                                         fill={
// // //                                           priorityColors[entry.priority] ||
// // //                                           theme.palette.text.disabled
// // //                                         }
// // //                                       />
// // //                                     ))}
// // //                                     <LabelList
// // //                                       dataKey="demand"
// // //                                       position="top"
// // //                                       offset={8}
// // //                                       style={{
// // //                                         fill: theme.palette.text.primary,
// // //                                         fontSize: "12px",
// // //                                         fontWeight: "bold",
// // //                                       }}
// // //                                       formatter={(value) => `${value}%`}
// // //                                     />
// // //                                   </Bar>
// // //                                 </BarChart>
// // //                               </ResponsiveContainer>
// // //                             </Box>
// // //                           </Paper>
// // //                         </TabPanel>
// // //                       );
// // //                     }
// // //                   )}
// // //                 </Box>
// // //               ) : (
// // //                 <Box
// // //                   sx={{
// // //                     display: "flex",
// // //                     flexDirection: "column",
// // //                     alignItems: "center",
// // //                     justifyContent: "center",
// // //                     textAlign: "center",
// // //                     py: 8,
// // //                     minHeight: 400,
// // //                   }}
// // //                 >
// // //                   <Insights
// // //                     sx={{ fontSize: 60, color: "text.disabled", mb: 2 }}
// // //                   />
// // //                   <Typography variant="h6" color="text.secondary">
// // //                     Select a role to view in-demand skills
// // //                   </Typography>
// // //                   <Typography variant="body2" color="text.disabled">
// // //                     The chart will update automatically as you make selections.
// // //                   </Typography>
// // //                 </Box>
// // //               )}
// // //             </Paper>
// // //           </Stack>
// // //         </Container>
// // //       </Box>

// // //       {/* --- DIALOGS (UI ENHANCEMENTS APPLIED) --- */}
// // //       <Dialog
// // //         open={resumeReviewDialog}
// // //         onClose={() => setResumeReviewDialog(false)}
// // //         maxWidth="lg"
// // //         fullWidth
// // //       >
// // //         <DialogTitle
// // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // //         >
// // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // //             <Assessment />
// // //             <Typography variant="h6">AI Resume Review</Typography>
// // //           </Stack>
// // //         </DialogTitle>
// // //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// // //           <RoleSelector
// // //             selectedRoles={selectedResumeRoles}
// // //             handleRoleChange={(e) =>
// // //               setSelectedResumeRoles((prev) =>
// // //                 e.target.checked
// // //                   ? [...prev, e.target.name]
// // //                   : prev.filter((r) => r !== e.target.name)
// // //               )
// // //             }
// // //           />
// // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // //             <Button
// // //               variant="contained"
// // //               onClick={() => fetchResumeReview(selectedResumeRoles)}
// // //             >
// // //               Generate Report
// // //             </Button>
// // //           </Box>
// // //           <Divider sx={{ mb: 2 }} />
// // //           {resumeReviewLoading ? (
// // //             <DialogSkeleton />
// // //           ) : (
// // //             resumeReviewData && (
// // //               <>
// // //                 <Tabs
// // //                   value={activeResumeTab}
// // //                   onChange={(e, val) => setActiveResumeTab(val)}
// // //                   centered
// // //                   variant="scrollable"
// // //                   scrollButtons="auto"
// // //                 >
// // //                   {Object.keys(resumeReviewData).map((role) => (
// // //                     <Tab key={role} label={role} />
// // //                   ))}
// // //                 </Tabs>
// // //                 {Object.entries(resumeReviewData).map(([role, data], index) => (
// // //                   <TabPanel value={activeResumeTab} index={index} key={role}>
// // //                     <Grid container spacing={3}>
// // //                       <Grid item xs={12} md={6}>
// // //                         <Paper
// // //                           variant="outlined"
// // //                           sx={{ p: 2.5, height: "100%", borderRadius: 2 }}
// // //                         >
// // //                           <Box
// // //                             sx={{
// // //                               p: 2,
// // //                               mb: 2,
// // //                               borderRadius: 1.5,
// // //                               background: (theme) =>
// // //                                 `linear-gradient(135deg, ${alpha(
// // //                                   theme.palette.error.light,
// // //                                   0.2
// // //                                 )}, ${alpha(theme.palette.error.dark, 0.2)})`,
// // //                             }}
// // //                           >
// // //                             <Typography variant="h6" fontWeight="500">
// // //                               ATS Compatibility
// // //                             </Typography>
// // //                             <Typography
// // //                               variant="h3"
// // //                               fontWeight="bold"
// // //                               color="error.dark"
// // //                             >
// // //                               {data.ATS_Compatibility.score}
// // //                               <Typography
// // //                                 component="span"
// // //                                 variant="h5"
// // //                                 color="text.secondary"
// // //                               >
// // //                                 /100
// // //                               </Typography>
// // //                             </Typography>
// // //                             <LinearProgress
// // //                               variant="determinate"
// // //                               value={data.ATS_Compatibility.score}
// // //                               color="error"
// // //                               sx={{ height: 6, borderRadius: 3 }}
// // //                             />
// // //                           </Box>
// // //                           <Typography variant="subtitle1" fontWeight="bold">
// // //                             Top Issues:
// // //                           </Typography>
// // //                           <List dense>
// // //                             {data.ATS_Compatibility.top_issues.map(
// // //                               (issue, i) => (
// // //                                 <ListItem key={i} sx={{ py: 0 }}>
// // //                                   <ListItemIcon sx={{ minWidth: 32 }}>
// // //                                     <ErrorOutline
// // //                                       fontSize="small"
// // //                                       color="error"
// // //                                     />
// // //                                   </ListItemIcon>
// // //                                   <ListItemText primary={issue} />
// // //                                 </ListItem>
// // //                               )
// // //                             )}
// // //                           </List>
// // //                         </Paper>
// // //                       </Grid>
// // //                       <Grid item xs={12} md={6}>
// // //                         <Paper
// // //                           variant="outlined"
// // //                           sx={{ p: 2.5, height: "100%", borderRadius: 2 }}
// // //                         >
// // //                           <Box
// // //                             sx={{
// // //                               p: 2,
// // //                               mb: 2,
// // //                               borderRadius: 1.5,
// // //                               background: (theme) =>
// // //                                 `linear-gradient(135deg, ${alpha(
// // //                                   theme.palette.success.light,
// // //                                   0.2
// // //                                 )}, ${alpha(theme.palette.success.dark, 0.2)})`,
// // //                             }}
// // //                           >
// // //                             <Typography variant="h6" fontWeight="500">
// // //                               Content & Format Quality
// // //                             </Typography>
// // //                             <Typography
// // //                               variant="body2"
// // //                               paragraph
// // //                               color="text.secondary"
// // //                             >
// // //                               {data.Content_Quality_Analysis.summary}
// // //                             </Typography>
// // //                           </Box>
// // //                           <Typography variant="subtitle1" fontWeight="bold">
// // //                             Top Strengths:
// // //                           </Typography>
// // //                           <List dense>
// // //                             {data.Content_Quality_Analysis.top_strengths.map(
// // //                               (strength, i) => (
// // //                                 <ListItem key={i} sx={{ py: 0 }}>
// // //                                   <ListItemIcon sx={{ minWidth: 32 }}>
// // //                                     <CheckCircle
// // //                                       fontSize="small"
// // //                                       color="success"
// // //                                     />
// // //                                   </ListItemIcon>
// // //                                   <ListItemText primary={strength} />
// // //                                 </ListItem>
// // //                               )
// // //                             )}
// // //                           </List>
// // //                         </Paper>
// // //                       </Grid>
// // //                       <Grid item xs={12}>
// // //                         <Paper
// // //                           variant="outlined"
// // //                           sx={{ p: 2.5, borderRadius: 2 }}
// // //                         >
// // //                           <Typography variant="h6" gutterBottom>
// // //                             Keyword & Section Optimization
// // //                           </Typography>
// // //                           <Stack
// // //                             direction={{ xs: "column", sm: "row" }}
// // //                             spacing={3}
// // //                             divider={
// // //                               <Divider orientation="vertical" flexItem />
// // //                             }
// // //                           >
// // //                             <Box flex={1}>
// // //                               <Typography variant="subtitle1" fontWeight="bold">
// // //                                 Missing Keywords
// // //                               </Typography>
// // //                               <Box
// // //                                 sx={{
// // //                                   display: "flex",
// // //                                   flexWrap: "wrap",
// // //                                   gap: 1,
// // //                                   mt: 1,
// // //                                 }}
// // //                               >
// // //                                 {data.Keyword_Optimization.missing_keywords.map(
// // //                                   (kw, i) => (
// // //                                     <Chip
// // //                                       key={i}
// // //                                       label={kw}
// // //                                       color="info"
// // //                                       size="small"
// // //                                     />
// // //                                   )
// // //                                 )}
// // //                               </Box>
// // //                             </Box>
// // //                             <Box flex={1}>
// // //                               <Typography variant="subtitle1" fontWeight="bold">
// // //                                 Missing Sections
// // //                               </Typography>
// // //                               <Box
// // //                                 sx={{
// // //                                   display: "flex",
// // //                                   flexWrap: "wrap",
// // //                                   gap: 1,
// // //                                   mt: 1,
// // //                                 }}
// // //                               >
// // //                                 {data.Format_and_Structure_Review.missing_sections.map(
// // //                                   (sec, i) => (
// // //                                     <Chip
// // //                                       key={i}
// // //                                       label={sec}
// // //                                       color="warning"
// // //                                       size="small"
// // //                                     />
// // //                                   )
// // //                                 )}
// // //                               </Box>
// // //                             </Box>
// // //                           </Stack>
// // //                         </Paper>
// // //                       </Grid>
// // //                     </Grid>
// // //                   </TabPanel>
// // //                 ))}
// // //               </>
// // //             )
// // //           )}
// // //         </DialogContent>
// // //         <DialogActions>
// // //           <Button onClick={() => setResumeReviewDialog(false)}>Close</Button>
// // //         </DialogActions>
// // //       </Dialog>
// // //       <Dialog
// // //         open={skillGapDialog}
// // //         onClose={() => setSkillGapDialog(false)}
// // //         maxWidth="lg"
// // //         fullWidth
// // //       >
// // //         <DialogTitle
// // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // //         >
// // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // //             <TrendingUp />
// // //             <Typography variant="h6">AI Skill Gap Analysis</Typography>
// // //           </Stack>
// // //         </DialogTitle>
// // //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// // //           <RoleSelector
// // //             selectedRoles={selectedSkillGapRoles}
// // //             handleRoleChange={(e) =>
// // //               setSelectedSkillGapRoles((prev) =>
// // //                 e.target.checked
// // //                   ? [...prev, e.target.name]
// // //                   : prev.filter((r) => r !== e.target.name)
// // //               )
// // //             }
// // //           />
// // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // //             <Button
// // //               variant="contained"
// // //               color="primary"
// // //               onClick={() => fetchSkillGap(selectedSkillGapRoles)}
// // //             >
// // //               Generate Analysis
// // //             </Button>
// // //           </Box>
// // //           <Divider sx={{ mb: 2 }} />
// // //           {skillGapLoading ? (
// // //             <DialogSkeleton />
// // //           ) : (
// // //             skillGapData && (
// // //               <>
// // //                 <Tabs
// // //                   value={activeSkillGapTab}
// // //                   onChange={(e, val) => setActiveSkillGapTab(val)}
// // //                   centered
// // //                   variant="scrollable"
// // //                   scrollButtons="auto"
// // //                 >
// // //                   {Object.keys(skillGapData).map((role) => (
// // //                     <Tab key={role} label={role} />
// // //                   ))}
// // //                 </Tabs>
// // //                 {Object.entries(skillGapData).map(([role, data], index) => (
// // //                   <TabPanel value={activeSkillGapTab} index={index} key={role}>
// // //                     <Grid container spacing={2}>
// // //                       <Grid item xs={12} md={6}>
// // //                         <Paper
// // //                           variant="outlined"
// // //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// // //                         >
// // //                           <Stack
// // //                             direction="row"
// // //                             spacing={1.5}
// // //                             alignItems="center"
// // //                             mb={1.5}
// // //                           >
// // //                             <Avatar sx={{ bgcolor: "primary.light" }}>
// // //                               <Person />
// // //                             </Avatar>
// // //                             <Typography variant="h6">Your Skills</Typography>
// // //                           </Stack>
// // //                           <Box
// // //                             sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
// // //                           >
// // //                             {data.Current_Skill_Mapping.map((skill, i) => (
// // //                               <Chip key={i} label={skill} variant="outlined" />
// // //                             ))}
// // //                           </Box>
// // //                         </Paper>
// // //                       </Grid>
// // //                       <Grid item xs={12} md={6}>
// // //                         <Paper
// // //                           variant="outlined"
// // //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// // //                         >
// // //                           <Stack
// // //                             direction="row"
// // //                             spacing={1.5}
// // //                             alignItems="center"
// // //                             mb={1.5}
// // //                           >
// // //                             <Avatar sx={{ bgcolor: "secondary.light" }}>
// // //                               <TrendingUp />
// // //                             </Avatar>
// // //                             <Typography variant="h6">
// // //                               In-Demand Market Skills
// // //                             </Typography>
// // //                           </Stack>
// // //                           <Box
// // //                             sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
// // //                           >
// // //                             {data.Market_Demand_Analysis.map((skill, i) => (
// // //                               <Chip key={i} label={skill} color="primary" />
// // //                             ))}
// // //                           </Box>
// // //                         </Paper>
// // //                       </Grid>
// // //                       <Grid item xs={12} md={6}>
// // //                         <Paper
// // //                           variant="outlined"
// // //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// // //                         >
// // //                           <Stack
// // //                             direction="row"
// // //                             spacing={1.5}
// // //                             alignItems="center"
// // //                             mb={1.5}
// // //                           >
// // //                             <Avatar sx={{ bgcolor: "info.light" }}>
// // //                               <School />
// // //                             </Avatar>
// // //                             <Typography variant="h6">
// // //                               Recommended Learning Path
// // //                             </Typography>
// // //                           </Stack>
// // //                           <List dense>
// // //                             {data.Learning_Path.map((path, i) => (
// // //                               <ListItem key={i} sx={{ py: 0.5 }}>
// // //                                 <ListItemIcon sx={{ minWidth: 36 }}>
// // //                                   <ArrowForward fontSize="small" color="info" />
// // //                                 </ListItemIcon>
// // //                                 <ListItemText primary={path} />
// // //                               </ListItem>
// // //                             ))}
// // //                           </List>
// // //                         </Paper>
// // //                       </Grid>
// // //                       <Grid item xs={12} md={6}>
// // //                         <Paper
// // //                           variant="outlined"
// // //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// // //                         >
// // //                           <Stack
// // //                             direction="row"
// // //                             spacing={1.5}
// // //                             alignItems="center"
// // //                             mb={1.5}
// // //                           >
// // //                             <Avatar sx={{ bgcolor: "success.light" }}>
// // //                               <MilitaryTech />
// // //                             </Avatar>
// // //                             <Typography variant="h6">
// // //                               Suggested Certifications
// // //                             </Typography>
// // //                           </Stack>
// // //                           <List dense>
// // //                             {data.Certification_Guidance.map((cert, i) => (
// // //                               <ListItem key={i} sx={{ py: 0.5 }}>
// // //                                 <ListItemIcon sx={{ minWidth: 36 }}>
// // //                                   <CheckCircle
// // //                                     fontSize="small"
// // //                                     color="success"
// // //                                   />
// // //                                 </ListItemIcon>
// // //                                 <ListItemText primary={cert} />
// // //                               </ListItem>
// // //                             ))}
// // //                           </List>
// // //                         </Paper>
// // //                       </Grid>
// // //                     </Grid>
// // //                   </TabPanel>
// // //                 ))}
// // //               </>
// // //             )
// // //           )}
// // //         </DialogContent>
// // //         <DialogActions>
// // //           <Button onClick={() => setSkillGapDialog(false)}>Close</Button>
// // //         </DialogActions>
// // //       </Dialog>
// // //       <Dialog
// // //         open={careerRoadmapDialog}
// // //         onClose={() => setCareerRoadmapDialog(false)}
// // //         maxWidth="lg"
// // //         fullWidth
// // //       >
// // //         <DialogTitle
// // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // //         >
// // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // //             <Timeline />
// // //             <Typography variant="h6">Personalized Career Roadmap</Typography>
// // //           </Stack>
// // //         </DialogTitle>
// // //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// // //           <RoleSelector
// // //             selectedRoles={selectedRoadmapRoles}
// // //             handleRoleChange={(e) =>
// // //               setSelectedRoadmapRoles((prev) =>
// // //                 e.target.checked
// // //                   ? [...prev, e.target.name]
// // //                   : prev.filter((r) => r !== e.target.name)
// // //               )
// // //             }
// // //           />
// // //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// // //             <Button
// // //               variant="contained"
// // //               color="primary"
// // //               onClick={() => fetchCareerRoadmap(selectedRoadmapRoles)}
// // //             >
// // //               Generate Roadmap
// // //             </Button>
// // //           </Box>
// // //           <Divider sx={{ mb: 2 }} />
// // //           {careerRoadmapLoading ? (
// // //             <DialogSkeleton />
// // //           ) : (
// // //             careerRoadmapData && (
// // //               <>
// // //                 <Tabs
// // //                   value={activeRoadmapTab}
// // //                   onChange={(e, val) => setActiveRoadmapTab(val)}
// // //                   centered
// // //                   variant="scrollable"
// // //                   scrollButtons="auto"
// // //                 >
// // //                   {Object.keys(careerRoadmapData).map((role) => (
// // //                     <Tab key={role} label={role} />
// // //                   ))}
// // //                 </Tabs>
// // //                 {Object.entries(careerRoadmapData).map(
// // //                   ([role, data], index) => (
// // //                     <TabPanel value={activeRoadmapTab} index={index} key={role}>
// // //                       <Typography variant="h5" gutterBottom align="center">
// // //                         Your AI-Generated Path to <strong>{role}</strong>
// // //                       </Typography>
// // //                       <Typography
// // //                         variant="body1"
// // //                         paragraph
// // //                         color="text.secondary"
// // //                         align="center"
// // //                       >
// // //                         Based on your current role:{" "}
// // //                         <strong>{data?.Current_Position || "N/A"}</strong> with{" "}
// // //                         <strong>{data?.Experience_Years || "N/A"}</strong> years
// // //                         of experience.
// // //                       </Typography>
// // //                       <Grid container spacing={2} sx={{ mt: 1 }}>
// // //                         <Grid item xs={12} md={6}>
// // //                           <Paper
// // //                             variant="outlined"
// // //                             sx={{
// // //                               p: 2.5,
// // //                               height: "100%",
// // //                               borderRadius: 2,
// // //                             }}
// // //                           >
// // //                             <Stack
// // //                               direction="row"
// // //                               spacing={2}
// // //                               alignItems="center"
// // //                             >
// // //                               <Avatar
// // //                                 sx={{
// // //                                   bgcolor: "primary.light",
// // //                                   width: 56,
// // //                                   height: 56,
// // //                                 }}
// // //                               >
// // //                                 <RocketLaunch />
// // //                               </Avatar>
// // //                               <Box>
// // //                                 <Typography
// // //                                   variant="overline"
// // //                                   color="primary.main"
// // //                                 >
// // //                                   Next Milestone
// // //                                 </Typography>
// // //                                 <Typography variant="h6" fontWeight="bold">
// // //                                   {data?.Next_Milestone?.title ||
// // //                                     "Not available"}
// // //                                 </Typography>
// // //                                 <Chip
// // //                                   size="small"
// // //                                   label={`Company: ${
// // //                                     data?.Next_Milestone?.company_type || "N/A"
// // //                                   }`}
// // //                                   sx={{ mt: 1 }}
// // //                                 />
// // //                               </Box>
// // //                             </Stack>
// // //                           </Paper>
// // //                         </Grid>
// // //                         <Grid item xs={12} md={6}>
// // //                           <Paper
// // //                             variant="outlined"
// // //                             sx={{
// // //                               p: 2.5,
// // //                               height: "100%",
// // //                               borderRadius: 2,
// // //                             }}
// // //                           >
// // //                             <Stack
// // //                               direction="row"
// // //                               spacing={2}
// // //                               alignItems="center"
// // //                             >
// // //                               <Avatar
// // //                                 sx={{
// // //                                   bgcolor: "success.light",
// // //                                   width: 56,
// // //                                   height: 56,
// // //                                 }}
// // //                               >
// // //                                 <Stars />
// // //                               </Avatar>
// // //                               <Box>
// // //                                 <Typography
// // //                                   variant="overline"
// // //                                   color="success.main"
// // //                                 >
// // //                                   Long-term Goal
// // //                                 </Typography>
// // //                                 <Typography variant="h6" fontWeight="bold">
// // //                                   {data?.Long_Term_Goal?.title ||
// // //                                     "Not available"}
// // //                                 </Typography>
// // //                                 <Chip
// // //                                   size="small"
// // //                                   label={`Company: ${
// // //                                     data?.Long_Term_Goal?.company_type || "N/A"
// // //                                   }`}
// // //                                   sx={{ mt: 1 }}
// // //                                 />
// // //                               </Box>
// // //                             </Stack>
// // //                           </Paper>
// // //                         </Grid>
// // //                       </Grid>
// // //                       <Divider sx={{ my: 3 }}>
// // //                         <Chip label="Recommended Actions" color="primary" />
// // //                       </Divider>
// // //                       <List>
// // //                         {data?.Recommended_Actions?.map((item, i) => (
// // //                           <ListItem key={i} alignItems="flex-start">
// // //                             <ListItemIcon>
// // //                               <Work color="primary" />
// // //                             </ListItemIcon>
// // //                             <ListItemText
// // //                               primary={item.action}
// // //                               secondary={item.reason}
// // //                             />
// // //                           </ListItem>
// // //                         )) || (
// // //                           <ListItem>
// // //                             <ListItemText primary="No actions recommended." />
// // //                           </ListItem>
// // //                         )}
// // //                       </List>
// // //                     </TabPanel>
// // //                   )
// // //                 )}
// // //               </>
// // //             )
// // //           )}
// // //         </DialogContent>
// // //         <DialogActions>
// // //           <Button onClick={() => setCareerRoadmapDialog(false)}>Close</Button>
// // //         </DialogActions>
// // //       </Dialog>
// // //       <Dialog
// // //         open={culturalPrepDialog}
// // //         onClose={() => {
// // //           setCulturalPrepDialog(false);
// // //           setCulturalPrepTab(0);
// // //         }}
// // //         maxWidth="md"
// // //         fullWidth
// // //         PaperProps={{ sx: { height: { md: 650 } } }}
// // //       >
// // //         <DialogTitle
// // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // //         >
// // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // //             <Psychology />
// // //             <Typography variant="h6">Cultural Preparation Insights</Typography>
// // //           </Stack>
// // //         </DialogTitle>
// // //         <DialogContent
// // //           dividers
// // //           sx={{
// // //             display: "flex",
// // //             p: 0,
// // //             overflow: "hidden",
// // //             flexDirection: { xs: "column", md: "row" },
// // //           }}
// // //         >
// // //           {culturalPrepLoading ? (
// // //             <DialogSkeleton />
// // //           ) : (
// // //             culturalPrepData && (
// // //               <>
// // //                 <Tabs
// // //                   orientation={
// // //                     theme.breakpoints.up("md") ? "vertical" : "horizontal"
// // //                   }
// // //                   variant="scrollable"
// // //                   value={culturalPrepTab}
// // //                   onChange={(e, val) => setCulturalPrepTab(val)}
// // //                   sx={{
// // //                     borderRight: { md: 1 },
// // //                     borderBottom: { xs: 1, md: 0 },
// // //                     borderColor: "divider",
// // //                     minWidth: { md: 150 },
// // //                   }}
// // //                 >
// // //                   {Object.values(culturalPrepData).map((region, index) => (
// // //                     <Tab key={index} label={region.location_name} />
// // //                   ))}
// // //                 </Tabs>
// // //                 <Box
// // //                   sx={{
// // //                     flex: { md: 1 },
// // //                     overflowY: "auto",
// // //                     p: { xs: 2, md: 3 },
// // //                     bgcolor: "background.default",
// // //                   }}
// // //                 >
// // //                   {Object.values(culturalPrepData).map((region, index) => (
// // //                     <TabPanel value={culturalPrepTab} index={index} key={index}>
// // //                       <Stack spacing={2}>
// // //                         <Paper
// // //                           elevation={0}
// // //                           sx={{
// // //                             p: 2,
// // //                             borderRadius: 2,
// // //                             border: 1,
// // //                             borderColor: "divider",
// // //                           }}
// // //                         >
// // //                           <Stack
// // //                             direction="row"
// // //                             spacing={1}
// // //                             alignItems="center"
// // //                             mb={1}
// // //                           >
// // //                             <Insights color="primary" />
// // //                             <Typography variant="h6">
// // //                               Cultural Insights
// // //                             </Typography>
// // //                           </Stack>
// // //                           <List dense>
// // //                             {region.cultural_insights.map((insight, i) => (
// // //                               <ListItem key={i}>
// // //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// // //                                   <ArrowForward fontSize="small" />
// // //                                 </ListItemIcon>
// // //                                 <ListItemText primary={insight} />
// // //                               </ListItem>
// // //                             ))}
// // //                           </List>
// // //                         </Paper>
// // //                         <Paper
// // //                           elevation={0}
// // //                           sx={{
// // //                             p: 2,
// // //                             borderRadius: 2,
// // //                             border: 1,
// // //                             borderColor: "divider",
// // //                           }}
// // //                         >
// // //                           <Stack
// // //                             direction="row"
// // //                             spacing={1}
// // //                             alignItems="center"
// // //                             mb={1}
// // //                           >
// // //                             <VideoCall color="primary" />
// // //                             <Typography variant="h6">
// // //                               Communication Tips
// // //                             </Typography>
// // //                           </Stack>
// // //                           <List dense>
// // //                             {region.communication_tips.map((tip, i) => (
// // //                               <ListItem key={i}>
// // //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// // //                                   <ArrowForward fontSize="small" />
// // //                                 </ListItemIcon>
// // //                                 <ListItemText primary={tip} />
// // //                               </ListItem>
// // //                             ))}
// // //                           </List>
// // //                         </Paper>
// // //                         <Paper
// // //                           elevation={0}
// // //                           sx={{
// // //                             p: 2,
// // //                             borderRadius: 2,
// // //                             border: 1,
// // //                             borderColor: "divider",
// // //                           }}
// // //                         >
// // //                           <Stack
// // //                             direction="row"
// // //                             spacing={1}
// // //                             alignItems="center"
// // //                             mb={1}
// // //                           >
// // //                             <Work color="primary" />
// // //                             <Typography variant="h6">Work Etiquette</Typography>
// // //                           </Stack>
// // //                           <List dense>
// // //                             {region.work_etiquette.map((tip, i) => (
// // //                               <ListItem key={i}>
// // //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// // //                                   <Stars fontSize="small" />
// // //                                 </ListItemIcon>
// // //                                 <ListItemText primary={tip} />
// // //                               </ListItem>
// // //                             ))}
// // //                           </List>
// // //                         </Paper>
// // //                       </Stack>
// // //                     </TabPanel>
// // //                   ))}
// // //                 </Box>
// // //               </>
// // //             )
// // //           )}
// // //         </DialogContent>
// // //         <DialogActions>
// // //           <Button onClick={() => setCulturalPrepDialog(false)}>Close</Button>
// // //         </DialogActions>
// // //       </Dialog>
// // //       <Dialog
// // //         open={salaryInsightsDialog}
// // //         onClose={() => setSalaryInsightsDialog(false)}
// // //         maxWidth="lg"
// // //         fullWidth
// // //       >
// // //         <DialogTitle
// // //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// // //         >
// // //           <Stack direction="row" alignItems="center" spacing={1.5}>
// // //             <Language />
// // //             <Typography variant="h6">Global Salary Insights</Typography>
// // //           </Stack>
// // //         </DialogTitle>
// // //         <DialogContent dividers sx={{ bgcolor: "background.default" }}>
// // //           {salaryInsightsLoading ? (
// // //             <DialogSkeleton />
// // //           ) : (
// // //             salaryInsightsData && (
// // //               <Stack spacing={3} sx={{ py: 2 }}>
// // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // //                   <Stack
// // //                     direction="row"
// // //                     spacing={1.5}
// // //                     alignItems="center"
// // //                     mb={2}
// // //                   >
// // //                     <LocationOn color="primary" />
// // //                     <Typography variant="h6">
// // //                       Salary Benchmarks by Location
// // //                     </Typography>
// // //                   </Stack>
// // //                   <Box
// // //                     sx={{
// // //                       display: "grid",
// // //                       gridTemplateColumns: {
// // //                         xs: "1fr",
// // //                         sm: "repeat(2, 1fr)",
// // //                         md: "repeat(3, 1fr)",
// // //                       },
// // //                       gap: 2,
// // //                     }}
// // //                   >
// // //                     {salaryInsightsData.location_based.map((loc, i) => (
// // //                       <Card
// // //                         key={i}
// // //                         variant="elevation"
// // //                         elevation={4}
// // //                         sx={{
// // //                           borderRadius: 3,
// // //                           background: (theme) =>
// // //                             `linear-gradient(145deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
// // //                           color: "primary.contrastText",
// // //                           transition: "transform 0.3s ease-in-out",
// // //                           "&:hover": {
// // //                             transform: "translateY(-4px)",
// // //                           },
// // //                         }}
// // //                       >
// // //                         <CardContent
// // //                           sx={{
// // //                             display: "flex",
// // //                             flexDirection: "column",
// // //                             height: "100%",
// // //                             p: 2.5,
// // //                           }}
// // //                         >
// // //                           <Stack
// // //                             direction="row"
// // //                             spacing={1}
// // //                             alignItems="center"
// // //                           >
// // //                             <LocationOn sx={{ opacity: 0.8 }} />
// // //                             <Typography
// // //                               variant="h6"
// // //                               component="div"
// // //                               fontWeight={600}
// // //                             >
// // //                               {loc.city}
// // //                             </Typography>
// // //                           </Stack>

// // //                           <Box
// // //                             sx={{
// // //                               flexGrow: 1,
// // //                               display: "flex",
// // //                               flexDirection: "column",
// // //                               justifyContent: "center",
// // //                               alignItems: "center",
// // //                               my: 2,
// // //                             }}
// // //                           >
// // //                             <Typography variant="caption" sx={{ opacity: 0.8 }}>
// // //                               MEDIAN SALARY
// // //                             </Typography>
// // //                             <Typography variant="h4" fontWeight="bold">
// // //                               {loc.median_salary}
// // //                             </Typography>
// // //                           </Box>

// // //                           <Divider
// // //                             sx={{ bgcolor: "rgba(255,255,255,0.2)", mb: 1.5 }}
// // //                           />

// // //                           <Stack
// // //                             direction="row"
// // //                             justifyContent="space-between"
// // //                             alignItems="center"
// // //                           >
// // //                             <Box textAlign="center">
// // //                               <Typography
// // //                                 variant="caption"
// // //                                 sx={{ opacity: 0.8 }}
// // //                               >
// // //                                 MIN
// // //                               </Typography>
// // //                               <Typography fontWeight="medium">
// // //                                 {loc.min_salary}
// // //                               </Typography>
// // //                             </Box>
// // //                             <Box textAlign="center">
// // //                               <Typography
// // //                                 variant="caption"
// // //                                 sx={{ opacity: 0.8 }}
// // //                               >
// // //                                 MAX
// // //                               </Typography>
// // //                               <Typography fontWeight="medium">
// // //                                 {loc.max_salary}
// // //                               </Typography>
// // //                             </Box>
// // //                           </Stack>
// // //                         </CardContent>
// // //                       </Card>
// // //                     ))}
// // //                   </Box>
// // //                 </Paper>
// // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // //                   <Stack
// // //                     direction="row"
// // //                     spacing={1.5}
// // //                     alignItems="center"
// // //                     mb={1}
// // //                   >
// // //                     <TrendingUp color="primary" />
// // //                     <Typography variant="h6">Location Demand Impact</Typography>
// // //                   </Stack>
// // //                   <List dense>
// // //                     {salaryInsightsData.salary_insights_summary.map(
// // //                       (item, i) => (
// // //                         <ListItem key={i} disableGutters sx={{ px: 1 }}>
// // //                           <Stack
// // //                             direction={{ xs: "column", sm: "row" }}
// // //                             spacing={{ xs: 0.5, sm: 2 }}
// // //                             alignItems="center"
// // //                             sx={{ width: "100%" }}
// // //                           >
// // //                             <ListItemText
// // //                               primary={item.role}
// // //                               sx={{
// // //                                 width: "100%",
// // //                                 m: 0,
// // //                                 flexBasis: { sm: "40%" },
// // //                                 flexShrink: 0,
// // //                               }}
// // //                             />
// // //                             <Box
// // //                               sx={{
// // //                                 width: "100%",
// // //                                 display: "flex",
// // //                                 alignItems: "center",
// // //                               }}
// // //                             >
// // //                               <LinearProgress
// // //                                 variant="determinate"
// // //                                 value={item.demand_in_salary_percent}
// // //                                 color="primary"
// // //                                 sx={{
// // //                                   width: "100%",
// // //                                   mr: 1.5,
// // //                                   height: 8,
// // //                                   borderRadius: 4,
// // //                                 }}
// // //                               />
// // //                               <Typography
// // //                                 variant="body2"
// // //                                 color="text.secondary"
// // //                               >{`${item.demand_in_salary_percent}%`}</Typography>
// // //                             </Box>
// // //                           </Stack>
// // //                         </ListItem>
// // //                       )
// // //                     )}
// // //                   </List>
// // //                 </Paper>
// // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // //                   <Stack
// // //                     direction="row"
// // //                     spacing={1.5}
// // //                     alignItems="center"
// // //                     mb={1}
// // //                   >
// // //                     <MonetizationOn color="success" />
// // //                     <Typography variant="h6">Negotiation Tips</Typography>
// // //                   </Stack>
// // //                   <List dense>
// // //                     {salaryInsightsData.negotiation_tips.map((tip, i) => (
// // //                       <ListItem key={i}>
// // //                         <ListItemIcon sx={{ minWidth: 32 }}>
// // //                           <CheckCircle color="success" fontSize="small" />
// // //                         </ListItemIcon>
// // //                         <ListItemText primary={tip} />
// // //                       </ListItem>
// // //                     ))}
// // //                   </List>
// // //                 </Paper>
// // //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// // //                   <Stack
// // //                     direction="row"
// // //                     spacing={1.5}
// // //                     alignItems="center"
// // //                     mb={1}
// // //                   >
// // //                     <Timeline color="warning" />
// // //                     <Typography variant="h6">Market Trends</Typography>
// // //                   </Stack>
// // //                   <List>
// // //                     {salaryInsightsData.market_trends.map((item, i) => (
// // //                       <ListItem key={i} alignItems="flex-start">
// // //                         <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
// // //                           <TrendingFlat color="warning" />
// // //                         </ListItemIcon>
// // //                         <ListItemText
// // //                           primary={item.trend}
// // //                           secondary={item.insight}
// // //                           primaryTypographyProps={{ fontWeight: 600 }}
// // //                         />
// // //                       </ListItem>
// // //                     ))}
// // //                   </List>
// // //                 </Paper>
// // //               </Stack>
// // //             )
// // //           )}
// // //         </DialogContent>
// // //         <DialogActions>
// // //           <Button onClick={() => setSalaryInsightsDialog(false)}>Close</Button>
// // //         </DialogActions>
// // //       </Dialog>
// // //     </Layout>
// // //   );
// // // };

// // // export default CareerAssistant;
// // import { useState, useEffect, useRef } from "react";
// // import {
// //   Grid,
// //   Card,
// //   CardContent,
// //   Container,
// //   Typography,
// //   Box,
// //   Button,
// //   Paper,
// //   Avatar,
// //   Chip,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   List,
// //   ListItem,
// //   ListItemIcon,
// //   ListItemText,
// //   Divider,
// //   Stack,
// //   LinearProgress,
// //   Skeleton,
// //   alpha,
// //   IconButton,
// //   Tabs,
// //   Tab,
// //   FormGroup,
// //   FormControlLabel,
// //   Checkbox,
// //   Alert,
// //   AlertTitle,
// // } from "@mui/material";
// // import { styled, useTheme } from "@mui/material/styles";
// // import {
// //   Psychology,
// //   TrendingUp,
// //   School,
// //   Work,
// //   Language,
// //   Assessment,
// //   VideoCall,
// //   Lightbulb,
// //   Timeline,
// //   CheckCircle,
// //   ErrorOutline,
// //   ArrowForward,
// //   MilitaryTech,
// //   Stars,
// //   RocketLaunch,
// //   TrendingDown,
// //   TrendingFlat,
// //   LocationOn,
// //   MonetizationOn,
// //   AutoAwesome,
// //   Close as CloseIcon,
// //   Insights,
// //   Person,
// // } from "@mui/icons-material";
// // import {
// //   BarChart,
// //   Bar,
// //   XAxis,
// //   YAxis,
// //   CartesianGrid,
// //   Tooltip,
// //   ResponsiveContainer,
// //   Cell,
// //   LabelList,
// // } from "recharts";
// // import Layout from "../common/Layout";
// // import { useNotification } from "../../context/NotificationContext";
// // import { useNavigate } from "react-router-dom";
// // import apiClient from "../../context/apiClient";

// // // --- Skeleton Components ---

// // const HeaderSkeleton = () => (
// //   <Paper sx={{ bgcolor: "mint.main", borderRadius: 3, p: { xs: 2, sm: 3 } }}>
// //     <Stack direction="row" alignItems="center" spacing={2}>
// //       <Skeleton variant="circular" width={64} height={64} />
// //       <Box sx={{ flex: 1 }}>
// //         <Skeleton variant="text" width="40%" height={48} />
// //         <Skeleton variant="text" width="60%" height={24} />
// //       </Box>
// //     </Stack>
// //   </Paper>
// // );

// // const ServiceListItemSkeleton = () => (
// //   <Paper
// //     sx={{
// //       display: "flex",
// //       flexDirection: "row",
// //       alignItems: "center",
// //       padding: 2,
// //       borderRadius: "12px",
// //       border: (theme) => `1px solid ${theme.palette.divider}`,
// //     }}
// //   >
// //     <Skeleton variant="circular" width={48} height={48} sx={{ mr: 2 }} />
// //     <Box flexGrow={1}>
// //       <Skeleton variant="text" height={30} width="50%" />
// //       <Skeleton variant="text" height={20} width="80%" />
// //     </Box>
// //     <Skeleton variant="circular" width={24} height={24} sx={{ ml: 2 }} />
// //   </Paper>
// // );

// // const ServicesSkeleton = () => (
// //   <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, bgcolor: "mint.main" }}>
// //     <Skeleton variant="text" width="60%" height={40} sx={{ mb: 3 }} />
// //     <Stack spacing={2}>
// //       {[...Array(5)].map((_, index) => (
// //         <ServiceListItemSkeleton key={index} />
// //       ))}
// //     </Stack>
// //   </Paper>
// // );

// // const TrendingSkillsSkeleton = () => (
// //   <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, bgcolor: "mint.main" }}>
// //     <Skeleton variant="text" width="40%" height={40} sx={{ mb: 2 }} />
// //     <Stack
// //       direction="row"
// //       spacing={2}
// //       sx={{ mb: 3, justifyContent: "center", flexWrap: "wrap", gap: 1 }}
// //     >
// //       <Skeleton variant="rounded" width={150} height={42} />
// //       <Skeleton variant="rounded" width={150} height={42} />
// //       <Skeleton variant="rounded" width={150} height={42} />
// //     </Stack>
// //     <Skeleton variant="rounded" width="100%" height={500} />
// //   </Paper>
// // );

// // const PageSkeleton = () => (
// //   <Layout title="AI Career Assistant">
// //     <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// //       <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
// //         <Stack spacing={4}>
// //           <HeaderSkeleton />
// //           <ServicesSkeleton />
// //           <TrendingSkillsSkeleton />
// //         </Stack>
// //       </Container>
// //     </Box>
// //   </Layout>
// // );

// // const ChartSkeleton = () => (
// //   <Box sx={{ height: { xs: 400, md: 500 }, width: "100%", pt: 2 }}>
// //     <Skeleton variant="rounded" width="100%" height="100%" />
// //   </Box>
// // );

// // // --- Helper Components ---

// // const ServiceListItem = styled(Paper)(({ theme, color = "primary" }) => ({
// //   backgroundColor: theme.palette.background.paper,
// //   display: "flex",
// //   flexDirection: "row",
// //   alignItems: "center",
// //   padding: theme.spacing(2),
// //   borderRadius: "12px",
// //   cursor: "pointer",
// //   transition:
// //     "background-color 0.3s ease, border-color 0.3s ease, transform 0.2s ease-in-out",
// //   border: `1px solid ${theme.palette.divider}`,
// //   "&:hover": {
// //     backgroundColor: alpha(
// //       theme.palette[color]?.main || theme.palette.primary.main,
// //       0.08
// //     ),
// //     borderColor: theme.palette[color]?.main || theme.palette.primary.main,
// //     transform: "scale(1.02)",
// //   },
// //   ".MuiAvatar-root": {
// //     backgroundColor: alpha(
// //       theme.palette[color]?.main || theme.palette.primary.main,
// //       0.15
// //     ),
// //     color: theme.palette[color]?.main || theme.palette.primary.main,
// //     marginRight: theme.spacing(2),
// //   },
// // }));

// // function TabPanel(props) {
// //   const { children, value, index, ...other } = props;
// //   return (
// //     <div
// //       role="tabpanel"
// //       hidden={value !== index}
// //       id={`tabpanel-${index}`}
// //       aria-labelledby={`tab-${index}`}
// //       {...other}
// //     >
// //       {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
// //     </div>
// //   );
// // }

// // // --- Main Component ---

// // const CareerAssistant = () => {
// //   const theme = useTheme();
// //   const { showNotification } = useNotification();
// //   const navigate = useNavigate();
// //   const isInitialMount = useRef(true);

// //   const availableRoles = [
// //     "AI/ML Engineer",
// //     "Data Scientist",
// //     "Business Analyst",
// //   ];

// //   // --- State Declarations ---
// //   const [pageLoading, setPageLoading] = useState(true);
// //   const [showWelcomeCard, setShowWelcomeCard] = useState(true);
// //   const [mockInterviewDialog, setMockInterviewDialog] = useState(false);
// //   const [resumeReviewDialog, setResumeReviewDialog] = useState(false);
// //   const [skillGapDialog, setSkillGapDialog] = useState(false);
// //   const [careerRoadmapDialog, setCareerRoadmapDialog] = useState(false);
// //   const [culturalPrepDialog, setCulturalPrepDialog] = useState(false);
// //   const [salaryInsightsDialog, setSalaryInsightsDialog] = useState(false);
// //   const [trendingSkillsData, setTrendingSkillsData] = useState({});
// //   const [skillsLoading, setSkillsLoading] = useState(true);
// //   const [selectedTrendingRoles, setSelectedTrendingRoles] = useState([
// //     "AI/ML Engineer",
// //   ]);
// //   const [activeTrendingTab, setActiveTrendingTab] = useState(0);
// //   const [resumeReviewData, setResumeReviewData] = useState(null);
// //   const [resumeReviewLoading, setResumeReviewLoading] = useState(false);
// //   const [selectedResumeRoles, setSelectedResumeRoles] = useState([]);
// //   const [activeResumeTab, setActiveResumeTab] = useState(0);
// //   const [skillGapData, setSkillGapData] = useState(null);
// //   const [skillGapLoading, setSkillGapLoading] = useState(false);
// //   const [selectedSkillGapRoles, setSelectedSkillGapRoles] = useState([]);
// //   const [activeSkillGapTab, setActiveSkillGapTab] = useState(0);
// //   const [careerRoadmapData, setCareerRoadmapData] = useState(null);
// //   const [careerRoadmapLoading, setCareerRoadmapLoading] = useState(false);
// //   const [selectedRoadmapRoles, setSelectedRoadmapRoles] = useState([]);
// //   const [activeRoadmapTab, setActiveRoadmapTab] = useState(0);
// //   const [culturalPrepData, setCulturalPrepData] = useState(null);
// //   const [culturalPrepLoading, setCulturalPrepLoading] = useState(false);
// //   const [culturalPrepTab, setCulturalPrepTab] = useState(0);
// //   const [salaryInsightsData, setSalaryInsightsData] = useState(null);
// //   const [salaryInsightsLoading, setSalaryInsightsLoading] = useState(false);

// //   // --- Data Fetching Functions ---

// //   const fetchTrendingSkills = async (roles) => {
// //     if (!roles || roles.length === 0) {
// //       setTrendingSkillsData({});
// //       setSkillsLoading(false);
// //       return;
// //     }
// //     setSkillsLoading(true);
// //     try {
// //       const response = await apiClient.post("/trending-skills/", {
// //         selected_roles: roles,
// //       });
// //       const transformedData = {};
// //       for (const [role, skills] of Object.entries(response.data)) {
// //         transformedData[role] = skills.map((skill) => ({
// //           skill: skill.skill,
// //           demand: parseInt(skill.demand) || 0,
// //           growth: skill.increase || "N/A",
// //           priority: skill.priority,
// //         }));
// //       }
// //       setTrendingSkillsData(transformedData);
// //       setActiveTrendingTab(0);
// //     } catch (error) {
// //       console.error("Failed to fetch trending skills:", error);
// //       showNotification("Could not load trending skills data.", "error");
// //       setTrendingSkillsData({});
// //     } finally {
// //       setSkillsLoading(false);
// //     }
// //   };

// //   const fetchResumeReview = async (roles) => {
// //     if (!roles || roles.length === 0) {
// //       setResumeReviewData({});
// //       return;
// //     }
// //     setResumeReviewLoading(true);
// //     try {
// //       const response = await apiClient.post("/resume/review-talent/", {
// //         target_roles: roles,
// //       });
// //       setResumeReviewData(response.data);
// //       setActiveResumeTab(0);
// //     } catch (error) {
// //       showNotification("Failed to load resume review data.", "error");
// //     } finally {
// //       setResumeReviewLoading(false);
// //     }
// //   };
// //   const fetchSkillGap = async (roles) => {
// //     if (!roles || roles.length === 0) {
// //       setSkillGapData({});
// //       return;
// //     }
// //     setSkillGapLoading(true);
// //     try {
// //       const response = await apiClient.post("/resume/skill-gap/", {
// //         selected_roles: roles,
// //       });
// //       setSkillGapData(response.data);
// //       setActiveSkillGapTab(0);
// //     } catch (error) {
// //       showNotification("Failed to load skill gap analysis.", "error");
// //     } finally {
// //       setSkillGapLoading(false);
// //     }
// //   };
// //   const fetchCareerRoadmap = async (roles) => {
// //     if (!roles || roles.length === 0) {
// //       setCareerRoadmapData({});
// //       return;
// //     }
// //     setCareerRoadmapLoading(true);
// //     try {
// //       const response = await apiClient.post("/resume/career-roadmap/", {
// //         target_roles: roles,
// //       });
// //       setCareerRoadmapData(response.data);
// //       setActiveRoadmapTab(0);
// //     } catch (error) {
// //       showNotification("Failed to load career roadmap.", "error");
// //       setCareerRoadmapData({});
// //     } finally {
// //       setCareerRoadmapLoading(false);
// //     }
// //   };

// //   // --- Handlers ---
// //   const handleTrendingRoleChange = (event) => {
// //     const { name, checked } = event.target;
// //     setSelectedTrendingRoles((prev) =>
// //       checked ? [...prev, name] : prev.filter((role) => role !== name)
// //     );
// //   };

// //   // --- Child Components ---
// //   const RoleSelector = ({ selectedRoles, handleRoleChange }) => (
// //     <FormGroup row sx={{ mb: 2, justifyContent: "center", flexWrap: "wrap" }}>
// //       {availableRoles.map((role) => (
// //         <FormControlLabel
// //           key={role}
// //           control={
// //             <Checkbox
// //               checked={selectedRoles.includes(role)}
// //               onChange={handleRoleChange}
// //               name={role}
// //             />
// //           }
// //           label={role}
// //         />
// //       ))}
// //     </FormGroup>
// //   );

// //   const CustomTooltip = ({ active, payload, label }) => {
// //     if (active && payload && payload.length) {
// //       const data = payload[0].payload;
// //       const priorityMuiColor = {
// //         High: "primary",
// //         Medium: "info",
// //       };
// //       return (
// //         <Paper
// //           elevation={3}
// //           sx={{
// //             p: 1.5,
// //             minWidth: 220,
// //             bgcolor: "background.paper",
// //             border: `1px solid ${theme.palette.divider}`,
// //             borderRadius: 2,
// //           }}
// //         >
// //           <Typography variant="body1" fontWeight="bold" gutterBottom>
// //             {label}
// //           </Typography>
// //           <Stack spacing={1}>
// //             <Stack
// //               direction="row"
// //               justifyContent="space-between"
// //               alignItems="center"
// //             >
// //               <Typography variant="body2" color="text.secondary">
// //                 Demand:
// //               </Typography>
// //               <Typography
// //                 variant="body2"
// //                 fontWeight="bold"
// //               >{`${data.demand}%`}</Typography>
// //             </Stack>
// //             <Stack
// //               direction="row"
// //               justifyContent="space-between"
// //               alignItems="center"
// //             >
// //               <Typography variant="body2" color="text.secondary">
// //                 Priority:
// //               </Typography>
// //               <Chip
// //                 label={data.priority}
// //                 size="small"
// //                 color={priorityMuiColor[data.priority] || "default"}
// //                 sx={{ fontWeight: 600 }}
// //               />
// //             </Stack>
// //             <Stack
// //               direction="row"
// //               justifyContent="space-between"
// //               alignItems="center"
// //             >
// //               <Typography variant="body2" color="text.secondary">
// //                 Growth:
// //               </Typography>
// //               <Typography
// //                 variant="body2"
// //                 fontWeight="bold"
// //                 color={
// //                   (data.growth || "").startsWith("+")
// //                     ? "success.main"
// //                     : "error.main"
// //                 }
// //               >
// //                 {data.growth}
// //               </Typography>
// //             </Stack>
// //           </Stack>
// //         </Paper>
// //       );
// //     }
// //     return null;
// //   };

// //   const RoundedVerticalBar = (props) => {
// //     const { fill, x, y, width, height } = props;
// //     const radius = 8;
// //     if (height <= 0) return null;
// //     return (
// //       <g>
// //         <path
// //           d={`M${x},${y + radius} A${radius},${radius} 0 0 1 ${
// //             x + radius
// //           },${y} L${x + width - radius},${y} A${radius},${radius} 0 0 1 ${
// //             x + width
// //           },${y + radius} L${x + width},${y + height} L${x},${y + height} Z`}
// //           fill={fill}
// //         />
// //       </g>
// //     );
// //   };

// //   const assistantServices = [
// //     {
// //       id: "resume-review",
// //       title: "AI Resume Review",
// //       description: "Get detailed feedback & ATS optimization suggestions.",
// //       icon: <Assessment />,
// //       color: "primary",
// //     },
// //     {
// //       id: "skill-assessment",
// //       title: "Skill Gap Analysis",
// //       description: "Identify critical skill gaps for your target roles.",
// //       icon: <TrendingUp />,
// //       color: "success",
// //     },
// //     {
// //       id: "career-roadmap",
// //       title: "Career Roadmap",
// //       description: "AI-generated path based on your profile and goals.",
// //       icon: <Timeline />,
// //       color: "warning",
// //     },
// //     {
// //       id: "salary-insights",
// //       title: "Salary Insights",
// //       description: "Real-time salary benchmarks for roles and locations.",
// //       icon: <Language />,
// //       color: "info",
// //     },
// //     {
// //       id: "cultural-prep",
// //       title: "Cultural Preparation",
// //       description: "Master workplace culture for different countries.",
// //       icon: <Psychology />,
// //       color: "error",
// //     },
// //   ];

// //   const handleServiceClick = async (service) => {
// //     const defaultRolePayload = ["AI/ML Engineer"];
// //     switch (service.id) {
// //       case "resume-review":
// //         setResumeReviewDialog(true);
// //         setSelectedResumeRoles(defaultRolePayload);
// //         await fetchResumeReview(defaultRolePayload);
// //         break;
// //       case "mock-interview":
// //         setMockInterviewDialog(true);
// //         break;
// //       case "skill-assessment":
// //         setSkillGapDialog(true);
// //         setSelectedSkillGapRoles(defaultRolePayload);
// //         await fetchSkillGap(defaultRolePayload);
// //         break;
// //       case "career-roadmap":
// //         setCareerRoadmapDialog(true);
// //         setSelectedRoadmapRoles(defaultRolePayload);
// //         await fetchCareerRoadmap(defaultRolePayload);
// //         break;
// //       case "cultural-prep":
// //         setCulturalPrepDialog(true);
// //         if (!culturalPrepData) {
// //           setCulturalPrepLoading(true);
// //           try {
// //             const res = await apiClient.get("/ai/cultural-preparation/");
// //             const validData = Object.fromEntries(
// //               Object.entries(res.data.cultural_preparation).filter(
// //                 ([, value]) => !value.error_message
// //               )
// //             );
// //             setCulturalPrepData(validData);
// //           } catch (err) {
// //             showNotification("Failed to load cultural prep data.", "error");
// //           } finally {
// //             setCulturalPrepLoading(false);
// //           }
// //         }
// //         break;
// //       case "salary-insights":
// //         setSalaryInsightsDialog(true);
// //         if (!salaryInsightsData) {
// //           setSalaryInsightsLoading(true);
// //           try {
// //             const res = await apiClient.get("/ai/salary-insights/");
// //             setSalaryInsightsData(res.data.salary_insights);
// //           } catch (err) {
// //             showNotification("Failed to load salary insights data.", "error");
// //           } finally {
// //             setSalaryInsightsLoading(false);
// //           }
// //         }
// //         break;
// //       default:
// //         showNotification(`${service.title} feature coming soon!`, "info");
// //     }
// //   };

// //   const DialogSkeleton = () => (
// //     <Stack spacing={3} sx={{ p: 2, minHeight: 400 }}>
// //       <Skeleton variant="rounded" width="60%" height={40} />
// //       <Skeleton variant="rounded" width="100%" height={100} />
// //       <Skeleton variant="rounded" width="40%" height={30} />
// //       <Skeleton variant="rounded" width="100%" height={150} />
// //     </Stack>
// //   );

// //   // Consolidated useEffect for fetching trending skills
// //   useEffect(() => {
// //     if (isInitialMount.current) {
// //       isInitialMount.current = false;
// //       // Initial load without debounce
// //       const initialLoad = async () => {
// //         await fetchTrendingSkills(selectedTrendingRoles);
// //         setPageLoading(false);
// //       };
// //       initialLoad();
// //     } else {
// //       // Debounced fetch for subsequent updates
// //       const handler = setTimeout(() => {
// //         fetchTrendingSkills(selectedTrendingRoles);
// //       }, 500);

// //       return () => {
// //         clearTimeout(handler);
// //       };
// //     }
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [selectedTrendingRoles]);

// //   if (pageLoading) {
// //     return <PageSkeleton />;
// //   }

// //   return (
// //     <Layout title="AI Career Assistant">
// //       <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
// //         <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
// //           <Stack spacing={4}>
// //             {/* ROW 1: Header Banner */}
// //             <Paper
// //               sx={{
// //                 bgcolor: "mint.main",
// //                 borderRadius: 3,
// //                 p: { xs: 2, sm: 3 },
// //               }}
// //             >
// //               <Stack direction="row" alignItems="center" spacing={2}>
// //                 <Avatar
// //                   sx={{
// //                     bgcolor: "primary.main",
// //                     color: "primary.contrastText",
// //                     width: { xs: 50, sm: 64 },
// //                     height: { xs: 50, sm: 64 },
// //                   }}
// //                 >
// //                   <Psychology sx={{ fontSize: { xs: 28, sm: 36 } }} />
// //                 </Avatar>
// //                 <Box>
// //                   <Typography
// //                     variant="h4"
// //                     component="h1"
// //                     fontWeight="bold"
// //                     sx={{ typography: { xs: "h5", sm: "h4" } }}
// //                   >
// //                     AI Career Assistant
// //                     <AutoAwesome
// //                       sx={{
// //                         fontSize: { xs: 22, sm: 28 },
// //                         ml: 1,
// //                         verticalAlign: "middle",
// //                         color: "primary.main",
// //                       }}
// //                     />
// //                   </Typography>
// //                   <Typography variant="body1" color="text.secondary">
// //                     Your intelligent, multilingual guide to global careers.
// //                   </Typography>
// //                 </Box>
// //               </Stack>
// //             </Paper>

// //             {/* ROW 2: Welcome Alert */}
// //             {showWelcomeCard && (
// //               <Alert
// //                 severity="info"
// //                 variant="filled"
// //                 onClose={() => setShowWelcomeCard(false)}
// //                 action={
// //                   <Button
// //                     color="inherit"
// //                     size="small"
// //                     onClick={() => {
// //                       handleServiceClick(assistantServices[0]);
// //                       setShowWelcomeCard(false);
// //                     }}
// //                   >
// //                     Start Review
// //                   </Button>
// //                 }
// //                 sx={{
// //                   bgcolor: "primary.dark",
// //                   color: "primary.contrastText",
// //                   borderRadius: 2,
// //                 }}
// //               >
// //                 <AlertTitle sx={{ fontWeight: "bold" }}>Welcome!</AlertTitle>
// //                 New here? Start with an AI Resume Review to get personalized
// //                 feedback and unlock other insights.
// //               </Alert>
// //             )}

// //             {/* ROW 3: Services List */}
// //             <Paper
// //               sx={{
// //                 p: { xs: 2, sm: 3 },
// //                 borderRadius: 3,
// //                 bgcolor: "mint.main",
// //               }}
// //             >
// //               <Stack direction="row" alignItems="center" spacing={1} mb={3}>
// //                 <Typography variant="h5" component="h2" fontWeight={600}>
// //                   AI-Powered Career Services
// //                 </Typography>
// //                 <RocketLaunch color="primary" />
// //               </Stack>
// //               <Stack spacing={2}>
// //                 {assistantServices.map((service) => (
// //                   <ServiceListItem
// //                     key={service.id}
// //                     color={service.color}
// //                     onClick={() => handleServiceClick(service)}
// //                   >
// //                     <Avatar sx={{ width: 48, height: 48 }}>
// //                       {service.icon}
// //                     </Avatar>
// //                     <Box flexGrow={1}>
// //                       <Typography
// //                         variant="h6"
// //                         component="div"
// //                         fontWeight="bold"
// //                       >
// //                         {service.title}
// //                       </Typography>
// //                       <Typography variant="body2" color="text.secondary">
// //                         {service.description}
// //                       </Typography>
// //                     </Box>
// //                     <IconButton sx={{ ml: 2 }}>
// //                       <ArrowForward />
// //                     </IconButton>
// //                   </ServiceListItem>
// //                 ))}
// //               </Stack>
// //             </Paper>

// //             {/* ROW 4: Trending Skills */}
// //             <Paper
// //               sx={{
// //                 p: { xs: 2, sm: 3 },
// //                 borderRadius: 3,
// //                 bgcolor: "mint.main",
// //               }}
// //             >
// //               <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
// //                 <Lightbulb color="primary" />
// //                 <Typography variant="h6" fontWeight={600}>
// //                   Top In-Demand Skills
// //                 </Typography>
// //               </Stack>
// //               <RoleSelector
// //                 selectedRoles={selectedTrendingRoles}
// //                 handleRoleChange={handleTrendingRoleChange}
// //               />
// //               {skillsLoading ? (
// //                 <ChartSkeleton />
// //               ) : Object.keys(trendingSkillsData).length > 0 ? (
// //                 <Box>
// //                   <Tabs
// //                     value={activeTrendingTab}
// //                     onChange={(e, val) => setActiveTrendingTab(val)}
// //                     variant="scrollable"
// //                     scrollButtons="auto"
// //                   >
// //                     {Object.keys(trendingSkillsData).map((role) => (
// //                       <Tab label={role} key={role} />
// //                     ))}
// //                   </Tabs>
// //                   {Object.entries(trendingSkillsData).map(
// //                     ([role, skills], index) => {
// //                       const sortedSkills = [...skills].sort(
// //                         (a, b) => b.demand - a.demand
// //                       );
// //                       const priorityColors = {
// //                         High: theme.palette.primary.main,
// //                         Medium: theme.palette.info.main,
// //                       };

// //                       return (
// //                         <TabPanel
// //                           value={activeTrendingTab}
// //                           index={index}
// //                           key={role}
// //                         >
// //                           <Paper
// //                             elevation={0}
// //                             sx={{
// //                               bgcolor: "background.paper",
// //                               borderRadius: 2,
// //                               p: { xs: 1, sm: 2 },
// //                             }}
// //                           >
// //                             <Box
// //                               sx={{
// //                                 height: { xs: 400, md: 500 },
// //                                 width: "100%",
// //                               }}
// //                             >
// //                               <ResponsiveContainer width="100%" height="100%">
// //                                 <BarChart
// //                                   data={sortedSkills}
// //                                   margin={{
// //                                     top: 30,
// //                                     right: 30,
// //                                     left: 20,
// //                                     bottom: 120,
// //                                   }}
// //                                 >
// //                                   <CartesianGrid
// //                                     vertical={false}
// //                                     stroke={theme.palette.divider}
// //                                     strokeDasharray="3 3"
// //                                   />
// //                                   <XAxis
// //                                     dataKey="skill"
// //                                     type="category"
// //                                     interval={0}
// //                                     angle={-45}
// //                                     textAnchor="end"
// //                                     tick={{
// //                                       fill: theme.palette.text.secondary,
// //                                       fontSize: 12,
// //                                     }}
// //                                     stroke={"transparent"}
// //                                   />
// //                                   <YAxis
// //                                     type="number"
// //                                     domain={[0, "dataMax + 15"]}
// //                                     allowDecimals={false}
// //                                     tickFormatter={(tick) => `${tick}%`}
// //                                     stroke={theme.palette.divider}
// //                                     tick={{
// //                                       fill: theme.palette.text.secondary,
// //                                     }}
// //                                   />
// //                                   <Tooltip
// //                                     content={<CustomTooltip />}
// //                                     cursor={{
// //                                       fill: alpha(
// //                                         theme.palette.primary.main,
// //                                         0.1
// //                                       ),
// //                                     }}
// //                                   />
// //                                   <Bar
// //                                     dataKey="demand"
// //                                     shape={<RoundedVerticalBar />}
// //                                     animationDuration={800}
// //                                   >
// //                                     {sortedSkills.map((entry, idx) => (
// //                                       <Cell
// //                                         key={`cell-${idx}`}
// //                                         fill={
// //                                           priorityColors[entry.priority] ||
// //                                           theme.palette.text.disabled
// //                                         }
// //                                       />
// //                                     ))}
// //                                     <LabelList
// //                                       dataKey="demand"
// //                                       position="top"
// //                                       offset={8}
// //                                       style={{
// //                                         fill: theme.palette.text.primary,
// //                                         fontSize: "12px",
// //                                         fontWeight: "bold",
// //                                       }}
// //                                       formatter={(value) => `${value}%`}
// //                                     />
// //                                   </Bar>
// //                                 </BarChart>
// //                               </ResponsiveContainer>
// //                             </Box>
// //                           </Paper>
// //                         </TabPanel>
// //                       );
// //                     }
// //                   )}
// //                 </Box>
// //               ) : (
// //                 <Box
// //                   sx={{
// //                     display: "flex",
// //                     flexDirection: "column",
// //                     alignItems: "center",
// //                     justifyContent: "center",
// //                     textAlign: "center",
// //                     py: 8,
// //                     minHeight: 400,
// //                   }}
// //                 >
// //                   <Insights
// //                     sx={{ fontSize: 60, color: "text.disabled", mb: 2 }}
// //                   />
// //                   <Typography variant="h6" color="text.secondary">
// //                     Select a role to view in-demand skills
// //                   </Typography>
// //                   <Typography variant="body2" color="text.disabled">
// //                     The chart will update automatically as you make selections.
// //                   </Typography>
// //                 </Box>
// //               )}
// //             </Paper>
// //           </Stack>
// //         </Container>
// //       </Box>

// //       {/* --- DIALOGS (UI ENHANCEMENTS APPLIED) --- */}
// //       <Dialog
// //         open={resumeReviewDialog}
// //         onClose={() => setResumeReviewDialog(false)}
// //         maxWidth="lg"
// //         fullWidth
// //       >
// //         <DialogTitle
// //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// //         >
// //           <Stack direction="row" alignItems="center" spacing={1.5}>
// //             <Assessment />
// //             <Typography variant="h6">AI Resume Review</Typography>
// //           </Stack>
// //         </DialogTitle>
// //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// //           <RoleSelector
// //             selectedRoles={selectedResumeRoles}
// //             handleRoleChange={(e) =>
// //               setSelectedResumeRoles((prev) =>
// //                 e.target.checked
// //                   ? [...prev, e.target.name]
// //                   : prev.filter((r) => r !== e.target.name)
// //               )
// //             }
// //           />
// //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// //             <Button
// //               variant="contained"
// //               onClick={() => fetchResumeReview(selectedResumeRoles)}
// //             >
// //               Generate Report
// //             </Button>
// //           </Box>
// //           <Divider sx={{ mb: 2 }} />
// //           {resumeReviewLoading ? (
// //             <DialogSkeleton />
// //           ) : (
// //             resumeReviewData && (
// //               <>
// //                 <Tabs
// //                   value={activeResumeTab}
// //                   onChange={(e, val) => setActiveResumeTab(val)}
// //                   centered
// //                   variant="scrollable"
// //                   scrollButtons="auto"
// //                 >
// //                   {Object.keys(resumeReviewData).map((role) => (
// //                     <Tab key={role} label={role} />
// //                   ))}
// //                 </Tabs>
// //                 {Object.entries(resumeReviewData).map(([role, data], index) => (
// //                   <TabPanel value={activeResumeTab} index={index} key={role}>
// //                     <Grid container spacing={3}>
// //                       <Grid item xs={12} md={6}>
// //                         <Paper
// //                           variant="outlined"
// //                           sx={{ p: 2.5, height: "100%", borderRadius: 2 }}
// //                         >
// //                           <Box
// //                             sx={{
// //                               p: 2,
// //                               mb: 2,
// //                               borderRadius: 1.5,
// //                               background: (theme) =>
// //                                 `linear-gradient(135deg, ${alpha(
// //                                   theme.palette.error.light,
// //                                   0.2
// //                                 )}, ${alpha(theme.palette.error.dark, 0.2)})`,
// //                             }}
// //                           >
// //                             <Typography variant="h6" fontWeight="500">
// //                               ATS Compatibility
// //                             </Typography>
// //                             <Typography
// //                               variant="h3"
// //                               fontWeight="bold"
// //                               color="error.dark"
// //                             >
// //                               {data.ATS_Compatibility.score}
// //                               <Typography
// //                                 component="span"
// //                                 variant="h5"
// //                                 color="text.secondary"
// //                               >
// //                                 /100
// //                               </Typography>
// //                             </Typography>
// //                             <LinearProgress
// //                               variant="determinate"
// //                               value={data.ATS_Compatibility.score}
// //                               color="error"
// //                               sx={{ height: 6, borderRadius: 3 }}
// //                             />
// //                           </Box>
// //                           <Typography variant="subtitle1" fontWeight="bold">
// //                             Top Issues:
// //                           </Typography>
// //                           <List dense>
// //                             {data.ATS_Compatibility.top_issues.map(
// //                               (issue, i) => (
// //                                 <ListItem key={i} sx={{ py: 0 }}>
// //                                   <ListItemIcon sx={{ minWidth: 32 }}>
// //                                     <ErrorOutline
// //                                       fontSize="small"
// //                                       color="error"
// //                                     />
// //                                   </ListItemIcon>
// //                                   <ListItemText primary={issue} />
// //                                 </ListItem>
// //                               )
// //                             )}
// //                           </List>
// //                         </Paper>
// //                       </Grid>
// //                       <Grid item xs={12} md={6}>
// //                         <Paper
// //                           variant="outlined"
// //                           sx={{ p: 2.5, height: "100%", borderRadius: 2 }}
// //                         >
// //                           <Box
// //                             sx={{
// //                               p: 2,
// //                               mb: 2,
// //                               borderRadius: 1.5,
// //                               background: (theme) =>
// //                                 `linear-gradient(135deg, ${alpha(
// //                                   theme.palette.success.light,
// //                                   0.2
// //                                 )}, ${alpha(theme.palette.success.dark, 0.2)})`,
// //                             }}
// //                           >
// //                             <Typography variant="h6" fontWeight="500">
// //                               Content & Format Quality
// //                             </Typography>
// //                             <Typography
// //                               variant="body2"
// //                               paragraph
// //                               color="text.secondary"
// //                             >
// //                               {data.Content_Quality_Analysis.summary}
// //                             </Typography>
// //                           </Box>
// //                           <Typography variant="subtitle1" fontWeight="bold">
// //                             Top Strengths:
// //                           </Typography>
// //                           <List dense>
// //                             {data.Content_Quality_Analysis.top_strengths.map(
// //                               (strength, i) => (
// //                                 <ListItem key={i} sx={{ py: 0 }}>
// //                                   <ListItemIcon sx={{ minWidth: 32 }}>
// //                                     <CheckCircle
// //                                       fontSize="small"
// //                                       color="success"
// //                                     />
// //                                   </ListItemIcon>
// //                                   <ListItemText primary={strength} />
// //                                 </ListItem>
// //                               )
// //                             )}
// //                           </List>
// //                         </Paper>
// //                       </Grid>
// //                       <Grid item xs={12}>
// //                         <Paper
// //                           variant="outlined"
// //                           sx={{ p: 2.5, borderRadius: 2 }}
// //                         >
// //                           <Typography variant="h6" gutterBottom>
// //                             Keyword & Section Optimization
// //                           </Typography>
// //                           <Stack
// //                             direction={{ xs: "column", sm: "row" }}
// //                             spacing={3}
// //                             divider={
// //                               <Divider orientation="vertical" flexItem />
// //                             }
// //                           >
// //                             <Box flex={1}>
// //                               <Typography variant="subtitle1" fontWeight="bold">
// //                                 Missing Keywords
// //                               </Typography>
// //                               <Box
// //                                 sx={{
// //                                   display: "flex",
// //                                   flexWrap: "wrap",
// //                                   gap: 1,
// //                                   mt: 1,
// //                                 }}
// //                               >
// //                                 {data.Keyword_Optimization.missing_keywords.map(
// //                                   (kw, i) => (
// //                                     <Chip
// //                                       key={i}
// //                                       label={kw}
// //                                       color="info"
// //                                       size="small"
// //                                     />
// //                                   )
// //                                 )}
// //                               </Box>
// //                             </Box>
// //                             <Box flex={1}>
// //                               <Typography variant="subtitle1" fontWeight="bold">
// //                                 Missing Sections
// //                               </Typography>
// //                               <Box
// //                                 sx={{
// //                                   display: "flex",
// //                                   flexWrap: "wrap",
// //                                   gap: 1,
// //                                   mt: 1,
// //                                 }}
// //                               >
// //                                 {data.Format_and_Structure_Review.missing_sections.map(
// //                                   (sec, i) => (
// //                                     <Chip
// //                                       key={i}
// //                                       label={sec}
// //                                       color="warning"
// //                                       size="small"
// //                                     />
// //                                   )
// //                                 )}
// //                               </Box>
// //                             </Box>
// //                           </Stack>
// //                         </Paper>
// //                       </Grid>
// //                     </Grid>
// //                   </TabPanel>
// //                 ))}
// //               </>
// //             )
// //           )}
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={() => setResumeReviewDialog(false)}>Close</Button>
// //         </DialogActions>
// //       </Dialog>
// //       <Dialog
// //         open={skillGapDialog}
// //         onClose={() => setSkillGapDialog(false)}
// //         maxWidth="lg"
// //         fullWidth
// //       >
// //         <DialogTitle
// //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// //         >
// //           <Stack direction="row" alignItems="center" spacing={1.5}>
// //             <TrendingUp />
// //             <Typography variant="h6">AI Skill Gap Analysis</Typography>
// //           </Stack>
// //         </DialogTitle>
// //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// //           <RoleSelector
// //             selectedRoles={selectedSkillGapRoles}
// //             handleRoleChange={(e) =>
// //               setSelectedSkillGapRoles((prev) =>
// //                 e.target.checked
// //                   ? [...prev, e.target.name]
// //                   : prev.filter((r) => r !== e.target.name)
// //               )
// //             }
// //           />
// //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// //             <Button
// //               variant="contained"
// //               color="primary"
// //               onClick={() => fetchSkillGap(selectedSkillGapRoles)}
// //             >
// //               Generate Analysis
// //             </Button>
// //           </Box>
// //           <Divider sx={{ mb: 2 }} />
// //           {skillGapLoading ? (
// //             <DialogSkeleton />
// //           ) : (
// //             skillGapData && (
// //               <>
// //                 <Tabs
// //                   value={activeSkillGapTab}
// //                   onChange={(e, val) => setActiveSkillGapTab(val)}
// //                   centered
// //                   variant="scrollable"
// //                   scrollButtons="auto"
// //                 >
// //                   {Object.keys(skillGapData).map((role) => (
// //                     <Tab key={role} label={role} />
// //                   ))}
// //                 </Tabs>
// //                 {Object.entries(skillGapData).map(([role, data], index) => (
// //                   <TabPanel value={activeSkillGapTab} index={index} key={role}>
// //                     <Grid container spacing={2}>
// //                       <Grid item xs={12} md={6}>
// //                         <Paper
// //                           variant="outlined"
// //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// //                         >
// //                           <Stack
// //                             direction="row"
// //                             spacing={1.5}
// //                             alignItems="center"
// //                             mb={1.5}
// //                           >
// //                             <Avatar sx={{ bgcolor: "primary.light" }}>
// //                               <Person />
// //                             </Avatar>
// //                             <Typography variant="h6">Your Skills</Typography>
// //                           </Stack>
// //                           <Box
// //                             sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
// //                           >
// //                             {data.Current_Skill_Mapping.map((skill, i) => (
// //                               <Chip key={i} label={skill} variant="outlined" />
// //                             ))}
// //                           </Box>
// //                         </Paper>
// //                       </Grid>
// //                       <Grid item xs={12} md={6}>
// //                         <Paper
// //                           variant="outlined"
// //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// //                         >
// //                           <Stack
// //                             direction="row"
// //                             spacing={1.5}
// //                             alignItems="center"
// //                             mb={1.5}
// //                           >
// //                             <Avatar sx={{ bgcolor: "secondary.light" }}>
// //                               <TrendingUp />
// //                             </Avatar>
// //                             <Typography variant="h6">
// //                               In-Demand Market Skills
// //                             </Typography>
// //                           </Stack>
// //                           <Box
// //                             sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
// //                           >
// //                             {data.Market_Demand_Analysis.map((skill, i) => (
// //                               <Chip key={i} label={skill} color="primary" />
// //                             ))}
// //                           </Box>
// //                         </Paper>
// //                       </Grid>
// //                       <Grid item xs={12} md={6}>
// //                         <Paper
// //                           variant="outlined"
// //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// //                         >
// //                           <Stack
// //                             direction="row"
// //                             spacing={1.5}
// //                             alignItems="center"
// //                             mb={1.5}
// //                           >
// //                             <Avatar sx={{ bgcolor: "info.light" }}>
// //                               <School />
// //                             </Avatar>
// //                             <Typography variant="h6">
// //                               Recommended Learning Path
// //                             </Typography>
// //                           </Stack>
// //                           <List dense>
// //                             {data.Learning_Path.map((path, i) => (
// //                               <ListItem key={i} sx={{ py: 0.5 }}>
// //                                 <ListItemIcon sx={{ minWidth: 36 }}>
// //                                   <ArrowForward fontSize="small" color="info" />
// //                                 </ListItemIcon>
// //                                 <ListItemText primary={path} />
// //                               </ListItem>
// //                             ))}
// //                           </List>
// //                         </Paper>
// //                       </Grid>
// //                       <Grid item xs={12} md={6}>
// //                         <Paper
// //                           variant="outlined"
// //                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
// //                         >
// //                           <Stack
// //                             direction="row"
// //                             spacing={1.5}
// //                             alignItems="center"
// //                             mb={1.5}
// //                           >
// //                             <Avatar sx={{ bgcolor: "success.light" }}>
// //                               <MilitaryTech />
// //                             </Avatar>
// //                             <Typography variant="h6">
// //                               Suggested Certifications
// //                             </Typography>
// //                           </Stack>
// //                           <List dense>
// //                             {data.Certification_Guidance.map((cert, i) => (
// //                               <ListItem key={i} sx={{ py: 0.5 }}>
// //                                 <ListItemIcon sx={{ minWidth: 36 }}>
// //                                   <CheckCircle
// //                                     fontSize="small"
// //                                     color="success"
// //                                   />
// //                                 </ListItemIcon>
// //                                 <ListItemText primary={cert} />
// //                               </ListItem>
// //                             ))}
// //                           </List>
// //                         </Paper>
// //                       </Grid>
// //                     </Grid>
// //                   </TabPanel>
// //                 ))}
// //               </>
// //             )
// //           )}
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={() => setSkillGapDialog(false)}>Close</Button>
// //         </DialogActions>
// //       </Dialog>
// //       <Dialog
// //         open={careerRoadmapDialog}
// //         onClose={() => setCareerRoadmapDialog(false)}
// //         maxWidth="lg"
// //         fullWidth
// //       >
// //         <DialogTitle
// //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// //         >
// //           <Stack direction="row" alignItems="center" spacing={1.5}>
// //             <Timeline />
// //             <Typography variant="h6">Personalized Career Roadmap</Typography>
// //           </Stack>
// //         </DialogTitle>
// //         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
// //           <RoleSelector
// //             selectedRoles={selectedRoadmapRoles}
// //             handleRoleChange={(e) =>
// //               setSelectedRoadmapRoles((prev) =>
// //                 e.target.checked
// //                   ? [...prev, e.target.name]
// //                   : prev.filter((r) => r !== e.target.name)
// //               )
// //             }
// //           />
// //           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
// //             <Button
// //               variant="contained"
// //               color="primary"
// //               onClick={() => fetchCareerRoadmap(selectedRoadmapRoles)}
// //             >
// //               Generate Roadmap
// //             </Button>
// //           </Box>
// //           <Divider sx={{ mb: 2 }} />
// //           {careerRoadmapLoading ? (
// //             <DialogSkeleton />
// //           ) : (
// //             careerRoadmapData && (
// //               <>
// //                 <Tabs
// //                   value={activeRoadmapTab}
// //                   onChange={(e, val) => setActiveRoadmapTab(val)}
// //                   centered
// //                   variant="scrollable"
// //                   scrollButtons="auto"
// //                 >
// //                   {Object.keys(careerRoadmapData).map((role) => (
// //                     <Tab key={role} label={role} />
// //                   ))}
// //                 </Tabs>
// //                 {Object.entries(careerRoadmapData).map(
// //                   ([role, data], index) => (
// //                     <TabPanel value={activeRoadmapTab} index={index} key={role}>
// //                       <Typography variant="h5" gutterBottom align="center">
// //                         Your AI-Generated Path to <strong>{role}</strong>
// //                       </Typography>
// //                       <Typography
// //                         variant="body1"
// //                         paragraph
// //                         color="text.secondary"
// //                         align="center"
// //                       >
// //                         Based on your current role:{" "}
// //                         <strong>{data?.Current_Position || "N/A"}</strong> with{" "}
// //                         <strong>{data?.Experience_Years || "N/A"}</strong> years
// //                         of experience.
// //                       </Typography>
// //                       <Grid container spacing={2} sx={{ mt: 1 }}>
// //                         <Grid item xs={12} md={6}>
// //                           <Paper
// //                             variant="outlined"
// //                             sx={{
// //                               p: 2.5,
// //                               height: "100%",
// //                               borderRadius: 2,
// //                             }}
// //                           >
// //                             <Stack
// //                               direction="row"
// //                               spacing={2}
// //                               alignItems="center"
// //                             >
// //                               <Avatar
// //                                 sx={{
// //                                   bgcolor: "primary.light",
// //                                   width: 56,
// //                                   height: 56,
// //                                 }}
// //                               >
// //                                 <RocketLaunch />
// //                               </Avatar>
// //                               <Box>
// //                                 <Typography
// //                                   variant="overline"
// //                                   color="primary.main"
// //                                 >
// //                                   Next Milestone
// //                                 </Typography>
// //                                 <Typography variant="h6" fontWeight="bold">
// //                                   {data?.Next_Milestone?.title ||
// //                                     "Not available"}
// //                                 </Typography>
// //                                 <Chip
// //                                   size="small"
// //                                   label={`Company: ${
// //                                     data?.Next_Milestone?.company_type || "N/A"
// //                                   }`}
// //                                   sx={{ mt: 1 }}
// //                                 />
// //                               </Box>
// //                             </Stack>
// //                           </Paper>
// //                         </Grid>
// //                         <Grid item xs={12} md={6}>
// //                           <Paper
// //                             variant="outlined"
// //                             sx={{
// //                               p: 2.5,
// //                               height: "100%",
// //                               borderRadius: 2,
// //                             }}
// //                           >
// //                             <Stack
// //                               direction="row"
// //                               spacing={2}
// //                               alignItems="center"
// //                             >
// //                               <Avatar
// //                                 sx={{
// //                                   bgcolor: "success.light",
// //                                   width: 56,
// //                                   height: 56,
// //                                 }}
// //                               >
// //                                 <Stars />
// //                               </Avatar>
// //                               <Box>
// //                                 <Typography
// //                                   variant="overline"
// //                                   color="success.main"
// //                                 >
// //                                   Long-term Goal
// //                                 </Typography>
// //                                 <Typography variant="h6" fontWeight="bold">
// //                                   {data?.Long_Term_Goal?.title ||
// //                                     "Not available"}
// //                                 </Typography>
// //                                 <Chip
// //                                   size="small"
// //                                   label={`Company: ${
// //                                     data?.Long_Term_Goal?.company_type || "N/A"
// //                                   }`}
// //                                   sx={{ mt: 1 }}
// //                                 />
// //                               </Box>
// //                             </Stack>
// //                           </Paper>
// //                         </Grid>
// //                       </Grid>
// //                       <Divider sx={{ my: 3 }}>
// //                         <Chip label="Recommended Actions" color="primary" />
// //                       </Divider>
// //                       <List>
// //                         {data?.Recommended_Actions?.map((item, i) => (
// //                           <ListItem key={i} alignItems="flex-start">
// //                             <ListItemIcon>
// //                               <Work color="primary" />
// //                             </ListItemIcon>
// //                             <ListItemText
// //                               primary={item.action}
// //                               secondary={item.reason}
// //                             />
// //                           </ListItem>
// //                         )) || (
// //                           <ListItem>
// //                             <ListItemText primary="No actions recommended." />
// //                           </ListItem>
// //                         )}
// //                       </List>
// //                     </TabPanel>
// //                   )
// //                 )}
// //               </>
// //             )
// //           )}
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={() => setCareerRoadmapDialog(false)}>Close</Button>
// //         </DialogActions>
// //       </Dialog>
// //       <Dialog
// //         open={culturalPrepDialog}
// //         onClose={() => {
// //           setCulturalPrepDialog(false);
// //           setCulturalPrepTab(0);
// //         }}
// //         maxWidth="md"
// //         fullWidth
// //         PaperProps={{ sx: { height: { md: 650 } } }}
// //       >
// //         <DialogTitle
// //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// //         >
// //           <Stack direction="row" alignItems="center" spacing={1.5}>
// //             <Psychology />
// //             <Typography variant="h6">Cultural Preparation Insights</Typography>
// //           </Stack>
// //         </DialogTitle>
// //         <DialogContent
// //           dividers
// //           sx={{
// //             display: "flex",
// //             p: 0,
// //             overflow: "hidden",
// //             flexDirection: { xs: "column", md: "row" },
// //           }}
// //         >
// //           {culturalPrepLoading ? (
// //             <DialogSkeleton />
// //           ) : (
// //             culturalPrepData && (
// //               <>
// //                 <Tabs
// //                   orientation={
// //                     theme.breakpoints.up("md") ? "vertical" : "horizontal"
// //                   }
// //                   variant="scrollable"
// //                   value={culturalPrepTab}
// //                   onChange={(e, val) => setCulturalPrepTab(val)}
// //                   sx={{
// //                     borderRight: { md: 1 },
// //                     borderBottom: { xs: 1, md: 0 },
// //                     borderColor: "divider",
// //                     minWidth: { md: 150 },
// //                   }}
// //                 >
// //                   {Object.values(culturalPrepData).map((region, index) => (
// //                     <Tab key={index} label={region.location_name} />
// //                   ))}
// //                 </Tabs>
// //                 <Box
// //                   sx={{
// //                     flex: { md: 1 },
// //                     overflowY: "auto",
// //                     p: { xs: 2, md: 3 },
// //                     bgcolor: "background.default",
// //                   }}
// //                 >
// //                   {Object.values(culturalPrepData).map((region, index) => (
// //                     <TabPanel value={culturalPrepTab} index={index} key={index}>
// //                       <Stack spacing={2}>
// //                         <Paper
// //                           elevation={0}
// //                           sx={{
// //                             p: 2,
// //                             borderRadius: 2,
// //                             border: 1,
// //                             borderColor: "divider",
// //                           }}
// //                         >
// //                           <Stack
// //                             direction="row"
// //                             spacing={1}
// //                             alignItems="center"
// //                             mb={1}
// //                           >
// //                             <Insights color="primary" />
// //                             <Typography variant="h6">
// //                               Cultural Insights
// //                             </Typography>
// //                           </Stack>
// //                           <List dense>
// //                             {region.cultural_insights.map((insight, i) => (
// //                               <ListItem key={i}>
// //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// //                                   <ArrowForward fontSize="small" />
// //                                 </ListItemIcon>
// //                                 <ListItemText primary={insight} />
// //                               </ListItem>
// //                             ))}
// //                           </List>
// //                         </Paper>
// //                         <Paper
// //                           elevation={0}
// //                           sx={{
// //                             p: 2,
// //                             borderRadius: 2,
// //                             border: 1,
// //                             borderColor: "divider",
// //                           }}
// //                         >
// //                           <Stack
// //                             direction="row"
// //                             spacing={1}
// //                             alignItems="center"
// //                             mb={1}
// //                           >
// //                             <VideoCall color="primary" />
// //                             <Typography variant="h6">
// //                               Communication Tips
// //                             </Typography>
// //                           </Stack>
// //                           <List dense>
// //                             {region.communication_tips.map((tip, i) => (
// //                               <ListItem key={i}>
// //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// //                                   <ArrowForward fontSize="small" />
// //                                 </ListItemIcon>
// //                                 <ListItemText primary={tip} />
// //                               </ListItem>
// //                             ))}
// //                           </List>
// //                         </Paper>
// //                         <Paper
// //                           elevation={0}
// //                           sx={{
// //                             p: 2,
// //                             borderRadius: 2,
// //                             border: 1,
// //                             borderColor: "divider",
// //                           }}
// //                         >
// //                           <Stack
// //                             direction="row"
// //                             spacing={1}
// //                             alignItems="center"
// //                             mb={1}
// //                           >
// //                             <Work color="primary" />
// //                             <Typography variant="h6">Work Etiquette</Typography>
// //                           </Stack>
// //                           <List dense>
// //                             {region.work_etiquette.map((tip, i) => (
// //                               <ListItem key={i}>
// //                                 <ListItemIcon sx={{ minWidth: 32 }}>
// //                                   <Stars fontSize="small" />
// //                                 </ListItemIcon>
// //                                 <ListItemText primary={tip} />
// //                               </ListItem>
// //                             ))}
// //                           </List>
// //                         </Paper>
// //                       </Stack>
// //                     </TabPanel>
// //                   ))}
// //                 </Box>
// //               </>
// //             )
// //           )}
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={() => setCulturalPrepDialog(false)}>Close</Button>
// //         </DialogActions>
// //       </Dialog>
// //       <Dialog
// //         open={salaryInsightsDialog}
// //         onClose={() => setSalaryInsightsDialog(false)}
// //         maxWidth="lg" // Changed to lg to accommodate more cards
// //         fullWidth
// //       >
// //         <DialogTitle
// //           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
// //         >
// //           <Stack direction="row" alignItems="center" spacing={1.5}>
// //             <Language />
// //             <Typography variant="h6">Global Salary Insights</Typography>
// //           </Stack>
// //         </DialogTitle>
// //         <DialogContent dividers sx={{ bgcolor: "background.default" }}>
// //           {salaryInsightsLoading ? (
// //             <DialogSkeleton />
// //           ) : (
// //             salaryInsightsData && (
// //               <Stack spacing={3} sx={{ py: 2 }}>
// //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// //                   <Stack
// //                     direction="row"
// //                     spacing={1.5}
// //                     alignItems="center"
// //                     mb={2}
// //                   >
// //                     <LocationOn color="primary" />
// //                     <Typography variant="h6">
// //                       Salary Benchmarks by Location
// //                     </Typography>
// //                   </Stack>
// //                   <Box
// //                     sx={{
// //                       display: "grid",
// //                       gridTemplateColumns: {
// //                         xs: "1fr",
// //                         sm: "repeat(2, 1fr)",
// //                         md: "repeat(3, 1fr)",
// //                         lg: "repeat(5, 1fr)",
// //                       },
// //                       gap: 2,
// //                     }}
// //                   >
// //                     {salaryInsightsData.location_based.map((loc, i) => (
// //                       <Card
// //                         key={i}
// //                         variant="elevation"
// //                         elevation={4}
// //                         sx={{
// //                           borderRadius: 3,
// //                           background: (theme) =>
// //                             `linear-gradient(145deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
// //                           color: "primary.contrastText",
// //                           transition: "transform 0.3s ease-in-out",
// //                           "&:hover": {
// //                             transform: "translateY(-4px)",
// //                           },
// //                         }}
// //                       >
// //                         <CardContent
// //                           sx={{
// //                             display: "flex",
// //                             flexDirection: "column",
// //                             height: "100%",
// //                             p: 2,
// //                           }}
// //                         >
// //                           <Stack
// //                             direction="row"
// //                             spacing={1}
// //                             alignItems="center"
// //                           >
// //                             <LocationOn
// //                               sx={{ opacity: 0.8, fontSize: "1rem" }}
// //                             />
// //                             <Typography
// //                               variant="body1"
// //                               component="div"
// //                               fontWeight={600}
// //                             >
// //                               {loc.city}
// //                             </Typography>
// //                           </Stack>

// //                           <Box
// //                             sx={{
// //                               flexGrow: 1,
// //                               display: "flex",
// //                               flexDirection: "column",
// //                               justifyContent: "center",
// //                               alignItems: "center",
// //                               my: 1,
// //                             }}
// //                           >
// //                             <Typography variant="caption" sx={{ opacity: 0.8 }}>
// //                               MEDIAN
// //                             </Typography>
// //                             <Typography variant="h5" fontWeight="bold">
// //                               {loc.median_salary}
// //                             </Typography>
// //                           </Box>

// //                           <Divider
// //                             sx={{ bgcolor: "rgba(255,255,255,0.2)", mb: 1 }}
// //                           />

// //                           <Stack
// //                             direction="row"
// //                             justifyContent="space-between"
// //                             alignItems="center"
// //                           >
// //                             <Box textAlign="center">
// //                               <Typography
// //                                 variant="caption"
// //                                 sx={{ opacity: 0.8 }}
// //                               >
// //                                 MIN
// //                               </Typography>
// //                               <Typography variant="body2" fontWeight="medium">
// //                                 {loc.min_salary}
// //                               </Typography>
// //                             </Box>
// //                             <Box textAlign="center">
// //                               <Typography
// //                                 variant="caption"
// //                                 sx={{ opacity: 0.8 }}
// //                               >
// //                                 MAX
// //                               </Typography>
// //                               <Typography variant="body2" fontWeight="medium">
// //                                 {loc.max_salary}
// //                               </Typography>
// //                             </Box>
// //                           </Stack>
// //                         </CardContent>
// //                       </Card>
// //                     ))}
// //                   </Box>
// //                 </Paper>
// //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// //                   <Stack
// //                     direction="row"
// //                     spacing={1.5}
// //                     alignItems="center"
// //                     mb={1}
// //                   >
// //                     <TrendingUp color="primary" />
// //                     <Typography variant="h6">Location Demand Impact</Typography>
// //                   </Stack>
// //                   <List dense>
// //                     {salaryInsightsData.salary_insights_summary.map(
// //                       (item, i) => (
// //                         <ListItem key={i} disableGutters sx={{ px: 1 }}>
// //                           <Stack
// //                             direction={{ xs: "column", sm: "row" }}
// //                             spacing={{ xs: 0.5, sm: 2 }}
// //                             alignItems="center"
// //                             sx={{ width: "100%" }}
// //                           >
// //                             <ListItemText
// //                               primary={item.role}
// //                               sx={{
// //                                 width: "100%",
// //                                 m: 0,
// //                                 flexBasis: { sm: "40%" },
// //                                 flexShrink: 0,
// //                               }}
// //                             />
// //                             <Box
// //                               sx={{
// //                                 width: "100%",
// //                                 display: "flex",
// //                                 alignItems: "center",
// //                               }}
// //                             >
// //                               <LinearProgress
// //                                 variant="determinate"
// //                                 value={item.demand_in_salary_percent}
// //                                 color="primary"
// //                                 sx={{
// //                                   width: "100%",
// //                                   mr: 1.5,
// //                                   height: 8,
// //                                   borderRadius: 4,
// //                                 }}
// //                               />
// //                               <Typography
// //                                 variant="body2"
// //                                 color="text.secondary"
// //                               >{`${item.demand_in_salary_percent}%`}</Typography>
// //                             </Box>
// //                           </Stack>
// //                         </ListItem>
// //                       )
// //                     )}
// //                   </List>
// //                 </Paper>
// //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// //                   <Stack
// //                     direction="row"
// //                     spacing={1.5}
// //                     alignItems="center"
// //                     mb={1}
// //                   >
// //                     <MonetizationOn color="success" />
// //                     <Typography variant="h6">Negotiation Tips</Typography>
// //                   </Stack>
// //                   <List dense>
// //                     {salaryInsightsData.negotiation_tips.map((tip, i) => (
// //                       <ListItem key={i}>
// //                         <ListItemIcon sx={{ minWidth: 32 }}>
// //                           <CheckCircle color="success" fontSize="small" />
// //                         </ListItemIcon>
// //                         <ListItemText primary={tip} />
// //                       </ListItem>
// //                     ))}
// //                   </List>
// //                 </Paper>
// //                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
// //                   <Stack
// //                     direction="row"
// //                     spacing={1.5}
// //                     alignItems="center"
// //                     mb={1}
// //                   >
// //                     <Timeline color="warning" />
// //                     <Typography variant="h6">Market Trends</Typography>
// //                   </Stack>
// //                   <List>
// //                     {salaryInsightsData.market_trends.map((item, i) => (
// //                       <ListItem key={i} alignItems="flex-start">
// //                         <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
// //                           <TrendingFlat color="warning" />
// //                         </ListItemIcon>
// //                         <ListItemText
// //                           primary={item.trend}
// //                           secondary={item.insight}
// //                           primaryTypographyProps={{ fontWeight: 600 }}
// //                         />
// //                       </ListItem>
// //                     ))}
// //                   </List>
// //                 </Paper>
// //               </Stack>
// //             )
// //           )}
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={() => setSalaryInsightsDialog(false)}>Close</Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Layout>
// //   );
// // };

// // export default CareerAssistant;
// import { useState, useEffect, useRef } from "react";
// import {
//   Grid,
//   Card,
//   CardContent,
//   Container,
//   Typography,
//   Box,
//   Button,
//   Paper,
//   Avatar,
//   Chip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   Stack,
//   LinearProgress,
//   Skeleton,
//   alpha,
//   IconButton,
//   Tabs,
//   Tab,
//   FormGroup,
//   FormControlLabel,
//   Checkbox,
//   Alert,
//   AlertTitle,
// } from "@mui/material";
// import { styled, useTheme } from "@mui/material/styles";
// import {
//   Psychology,
//   TrendingUp,
//   School,
//   Work,
//   Language,
//   Assessment,
//   VideoCall,
//   Lightbulb,
//   Timeline,
//   CheckCircle,
//   ErrorOutline,
//   ArrowForward,
//   MilitaryTech,
//   Stars,
//   RocketLaunch,
//   TrendingDown,
//   TrendingFlat,
//   LocationOn,
//   MonetizationOn,
//   AutoAwesome,
//   Close as CloseIcon,
//   Insights,
//   Person,
// } from "@mui/icons-material";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   Cell,
//   LabelList,
// } from "recharts";
// import Layout from "../common/Layout";
// import { useNotification } from "../../context/NotificationContext";
// import { useNavigate } from "react-router-dom";
// import apiClient from "../../context/apiClient";

// // --- Skeleton Components ---

// const HeaderSkeleton = () => (
//   <Paper sx={{ bgcolor: "mint.main", borderRadius: 3, p: { xs: 2, sm: 3 } }}>
//     <Stack direction="row" alignItems="center" spacing={2}>
//       <Skeleton variant="circular" width={64} height={64} />
//       <Box sx={{ flex: 1 }}>
//         <Skeleton variant="text" width="40%" height={48} />
//         <Skeleton variant="text" width="60%" height={24} />
//       </Box>
//     </Stack>
//   </Paper>
// );

// const ServiceListItemSkeleton = () => (
//   <Paper
//     sx={{
//       display: "flex",
//       flexDirection: "row",
//       alignItems: "center",
//       padding: 2,
//       borderRadius: "12px",
//       border: (theme) => `1px solid ${theme.palette.divider}`,
//     }}
//   >
//     <Skeleton variant="circular" width={48} height={48} sx={{ mr: 2 }} />
//     <Box flexGrow={1}>
//       <Skeleton variant="text" height={30} width="50%" />
//       <Skeleton variant="text" height={20} width="80%" />
//     </Box>
//     <Skeleton variant="circular" width={24} height={24} sx={{ ml: 2 }} />
//   </Paper>
// );

// const ServicesSkeleton = () => (
//   <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, bgcolor: "mint.main" }}>
//     <Skeleton variant="text" width="60%" height={40} sx={{ mb: 3 }} />
//     <Stack spacing={2}>
//       {[...Array(5)].map((_, index) => (
//         <ServiceListItemSkeleton key={index} />
//       ))}
//     </Stack>
//   </Paper>
// );

// const TrendingSkillsSkeleton = () => (
//   <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3, bgcolor: "mint.main" }}>
//     <Skeleton variant="text" width="40%" height={40} sx={{ mb: 2 }} />
//     <Stack
//       direction="row"
//       spacing={2}
//       sx={{ mb: 3, justifyContent: "center", flexWrap: "wrap", gap: 1 }}
//     >
//       <Skeleton variant="rounded" width={150} height={42} />
//       <Skeleton variant="rounded" width={150} height={42} />
//       <Skeleton variant="rounded" width={150} height={42} />
//     </Stack>
//     <Skeleton variant="rounded" width="100%" height={500} />
//   </Paper>
// );

// const PageSkeleton = () => (
//   <Layout title="AI Career Assistant">
//     <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
//       <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
//         <Stack spacing={4}>
//           <HeaderSkeleton />
//           <ServicesSkeleton />
//           <TrendingSkillsSkeleton />
//         </Stack>
//       </Container>
//     </Box>
//   </Layout>
// );

// const ChartSkeleton = () => (
//   <Box sx={{ height: { xs: 400, md: 500 }, width: "100%", pt: 2 }}>
//     <Skeleton variant="rounded" width="100%" height="100%" />
//   </Box>
// );

// const DialogSkeleton = () => (
//   <Stack spacing={3} sx={{ p: 2, minHeight: 400 }}>
//     <Skeleton variant="rounded" width="60%" height={40} />
//     <Skeleton variant="rounded" width="100%" height={100} />
//     <Skeleton variant="rounded" width="40%" height={30} />
//     <Skeleton variant="rounded" width="100%" height={150} />
//   </Stack>
// );

// const CulturalPrepDialogSkeleton = () => (
//   <Stack
//     direction={{ xs: "column", md: "row" }}
//     sx={{ width: "100%", height: "100%", p: 0 }}
//   >
//     <Stack
//       spacing={2}
//       sx={{
//         p: 2,
//         borderRight: { md: 1 },
//         borderBottom: { xs: 1, md: 0 },
//         borderColor: "divider",
//         minWidth: { md: 150 },
//       }}
//     >
//       <Skeleton variant="rounded" height={40} />
//       <Skeleton variant="rounded" height={40} />
//       <Skeleton variant="rounded" height={40} />
//       <Skeleton variant="rounded" height={40} />
//     </Stack>
//     <Box sx={{ flex: 1, p: { xs: 2, md: 3 }, overflow: "hidden" }}>
//       <Stack spacing={3}>
//         <Stack spacing={1}>
//           <Skeleton variant="text" width="60%" height={32} />
//           <Skeleton variant="text" width="90%" />
//           <Skeleton variant="text" width="80%" />
//           <Skeleton variant="text" width="85%" />
//         </Stack>
//         <Stack spacing={1}>
//           <Skeleton variant="text" width="50%" height={32} />
//           <Skeleton variant="text" width="95%" />
//           <Skeleton variant="text" width="75%" />
//         </Stack>
//         <Stack spacing={1}>
//           <Skeleton variant="text" width="40%" height={32} />
//           <Skeleton variant="text" width="80%" />
//           <Skeleton variant="text" width="90%" />
//         </Stack>
//       </Stack>
//     </Box>
//   </Stack>
// );

// const SalaryInsightsDialogSkeleton = () => (
//   <Stack spacing={3} sx={{ py: 2 }}>
//     {/* Location Benchmarks Section */}
//     <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
//       <Skeleton variant="text" width="40%" height={40} sx={{ mb: 2 }} />
//       <Box
//         sx={{
//           display: "grid",
//           gridTemplateColumns: {
//             xs: "1fr",
//             sm: "repeat(2, 1fr)",
//             md: "repeat(3, 1fr)",
//             lg: "repeat(5, 1fr)",
//           },
//           gap: 2,
//         }}
//       >
//         {[...Array(5)].map((_, i) => (
//           <Skeleton key={i} variant="rounded" height={160} />
//         ))}
//       </Box>
//     </Paper>

//     {/* Demand Impact Section */}
//     <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
//       <Skeleton variant="text" width="50%" height={40} sx={{ mb: 1 }} />
//       <Stack spacing={2}>
//         <Skeleton variant="rounded" height={30} />
//         <Skeleton variant="rounded" height={30} />
//         <Skeleton variant="rounded" height={30} />
//       </Stack>
//     </Paper>

//     {/* Negotiation Tips Section */}
//     <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
//       <Skeleton variant="text" width="30%" height={40} sx={{ mb: 1 }} />
//       <Stack spacing={1}>
//         <Skeleton variant="text" />
//         <Skeleton variant="text" width="90%" />
//         <Skeleton variant="text" width="95%" />
//       </Stack>
//     </Paper>
//   </Stack>
// );

// // --- Helper Components ---

// const ServiceListItem = styled(Paper)(({ theme, color = "primary" }) => ({
//   backgroundColor: theme.palette.background.paper,
//   display: "flex",
//   flexDirection: "row",
//   alignItems: "center",
//   padding: theme.spacing(2),
//   borderRadius: "12px",
//   cursor: "pointer",
//   transition:
//     "background-color 0.3s ease, border-color 0.3s ease, transform 0.2s ease-in-out",
//   border: `1px solid ${theme.palette.divider}`,
//   "&:hover": {
//     backgroundColor: alpha(
//       theme.palette[color]?.main || theme.palette.primary.main,
//       0.08
//     ),
//     borderColor: theme.palette[color]?.main || theme.palette.primary.main,
//     transform: "scale(1.02)",
//   },
//   ".MuiAvatar-root": {
//     backgroundColor: alpha(
//       theme.palette[color]?.main || theme.palette.primary.main,
//       0.15
//     ),
//     color: theme.palette[color]?.main || theme.palette.primary.main,
//     marginRight: theme.spacing(2),
//   },
// }));

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`tabpanel-${index}`}
//       aria-labelledby={`tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// // --- Main Component ---

// const CareerAssistant = () => {
//   const theme = useTheme();
//   const { showNotification } = useNotification();
//   const navigate = useNavigate();
//   const isInitialMount = useRef(true);

//   const availableRoles = [
//     "AI/ML Engineer",
//     "Data Scientist",
//     "Business Analyst",
//   ];

//   // --- State Declarations ---
//   const [pageLoading, setPageLoading] = useState(true);
//   const [showWelcomeCard, setShowWelcomeCard] = useState(true);
//   const [mockInterviewDialog, setMockInterviewDialog] = useState(false);
//   const [resumeReviewDialog, setResumeReviewDialog] = useState(false);
//   const [skillGapDialog, setSkillGapDialog] = useState(false);
//   const [careerRoadmapDialog, setCareerRoadmapDialog] = useState(false);
//   const [culturalPrepDialog, setCulturalPrepDialog] = useState(false);
//   const [salaryInsightsDialog, setSalaryInsightsDialog] = useState(false);
//   const [trendingSkillsData, setTrendingSkillsData] = useState({});
//   const [skillsLoading, setSkillsLoading] = useState(true);
//   const [selectedTrendingRoles, setSelectedTrendingRoles] = useState([
//     "AI/ML Engineer",
//   ]);
//   const [activeTrendingTab, setActiveTrendingTab] = useState(0);
//   const [resumeReviewData, setResumeReviewData] = useState(null);
//   const [resumeReviewLoading, setResumeReviewLoading] = useState(false);
//   const [selectedResumeRoles, setSelectedResumeRoles] = useState([]);
//   const [activeResumeTab, setActiveResumeTab] = useState(0);
//   const [skillGapData, setSkillGapData] = useState(null);
//   const [skillGapLoading, setSkillGapLoading] = useState(false);
//   const [selectedSkillGapRoles, setSelectedSkillGapRoles] = useState([]);
//   const [activeSkillGapTab, setActiveSkillGapTab] = useState(0);
//   const [careerRoadmapData, setCareerRoadmapData] = useState(null);
//   const [careerRoadmapLoading, setCareerRoadmapLoading] = useState(false);
//   const [selectedRoadmapRoles, setSelectedRoadmapRoles] = useState([]);
//   const [activeRoadmapTab, setActiveRoadmapTab] = useState(0);
//   const [culturalPrepData, setCulturalPrepData] = useState(null);
//   const [culturalPrepLoading, setCulturalPrepLoading] = useState(false);
//   const [culturalPrepTab, setCulturalPrepTab] = useState(0);
//   const [salaryInsightsData, setSalaryInsightsData] = useState(null);
//   const [salaryInsightsLoading, setSalaryInsightsLoading] = useState(false);

//   // --- Data Fetching Functions ---

//   const fetchTrendingSkills = async (roles) => {
//     if (!roles || roles.length === 0) {
//       setTrendingSkillsData({});
//       setSkillsLoading(false);
//       return;
//     }
//     setSkillsLoading(true);
//     try {
//       const response = await apiClient.post("/trending-skills/", {
//         selected_roles: roles,
//       });
//       const transformedData = {};
//       for (const [role, skills] of Object.entries(response.data)) {
//         transformedData[role] = skills.map((skill) => ({
//           skill: skill.skill,
//           demand: parseInt(skill.demand) || 0,
//           growth: skill.increase || "N/A",
//           priority: skill.priority,
//         }));
//       }
//       setTrendingSkillsData(transformedData);
//       setActiveTrendingTab(0);
//     } catch (error) {
//       console.error("Failed to fetch trending skills:", error);
//       showNotification("Could not load trending skills data.", "error");
//       setTrendingSkillsData({});
//     } finally {
//       setSkillsLoading(false);
//     }
//   };

//   const fetchResumeReview = async (roles) => {
//     if (!roles || roles.length === 0) {
//       setResumeReviewData({});
//       return;
//     }
//     setResumeReviewLoading(true);
//     try {
//       const response = await apiClient.post("/resume/review-talent/", {
//         target_roles: roles,
//       });
//       setResumeReviewData(response.data);
//       setActiveResumeTab(0);
//     } catch (error) {
//       showNotification("Failed to load resume review data.", "error");
//     } finally {
//       setResumeReviewLoading(false);
//     }
//   };
//   const fetchSkillGap = async (roles) => {
//     if (!roles || roles.length === 0) {
//       setSkillGapData({});
//       return;
//     }
//     setSkillGapLoading(true);
//     try {
//       const response = await apiClient.post("/resume/skill-gap/", {
//         selected_roles: roles,
//       });
//       setSkillGapData(response.data);
//       setActiveSkillGapTab(0);
//     } catch (error) {
//       showNotification("Failed to load skill gap analysis.", "error");
//     } finally {
//       setSkillGapLoading(false);
//     }
//   };
//   const fetchCareerRoadmap = async (roles) => {
//     if (!roles || roles.length === 0) {
//       setCareerRoadmapData({});
//       return;
//     }
//     setCareerRoadmapLoading(true);
//     try {
//       const response = await apiClient.post("/resume/career-roadmap/", {
//         target_roles: roles,
//       });
//       setCareerRoadmapData(response.data);
//       setActiveRoadmapTab(0);
//     } catch (error) {
//       showNotification("Failed to load career roadmap.", "error");
//       setCareerRoadmapData({});
//     } finally {
//       setCareerRoadmapLoading(false);
//     }
//   };

//   // --- Handlers ---
//   const handleTrendingRoleChange = (event) => {
//     const { name, checked } = event.target;
//     setSelectedTrendingRoles((prev) =>
//       checked ? [...prev, name] : prev.filter((role) => role !== name)
//     );
//   };

//   // --- Child Components ---
//   const RoleSelector = ({ selectedRoles, handleRoleChange }) => (
//     <FormGroup row sx={{ mb: 2, justifyContent: "center", flexWrap: "wrap" }}>
//       {availableRoles.map((role) => (
//         <FormControlLabel
//           key={role}
//           control={
//             <Checkbox
//               checked={selectedRoles.includes(role)}
//               onChange={handleRoleChange}
//               name={role}
//             />
//           }
//           label={role}
//         />
//       ))}
//     </FormGroup>
//   );

//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       const data = payload[0].payload;
//       const priorityMuiColor = {
//         High: "primary",
//         Medium: "info",
//       };
//       return (
//         <Paper
//           elevation={3}
//           sx={{
//             p: 1.5,
//             minWidth: 220,
//             bgcolor: "background.paper",
//             border: `1px solid ${theme.palette.divider}`,
//             borderRadius: 2,
//           }}
//         >
//           <Typography variant="body1" fontWeight="bold" gutterBottom>
//             {label}
//           </Typography>
//           <Stack spacing={1}>
//             <Stack
//               direction="row"
//               justifyContent="space-between"
//               alignItems="center"
//             >
//               <Typography variant="body2" color="text.secondary">
//                 Demand:
//               </Typography>
//               <Typography
//                 variant="body2"
//                 fontWeight="bold"
//               >{`${data.demand}%`}</Typography>
//             </Stack>
//             <Stack
//               direction="row"
//               justifyContent="space-between"
//               alignItems="center"
//             >
//               <Typography variant="body2" color="text.secondary">
//                 Priority:
//               </Typography>
//               <Chip
//                 label={data.priority}
//                 size="small"
//                 color={priorityMuiColor[data.priority] || "default"}
//                 sx={{ fontWeight: 600 }}
//               />
//             </Stack>
//             <Stack
//               direction="row"
//               justifyContent="space-between"
//               alignItems="center"
//             >
//               <Typography variant="body2" color="text.secondary">
//                 Growth:
//               </Typography>
//               <Typography
//                 variant="body2"
//                 fontWeight="bold"
//                 color={
//                   (data.growth || "").startsWith("+")
//                     ? "success.main"
//                     : "error.main"
//                 }
//               >
//                 {data.growth}
//               </Typography>
//             </Stack>
//           </Stack>
//         </Paper>
//       );
//     }
//     return null;
//   };

//   const RoundedVerticalBar = (props) => {
//     const { fill, x, y, width, height } = props;
//     const radius = 8;
//     if (height <= 0) return null;
//     return (
//       <g>
//         <path
//           d={`M${x},${y + radius} A${radius},${radius} 0 0 1 ${
//             x + radius
//           },${y} L${x + width - radius},${y} A${radius},${radius} 0 0 1 ${
//             x + width
//           },${y + radius} L${x + width},${y + height} L${x},${y + height} Z`}
//           fill={fill}
//         />
//       </g>
//     );
//   };

//   const assistantServices = [
//     {
//       id: "resume-review",
//       title: "AI Resume Review",
//       description: "Get detailed feedback & ATS optimization suggestions.",
//       icon: <Assessment />,
//       color: "primary",
//     },
//     {
//       id: "skill-assessment",
//       title: "Skill Gap Analysis",
//       description: "Identify critical skill gaps for your target roles.",
//       icon: <TrendingUp />,
//       color: "success",
//     },
//     {
//       id: "career-roadmap",
//       title: "Career Roadmap",
//       description: "AI-generated path based on your profile and goals.",
//       icon: <Timeline />,
//       color: "warning",
//     },
//     {
//       id: "salary-insights",
//       title: "Salary Insights",
//       description: "Real-time salary benchmarks for roles and locations.",
//       icon: <Language />,
//       color: "info",
//     },
//     {
//       id: "cultural-prep",
//       title: "Cultural Preparation",
//       description: "Master workplace culture for different countries.",
//       icon: <Psychology />,
//       color: "error",
//     },
//   ];

//   const handleServiceClick = async (service) => {
//     const defaultRolePayload = ["AI/ML Engineer"];
//     switch (service.id) {
//       case "resume-review":
//         setResumeReviewDialog(true);
//         setSelectedResumeRoles(defaultRolePayload);
//         await fetchResumeReview(defaultRolePayload);
//         break;
//       case "mock-interview":
//         setMockInterviewDialog(true);
//         break;
//       case "skill-assessment":
//         setSkillGapDialog(true);
//         setSelectedSkillGapRoles(defaultRolePayload);
//         await fetchSkillGap(defaultRolePayload);
//         break;
//       case "career-roadmap":
//         setCareerRoadmapDialog(true);
//         setSelectedRoadmapRoles(defaultRolePayload);
//         await fetchCareerRoadmap(defaultRolePayload);
//         break;
//       case "cultural-prep":
//         setCulturalPrepDialog(true);
//         if (!culturalPrepData) {
//           setCulturalPrepLoading(true);
//           try {
//             const res = await apiClient.get("/ai/cultural-preparation/");
//             const validData = Object.fromEntries(
//               Object.entries(res.data.cultural_preparation).filter(
//                 ([, value]) => !value.error_message
//               )
//             );
//             setCulturalPrepData(validData);
//           } catch (err) {
//             showNotification("Failed to load cultural prep data.", "error");
//           } finally {
//             setCulturalPrepLoading(false);
//           }
//         }
//         break;
//       case "salary-insights":
//         setSalaryInsightsDialog(true);
//         if (!salaryInsightsData) {
//           setSalaryInsightsLoading(true);
//           try {
//             const res = await apiClient.get("/ai/salary-insights/");
//             setSalaryInsightsData(res.data.salary_insights);
//           } catch (err) {
//             showNotification("Failed to load salary insights data.", "error");
//           } finally {
//             setSalaryInsightsLoading(false);
//           }
//         }
//         break;
//       default:
//         showNotification(`${service.title} feature coming soon!`, "info");
//     }
//   };

//   // Consolidated useEffect for fetching trending skills
//   useEffect(() => {
//     if (isInitialMount.current) {
//       isInitialMount.current = false;
//       // Initial load without debounce
//       const initialLoad = async () => {
//         await fetchTrendingSkills(selectedTrendingRoles);
//         setPageLoading(false);
//       };
//       initialLoad();
//     } else {
//       // Debounced fetch for subsequent updates
//       const handler = setTimeout(() => {
//         fetchTrendingSkills(selectedTrendingRoles);
//       }, 500);

//       return () => {
//         clearTimeout(handler);
//       };
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedTrendingRoles]);

//   if (pageLoading) {
//     return <PageSkeleton />;
//   }

//   return (
//     <Layout title="AI Career Assistant">
//       <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
//         <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
//           <Stack spacing={4}>
//             {/* ROW 1: Header Banner */}
//             <Paper
//               sx={{
//                 bgcolor: "mint.main",
//                 borderRadius: 3,
//                 p: { xs: 2, sm: 3 },
//               }}
//             >
//               <Stack direction="row" alignItems="center" spacing={2}>
//                 <Avatar
//                   sx={{
//                     bgcolor: "primary.main",
//                     color: "primary.contrastText",
//                     width: { xs: 50, sm: 64 },
//                     height: { xs: 50, sm: 64 },
//                   }}
//                 >
//                   <Psychology sx={{ fontSize: { xs: 28, sm: 36 } }} />
//                 </Avatar>
//                 <Box>
//                   <Typography
//                     variant="h4"
//                     component="h1"
//                     fontWeight="bold"
//                     sx={{ typography: { xs: "h5", sm: "h4" } }}
//                   >
//                     AI Career Assistant
//                     <AutoAwesome
//                       sx={{
//                         fontSize: { xs: 22, sm: 28 },
//                         ml: 1,
//                         verticalAlign: "middle",
//                         color: "primary.main",
//                       }}
//                     />
//                   </Typography>
//                   <Typography variant="body1" color="text.secondary">
//                     Your intelligent, multilingual guide to global careers.
//                   </Typography>
//                 </Box>
//               </Stack>
//             </Paper>

//             {/* ROW 2: Welcome Alert */}
//             {showWelcomeCard && (
//               <Alert
//                 severity="info"
//                 variant="filled"
//                 onClose={() => setShowWelcomeCard(false)}
//                 action={
//                   <Button
//                     color="inherit"
//                     size="small"
//                     onClick={() => {
//                       handleServiceClick(assistantServices[0]);
//                       setShowWelcomeCard(false);
//                     }}
//                   >
//                     Start Review
//                   </Button>
//                 }
//                 sx={{
//                   bgcolor: "primary.dark",
//                   color: "primary.contrastText",
//                   borderRadius: 2,
//                 }}
//               >
//                 <AlertTitle sx={{ fontWeight: "bold" }}>Welcome!</AlertTitle>
//                 New here? Start with an AI Resume Review to get personalized
//                 feedback and unlock other insights.
//               </Alert>
//             )}

//             {/* ROW 3: Services List */}
//             <Paper
//               sx={{
//                 p: { xs: 2, sm: 3 },
//                 borderRadius: 3,
//                 bgcolor: "mint.main",
//               }}
//             >
//               <Stack direction="row" alignItems="center" spacing={1} mb={3}>
//                 <Typography variant="h5" component="h2" fontWeight={600}>
//                   AI-Powered Career Services
//                 </Typography>
//                 <RocketLaunch color="primary" />
//               </Stack>
//               <Stack spacing={2}>
//                 {assistantServices.map((service) => (
//                   <ServiceListItem
//                     key={service.id}
//                     color={service.color}
//                     onClick={() => handleServiceClick(service)}
//                   >
//                     <Avatar sx={{ width: 48, height: 48 }}>
//                       {service.icon}
//                     </Avatar>
//                     <Box flexGrow={1}>
//                       <Typography
//                         variant="h6"
//                         component="div"
//                         fontWeight="bold"
//                       >
//                         {service.title}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary">
//                         {service.description}
//                       </Typography>
//                     </Box>
//                     <IconButton sx={{ ml: 2 }}>
//                       <ArrowForward />
//                     </IconButton>
//                   </ServiceListItem>
//                 ))}
//               </Stack>
//             </Paper>

//             {/* ROW 4: Trending Skills */}
//             <Paper
//               sx={{
//                 p: { xs: 2, sm: 3 },
//                 borderRadius: 3,
//                 bgcolor: "mint.main",
//               }}
//             >
//               <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
//                 <Lightbulb color="primary" />
//                 <Typography variant="h6" fontWeight={600}>
//                   Top In-Demand Skills
//                 </Typography>
//               </Stack>
//               <RoleSelector
//                 selectedRoles={selectedTrendingRoles}
//                 handleRoleChange={handleTrendingRoleChange}
//               />
//               {skillsLoading ? (
//                 <ChartSkeleton />
//               ) : Object.keys(trendingSkillsData).length > 0 ? (
//                 <Box>
//                   <Tabs
//                     value={activeTrendingTab}
//                     onChange={(e, val) => setActiveTrendingTab(val)}
//                     variant="scrollable"
//                     scrollButtons="auto"
//                   >
//                     {Object.keys(trendingSkillsData).map((role) => (
//                       <Tab label={role} key={role} />
//                     ))}
//                   </Tabs>
//                   {Object.entries(trendingSkillsData).map(
//                     ([role, skills], index) => {
//                       const sortedSkills = [...skills].sort(
//                         (a, b) => b.demand - a.demand
//                       );
//                       const priorityColors = {
//                         High: theme.palette.primary.main,
//                         Medium: theme.palette.info.main,
//                       };

//                       return (
//                         <TabPanel
//                           value={activeTrendingTab}
//                           index={index}
//                           key={role}
//                         >
//                           <Paper
//                             elevation={0}
//                             sx={{
//                               bgcolor: "background.paper",
//                               borderRadius: 2,
//                               p: { xs: 1, sm: 2 },
//                             }}
//                           >
//                             <Box
//                               sx={{
//                                 height: { xs: 400, md: 500 },
//                                 width: "100%",
//                               }}
//                             >
//                               <ResponsiveContainer width="100%" height="100%">
//                                 <BarChart
//                                   data={sortedSkills}
//                                   margin={{
//                                     top: 30,
//                                     right: 30,
//                                     left: 20,
//                                     bottom: 120,
//                                   }}
//                                 >
//                                   <CartesianGrid
//                                     vertical={false}
//                                     stroke={theme.palette.divider}
//                                     strokeDasharray="3 3"
//                                   />
//                                   <XAxis
//                                     dataKey="skill"
//                                     type="category"
//                                     interval={0}
//                                     angle={-45}
//                                     textAnchor="end"
//                                     tick={{
//                                       fill: theme.palette.text.secondary,
//                                       fontSize: 12,
//                                     }}
//                                     stroke={"transparent"}
//                                   />
//                                   <YAxis
//                                     type="number"
//                                     domain={[0, "dataMax + 15"]}
//                                     allowDecimals={false}
//                                     tickFormatter={(tick) => `${tick}%`}
//                                     stroke={theme.palette.divider}
//                                     tick={{
//                                       fill: theme.palette.text.secondary,
//                                     }}
//                                   />
//                                   <Tooltip
//                                     content={<CustomTooltip />}
//                                     cursor={{
//                                       fill: alpha(
//                                         theme.palette.primary.main,
//                                         0.1
//                                       ),
//                                     }}
//                                   />
//                                   <Bar
//                                     dataKey="demand"
//                                     shape={<RoundedVerticalBar />}
//                                     animationDuration={800}
//                                   >
//                                     {sortedSkills.map((entry, idx) => (
//                                       <Cell
//                                         key={`cell-${idx}`}
//                                         fill={
//                                           priorityColors[entry.priority] ||
//                                           theme.palette.text.disabled
//                                         }
//                                       />
//                                     ))}
//                                     <LabelList
//                                       dataKey="demand"
//                                       position="top"
//                                       offset={8}
//                                       style={{
//                                         fill: theme.palette.text.primary,
//                                         fontSize: "12px",
//                                         fontWeight: "bold",
//                                       }}
//                                       formatter={(value) => `${value}%`}
//                                     />
//                                   </Bar>
//                                 </BarChart>
//                               </ResponsiveContainer>
//                             </Box>
//                           </Paper>
//                         </TabPanel>
//                       );
//                     }
//                   )}
//                 </Box>
//               ) : (
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     textAlign: "center",
//                     py: 8,
//                     minHeight: 400,
//                   }}
//                 >
//                   <Insights
//                     sx={{ fontSize: 60, color: "text.disabled", mb: 2 }}
//                   />
//                   <Typography variant="h6" color="text.secondary">
//                     Select a role to view in-demand skills
//                   </Typography>
//                   <Typography variant="body2" color="text.disabled">
//                     The chart will update automatically as you make selections.
//                   </Typography>
//                 </Box>
//               )}
//             </Paper>
//           </Stack>
//         </Container>
//       </Box>

//       {/* --- DIALOGS (UI ENHANCEMENTS APPLIED) --- */}
//       <Dialog
//         open={resumeReviewDialog}
//         onClose={() => setResumeReviewDialog(false)}
//         maxWidth="lg"
//         fullWidth
//       >
//         <DialogTitle
//           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
//         >
//           <Stack direction="row" alignItems="center" spacing={1.5}>
//             <Assessment />
//             <Typography variant="h6">AI Resume Review</Typography>
//           </Stack>
//         </DialogTitle>
//         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
//           <RoleSelector
//             selectedRoles={selectedResumeRoles}
//             handleRoleChange={(e) =>
//               setSelectedResumeRoles((prev) =>
//                 e.target.checked
//                   ? [...prev, e.target.name]
//                   : prev.filter((r) => r !== e.target.name)
//               )
//             }
//           />
//           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
//             <Button
//               variant="contained"
//               onClick={() => fetchResumeReview(selectedResumeRoles)}
//             >
//               Generate Report
//             </Button>
//           </Box>
//           <Divider sx={{ mb: 2 }} />
//           {resumeReviewLoading ? (
//             <DialogSkeleton />
//           ) : (
//             resumeReviewData && (
//               <>
//                 <Tabs
//                   value={activeResumeTab}
//                   onChange={(e, val) => setActiveResumeTab(val)}
//                   centered
//                   variant="scrollable"
//                   scrollButtons="auto"
//                 >
//                   {Object.keys(resumeReviewData).map((role) => (
//                     <Tab key={role} label={role} />
//                   ))}
//                 </Tabs>
//                 {Object.entries(resumeReviewData).map(([role, data], index) => (
//                   <TabPanel value={activeResumeTab} index={index} key={role}>
//                     <Grid container spacing={3}>
//                       <Grid item xs={12} md={6}>
//                         <Paper
//                           variant="outlined"
//                           sx={{ p: 2.5, height: "100%", borderRadius: 2 }}
//                         >
//                           <Box
//                             sx={{
//                               p: 2,
//                               mb: 2,
//                               borderRadius: 1.5,
//                               background: (theme) =>
//                                 `linear-gradient(135deg, ${alpha(
//                                   theme.palette.error.light,
//                                   0.2
//                                 )}, ${alpha(theme.palette.error.dark, 0.2)})`,
//                             }}
//                           >
//                             <Typography variant="h6" fontWeight="500">
//                               ATS Compatibility
//                             </Typography>
//                             <Typography
//                               variant="h3"
//                               fontWeight="bold"
//                               color="error.dark"
//                             >
//                               {data.ATS_Compatibility.score}
//                               <Typography
//                                 component="span"
//                                 variant="h5"
//                                 color="text.secondary"
//                               >
//                                 /100
//                               </Typography>
//                             </Typography>
//                             <LinearProgress
//                               variant="determinate"
//                               value={data.ATS_Compatibility.score}
//                               color="error"
//                               sx={{ height: 6, borderRadius: 3 }}
//                             />
//                           </Box>
//                           <Typography variant="subtitle1" fontWeight="bold">
//                             Top Issues:
//                           </Typography>
//                           <List dense>
//                             {data.ATS_Compatibility.top_issues.map(
//                               (issue, i) => (
//                                 <ListItem key={i} sx={{ py: 0 }}>
//                                   <ListItemIcon sx={{ minWidth: 32 }}>
//                                     <ErrorOutline
//                                       fontSize="small"
//                                       color="error"
//                                     />
//                                   </ListItemIcon>
//                                   <ListItemText primary={issue} />
//                                 </ListItem>
//                               )
//                             )}
//                           </List>
//                         </Paper>
//                       </Grid>
//                       <Grid item xs={12} md={6}>
//                         <Paper
//                           variant="outlined"
//                           sx={{ p: 2.5, height: "100%", borderRadius: 2 }}
//                         >
//                           <Box
//                             sx={{
//                               p: 2,
//                               mb: 2,
//                               borderRadius: 1.5,
//                               background: (theme) =>
//                                 `linear-gradient(135deg, ${alpha(
//                                   theme.palette.success.light,
//                                   0.2
//                                 )}, ${alpha(theme.palette.success.dark, 0.2)})`,
//                             }}
//                           >
//                             <Typography variant="h6" fontWeight="500">
//                               Content & Format Quality
//                             </Typography>
//                             <Typography
//                               variant="body2"
//                               paragraph
//                               color="text.secondary"
//                             >
//                               {data.Content_Quality_Analysis.summary}
//                             </Typography>
//                           </Box>
//                           <Typography variant="subtitle1" fontWeight="bold">
//                             Top Strengths:
//                           </Typography>
//                           <List dense>
//                             {data.Content_Quality_Analysis.top_strengths.map(
//                               (strength, i) => (
//                                 <ListItem key={i} sx={{ py: 0 }}>
//                                   <ListItemIcon sx={{ minWidth: 32 }}>
//                                     <CheckCircle
//                                       fontSize="small"
//                                       color="success"
//                                     />
//                                   </ListItemIcon>
//                                   <ListItemText primary={strength} />
//                                 </ListItem>
//                               )
//                             )}
//                           </List>
//                         </Paper>
//                       </Grid>
//                       <Grid item xs={12}>
//                         <Paper
//                           variant="outlined"
//                           sx={{ p: 2.5, borderRadius: 2 }}
//                         >
//                           <Typography variant="h6" gutterBottom>
//                             Keyword & Section Optimization
//                           </Typography>
//                           <Stack
//                             direction={{ xs: "column", sm: "row" }}
//                             spacing={3}
//                             divider={
//                               <Divider orientation="vertical" flexItem />
//                             }
//                           >
//                             <Box flex={1}>
//                               <Typography variant="subtitle1" fontWeight="bold">
//                                 Missing Keywords
//                               </Typography>
//                               <Box
//                                 sx={{
//                                   display: "flex",
//                                   flexWrap: "wrap",
//                                   gap: 1,
//                                   mt: 1,
//                                 }}
//                               >
//                                 {data.Keyword_Optimization.missing_keywords.map(
//                                   (kw, i) => (
//                                     <Chip
//                                       key={i}
//                                       label={kw}
//                                       color="info"
//                                       size="small"
//                                     />
//                                   )
//                                 )}
//                               </Box>
//                             </Box>
//                             <Box flex={1}>
//                               <Typography variant="subtitle1" fontWeight="bold">
//                                 Missing Sections
//                               </Typography>
//                               <Box
//                                 sx={{
//                                   display: "flex",
//                                   flexWrap: "wrap",
//                                   gap: 1,
//                                   mt: 1,
//                                 }}
//                               >
//                                 {data.Format_and_Structure_Review.missing_sections.map(
//                                   (sec, i) => (
//                                     <Chip
//                                       key={i}
//                                       label={sec}
//                                       color="warning"
//                                       size="small"
//                                     />
//                                   )
//                                 )}
//                               </Box>
//                             </Box>
//                           </Stack>
//                         </Paper>
//                       </Grid>
//                     </Grid>
//                   </TabPanel>
//                 ))}
//               </>
//             )
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setResumeReviewDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>
//       <Dialog
//         open={skillGapDialog}
//         onClose={() => setSkillGapDialog(false)}
//         maxWidth="lg"
//         fullWidth
//       >
//         <DialogTitle
//           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
//         >
//           <Stack direction="row" alignItems="center" spacing={1.5}>
//             <TrendingUp />
//             <Typography variant="h6">AI Skill Gap Analysis</Typography>
//           </Stack>
//         </DialogTitle>
//         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
//           <RoleSelector
//             selectedRoles={selectedSkillGapRoles}
//             handleRoleChange={(e) =>
//               setSelectedSkillGapRoles((prev) =>
//                 e.target.checked
//                   ? [...prev, e.target.name]
//                   : prev.filter((r) => r !== e.target.name)
//               )
//             }
//           />
//           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={() => fetchSkillGap(selectedSkillGapRoles)}
//             >
//               Generate Analysis
//             </Button>
//           </Box>
//           <Divider sx={{ mb: 2 }} />
//           {skillGapLoading ? (
//             <DialogSkeleton />
//           ) : (
//             skillGapData && (
//               <>
//                 <Tabs
//                   value={activeSkillGapTab}
//                   onChange={(e, val) => setActiveSkillGapTab(val)}
//                   centered
//                   variant="scrollable"
//                   scrollButtons="auto"
//                 >
//                   {Object.keys(skillGapData).map((role) => (
//                     <Tab key={role} label={role} />
//                   ))}
//                 </Tabs>
//                 {Object.entries(skillGapData).map(([role, data], index) => (
//                   <TabPanel value={activeSkillGapTab} index={index} key={role}>
//                     <Grid container spacing={2}>
//                       <Grid item xs={12} md={6}>
//                         <Paper
//                           variant="outlined"
//                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
//                         >
//                           <Stack
//                             direction="row"
//                             spacing={1.5}
//                             alignItems="center"
//                             mb={1.5}
//                           >
//                             <Avatar sx={{ bgcolor: "primary.light" }}>
//                               <Person />
//                             </Avatar>
//                             <Typography variant="h6">Your Skills</Typography>
//                           </Stack>
//                           <Box
//                             sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
//                           >
//                             {data.Current_Skill_Mapping.map((skill, i) => (
//                               <Chip key={i} label={skill} variant="outlined" />
//                             ))}
//                           </Box>
//                         </Paper>
//                       </Grid>
//                       <Grid item xs={12} md={6}>
//                         <Paper
//                           variant="outlined"
//                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
//                         >
//                           <Stack
//                             direction="row"
//                             spacing={1.5}
//                             alignItems="center"
//                             mb={1.5}
//                           >
//                             <Avatar sx={{ bgcolor: "secondary.light" }}>
//                               <TrendingUp />
//                             </Avatar>
//                             <Typography variant="h6">
//                               In-Demand Market Skills
//                             </Typography>
//                           </Stack>
//                           <Box
//                             sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
//                           >
//                             {data.Market_Demand_Analysis.map((skill, i) => (
//                               <Chip key={i} label={skill} color="primary" />
//                             ))}
//                           </Box>
//                         </Paper>
//                       </Grid>
//                       <Grid item xs={12} md={6}>
//                         <Paper
//                           variant="outlined"
//                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
//                         >
//                           <Stack
//                             direction="row"
//                             spacing={1.5}
//                             alignItems="center"
//                             mb={1.5}
//                           >
//                             <Avatar sx={{ bgcolor: "info.light" }}>
//                               <School />
//                             </Avatar>
//                             <Typography variant="h6">
//                               Recommended Learning Path
//                             </Typography>
//                           </Stack>
//                           <List dense>
//                             {data.Learning_Path.map((path, i) => (
//                               <ListItem key={i} sx={{ py: 0.5 }}>
//                                 <ListItemIcon sx={{ minWidth: 36 }}>
//                                   <ArrowForward fontSize="small" color="info" />
//                                 </ListItemIcon>
//                                 <ListItemText primary={path} />
//                               </ListItem>
//                             ))}
//                           </List>
//                         </Paper>
//                       </Grid>
//                       <Grid item xs={12} md={6}>
//                         <Paper
//                           variant="outlined"
//                           sx={{ p: 2, height: "100%", borderRadius: 2 }}
//                         >
//                           <Stack
//                             direction="row"
//                             spacing={1.5}
//                             alignItems="center"
//                             mb={1.5}
//                           >
//                             <Avatar sx={{ bgcolor: "success.light" }}>
//                               <MilitaryTech />
//                             </Avatar>
//                             <Typography variant="h6">
//                               Suggested Certifications
//                             </Typography>
//                           </Stack>
//                           <List dense>
//                             {data.Certification_Guidance.map((cert, i) => (
//                               <ListItem key={i} sx={{ py: 0.5 }}>
//                                 <ListItemIcon sx={{ minWidth: 36 }}>
//                                   <CheckCircle
//                                     fontSize="small"
//                                     color="success"
//                                   />
//                                 </ListItemIcon>
//                                 <ListItemText primary={cert} />
//                               </ListItem>
//                             ))}
//                           </List>
//                         </Paper>
//                       </Grid>
//                     </Grid>
//                   </TabPanel>
//                 ))}
//               </>
//             )
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setSkillGapDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>
//       <Dialog
//         open={careerRoadmapDialog}
//         onClose={() => setCareerRoadmapDialog(false)}
//         maxWidth="lg"
//         fullWidth
//       >
//         <DialogTitle
//           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
//         >
//           <Stack direction="row" alignItems="center" spacing={1.5}>
//             <Timeline />
//             <Typography variant="h6">Personalized Career Roadmap</Typography>
//           </Stack>
//         </DialogTitle>
//         <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
//           <RoleSelector
//             selectedRoles={selectedRoadmapRoles}
//             handleRoleChange={(e) =>
//               setSelectedRoadmapRoles((prev) =>
//                 e.target.checked
//                   ? [...prev, e.target.name]
//                   : prev.filter((r) => r !== e.target.name)
//               )
//             }
//           />
//           <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={() => fetchCareerRoadmap(selectedRoadmapRoles)}
//             >
//               Generate Roadmap
//             </Button>
//           </Box>
//           <Divider sx={{ mb: 2 }} />
//           {careerRoadmapLoading ? (
//             <DialogSkeleton />
//           ) : (
//             careerRoadmapData && (
//               <>
//                 <Tabs
//                   value={activeRoadmapTab}
//                   onChange={(e, val) => setActiveRoadmapTab(val)}
//                   centered
//                   variant="scrollable"
//                   scrollButtons="auto"
//                 >
//                   {Object.keys(careerRoadmapData).map((role) => (
//                     <Tab key={role} label={role} />
//                   ))}
//                 </Tabs>
//                 {Object.entries(careerRoadmapData).map(
//                   ([role, data], index) => (
//                     <TabPanel value={activeRoadmapTab} index={index} key={role}>
//                       <Typography variant="h5" gutterBottom align="center">
//                         Your AI-Generated Path to <strong>{role}</strong>
//                       </Typography>
//                       <Typography
//                         variant="body1"
//                         paragraph
//                         color="text.secondary"
//                         align="center"
//                       >
//                         Based on your current role:{" "}
//                         <strong>{data?.Current_Position || "N/A"}</strong> with{" "}
//                         <strong>{data?.Experience_Years || "N/A"}</strong> years
//                         of experience.
//                       </Typography>
//                       <Grid container spacing={2} sx={{ mt: 1 }}>
//                         <Grid item xs={12} md={6}>
//                           <Paper
//                             variant="outlined"
//                             sx={{
//                               p: 2.5,
//                               height: "100%",
//                               borderRadius: 2,
//                             }}
//                           >
//                             <Stack
//                               direction="row"
//                               spacing={2}
//                               alignItems="center"
//                             >
//                               <Avatar
//                                 sx={{
//                                   bgcolor: "primary.light",
//                                   width: 56,
//                                   height: 56,
//                                 }}
//                               >
//                                 <RocketLaunch />
//                               </Avatar>
//                               <Box>
//                                 <Typography
//                                   variant="overline"
//                                   color="primary.main"
//                                 >
//                                   Next Milestone
//                                 </Typography>
//                                 <Typography variant="h6" fontWeight="bold">
//                                   {data?.Next_Milestone?.title ||
//                                     "Not available"}
//                                 </Typography>
//                                 <Chip
//                                   size="small"
//                                   label={`Company: ${
//                                     data?.Next_Milestone?.company_type || "N/A"
//                                   }`}
//                                   sx={{ mt: 1 }}
//                                 />
//                               </Box>
//                             </Stack>
//                           </Paper>
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                           <Paper
//                             variant="outlined"
//                             sx={{
//                               p: 2.5,
//                               height: "100%",
//                               borderRadius: 2,
//                             }}
//                           >
//                             <Stack
//                               direction="row"
//                               spacing={2}
//                               alignItems="center"
//                             >
//                               <Avatar
//                                 sx={{
//                                   bgcolor: "success.light",
//                                   width: 56,
//                                   height: 56,
//                                 }}
//                               >
//                                 <Stars />
//                               </Avatar>
//                               <Box>
//                                 <Typography
//                                   variant="overline"
//                                   color="success.main"
//                                 >
//                                   Long-term Goal
//                                 </Typography>
//                                 <Typography variant="h6" fontWeight="bold">
//                                   {data?.Long_Term_Goal?.title ||
//                                     "Not available"}
//                                 </Typography>
//                                 <Chip
//                                   size="small"
//                                   label={`Company: ${
//                                     data?.Long_Term_Goal?.company_type || "N/A"
//                                   }`}
//                                   sx={{ mt: 1 }}
//                                 />
//                               </Box>
//                             </Stack>
//                           </Paper>
//                         </Grid>
//                       </Grid>
//                       <Divider sx={{ my: 3 }}>
//                         <Chip label="Recommended Actions" color="primary" />
//                       </Divider>
//                       <List>
//                         {data?.Recommended_Actions?.map((item, i) => (
//                           <ListItem key={i} alignItems="flex-start">
//                             <ListItemIcon>
//                               <Work color="primary" />
//                             </ListItemIcon>
//                             <ListItemText
//                               primary={item.action}
//                               secondary={item.reason}
//                             />
//                           </ListItem>
//                         )) || (
//                           <ListItem>
//                             <ListItemText primary="No actions recommended." />
//                           </ListItem>
//                         )}
//                       </List>
//                     </TabPanel>
//                   )
//                 )}
//               </>
//             )
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setCareerRoadmapDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>
//       <Dialog
//         open={culturalPrepDialog}
//         onClose={() => {
//           setCulturalPrepDialog(false);
//           setCulturalPrepTab(0);
//         }}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ sx: { height: { md: 650 } } }}
//       >
//         <DialogTitle
//           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
//         >
//           <Stack direction="row" alignItems="center" spacing={1.5}>
//             <Psychology />
//             <Typography variant="h6">Cultural Preparation Insights</Typography>
//           </Stack>
//         </DialogTitle>
//         <DialogContent
//           dividers
//           sx={{
//             display: "flex",
//             p: 0,
//             overflow: "hidden",
//             flexDirection: { xs: "column", md: "row" },
//           }}
//         >
//           {culturalPrepLoading ? (
//             <CulturalPrepDialogSkeleton />
//           ) : (
//             culturalPrepData && (
//               <>
//                 <Tabs
//                   orientation={
//                     theme.breakpoints.up("md") ? "vertical" : "horizontal"
//                   }
//                   variant="scrollable"
//                   value={culturalPrepTab}
//                   onChange={(e, val) => setCulturalPrepTab(val)}
//                   sx={{
//                     borderRight: { md: 1 },
//                     borderBottom: { xs: 1, md: 0 },
//                     borderColor: "divider",
//                     minWidth: { md: 150 },
//                   }}
//                 >
//                   {Object.values(culturalPrepData).map((region, index) => (
//                     <Tab key={index} label={region.location_name} />
//                   ))}
//                 </Tabs>
//                 <Box
//                   sx={{
//                     flex: { md: 1 },
//                     overflowY: "auto",
//                     p: { xs: 2, md: 3 },
//                     bgcolor: "background.default",
//                   }}
//                 >
//                   {Object.values(culturalPrepData).map((region, index) => (
//                     <TabPanel value={culturalPrepTab} index={index} key={index}>
//                       <Stack spacing={2}>
//                         <Paper
//                           elevation={0}
//                           sx={{
//                             p: 2,
//                             borderRadius: 2,
//                             border: 1,
//                             borderColor: "divider",
//                           }}
//                         >
//                           <Stack
//                             direction="row"
//                             spacing={1}
//                             alignItems="center"
//                             mb={1}
//                           >
//                             <Insights color="primary" />
//                             <Typography variant="h6">
//                               Cultural Insights
//                             </Typography>
//                           </Stack>
//                           <List dense>
//                             {region.cultural_insights.map((insight, i) => (
//                               <ListItem key={i}>
//                                 <ListItemIcon sx={{ minWidth: 32 }}>
//                                   <ArrowForward fontSize="small" />
//                                 </ListItemIcon>
//                                 <ListItemText primary={insight} />
//                               </ListItem>
//                             ))}
//                           </List>
//                         </Paper>
//                         <Paper
//                           elevation={0}
//                           sx={{
//                             p: 2,
//                             borderRadius: 2,
//                             border: 1,
//                             borderColor: "divider",
//                           }}
//                         >
//                           <Stack
//                             direction="row"
//                             spacing={1}
//                             alignItems="center"
//                             mb={1}
//                           >
//                             <VideoCall color="primary" />
//                             <Typography variant="h6">
//                               Communication Tips
//                             </Typography>
//                           </Stack>
//                           <List dense>
//                             {region.communication_tips.map((tip, i) => (
//                               <ListItem key={i}>
//                                 <ListItemIcon sx={{ minWidth: 32 }}>
//                                   <ArrowForward fontSize="small" />
//                                 </ListItemIcon>
//                                 <ListItemText primary={tip} />
//                               </ListItem>
//                             ))}
//                           </List>
//                         </Paper>
//                         <Paper
//                           elevation={0}
//                           sx={{
//                             p: 2,
//                             borderRadius: 2,
//                             border: 1,
//                             borderColor: "divider",
//                           }}
//                         >
//                           <Stack
//                             direction="row"
//                             spacing={1}
//                             alignItems="center"
//                             mb={1}
//                           >
//                             <Work color="primary" />
//                             <Typography variant="h6">Work Etiquette</Typography>
//                           </Stack>
//                           <List dense>
//                             {region.work_etiquette.map((tip, i) => (
//                               <ListItem key={i}>
//                                 <ListItemIcon sx={{ minWidth: 32 }}>
//                                   <Stars fontSize="small" />
//                                 </ListItemIcon>
//                                 <ListItemText primary={tip} />
//                               </ListItem>
//                             ))}
//                           </List>
//                         </Paper>
//                       </Stack>
//                     </TabPanel>
//                   ))}
//                 </Box>
//               </>
//             )
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setCulturalPrepDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>
//       <Dialog
//         open={salaryInsightsDialog}
//         onClose={() => setSalaryInsightsDialog(false)}
//         maxWidth="lg" // Changed to lg to accommodate more cards
//         fullWidth
//       >
//         <DialogTitle
//           sx={{ bgcolor: "primary.dark", color: "primary.contrastText" }}
//         >
//           <Stack direction="row" alignItems="center" spacing={1.5}>
//             <Language />
//             <Typography variant="h6">Global Salary Insights</Typography>
//           </Stack>
//         </DialogTitle>
//         <DialogContent dividers sx={{ bgcolor: "background.default" }}>
//           {salaryInsightsLoading ? (
//             <SalaryInsightsDialogSkeleton />
//           ) : (
//             salaryInsightsData && (
//               <Stack spacing={3} sx={{ py: 2 }}>
//                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
//                   <Stack
//                     direction="row"
//                     spacing={1.5}
//                     alignItems="center"
//                     mb={2}
//                   >
//                     <LocationOn color="primary" />
//                     <Typography variant="h6">
//                       Salary Benchmarks by Location
//                     </Typography>
//                   </Stack>
//                   <Box
//                     sx={{
//                       display: "grid",
//                       gridTemplateColumns: {
//                         xs: "1fr",
//                         sm: "repeat(2, 1fr)",
//                         md: "repeat(3, 1fr)",
//                         lg: "repeat(5, 1fr)",
//                       },
//                       gap: 2,
//                     }}
//                   >
//                     {salaryInsightsData.location_based.map((loc, i) => (
//                       <Card
//                         key={i}
//                         variant="elevation"
//                         elevation={4}
//                         sx={{
//                           borderRadius: 3,
//                           background: (theme) =>
//                             `linear-gradient(145deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
//                           color: "primary.contrastText",
//                           transition: "transform 0.3s ease-in-out",
//                           "&:hover": {
//                             transform: "translateY(-4px)",
//                           },
//                         }}
//                       >
//                         <CardContent
//                           sx={{
//                             display: "flex",
//                             flexDirection: "column",
//                             height: "100%",
//                             p: 2,
//                           }}
//                         >
//                           <Stack
//                             direction="row"
//                             spacing={1}
//                             alignItems="center"
//                           >
//                             <LocationOn
//                               sx={{ opacity: 0.8, fontSize: "1rem" }}
//                             />
//                             <Typography
//                               variant="body1"
//                               component="div"
//                               fontWeight={600}
//                             >
//                               {loc.city}
//                             </Typography>
//                           </Stack>

//                           <Box
//                             sx={{
//                               flexGrow: 1,
//                               display: "flex",
//                               flexDirection: "column",
//                               justifyContent: "center",
//                               alignItems: "center",
//                               my: 1,
//                             }}
//                           >
//                             <Typography variant="caption" sx={{ opacity: 0.8 }}>
//                               MEDIAN
//                             </Typography>
//                             <Typography variant="h5" fontWeight="bold">
//                               {loc.median_salary}
//                             </Typography>
//                           </Box>

//                           <Divider
//                             sx={{ bgcolor: "rgba(255,255,255,0.2)", mb: 1 }}
//                           />

//                           <Stack
//                             direction="row"
//                             justifyContent="space-between"
//                             alignItems="center"
//                           >
//                             <Box textAlign="center">
//                               <Typography
//                                 variant="caption"
//                                 sx={{ opacity: 0.8 }}
//                               >
//                                 MIN
//                               </Typography>
//                               <Typography variant="body2" fontWeight="medium">
//                                 {loc.min_salary}
//                               </Typography>
//                             </Box>
//                             <Box textAlign="center">
//                               <Typography
//                                 variant="caption"
//                                 sx={{ opacity: 0.8 }}
//                               >
//                                 MAX
//                               </Typography>
//                               <Typography variant="body2" fontWeight="medium">
//                                 {loc.max_salary}
//                               </Typography>
//                             </Box>
//                           </Stack>
//                         </CardContent>
//                       </Card>
//                     ))}
//                   </Box>
//                 </Paper>
//                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
//                   <Stack
//                     direction="row"
//                     spacing={1.5}
//                     alignItems="center"
//                     mb={1}
//                   >
//                     <TrendingUp color="primary" />
//                     <Typography variant="h6">Location Demand Impact</Typography>
//                   </Stack>
//                   <List dense>
//                     {salaryInsightsData.salary_insights_summary.map(
//                       (item, i) => (
//                         <ListItem key={i} disableGutters sx={{ px: 1 }}>
//                           <Stack
//                             direction={{ xs: "column", sm: "row" }}
//                             spacing={{ xs: 0.5, sm: 2 }}
//                             alignItems="center"
//                             sx={{ width: "100%" }}
//                           >
//                             <ListItemText
//                               primary={item.role}
//                               sx={{
//                                 width: "100%",
//                                 m: 0,
//                                 flexBasis: { sm: "40%" },
//                                 flexShrink: 0,
//                               }}
//                             />
//                             <Box
//                               sx={{
//                                 width: "100%",
//                                 display: "flex",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <LinearProgress
//                                 variant="determinate"
//                                 value={item.demand_in_salary_percent}
//                                 color="primary"
//                                 sx={{
//                                   width: "100%",
//                                   mr: 1.5,
//                                   height: 8,
//                                   borderRadius: 4,
//                                 }}
//                               />
//                               <Typography
//                                 variant="body2"
//                                 color="text.secondary"
//                               >{`${item.demand_in_salary_percent}%`}</Typography>
//                             </Box>
//                           </Stack>
//                         </ListItem>
//                       )
//                     )}
//                   </List>
//                 </Paper>
//                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
//                   <Stack
//                     direction="row"
//                     spacing={1.5}
//                     alignItems="center"
//                     mb={1}
//                   >
//                     <MonetizationOn color="success" />
//                     <Typography variant="h6">Negotiation Tips</Typography>
//                   </Stack>
//                   <List dense>
//                     {salaryInsightsData.negotiation_tips.map((tip, i) => (
//                       <ListItem key={i}>
//                         <ListItemIcon sx={{ minWidth: 32 }}>
//                           <CheckCircle color="success" fontSize="small" />
//                         </ListItemIcon>
//                         <ListItemText primary={tip} />
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Paper>
//                 <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
//                   <Stack
//                     direction="row"
//                     spacing={1.5}
//                     alignItems="center"
//                     mb={1}
//                   >
//                     <Timeline color="warning" />
//                     <Typography variant="h6">Market Trends</Typography>
//                   </Stack>
//                   <List>
//                     {salaryInsightsData.market_trends.map((item, i) => (
//                       <ListItem key={i} alignItems="flex-start">
//                         <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
//                           <TrendingFlat color="warning" />
//                         </ListItemIcon>
//                         <ListItemText
//                           primary={item.trend}
//                           secondary={item.insight}
//                           primaryTypographyProps={{ fontWeight: 600 }}
//                         />
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Paper>
//               </Stack>
//             )
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setSalaryInsightsDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>
//     </Layout>
//   );
// };

// export default CareerAssistant;
import { useState, useEffect, useRef } from "react";
import {
  Grid,
  Card,
  CardContent,
  Container,
  Typography,
  Box,
  Button,
  Paper,
  Avatar,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Stack,
  LinearProgress,
  Skeleton,
  alpha,
  IconButton,
  Tabs,
  Tab,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Alert,
  AlertTitle,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import {
  Psychology,
  TrendingUp,
  School,
  Work,
  Language,
  Assessment,
  VideoCall,
  Lightbulb,
  Timeline,
  CheckCircle,
  ErrorOutline,
  ArrowForward,
  MilitaryTech,
  Stars,
  RocketLaunch,
  TrendingFlat,
  LocationOn,
  MonetizationOn,
  AutoAwesome,
  Insights,
  Person,
} from "@mui/icons-material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
  LabelList,
} from "recharts";
import Layout from "../common/Layout";
import { useNotification } from "../../context/NotificationContext";
import { useNavigate } from "react-router-dom";
import apiClient from "../../context/apiClient";

// --- Skeleton Components ---

const HeaderSkeleton = () => (
  <Paper
    elevation={0}
    sx={{
      bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
      borderRadius: "24px",
      p: { xs: 2, sm: 3 },
      border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
    }}
  >
    <Stack direction="row" alignItems="center" spacing={2}>
      <Skeleton
        variant="circular"
        width={64}
        height={64}
        sx={{ bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1) }}
      />
      <Box sx={{ flex: 1 }}>
        <Skeleton
          variant="text"
          width="40%"
          height={48}
          sx={{ bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1) }}
        />
        <Skeleton
          variant="text"
          width="60%"
          height={24}
          sx={{ bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1) }}
        />
      </Box>
    </Stack>
  </Paper>
);

const ServiceListItemSkeleton = () => (
  <Paper
    elevation={0}
    sx={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: 2,
      borderRadius: "24px",
      bgcolor: (theme) => alpha(theme.palette.primary.main, 0.02),
      border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
    }}
  >
    <Skeleton
      variant="circular"
      width={48}
      height={48}
      sx={{ mr: 2, bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1) }}
    />
    <Box flexGrow={1}>
      <Skeleton
        variant="text"
        height={30}
        width="50%"
        sx={{ bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1) }}
      />
      <Skeleton
        variant="text"
        height={20}
        width="80%"
        sx={{ bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1) }}
      />
    </Box>
    <Skeleton
      variant="circular"
      width={24}
      height={24}
      sx={{ ml: 2, bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1) }}
    />
  </Paper>
);

const ServicesSkeleton = () => (
  <Paper
    elevation={0}
    sx={{
      p: { xs: 2, sm: 3 },
      borderRadius: "24px",
      bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
      border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
    }}
  >
    <Skeleton
      variant="text"
      width="60%"
      height={40}
      sx={{ mb: 3, bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1) }}
    />
    <Stack spacing={2}>
      {[...Array(5)].map((_, index) => (
        <ServiceListItemSkeleton key={index} />
      ))}
    </Stack>
  </Paper>
);

const TrendingSkillsSkeleton = () => (
  <Paper
    elevation={0}
    sx={{
      p: { xs: 2, sm: 3 },
      borderRadius: "24px",
      bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
      border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
    }}
  >
    <Skeleton
      variant="text"
      width="40%"
      height={40}
      sx={{ mb: 2, bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1) }}
    />
    <Stack
      direction="row"
      spacing={2}
      sx={{ mb: 3, justifyContent: "center", flexWrap: "wrap", gap: 1 }}
    >
      <Skeleton
        variant="rounded"
        width={150}
        height={42}
        sx={{
          borderRadius: "20px",
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
        }}
      />
      <Skeleton
        variant="rounded"
        width={150}
        height={42}
        sx={{
          borderRadius: "20px",
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
        }}
      />
      <Skeleton
        variant="rounded"
        width={150}
        height={42}
        sx={{
          borderRadius: "20px",
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
        }}
      />
    </Stack>
    <Skeleton
      variant="rounded"
      width="100%"
      height={500}
      sx={{
        borderRadius: "24px",
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.05),
      }}
    />
  </Paper>
);

const PageSkeleton = () => (
  <Layout title="AI Career Assistant">
    <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
      <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
        <Stack spacing={4}>
          <HeaderSkeleton />
          <ServicesSkeleton />
          <TrendingSkillsSkeleton />
        </Stack>
      </Container>
    </Box>
  </Layout>
);

const ChartSkeleton = () => (
  <Box sx={{ height: { xs: 400, md: 500 }, width: "100%", pt: 2 }}>
    <Skeleton variant="rounded" width="100%" height="100%" />
  </Box>
);

const DialogSkeleton = () => (
  <Stack spacing={3} sx={{ p: 2, minHeight: 400 }}>
    <Skeleton variant="rounded" width="60%" height={40} />
    <Skeleton variant="rounded" width="100%" height={100} />
    <Skeleton variant="rounded" width="40%" height={30} />
    <Skeleton variant="rounded" width="100%" height={150} />
  </Stack>
);

const CulturalPrepDialogSkeleton = () => (
  <Stack
    direction={{ xs: "column", md: "row" }}
    sx={{ width: "100%", height: "100%", p: 0 }}
  >
    <Stack
      spacing={2}
      sx={{
        p: 2,
        borderRight: { md: 1 },
        borderBottom: { xs: 1, md: 0 },
        borderColor: "divider",
        minWidth: { md: 150 },
      }}
    >
      <Skeleton variant="rounded" height={40} />
      <Skeleton variant="rounded" height={40} />
      <Skeleton variant="rounded" height={40} />
      <Skeleton variant="rounded" height={40} />
    </Stack>
    <Box sx={{ flex: 1, p: { xs: 2, md: 3 }, overflow: "hidden" }}>
      <Stack spacing={3}>
        <Stack spacing={1}>
          <Skeleton variant="text" width="60%" height={32} />
          <Skeleton variant="text" width="90%" />
          <Skeleton variant="text" width="80%" />
          <Skeleton variant="text" width="85%" />
        </Stack>
        <Stack spacing={1}>
          <Skeleton variant="text" width="50%" height={32} />
          <Skeleton variant="text" width="95%" />
          <Skeleton variant="text" width="75%" />
        </Stack>
        <Stack spacing={1}>
          <Skeleton variant="text" width="40%" height={32} />
          <Skeleton variant="text" width="80%" />
          <Skeleton variant="text" width="90%" />
        </Stack>
      </Stack>
    </Box>
  </Stack>
);

const SalaryInsightsDialogSkeleton = () => (
  <Stack spacing={3} sx={{ py: 2 }}>
    {/* Location Benchmarks Section */}
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Skeleton variant="text" width="40%" height={40} sx={{ mb: 2 }} />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
            lg: "repeat(5, 1fr)",
          },
          gap: 2,
        }}
      >
        {[...Array(5)].map((_, i) => (
          <Skeleton key={i} variant="rounded" height={160} />
        ))}
      </Box>
    </Paper>

    {/* Demand Impact Section */}
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Skeleton variant="text" width="50%" height={40} sx={{ mb: 1 }} />
      <Stack spacing={2}>
        <Skeleton variant="rounded" height={30} />
        <Skeleton variant="rounded" height={30} />
        <Skeleton variant="rounded" height={30} />
      </Stack>
    </Paper>

    {/* Negotiation Tips Section */}
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Skeleton variant="text" width="30%" height={40} sx={{ mb: 1 }} />
      <Stack spacing={1}>
        <Skeleton variant="text" />
        <Skeleton variant="text" width="90%" />
        <Skeleton variant="text" width="95%" />
      </Stack>
    </Paper>
  </Stack>
);

// --- Helper Components ---

const ServiceListItem = styled(Paper)(({ theme, color = "primary" }) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.03),
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: theme.spacing(3),
  borderRadius: "24px",
  cursor: "pointer",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
  position: "relative",
  overflow: "hidden",
  boxShadow: "none",
  elevation: 0,
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.06),
    borderColor: alpha(theme.palette.primary.main, 0.3),
    transform: "translateY(-4px)",
    boxShadow: `0 12px 30px ${alpha(theme.palette.common.black, 0.08)}`,
    "& .arrow-icon": {
      transform: "translateX(4px)",
      color: theme.palette.primary.main,
    },
  },
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "6px",
    height: "100%",
    backgroundColor: theme.palette[color]?.main || theme.palette.primary.main,
    opacity: 0.8,
  },
  ".MuiAvatar-root": {
    backgroundColor: alpha(
      theme.palette[color]?.main || theme.palette.primary.main,
      0.15,
    ),
    color: theme.palette[color]?.main || theme.palette.primary.main,
    marginRight: theme.spacing(2.5),
    width: 60,
    height: 60,
    borderRadius: "18px",
    boxShadow: `0 4px 12px ${alpha(theme.palette[color]?.main || theme.palette.primary.main, 0.2)}`,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: { xs: 2, md: 0 } }}>{children}</Box>}
    </div>
  );
}

// --- Main Component ---

const CareerAssistant = () => {
  const theme = useTheme();
  const { showNotification } = useNotification();
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();
  const isInitialMount = useRef(true);

  const availableRoles = [
    "AI/ML Engineer",
    "Data Scientist",
    "Business Analyst",
  ];

  // --- State Declarations ---
  const [pageLoading, setPageLoading] = useState(true);
  const [showWelcomeCard, setShowWelcomeCard] = useState(true);
  const [, setMockInterviewDialog] = useState(false);
  const [resumeReviewDialog, setResumeReviewDialog] = useState(false);
  const [skillGapDialog, setSkillGapDialog] = useState(false);
  const [careerRoadmapDialog, setCareerRoadmapDialog] = useState(false);
  const [culturalPrepDialog, setCulturalPrepDialog] = useState(false);
  const [salaryInsightsDialog, setSalaryInsightsDialog] = useState(false);
  const [trendingSkillsData, setTrendingSkillsData] = useState({});
  const [skillsLoading, setSkillsLoading] = useState(true);
  const [selectedTrendingRoles, setSelectedTrendingRoles] = useState([
    "AI/ML Engineer",
  ]);
  const [activeTrendingTab, setActiveTrendingTab] = useState(0);
  const [resumeReviewData, setResumeReviewData] = useState(null);
  const [resumeReviewLoading, setResumeReviewLoading] = useState(false);
  const [selectedResumeRoles, setSelectedResumeRoles] = useState([]);
  const [activeResumeTab, setActiveResumeTab] = useState(0);
  const [skillGapData, setSkillGapData] = useState(null);
  const [skillGapLoading, setSkillGapLoading] = useState(false);
  const [selectedSkillGapRoles, setSelectedSkillGapRoles] = useState([]);
  const [activeSkillGapTab, setActiveSkillGapTab] = useState(0);
  const [careerRoadmapData, setCareerRoadmapData] = useState(null);
  const [careerRoadmapLoading, setCareerRoadmapLoading] = useState(false);
  const [selectedRoadmapRoles, setSelectedRoadmapRoles] = useState([]);
  const [activeRoadmapTab, setActiveRoadmapTab] = useState(0);
  const [culturalPrepData, setCulturalPrepData] = useState(null);
  const [culturalPrepLoading, setCulturalPrepLoading] = useState(false);
  const [culturalPrepTab, setCulturalPrepTab] = useState(0);
  const [salaryInsightsData, setSalaryInsightsData] = useState(null);
  const [salaryInsightsLoading, setSalaryInsightsLoading] = useState(false);

  // --- Data Fetching Functions ---

  const fetchTrendingSkills = async (roles) => {
    if (!roles || roles.length === 0) {
      setTrendingSkillsData({});
      setSkillsLoading(false);
      return;
    }
    setSkillsLoading(true);
    try {
      const response = await apiClient.post("/trending-skills/", {
        selected_roles: roles,
      });
      const transformedData = {};
      for (const [role, skills] of Object.entries(response.data)) {
        transformedData[role] = skills.map((skill) => ({
          skill: skill.skill,
          demand: parseInt(skill.demand) || 0,
          growth: skill.increase || "N/A",
          priority: skill.priority,
        }));
      }
      setTrendingSkillsData(transformedData);
      setActiveTrendingTab(0);
    } catch (error) {
      console.error("Failed to fetch trending skills:", error);
      showNotification("Could not load trending skills data.", "error");
      setTrendingSkillsData({});
    } finally {
      setSkillsLoading(false);
    }
  };

  const fetchResumeReview = async (roles) => {
    if (!roles || roles.length === 0) {
      setResumeReviewData({});
      return;
    }
    setResumeReviewLoading(true);
    try {
      const response = await apiClient.post("/resume/review-talent/", {
        target_roles: roles,
      });
      setResumeReviewData(response.data);
      setActiveResumeTab(0);
    } catch (error) {
      showNotification("Failed to load resume review data.", "error");
    } finally {
      setResumeReviewLoading(false);
    }
  };
  const fetchSkillGap = async (roles) => {
    if (!roles || roles.length === 0) {
      setSkillGapData({});
      return;
    }
    setSkillGapLoading(true);
    try {
      const response = await apiClient.post("/resume/skill-gap/", {
        selected_roles: roles,
      });
      setSkillGapData(response.data);
      setActiveSkillGapTab(0);
    } catch (error) {
      showNotification("Failed to load skill gap analysis.", "error");
    } finally {
      setSkillGapLoading(false);
    }
  };
  const fetchCareerRoadmap = async (roles) => {
    if (!roles || roles.length === 0) {
      setCareerRoadmapData({});
      return;
    }
    setCareerRoadmapLoading(true);
    try {
      const response = await apiClient.post("/resume/career-roadmap/", {
        target_roles: roles,
      });
      setCareerRoadmapData(response.data);
      setActiveRoadmapTab(0);
    } catch (error) {
      showNotification("Failed to load career roadmap.", "error");
      setCareerRoadmapData({});
    } finally {
      setCareerRoadmapLoading(false);
    }
  };

  // --- Handlers ---
  const handleTrendingRoleChange = (event) => {
    const { name, checked } = event.target;
    setSelectedTrendingRoles((prev) =>
      checked ? [...prev, name] : prev.filter((role) => role !== name),
    );
  };

  // --- Child Components ---
  const RoleSelector = ({ selectedRoles, handleRoleChange }) => (
    <FormGroup
      row
      sx={{ mb: 3, justifyContent: "center", flexWrap: "wrap", gap: 1 }}
    >
      {availableRoles.map((role) => (
        <FormControlLabel
          key={role}
          control={
            <Checkbox
              checked={selectedRoles.includes(role)}
              onChange={handleRoleChange}
              name={role}
              sx={{
                color: alpha(theme.palette.primary.main, 0.4),
                "&.Mui-checked": {
                  color: "primary.main",
                },
              }}
            />
          }
          label={
            <Typography sx={{ fontWeight: 500, fontSize: "0.95rem" }}>
              {role}
            </Typography>
          }
          sx={{
            mx: 1,
            px: 2,
            py: 0.5,
            borderRadius: "50px",
            border: (theme) =>
              `1px solid ${selectedRoles.includes(role) ? theme.palette.primary.main : alpha(theme.palette.divider, 0.1)}`,
            transition: "all 0.2s",
            bgcolor: (theme) =>
              selectedRoles.includes(role)
                ? alpha(theme.palette.primary.main, 0.05)
                : "transparent",
          }}
        />
      ))}
    </FormGroup>
  );

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      const priorityMuiColor = {
        High: "primary",
        Medium: "info",
      };
      return (
        <Paper
          elevation={3}
          sx={{
            p: 1.5,
            minWidth: 220,
            bgcolor: "background.paper",
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 2,
          }}
        >
          <Typography variant="body1" fontWeight="bold" gutterBottom>
            {label}
          </Typography>
          <Stack spacing={1}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="body2" color="text.secondary">
                Demand:
              </Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
              >{`${data.demand}%`}</Typography>
            </Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="body2" color="text.secondary">
                Priority:
              </Typography>
              <Chip
                label={data.priority}
                size="small"
                color={priorityMuiColor[data.priority] || "default"}
                sx={{ fontWeight: 600 }}
              />
            </Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="body2" color="text.secondary">
                Growth:
              </Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
                color={
                  (data.growth || "").startsWith("+")
                    ? "success.main"
                    : "error.main"
                }
              >
                {data.growth}
              </Typography>
            </Stack>
          </Stack>
        </Paper>
      );
    }
    return null;
  };

  const RoundedVerticalBar = (props) => {
    const { fill, x, y, width, height } = props;
    const radius = 8;
    if (height <= 0) return null;
    return (
      <g>
        <path
          d={`M${x},${y + radius} A${radius},${radius} 0 0 1 ${
            x + radius
          },${y} L${x + width - radius},${y} A${radius},${radius} 0 0 1 ${
            x + width
          },${y + radius} L${x + width},${y + height} L${x},${y + height} Z`}
          fill={fill}
        />
      </g>
    );
  };

  const assistantServices = [
    {
      id: "resume-review",
      title: "AI Resume Review",
      description: "Get detailed feedback & ATS optimization suggestions.",
      icon: <Assessment />,
      color: "primary",
    },
    {
      id: "skill-assessment",
      title: "Skill Gap Analysis",
      description: "Identify critical skill gaps for your target roles.",
      icon: <TrendingUp />,
      color: "success",
    },
    {
      id: "career-roadmap",
      title: "Career Roadmap",
      description: "AI-generated path based on your profile and goals.",
      icon: <Timeline />,
      color: "warning",
    },
    {
      id: "salary-insights",
      title: "Salary Insights",
      description: "Real-time salary benchmarks for roles and locations.",
      icon: <Language />,
      color: "info",
    },
    {
      id: "cultural-prep",
      title: "Cultural Preparation",
      description: "Master workplace culture for different countries.",
      icon: <Psychology />,
      color: "error",
    },
  ];

  const handleServiceClick = async (service) => {
    const defaultRolePayload = ["AI/ML Engineer"];
    switch (service.id) {
      case "resume-review":
        setResumeReviewDialog(true);
        setSelectedResumeRoles(defaultRolePayload);
        await fetchResumeReview(defaultRolePayload);
        break;
      case "mock-interview":
        setMockInterviewDialog(true);
        break;
      case "skill-assessment":
        setSkillGapDialog(true);
        setSelectedSkillGapRoles(defaultRolePayload);
        await fetchSkillGap(defaultRolePayload);
        break;
      case "career-roadmap":
        setCareerRoadmapDialog(true);
        setSelectedRoadmapRoles(defaultRolePayload);
        await fetchCareerRoadmap(defaultRolePayload);
        break;
      case "cultural-prep":
        setCulturalPrepDialog(true);
        if (!culturalPrepData) {
          setCulturalPrepLoading(true);
          try {
            const res = await apiClient.get("/ai/cultural-preparation/");
            // FIX: Directly access the 'locations' array from the response
            const locationsArray =
              res.data?.cultural_preparation?.locations || [];
            setCulturalPrepData(locationsArray);
          } catch (err) {
            showNotification("Failed to load cultural prep data.", "error");
          } finally {
            setCulturalPrepLoading(false);
          }
        }
        break;
      case "salary-insights":
        setSalaryInsightsDialog(true);
        if (!salaryInsightsData) {
          setSalaryInsightsLoading(true);
          try {
            const res = await apiClient.get("/ai/salary-insights/");
            setSalaryInsightsData(res.data.salary_insights);
          } catch (err) {
            showNotification("Failed to load salary insights data.", "error");
          } finally {
            setSalaryInsightsLoading(false);
          }
        }
        break;
      default:
        showNotification(`${service.title} feature coming soon!`, "info");
    }
  };

  // Consolidated useEffect for fetching trending skills
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      // Initial load without debounce
      const initialLoad = async () => {
        await fetchTrendingSkills(selectedTrendingRoles);
        setPageLoading(false);
      };
      initialLoad();
    } else {
      // Debounced fetch for subsequent updates
      const handler = setTimeout(() => {
        fetchTrendingSkills(selectedTrendingRoles);
      }, 500);

      return () => {
        clearTimeout(handler);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTrendingRoles]);

  if (pageLoading) {
    return <PageSkeleton />;
  }

  return (
    <Layout title="AI Career Assistant">
      <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
        <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 4 } }}>
          <Stack spacing={4}>
            {/* ROW 1: Header Banner */}
            <Paper
              elevation={0}
              sx={{
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
                borderRadius: "24px",
                p: { xs: 3, sm: 4 },
                border: (theme) =>
                  `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
                position: "relative",
                overflow: "hidden",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  top: "-50%",
                  right: "-10%",
                  width: "300px",
                  height: "300px",
                  background: (theme) =>
                    `radial-gradient(circle, ${alpha(theme.palette.primary.main, 0.1)} 0%, transparent 70%)`,
                  borderRadius: "50%",
                },
              }}
            >
              <Stack direction="row" alignItems="center" spacing={3}>
                <Avatar
                  sx={{
                    bgcolor: "primary.main",
                    color: "common.white",
                    width: { xs: 60, sm: 80 },
                    height: { xs: 60, sm: 80 },
                    borderRadius: "20px",
                    boxShadow: `0 8px 16px ${alpha(theme.palette.primary.main, 0.3)}`,
                  }}
                >
                  <Psychology sx={{ fontSize: { xs: 32, sm: 44 } }} />
                </Avatar>
                <Box>
                  <Typography
                    variant="h3"
                    component="h1"
                    fontWeight="bold"
                    sx={{
                      typography: { xs: "h5", sm: "h4", md: "h3" },
                      color: "text.primary",
                    }}
                  >
                    AI Career Assistant
                    <AutoAwesome
                      sx={{
                        fontSize: { xs: 24, sm: 32 },
                        ml: 1.5,
                        verticalAlign: "middle",
                        color: "primary.main",
                      }}
                    />
                  </Typography>
                  <Typography
                    variant="h6"
                    color="text.secondary"
                    sx={{ fontWeight: 400, opacity: 0.8 }}
                  >
                    Your intelligent, multilingual guide to global careers.
                  </Typography>
                </Box>
              </Stack>
            </Paper>

            {/* ROW 2: Welcome Alert */}
            {showWelcomeCard && (
              <Alert
                severity="info"
                variant="filled"
                onClose={() => setShowWelcomeCard(false)}
                action={
                  <Button
                    color="inherit"
                    size="small"
                    onClick={() => {
                      handleServiceClick(assistantServices[0]);
                      setShowWelcomeCard(false);
                    }}
                  >
                    Start Review
                  </Button>
                }
                sx={{
                  bgcolor: "primary.light",
                  color: "#000000ff",
                  borderRadius: 2,
                }}
              >
                <AlertTitle sx={{ fontWeight: "bold" }}>Welcome!</AlertTitle>
                New here? Start with an AI Resume Review to get personalized
                feedback and unlock other insights.
              </Alert>
            )}

            {/* ROW 3: Services List */}
            <Box>
              <Stack direction="row" alignItems="center" spacing={1.5} mb={3}>
                <Typography
                  variant="h5"
                  component="h2"
                  fontWeight={700}
                  sx={{ color: "text.primary" }}
                >
                  AI-Powered Career Services
                </Typography>
                <RocketLaunch sx={{ color: "primary.main", fontSize: 28 }} />
              </Stack>
              <Grid container spacing={3}>
                {assistantServices.map((service) => (
                  <Grid item xs={12} md={6} key={service.id}>
                    <ServiceListItem
                      color={service.color}
                      onClick={() => handleServiceClick(service)}
                    >
                      <Avatar>{service.icon}</Avatar>
                      <Box flexGrow={1}>
                        <Typography
                          variant="h6"
                          component="div"
                          fontWeight="700"
                        >
                          {service.title}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ lineHeight: 1.6 }}
                        >
                          {service.description}
                        </Typography>
                      </Box>
                      <IconButton
                        className="arrow-icon"
                        sx={{ transition: "all 0.3s" }}
                      >
                        <ArrowForward />
                      </IconButton>
                    </ServiceListItem>
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* ROW 4: Trending Skills */}
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, sm: 4 },
                borderRadius: "24px",
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
                border: (theme) =>
                  `1px solid ${alpha(theme.palette.primary.main, 0.15)}`,
              }}
            >
              <Stack direction="row" alignItems="center" spacing={1.5} mb={3}>
                <Box
                  sx={{
                    p: 1,
                    borderRadius: "10px",
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                    display: "flex",
                  }}
                >
                  <Lightbulb sx={{ color: "primary.main" }} />
                </Box>
                <Typography variant="h5" fontWeight={700}>
                  Top In-Demand Skills
                </Typography>
              </Stack>
              <RoleSelector
                selectedRoles={selectedTrendingRoles}
                handleRoleChange={handleTrendingRoleChange}
              />
              {skillsLoading ? (
                <ChartSkeleton />
              ) : Object.keys(trendingSkillsData).length > 0 ? (
                <Box>
                  <Tabs
                    value={activeTrendingTab}
                    onChange={(e, val) => setActiveTrendingTab(val)}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                      mb: 2,
                      "& .MuiTabs-indicator": {
                        height: 3,
                        borderRadius: "3px 3px 0 0",
                      },
                      "& .MuiTab-root": {
                        fontWeight: 600,
                        fontSize: "1rem",
                        textTransform: "none",
                      },
                    }}
                  >
                    {Object.keys(trendingSkillsData).map((role) => (
                      <Tab label={role} key={role} />
                    ))}
                  </Tabs>
                  {Object.entries(trendingSkillsData).map(
                    ([role, skills], index) => {
                      const sortedSkills = [...skills].sort(
                        (a, b) => b.demand - a.demand,
                      );
                      const priorityColors = {
                        High: theme.palette.primary.main,
                        Medium: alpha(theme.palette.primary.main, 0.6),
                      };

                      return (
                        <TabPanel
                          value={activeTrendingTab}
                          index={index}
                          key={role}
                        >
                          <Box
                            sx={{
                              bgcolor: alpha(theme.palette.divider, 0.02),
                              borderRadius: "20px",
                              p: { xs: 2, sm: 3 },
                              border: (theme) =>
                                `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                            }}
                          >
                            <Box
                              sx={{
                                height: { xs: 400, md: 500 },
                                width: "100%",
                              }}
                            >
                              <ResponsiveContainer width="100%" height="100%">
                                <BarChart
                                  data={sortedSkills}
                                  margin={{
                                    top: 30,
                                    right: 30,
                                    left: 20,
                                    bottom: 120,
                                  }}
                                >
                                  <CartesianGrid
                                    vertical={false}
                                    stroke={theme.palette.divider}
                                    strokeDasharray="3 3"
                                  />
                                  <XAxis
                                    dataKey="skill"
                                    type="category"
                                    interval={0}
                                    angle={-45}
                                    textAnchor="end"
                                    tick={{
                                      fill: theme.palette.text.secondary,
                                      fontSize: 12,
                                    }}
                                    stroke={"transparent"}
                                  />
                                  <YAxis
                                    type="number"
                                    domain={[0, "dataMax + 15"]}
                                    allowDecimals={false}
                                    tickFormatter={(tick) => `${tick}%`}
                                    stroke={theme.palette.divider}
                                    tick={{
                                      fill: theme.palette.text.secondary,
                                    }}
                                  />
                                  <Tooltip
                                    content={<CustomTooltip />}
                                    cursor={{
                                      fill: alpha(
                                        theme.palette.primary.main,
                                        0.05,
                                      ),
                                    }}
                                  />
                                  <Bar
                                    dataKey="demand"
                                    shape={<RoundedVerticalBar />}
                                    animationDuration={1200}
                                  >
                                    {sortedSkills.map((entry, idx) => (
                                      <Cell
                                        key={`cell-${idx}`}
                                        fill={
                                          priorityColors[entry.priority] ||
                                          alpha(theme.palette.primary.main, 0.3)
                                        }
                                      />
                                    ))}
                                    <LabelList
                                      dataKey="demand"
                                      position="top"
                                      offset={8}
                                      style={{
                                        fill: theme.palette.text.primary,
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                      }}
                                      formatter={(value) => `${value}%`}
                                    />
                                  </Bar>
                                </BarChart>
                              </ResponsiveContainer>
                            </Box>
                          </Box>
                        </TabPanel>
                      );
                    },
                  )}
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    py: 8,
                    minHeight: 400,
                  }}
                >
                  <Insights
                    sx={{ fontSize: 60, color: "text.disabled", mb: 2 }}
                  />
                  <Typography variant="h6" color="text.secondary">
                    Select a role to view in-demand skills
                  </Typography>
                  <Typography variant="body2" color="text.disabled">
                    The chart will update automatically as you make selections.
                  </Typography>
                </Box>
              )}
            </Paper>
          </Stack>
        </Container>
      </Box>

      {/* --- DIALOGS (UI ENHANCEMENTS APPLIED) --- */}
      <Dialog
        open={resumeReviewDialog}
        onClose={() => setResumeReviewDialog(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "28px", overflow: "hidden" },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: (theme) =>
              theme.palette.mode === "dark" ? "grey.800" : "grey.900",
            color: "common.white",
            p: 3,
            borderBottom: (theme) =>
              `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Box
              sx={{
                p: 1,
                borderRadius: "12px",
                bgcolor: alpha(theme.palette.primary.main, 0.15),
                display: "flex",
              }}
            >
              <Assessment sx={{ color: "primary.main" }} />
            </Box>
            <Typography variant="h5" fontWeight={700}>
              AI Resume Review
            </Typography>
          </Stack>
        </DialogTitle>

        <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
          <RoleSelector
            selectedRoles={selectedResumeRoles}
            handleRoleChange={(e) =>
              setSelectedResumeRoles((prev) =>
                e.target.checked
                  ? [...prev, e.target.name]
                  : prev.filter((r) => r !== e.target.name),
              )
            }
          />
          <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
            <Button
              variant="contained"
              onClick={() => fetchResumeReview(selectedResumeRoles)}
            >
              Generate Report
            </Button>
          </Box>
          <Divider sx={{ mb: 2 }} />
          {resumeReviewLoading ? (
            <DialogSkeleton />
          ) : (
            resumeReviewData && (
              <>
                <Tabs
                  value={activeResumeTab}
                  onChange={(e, val) => setActiveResumeTab(val)}
                  centered
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {Object.keys(resumeReviewData).map((role) => (
                    <Tab key={role} label={role} />
                  ))}
                </Tabs>
                {Object.entries(resumeReviewData).map(([role, data], index) => (
                  <TabPanel value={activeResumeTab} index={index} key={role}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <Paper
                          variant="outlined"
                          sx={{ p: 2.5, height: "100%", borderRadius: 2 }}
                        >
                          <Box
                            sx={{
                              p: 2,
                              mb: 2,
                              borderRadius: 1.5,
                              background: (theme) =>
                                `linear-gradient(135deg, ${alpha(
                                  theme.palette.error.light,
                                  0.2,
                                )}, ${alpha(theme.palette.error.dark, 0.2)})`,
                            }}
                          >
                            <Typography variant="h6" fontWeight="500">
                              ATS Compatibility
                            </Typography>
                            <Typography
                              variant="h3"
                              fontWeight="bold"
                              color="error.dark"
                            >
                              {data.ATS_Compatibility.score}
                              <Typography
                                component="span"
                                variant="h5"
                                color="text.secondary"
                              >
                                /100
                              </Typography>
                            </Typography>
                            <LinearProgress
                              variant="determinate"
                              value={data.ATS_Compatibility.score}
                              color="error"
                              sx={{ height: 6, borderRadius: 3 }}
                            />
                          </Box>
                          <Typography variant="subtitle1" fontWeight="bold">
                            Top Issues:
                          </Typography>
                          <List dense>
                            {data.ATS_Compatibility.top_issues.map(
                              (issue, i) => (
                                <ListItem key={i} sx={{ py: 0 }}>
                                  <ListItemIcon sx={{ minWidth: 32 }}>
                                    <ErrorOutline
                                      fontSize="small"
                                      color="error"
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary={issue} />
                                </ListItem>
                              ),
                            )}
                          </List>
                        </Paper>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Paper
                          variant="outlined"
                          sx={{ p: 2.5, height: "100%", borderRadius: 2 }}
                        >
                          <Box
                            sx={{
                              p: 2,
                              mb: 2,
                              borderRadius: 1.5,
                              background: (theme) =>
                                `linear-gradient(135deg, ${alpha(
                                  theme.palette.success.light,
                                  0.2,
                                )}, ${alpha(theme.palette.success.dark, 0.2)})`,
                            }}
                          >
                            <Typography variant="h6" fontWeight="500">
                              Content & Format Quality
                            </Typography>
                            <Typography
                              variant="body2"
                              paragraph
                              color="text.secondary"
                            >
                              {data.Content_Quality_Analysis.summary}
                            </Typography>
                          </Box>
                          <Typography variant="subtitle1" fontWeight="bold">
                            Top Strengths:
                          </Typography>
                          <List dense>
                            {data.Content_Quality_Analysis.top_strengths.map(
                              (strength, i) => (
                                <ListItem key={i} sx={{ py: 0 }}>
                                  <ListItemIcon sx={{ minWidth: 32 }}>
                                    <CheckCircle
                                      fontSize="small"
                                      color="success"
                                    />
                                  </ListItemIcon>
                                  <ListItemText primary={strength} />
                                </ListItem>
                              ),
                            )}
                          </List>
                        </Paper>
                      </Grid>
                      <Grid item xs={12}>
                        <Paper
                          variant="outlined"
                          sx={{ p: 2.5, borderRadius: 2 }}
                        >
                          <Typography variant="h6" gutterBottom>
                            Keyword & Section Optimization
                          </Typography>
                          <Stack
                            direction={{ xs: "column", sm: "row" }}
                            spacing={3}
                            divider={
                              <Divider orientation="vertical" flexItem />
                            }
                          >
                            <Box flex={1}>
                              <Typography variant="subtitle1" fontWeight="bold">
                                Missing Keywords
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 1,
                                  mt: 1,
                                }}
                              >
                                {data.Keyword_Optimization.missing_keywords.map(
                                  (kw, i) => (
                                    <Chip
                                      key={i}
                                      label={kw}
                                      color="info"
                                      size="small"
                                    />
                                  ),
                                )}
                              </Box>
                            </Box>
                            <Box flex={1}>
                              <Typography variant="subtitle1" fontWeight="bold">
                                Missing Sections
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 1,
                                  mt: 1,
                                }}
                              >
                                {data.Format_and_Structure_Review.missing_sections.map(
                                  (sec, i) => (
                                    <Chip
                                      key={i}
                                      label={sec}
                                      color="warning"
                                      size="small"
                                    />
                                  ),
                                )}
                              </Box>
                            </Box>
                          </Stack>
                        </Paper>
                      </Grid>
                    </Grid>
                  </TabPanel>
                ))}
              </>
            )
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setResumeReviewDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={skillGapDialog}
        onClose={() => setSkillGapDialog(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "28px", overflow: "hidden" },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: (theme) =>
              theme.palette.mode === "dark" ? "grey.800" : "grey.900",
            color: "common.white",
            p: 3,
            borderBottom: (theme) =>
              `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Box
              sx={{
                p: 1,
                borderRadius: "12px",
                bgcolor: alpha(theme.palette.primary.main, 0.15),
                display: "flex",
              }}
            >
              <TrendingUp sx={{ color: "primary.main" }} />
            </Box>
            <Typography variant="h5" fontWeight={700}>
              AI Skill Gap Analysis
            </Typography>
          </Stack>
        </DialogTitle>

        <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
          <RoleSelector
            selectedRoles={selectedSkillGapRoles}
            handleRoleChange={(e) =>
              setSelectedSkillGapRoles((prev) =>
                e.target.checked
                  ? [...prev, e.target.name]
                  : prev.filter((r) => r !== e.target.name),
              )
            }
          />
          <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => fetchSkillGap(selectedSkillGapRoles)}
            >
              Generate Analysis
            </Button>
          </Box>
          <Divider sx={{ mb: 2 }} />
          {skillGapLoading ? (
            <DialogSkeleton />
          ) : (
            skillGapData && (
              <>
                <Tabs
                  value={activeSkillGapTab}
                  onChange={(e, val) => setActiveSkillGapTab(val)}
                  centered
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {Object.keys(skillGapData).map((role) => (
                    <Tab key={role} label={role} />
                  ))}
                </Tabs>
                {Object.entries(skillGapData).map(([role, data], index) => (
                  <TabPanel value={activeSkillGapTab} index={index} key={role}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Paper
                          variant="outlined"
                          sx={{ p: 2, height: "100%", borderRadius: 2 }}
                        >
                          <Stack
                            direction="row"
                            spacing={1.5}
                            alignItems="center"
                            mb={1.5}
                          >
                            <Avatar sx={{ bgcolor: "primary.light" }}>
                              <Person />
                            </Avatar>
                            <Typography variant="h6">Your Skills</Typography>
                          </Stack>
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
                          >
                            {data.Current_Skill_Mapping.map((skill, i) => (
                              <Chip key={i} label={skill} variant="outlined" />
                            ))}
                          </Box>
                        </Paper>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Paper
                          variant="outlined"
                          sx={{ p: 2, height: "100%", borderRadius: 2 }}
                        >
                          <Stack
                            direction="row"
                            spacing={1.5}
                            alignItems="center"
                            mb={1.5}
                          >
                            <Avatar sx={{ bgcolor: "secondary.light" }}>
                              <TrendingUp />
                            </Avatar>
                            <Typography variant="h6">
                              In-Demand Market Skills
                            </Typography>
                          </Stack>
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
                          >
                            {data.Market_Demand_Analysis.map((skill, i) => (
                              <Chip key={i} label={skill} color="primary" />
                            ))}
                          </Box>
                        </Paper>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Paper
                          variant="outlined"
                          sx={{ p: 2, height: "100%", borderRadius: 2 }}
                        >
                          <Stack
                            direction="row"
                            spacing={1.5}
                            alignItems="center"
                            mb={1.5}
                          >
                            <Avatar sx={{ bgcolor: "info.light" }}>
                              <School />
                            </Avatar>
                            <Typography variant="h6">
                              Recommended Learning Path
                            </Typography>
                          </Stack>
                          <List dense>
                            {data.Learning_Path.map((path, i) => (
                              <ListItem key={i} sx={{ py: 0.5 }}>
                                <ListItemIcon sx={{ minWidth: 36 }}>
                                  <ArrowForward fontSize="small" color="info" />
                                </ListItemIcon>
                                <ListItemText primary={path} />
                              </ListItem>
                            ))}
                          </List>
                        </Paper>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Paper
                          variant="outlined"
                          sx={{ p: 2, height: "100%", borderRadius: 2 }}
                        >
                          <Stack
                            direction="row"
                            spacing={1.5}
                            alignItems="center"
                            mb={1.5}
                          >
                            <Avatar sx={{ bgcolor: "success.light" }}>
                              <MilitaryTech />
                            </Avatar>
                            <Typography variant="h6">
                              Suggested Certifications
                            </Typography>
                          </Stack>
                          <List dense>
                            {data.Certification_Guidance.map((cert, i) => (
                              <ListItem key={i} sx={{ py: 0.5 }}>
                                <ListItemIcon sx={{ minWidth: 36 }}>
                                  <CheckCircle
                                    fontSize="small"
                                    color="success"
                                  />
                                </ListItemIcon>
                                <ListItemText primary={cert} />
                              </ListItem>
                            ))}
                          </List>
                        </Paper>
                      </Grid>
                    </Grid>
                  </TabPanel>
                ))}
              </>
            )
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSkillGapDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={careerRoadmapDialog}
        onClose={() => setCareerRoadmapDialog(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "28px", overflow: "hidden" },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: (theme) =>
              theme.palette.mode === "dark" ? "grey.800" : "grey.900",
            color: "common.white",
            p: 3,
            borderBottom: (theme) =>
              `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Box
              sx={{
                p: 1,
                borderRadius: "12px",
                bgcolor: alpha(theme.palette.primary.main, 0.15),
                display: "flex",
              }}
            >
              <Timeline sx={{ color: "primary.main" }} />
            </Box>
            <Typography variant="h5" fontWeight={700}>
              Personalized Career Roadmap
            </Typography>
          </Stack>
        </DialogTitle>

        <DialogContent dividers sx={{ bgcolor: "background.default", p: 3 }}>
          <RoleSelector
            selectedRoles={selectedRoadmapRoles}
            handleRoleChange={(e) =>
              setSelectedRoadmapRoles((prev) =>
                e.target.checked
                  ? [...prev, e.target.name]
                  : prev.filter((r) => r !== e.target.name),
              )
            }
          />
          <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => fetchCareerRoadmap(selectedRoadmapRoles)}
            >
              Generate Roadmap
            </Button>
          </Box>
          <Divider sx={{ mb: 2 }} />
          {careerRoadmapLoading ? (
            <DialogSkeleton />
          ) : (
            careerRoadmapData && (
              <>
                <Tabs
                  value={activeRoadmapTab}
                  onChange={(e, val) => setActiveRoadmapTab(val)}
                  centered
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {Object.keys(careerRoadmapData).map((role) => (
                    <Tab key={role} label={role} />
                  ))}
                </Tabs>
                {Object.entries(careerRoadmapData).map(
                  ([role, data], index) => (
                    <TabPanel value={activeRoadmapTab} index={index} key={role}>
                      <Typography variant="h5" gutterBottom align="center">
                        Your AI-Generated Path to <strong>{role}</strong>
                      </Typography>
                      <Typography
                        variant="body1"
                        paragraph
                        color="text.secondary"
                        align="center"
                      >
                        Based on your current role:{" "}
                        <strong>{data?.Current_Position || "N/A"}</strong> with{" "}
                        <strong>{data?.Experience_Years || "N/A"}</strong> years
                        of experience.
                      </Typography>
                      <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12} md={6}>
                          <Paper
                            variant="outlined"
                            sx={{
                              p: 2.5,
                              height: "100%",
                              borderRadius: 2,
                            }}
                          >
                            <Stack
                              direction="row"
                              spacing={2}
                              alignItems="center"
                            >
                              <Avatar
                                sx={{
                                  bgcolor: "primary.light",
                                  width: 56,
                                  height: 56,
                                }}
                              >
                                <RocketLaunch />
                              </Avatar>
                              <Box>
                                <Typography
                                  variant="overline"
                                  color="primary.main"
                                >
                                  Next Milestone
                                </Typography>
                                <Typography variant="h6" fontWeight="bold">
                                  {data?.Next_Milestone?.title ||
                                    "Not available"}
                                </Typography>
                                <Chip
                                  size="small"
                                  label={`Company: ${
                                    data?.Next_Milestone?.company_type || "N/A"
                                  }`}
                                  sx={{ mt: 1 }}
                                />
                              </Box>
                            </Stack>
                          </Paper>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Paper
                            variant="outlined"
                            sx={{
                              p: 2.5,
                              height: "100%",
                              borderRadius: 2,
                            }}
                          >
                            <Stack
                              direction="row"
                              spacing={2}
                              alignItems="center"
                            >
                              <Avatar
                                sx={{
                                  bgcolor: "success.light",
                                  width: 56,
                                  height: 56,
                                }}
                              >
                                <Stars />
                              </Avatar>
                              <Box>
                                <Typography
                                  variant="overline"
                                  color="success.main"
                                >
                                  Long-term Goal
                                </Typography>
                                <Typography variant="h6" fontWeight="bold">
                                  {data?.Long_Term_Goal?.title ||
                                    "Not available"}
                                </Typography>
                                <Chip
                                  size="small"
                                  label={`Company: ${
                                    data?.Long_Term_Goal?.company_type || "N/A"
                                  }`}
                                  sx={{ mt: 1 }}
                                />
                              </Box>
                            </Stack>
                          </Paper>
                        </Grid>
                      </Grid>
                      <Divider sx={{ my: 3 }}>
                        <Chip label="Recommended Actions" color="primary" />
                      </Divider>
                      <List>
                        {data?.Recommended_Actions?.map((item, i) => (
                          <ListItem key={i} alignItems="flex-start">
                            <ListItemIcon>
                              <Work color="primary" />
                            </ListItemIcon>
                            <ListItemText
                              primary={item.action}
                              secondary={item.reason}
                            />
                          </ListItem>
                        )) || (
                          <ListItem>
                            <ListItemText primary="No actions recommended." />
                          </ListItem>
                        )}
                      </List>
                    </TabPanel>
                  ),
                )}
              </>
            )
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCareerRoadmapDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={culturalPrepDialog}
        onClose={() => {
          setCulturalPrepDialog(false);
          setCulturalPrepTab(0);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            height: { md: 650 },
            borderRadius: "28px",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: (theme) =>
              theme.palette.mode === "dark" ? "grey.800" : "grey.900",
            color: "common.white",
            p: 3,
            borderBottom: (theme) =>
              `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Box
              sx={{
                p: 1,
                borderRadius: "12px",
                bgcolor: alpha(theme.palette.primary.main, 0.15),
                display: "flex",
              }}
            >
              <Psychology sx={{ color: "primary.main" }} />
            </Box>
            <Typography variant="h5" fontWeight={700}>
              Cultural Preparation Insights
            </Typography>
          </Stack>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            display: "flex",
            p: 0,
            overflow: "hidden",
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          {culturalPrepLoading ? (
            <CulturalPrepDialogSkeleton />
          ) : (
            culturalPrepData &&
            culturalPrepData.length > 0 && (
              <>
                <Tabs
                  orientation={
                    theme.breakpoints.up("md") ? "vertical" : "horizontal"
                  }
                  variant="scrollable"
                  value={culturalPrepTab}
                  onChange={(e, val) => setCulturalPrepTab(val)}
                  sx={{
                    borderRight: { md: 1 },
                    borderBottom: { xs: 1, md: 0 },
                    borderColor: "divider",
                    minWidth: { md: 150 },
                  }}
                >
                  {/* FIX: Iterate directly over the culturalPrepData array */}
                  {culturalPrepData.map((region, index) => (
                    <Tab key={index} label={region.location_name} />
                  ))}
                </Tabs>
                <Box
                  sx={{
                    flex: { md: 1 },
                    overflowY: "auto",
                    p: { xs: 2, md: 3 },
                    bgcolor: "background.default",
                  }}
                >
                  {/* FIX: Iterate directly over the culturalPrepData array */}
                  {culturalPrepData.map((region, index) => (
                    <TabPanel value={culturalPrepTab} index={index} key={index}>
                      <Stack spacing={2}>
                        <Paper
                          elevation={0}
                          sx={{
                            p: 2,
                            borderRadius: 2,
                            border: 1,
                            borderColor: "divider",
                          }}
                        >
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            mb={1}
                          >
                            <Insights color="primary" />
                            <Typography variant="h6">
                              Cultural Insights
                            </Typography>
                          </Stack>
                          <List dense>
                            {/* FIX: Add optional chaining for safety */}
                            {region.cultural_insights?.map((insight, i) => (
                              <ListItem key={i}>
                                <ListItemIcon sx={{ minWidth: 32 }}>
                                  <ArrowForward fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={insight} />
                              </ListItem>
                            ))}
                          </List>
                        </Paper>
                        <Paper
                          elevation={0}
                          sx={{
                            p: 2,
                            borderRadius: 2,
                            border: 1,
                            borderColor: "divider",
                          }}
                        >
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            mb={1}
                          >
                            <VideoCall color="primary" />
                            <Typography variant="h6">
                              Communication Tips
                            </Typography>
                          </Stack>
                          <List dense>
                            {/* FIX: Add optional chaining for safety */}
                            {region.communication_tips?.map((tip, i) => (
                              <ListItem key={i}>
                                <ListItemIcon sx={{ minWidth: 32 }}>
                                  <ArrowForward fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={tip} />
                              </ListItem>
                            ))}
                          </List>
                        </Paper>
                        <Paper
                          elevation={0}
                          sx={{
                            p: 2,
                            borderRadius: 2,
                            border: 1,
                            borderColor: "divider",
                          }}
                        >
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            mb={1}
                          >
                            <Work color="primary" />
                            <Typography variant="h6">Work Etiquette</Typography>
                          </Stack>
                          <List dense>
                            {/* FIX: Add optional chaining for safety */}
                            {region.work_etiquette?.map((tip, i) => (
                              <ListItem key={i}>
                                <ListItemIcon sx={{ minWidth: 32 }}>
                                  <Stars fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={tip} />
                              </ListItem>
                            ))}
                          </List>
                        </Paper>
                      </Stack>
                    </TabPanel>
                  ))}
                </Box>
              </>
            )
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCulturalPrepDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={salaryInsightsDialog}
        onClose={() => setSalaryInsightsDialog(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "28px", overflow: "hidden" },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: (theme) =>
              theme.palette.mode === "dark" ? "grey.800" : "grey.900",
            color: "common.white",
            p: 3,
            borderBottom: (theme) =>
              `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Box
              sx={{
                p: 1,
                borderRadius: "12px",
                bgcolor: alpha(theme.palette.primary.main, 0.15),
                display: "flex",
              }}
            >
              <Language sx={{ color: "primary.main" }} />
            </Box>
            <Typography variant="h5" fontWeight={700}>
              Global Salary Insights
            </Typography>
          </Stack>
        </DialogTitle>

        <DialogContent dividers sx={{ bgcolor: "background.default" }}>
          {salaryInsightsLoading ? (
            <SalaryInsightsDialogSkeleton />
          ) : (
            salaryInsightsData && (
              <Stack spacing={3} sx={{ py: 2 }}>
                <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                  <Stack
                    direction="row"
                    spacing={1.5}
                    alignItems="center"
                    mb={2}
                  >
                    <LocationOn color="primary" />
                    <Typography variant="h6">
                      Salary Benchmarks by Location
                    </Typography>
                  </Stack>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, 1fr)",
                        md: "repeat(3, 1fr)",
                        lg: "repeat(5, 1fr)",
                      },
                      gap: 2,
                    }}
                  >
                    {salaryInsightsData.location_based.map((loc, i) => (
                      <Card
                        key={i}
                        variant="elevation"
                        elevation={4}
                        sx={{
                          borderRadius: 3,
                          background: (theme) =>
                            `linear-gradient(145deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                          color: "primary.contrastText",
                          transition: "transform 0.3s ease-in-out",
                          "&:hover": {
                            transform: "translateY(-4px)",
                          },
                        }}
                      >
                        <CardContent
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            p: 2,
                          }}
                        >
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                          >
                            <LocationOn
                              sx={{ opacity: 0.8, fontSize: "1rem" }}
                            />
                            <Typography
                              variant="body1"
                              component="div"
                              fontWeight={600}
                            >
                              {loc.city}
                            </Typography>
                          </Stack>

                          <Box
                            sx={{
                              flexGrow: 1,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              my: 1,
                            }}
                          >
                            <Typography variant="caption" sx={{ opacity: 0.8 }}>
                              MEDIAN
                            </Typography>
                            <Typography variant="h5" fontWeight="bold">
                              {loc.median_salary}
                            </Typography>
                          </Box>

                          <Divider
                            sx={{ bgcolor: "rgba(255,255,255,0.2)", mb: 1 }}
                          />

                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Box textAlign="center">
                              <Typography
                                variant="caption"
                                sx={{ opacity: 0.8 }}
                              >
                                MIN
                              </Typography>
                              <Typography variant="body2" fontWeight="medium">
                                {loc.min_salary}
                              </Typography>
                            </Box>
                            <Box textAlign="center">
                              <Typography
                                variant="caption"
                                sx={{ opacity: 0.8 }}
                              >
                                MAX
                              </Typography>
                              <Typography variant="body2" fontWeight="medium">
                                {loc.max_salary}
                              </Typography>
                            </Box>
                          </Stack>
                        </CardContent>
                      </Card>
                    ))}
                  </Box>
                </Paper>
                <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                  <Stack
                    direction="row"
                    spacing={1.5}
                    alignItems="center"
                    mb={1}
                  >
                    <TrendingUp color="primary" />
                    <Typography variant="h6">Location Demand Impact</Typography>
                  </Stack>
                  <List dense>
                    {salaryInsightsData.salary_insights_summary.map(
                      (item, i) => (
                        <ListItem key={i} disableGutters sx={{ px: 1 }}>
                          <Stack
                            direction={{ xs: "column", sm: "row" }}
                            spacing={{ xs: 0.5, sm: 2 }}
                            alignItems="center"
                            sx={{ width: "100%" }}
                          >
                            <ListItemText
                              primary={item.role}
                              sx={{
                                width: "100%",
                                m: 0,
                                flexBasis: { sm: "40%" },
                                flexShrink: 0,
                              }}
                            />
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <LinearProgress
                                variant="determinate"
                                value={item.demand_in_salary_percent}
                                color="primary"
                                sx={{
                                  width: "100%",
                                  mr: 1.5,
                                  height: 8,
                                  borderRadius: 4,
                                }}
                              />
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >{`${item.demand_in_salary_percent}%`}</Typography>
                            </Box>
                          </Stack>
                        </ListItem>
                      ),
                    )}
                  </List>
                </Paper>
                <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                  <Stack
                    direction="row"
                    spacing={1.5}
                    alignItems="center"
                    mb={1}
                  >
                    <MonetizationOn color="success" />
                    <Typography variant="h6">Negotiation Tips</Typography>
                  </Stack>
                  <List dense>
                    {salaryInsightsData.negotiation_tips.map((tip, i) => (
                      <ListItem key={i}>
                        <ListItemIcon sx={{ minWidth: 32 }}>
                          <CheckCircle color="success" fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary={tip} />
                      </ListItem>
                    ))}
                  </List>
                </Paper>
                <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                  <Stack
                    direction="row"
                    spacing={1.5}
                    alignItems="center"
                    mb={1}
                  >
                    <Timeline color="warning" />
                    <Typography variant="h6">Market Trends</Typography>
                  </Stack>
                  <List>
                    {salaryInsightsData.market_trends.map((item, i) => (
                      <ListItem key={i} alignItems="flex-start">
                        <ListItemIcon sx={{ minWidth: 32, mt: 0.5 }}>
                          <TrendingFlat color="warning" />
                        </ListItemIcon>
                        <ListItemText
                          primary={item.trend}
                          secondary={item.insight}
                          primaryTypographyProps={{ fontWeight: 600 }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Paper>
              </Stack>
            )
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSalaryInsightsDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Layout>
  );
};

export default CareerAssistant;
